import { LogoUpload } from './chunk-Z3N3HDXV.js';
import { usePermission } from './chunk-JNMH5O4E.js';
import { useQuery, useApiClient, useResourceRevision, useMutation, useAsyncResource } from './chunk-SVHHKDIK.js';
import { useEntitlement, useLadderShared, useEntitled, useOfferedRungs } from './chunk-BS6JEKBZ.js';
import { useFeatureFlag } from './chunk-WJJBT3ZR.js';
import { useActorNameIfKnown, ActorName } from './chunk-W23J47FP.js';
import { useDepsChanged } from './chunk-I37XHMWY.js';
import { notifySuccess, notifyError } from './chunk-26PMNFER.js';
import { DataTableColumnHeader, ResourceTable } from './chunk-TEUSJPYG.js';
import { ErrorState, EmptyState } from './chunk-4PI4D3M6.js';
import { FilterChip, Slider, EnumSelect, ColorSwatch, ViewModeToggle, ColorPicker, NativeSelect, Select, SelectTrigger, SelectValue, SelectContent, SelectGroup, SelectLabel, SelectItem, AlertDialog, AlertDialogTrigger, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogCancel, AlertDialogAction, Switch, Alert, AlertDescription, Collapsible, CollapsibleTrigger, CollapsibleContent } from './chunk-IVSFWWLB.js';
import { Spinner } from './chunk-T2TNXQRV.js';
import { Textarea } from './chunk-375TQAFA.js';
import { Card, CardContent, CardHeader, CardTitle, CardFooter, CardDescription } from './chunk-WNZ465SZ.js';
import { Skeleton } from './chunk-7QAGCS3T.js';
import { Checkbox } from './chunk-KAFWCBYS.js';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from './chunk-PEIGN6MO.js';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from './chunk-DAJW2H54.js';
import { AddressAvatar, AddressDisplay, RiskBadge, ChainAvatar, LifecycleBadge, CounterfeitMark, useSignedCdnImage, AttributionChips, useChainRegistryVersion, useTierCutoffs, WhyPanel, ReadConfidenceBoundary, useTierFor } from './chunk-A5XYUD6X.js';
import { Field } from './chunk-B25HJXFB.js';
import { opensInApp, RichTooltip, HoverCard, HoverCardTrigger, HoverCardContent, MiddleEllipsis } from './chunk-U3PKU5BY.js';
import { CopyButton } from './chunk-SPEZAFS3.js';
import { Popover, PopoverTrigger, PopoverContent } from './chunk-BLADNTOL.js';
import { Input } from './chunk-VYHSTPFS.js';
import { Label } from './chunk-676CI6I4.js';
import { Badge, badgeVariants } from './chunk-S775MXMS.js';
import { Button } from './chunk-UDB35RLY.js';
import { cn } from './chunk-FFX3LZW7.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import * as React26 from 'react';
import { FinalityState, chainDisplayName, normalizeTxHash, getExplorerUrl, shortenHash, chainSelectOptions, toCanonicalChainId, CANONICAL_CHAIN_VALUE_KIND, chainDecodeVocabulary, isValidAddress, shortenIdentifier, shortenAddress, normalizeAddress } from '@authe/fe-commons/chains';
import { Star, Layers, FileCode2, RefreshCw, HelpCircle, PackageX, CircleSlash, PinOff, ArrowUpCircle, CheckCircle2, AlertTriangle, ArrowDownLeft, ArrowUpRight, Building2, Globe, Users, Lock, Eye, Database, Plus, Search, Check, StarOff, Undo2, ChevronDown, Play, Pause, X, Loader2, Pin, ArrowLeftRight, RotateCcw, Quote, Trash2, ShieldOff, Scissors, Pencil, ShieldAlert, ExternalLink, Network, Table2, Info, ChevronRight, Copy, PowerOff, Power } from 'lucide-react';
import { addressRowScopeDescription, addressRowScopeLabel, summarizeActivity, ADDRESS_TYPE_LABEL, isVerified, hasRecordedView, isContractLike, isContractType, isBeingMapped, addressColorOf, sourceLabel, approvalLabel, addressTypeFromRoles, showsRecordedValue, severityLabel, lifecycleLabel, membershipRoleLabel, walletDataPaths, mergeWalletNftPages, MEMBERSHIP_ROLE_SUGGESTIONS, membershipRoleSuggestion, ADDRESS_TYPES } from '@authe/fe-commons/addresses';
import { formatRelativeTime, formatTimestamp } from '@authe/fe-commons/time';
import { displayChainText, str, num, safeTicker, chainText, LIVE_MODES, LIVE_MODE_LABELS, allowedLiveMode } from '@authe/fe-commons/display';
import { isWidenableScope, sameScopeOverrides } from '@authe/fe-commons/models';
import { declaredRisk } from '@authe/fe-commons/overlays';
import { tokenCategoryLabel, tokenConfidence, TOKEN_CATEGORY_UNKNOWN_REASON, tokenLogoRef } from '@authe/fe-commons/tokens';
import { scoredConfidence, WRITE_SCOPE_LABEL, WRITE_PATH, WRITE_SCOPE_RUNG, ATTRIBUTION_POLICIES, READ_ONLY_SCOPE_PREFS, SCOPE_HINT_FLAG, effectiveScopes, writeHintState, KIND_LABEL, WRITE_SCOPE_MEANING, RESOLVE_SCOPE_LABEL, attributionLadderGap, writeScopeResources, policyFor, writeScopeLabel, readScopeResources, readScopeRung, resolveScopeLabel, surfaceHintState, subjectKey, pruneToCapability, clearedAttributes, attributionCapability, missingRequired, enforcedWriteOf, isWriteBlocked, enforcedBySentence, BUNDLE_KEY, primaryWriteRung, readHintState, SCOPE_SOURCE_LABEL } from '@authe/fe-commons/attribution';
import { nativeTokenMeta, isUnlimitedAmount, formatTokenAmount, formatTokenDisplay, summarizeSwap, computeNetFlow, aggregateNetUsd, formatUsd, formatShare, formatPercentCell, formatBalanceCell } from '@authe/fe-commons/value';
import { EventCriticality, criticalityLabel } from '@authe/fe-commons/events';
import { missingLegLabel, missingLegReason, sagaLabel } from '@authe/fe-commons/grouping';
import { AWS_REGIONS } from '@authe/fe-commons/region';
import { VERSION_SYNC_LABEL, daysSinceMs, STALE_AFTER_DAYS, APP_CATEGORY_LABEL, AUTHORIZER_LATEST, isStageVariableAlias } from '@authe/fe-commons/release';
import { deriveCatalogOwnership, CATALOG_RESOURCES, DEFAULT_ENTITY_TYPE, entityTypeOptions, CATALOG_LIFECYCLE_LABEL, CATALOG_LIFECYCLES, isEmptyFieldOverrides } from '@authe/fe-commons/catalog';
import { offeredOptions, txScope, rungOffered } from '@authe/fe-commons/tenancy';
import { ENTITLEMENT } from '@authe/fe-commons/plans';
import { ErrorCode, toErrorResponse, errorCodeOf } from '@authe/fe-commons/errors';
import { NOTABLE_CATEGORIES, UNKNOWN_CATEGORIES, ALARMING_CATEGORIES, categoryLabel, ambiguousAssetSymbols, formatAssetAmountWithSymbol, assetSymbol, formatRatio, formatAssetAmount, isNotableRatio, unpricedReason, assertedValue, MAX_ASSERTED_AMOUNTS, isDecimalAmount, newAssertedAmount } from '@authe/fe-commons/funds';
import { randomHex } from '@authe/fe-commons/ids';
import { triggerFieldOptions, flattenCondition, predicate, coerceValue, isUnaryOperator, valueText, operatorsForField, getTriggerField, isListOperator, predicateProblem, TRIGGER_OPERATOR_LABELS, conditionFromPredicates } from '@authe/fe-commons/triggers';
import { stepName, stepsLabel } from '@authe/fe-commons/story';
import { ConfidenceTier, recordedConfidence, formatConfidence, domainLabel, GATE_ACTION_LABELS, domainsToShow, knobsToShow, knobLabel, candidateSection, ownSectionOf, changedKnobs, localProblems, inertOrigins, policyRowGroup, enforcementFor, CUTOFF_LABELS, knobStatus, originOf, CUTOFF_HELP, inertReason, weightRows, weightTableTitle, sectionSettings, knobKind, KNOB_HELP, formatKnobValue, explainKnob, RISK_POINTS_MAX, RISK_POINTS_MIN, describeSetting, floorDomain, actionDomain, authorsNothing, shadowedSettings, policyAtScope, activityWithheld, activitySummary, inheritedValue, settingLabel, offeredGateActions, DOMAIN_HELP, GATE_ACTION_HELP, ACTION_VERBS } from '@authe/fe-commons/evidence';
import { kindOf, displayOf, rawOf, DECODED_ENVELOPE_MARKER, isEnriched } from '@authe/fe-commons/storage';
import { scopeRungLabel, availableOverrideRungs } from '@authe/fe-commons/contracts';
import { resolveNode, fieldKind, fieldLabel, isChainField, originPath, getAt, problemsAt, removedAt, originAt, downstreamAt, removeListValue, restoreListValue, mapValueNode, setAt, unsetAt, identityFields, tableColumns, itemNode, removeEntry, restoreEntry, upsertEntry, resetEntryField, deepestOriginUnder, OVERRIDE_TIERS, overriddenBelow, originCounts, removedUnder, downstreamUnder, problemsUnder, sliceOf, withSlice, problemTextAt, addListValue, downstreamAddedAt } from '@authe/fe-commons/protocol-editor';
import { CLUSTER_OVERRIDE_AUTHORING_SCOPES, CLUSTER_OVERRIDE_SCOPE_RANK, overrideNeedsPeer, CLUSTER_OVERRIDE_ACTION_LABELS, CLUSTER_OVERRIDE_SCOPE_LABELS, STRENGTH_EXPLAINER, STRENGTH_LABEL, linkKindLabel, expandContractLinks, hasContractReferenceDirection, strengthViewOptions, strengthViewMin, filterRelatedAddressView, RELATED_ADDRESS_GRAPH_LIMITS, RELATIONSHIP_CLAIM_LABELS, evidenceLabel, contractObservations, contractPredicateLabel } from '@authe/fe-commons/related-addresses';
import { bannersFor } from '@authe/fe-commons/incidents';
import { TRANSACTION_FLAG_META } from '@authe/fe-commons/spam';
import { validateDraft, withMatchBy, emptySelector, emptyDraft, specToDraft, draftToSpec, requiredSpecFields, validate, scopeOptions, groupBySagaKind, sectionWithRecipeSwitched, parseSpec, draftIsValid, isValid, toUpdateInput, toCreateInput, builtinOverrideDraft, deletionImpact, splitAddresses, emptyPart, flowSummary, recipeCanBeSwitched, standingOf, neverMatchedNote } from '@authe/fe-commons/grouping-rules';

function AddressIdentity({
  address,
  name,
  chain,
  logoUrl,
  color,
  size = "sm",
  children,
  className
}) {
  return /* @__PURE__ */ jsxs("div", { className: cn("flex min-w-0 items-center gap-2", className), children: [
    /* @__PURE__ */ jsx(AddressAvatar, { logoUrl, color, name: name || address, size }),
    /* @__PURE__ */ jsxs("div", { className: "min-w-0", children: [
      /* @__PURE__ */ jsx(
        AddressDisplay,
        {
          presentation: "plain",
          size,
          showAvatar: false,
          showRiskBadge: false,
          address,
          label: name || void 0,
          chain: chain ?? void 0
        }
      ),
      children
    ] })
  ] });
}
function AddressActivityStats({
  activity,
  includeSeen = true,
  className
}) {
  const summary = summarizeActivity(activity);
  return /* @__PURE__ */ jsxs("dl", { className: cn("grid grid-cols-2 gap-x-6 gap-y-2 text-sm sm:grid-cols-4", className), children: [
    /* @__PURE__ */ jsx(Stat, { label: "Chains", value: String(summary.activeChains) }),
    /* @__PURE__ */ jsx(Stat, { label: "Transactions", value: summary.totalTx.toLocaleString() }),
    /* @__PURE__ */ jsx(Stat, { label: "DeFi", value: summary.totalDefi.toLocaleString() }),
    /* @__PURE__ */ jsx(Stat, { label: "NFT", value: summary.totalNft.toLocaleString() }),
    /* @__PURE__ */ jsx(Stat, { label: "Token transfers", value: summary.totalTokenTransfers.toLocaleString() }),
    includeSeen && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(Stat, { label: "First seen", at: summary.firstSeenAt }),
      /* @__PURE__ */ jsx(Stat, { label: "Last seen", at: summary.lastSeenAt })
    ] })
  ] });
}
function Stat({
  label,
  value,
  at
}) {
  const text = at != null && at !== 0 ? formatRelativeTime(at) : value ?? "\u2014";
  const title = at != null && at !== 0 ? formatTimestamp(at) : void 0;
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("dt", { className: "text-xs text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx("dd", { className: "font-medium text-foreground", title, children: text })
  ] });
}
function AddressDomainBadge({ name, className }) {
  const shown = displayChainText(name, { maxChars: 48 });
  if (!shown.text) return null;
  return /* @__PURE__ */ jsx(
    Badge,
    {
      variant: "outline",
      className: cn("max-w-[16rem] truncate font-medium", className),
      title: shown.title,
      children: shown.text
    }
  );
}
function AddressHeaderCard({
  address,
  name,
  chain,
  chains,
  activity,
  worstRisk,
  domainName,
  entities = [],
  renderEntityLink,
  color,
  logoUrl,
  actions,
  className
}) {
  return /* @__PURE__ */ jsx(Card, { className, children: /* @__PURE__ */ jsxs(CardContent, { className: "space-y-4 pt-6", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center justify-between gap-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
        /* @__PURE__ */ jsx(AddressAvatar, { logoUrl, color, name: name ?? address, size: "md" }),
        /* @__PURE__ */ jsx(
          AddressDisplay,
          {
            presentation: "plain",
            size: "md",
            showAvatar: false,
            showRiskBadge: false,
            address,
            label: name,
            chain,
            showExplorerIcon: true
          }
        ),
        /* @__PURE__ */ jsx(AddressDomainBadge, { name: domainName ?? null })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        worstRisk && /* @__PURE__ */ jsx(RiskBadge, { level: worstRisk }),
        actions
      ] })
    ] }),
    chains.length > 0 && /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
      /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "Appears on" }),
      chains.map(({ chain: c, primary }) => /* @__PURE__ */ jsxs(
        "span",
        {
          className: "inline-flex items-center gap-1 rounded-full border border-border bg-muted/40 px-2 py-0.5 text-xs",
          title: primary ? `${chainDisplayName(c)} \u2014 primary chain` : chainDisplayName(c),
          children: [
            /* @__PURE__ */ jsx(ChainAvatar, { chain: c, size: "sm", showName: false }),
            /* @__PURE__ */ jsx("span", { children: chainDisplayName(c) }),
            primary && /* @__PURE__ */ jsx(Star, { className: "h-3 w-3 fill-current text-amber-500", "aria-hidden": true })
          ]
        },
        c
      ))
    ] }),
    /* @__PURE__ */ jsx(AddressActivityStats, { activity }),
    entities.length > 0 && /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2 border-t border-border pt-3", children: [
      /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "Belongs to" }),
      entities.map((entity) => {
        const chip = /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1 rounded-full border border-border px-2 py-0.5 text-xs hover:bg-accent", children: [
          /* @__PURE__ */ jsx(Star, { className: "h-3 w-3 fill-current text-amber-500", "aria-hidden": true }),
          entity.label
        ] });
        return /* @__PURE__ */ jsx(React26.Fragment, { children: renderEntityLink ? renderEntityLink(entity, chip) : chip }, entity.id);
      })
    ] })
  ] }) });
}
function AddressChainSwitcher({
  chains,
  selected,
  onSelect,
  allowAllChains = true,
  className
}) {
  return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-wrap gap-2", className), role: "group", "aria-label": "Chain", children: [
    allowAllChains && /* @__PURE__ */ jsxs(
      SwitcherButton,
      {
        active: selected === null,
        onClick: () => onSelect(null),
        label: `All chains (${chains.length})`,
        title: "Compare every chain this address appears on",
        children: [
          /* @__PURE__ */ jsx(Layers, { className: "h-3.5 w-3.5" }),
          /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: "All chains" })
        ]
      }
    ),
    chains.map((entry) => {
      const name = chainDisplayName(entry.chain);
      const notes = [
        entry.primary ? "primary chain" : null,
        entry.contract ? "contract" : null,
        entry.catalogued === false ? "not verified yet" : null
      ].filter(Boolean);
      return /* @__PURE__ */ jsxs(
        SwitcherButton,
        {
          active: entry.chain === selected,
          onClick: () => onSelect(entry.chain),
          label: notes.length > 0 ? `${name} \u2014 ${notes.join(", ")}` : name,
          title: notes.length > 0 ? `${name} \u2014 ${notes.join(", ")}` : name,
          children: [
            /* @__PURE__ */ jsx(ChainAvatar, { chain: entry.chain, size: "sm", showName: false }),
            /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: name }),
            entry.primary && /* @__PURE__ */ jsx(Star, { className: "h-3 w-3 fill-current text-amber-500", "aria-hidden": true }),
            entry.contract && /* @__PURE__ */ jsx(FileCode2, { className: "h-3 w-3 opacity-70", "aria-hidden": true }),
            entry.catalogued === false && /* @__PURE__ */ jsx("span", { className: "h-1.5 w-1.5 rounded-full bg-muted-foreground/50", "aria-hidden": true })
          ]
        },
        entry.chain
      );
    })
  ] });
}
function SwitcherButton({
  active,
  onClick,
  label,
  title,
  children
}) {
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      onClick,
      "aria-pressed": active,
      "aria-label": label,
      title,
      className: cn(
        "inline-flex items-center gap-2 rounded-lg border px-3 py-1.5 transition-colors",
        active ? "border-primary bg-primary/10 text-foreground" : "border-border text-muted-foreground hover:bg-accent"
      ),
      children
    }
  );
}
function buildScopeChoices(otherScopes, activeScope, copy) {
  const choices = [
    {
      key: "own",
      label: copy.ownLabel,
      description: copy.ownDescription,
      count: 1,
      active: activeScope == null,
      selectable: true,
      scope: null
    }
  ];
  for (const option of otherScopes) {
    const selectable = isWidenableScope(option);
    choices.push({
      key: option.scope,
      label: copy.scopeLabel(option.scope),
      description: copy.scopeDescription(option.scope),
      count: option.count,
      active: selectable && activeScope != null && sameScopeOverrides(activeScope.overrides, option.overrides),
      selectable,
      scope: option
    });
  }
  return choices;
}
function ScopeSwitcher({
  otherScopes,
  activeScope = null,
  onSelect,
  busy = false,
  className,
  copy
}) {
  const choices = buildScopeChoices(otherScopes, activeScope, copy);
  if (choices.length <= 1) return null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn("flex flex-wrap items-center gap-1.5", className),
      role: "group",
      "aria-label": copy.ariaLabel,
      children: [
        /* @__PURE__ */ jsx("span", { className: "mr-0.5 text-xs font-medium text-muted-foreground", children: copy.prefixLabel ?? "Scope" }),
        choices.map(
          (choice) => choice.selectable ? /* @__PURE__ */ jsxs(
            Button,
            {
              type: "button",
              size: "sm",
              variant: choice.active ? "secondary" : "outline",
              "aria-pressed": choice.active,
              disabled: busy,
              title: choice.description,
              onClick: () => onSelect(choice.scope),
              children: [
                choice.label,
                choice.count > 1 ? /* @__PURE__ */ jsxs("span", { className: "ml-1 opacity-70", children: [
                  "\xD7",
                  choice.count
                ] }) : null
              ]
            },
            choice.key
          ) : /* @__PURE__ */ jsxs(
            Badge,
            {
              variant: "outline",
              title: choice.description,
              className: "cursor-default font-normal text-muted-foreground",
              children: [
                choice.label,
                choice.count > 0 ? /* @__PURE__ */ jsxs("span", { className: "ml-1 opacity-70", children: [
                  "\xD7",
                  choice.count
                ] }) : null
              ]
            },
            choice.key
          )
        )
      ]
    }
  );
}
var OWN_LABEL = "Your view";
var OWN_DESCRIPTION = "Your own view (your private overrides on top of the shared tiers).";
var ADDRESS_SCOPE_COPY = {
  ownLabel: OWN_LABEL,
  ownDescription: OWN_DESCRIPTION,
  scopeLabel: addressRowScopeLabel,
  scopeDescription: addressRowScopeDescription,
  ariaLabel: "View this address at another scope"
};
function buildAddressScopeChoices(otherScopes, activeScope, ownLabel = OWN_LABEL) {
  return buildScopeChoices(otherScopes, activeScope, { ...ADDRESS_SCOPE_COPY, ownLabel });
}
function AddressScopeSwitcher({
  otherScopes,
  activeScope = null,
  onSelect,
  busy = false,
  className
}) {
  return /* @__PURE__ */ jsx(
    ScopeSwitcher,
    {
      otherScopes,
      activeScope,
      onSelect,
      busy,
      className,
      copy: ADDRESS_SCOPE_COPY
    }
  );
}
var TONE = {
  contract: "text-sky-700 dark:text-sky-400 border-sky-500/30",
  token: "text-violet-700 dark:text-violet-400 border-violet-500/30",
  nft: "text-pink-700 dark:text-pink-400 border-pink-500/30",
  exchange: "text-amber-700 dark:text-amber-400 border-amber-500/30",
  dex: "text-amber-700 dark:text-amber-400 border-amber-500/30",
  dex_pool: "text-amber-700 dark:text-amber-400 border-amber-500/30",
  // Shared infrastructure a cluster must never merge on — the two types that
  // exist *because* getting them wrong is expensive. Tinted like a warning
  // rather than like a venue so they don't read as ordinary DeFi plumbing.
  mixer: "text-red-700 dark:text-red-400 border-red-500/30",
  distributor: "text-red-700 dark:text-red-400 border-red-500/30",
  proxy: "text-orange-700 dark:text-orange-400 border-orange-500/30"
};
function titleCase(value) {
  return value.split(/[_\s]+/).map((w) => w ? w.charAt(0).toUpperCase() + w.slice(1) : w).join(" ");
}
function AddressTypeBadge({
  type,
  className,
  title
}) {
  const key = type ?? "unknown";
  const label = ADDRESS_TYPE_LABEL[key] ?? titleCase(String(type ?? "unknown"));
  return /* @__PURE__ */ jsx(
    Badge,
    {
      variant: "outline",
      className: cn("border text-[11px]", TONE[key], className),
      ...title ? { title } : {},
      children: label
    }
  );
}
function PrimaryChainBadge({
  primary,
  showWhenFalse = false,
  className
}) {
  if (!primary) {
    if (!showWhenFalse) return null;
    return /* @__PURE__ */ jsx(Badge, { variant: "outline", className: cn("text-[11px] text-muted-foreground", className), children: "Secondary" });
  }
  return /* @__PURE__ */ jsxs(
    Badge,
    {
      variant: "outline",
      className: cn(
        "gap-1 border-amber-500/40 text-[11px] text-amber-700 dark:text-amber-400",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(Star, { className: "h-3 w-3 fill-current" }),
        "Primary chain"
      ]
    }
  );
}
function AddressChainComparison({
  rows,
  onSelectChain,
  className
}) {
  if (rows.length === 0) {
    return /* @__PURE__ */ jsx("p", { className: cn("text-sm text-muted-foreground", className), children: "No chains to compare for this address yet." });
  }
  return /* @__PURE__ */ jsx("div", { className: cn("overflow-x-auto", className), children: /* @__PURE__ */ jsxs(Table, { className: "w-full text-sm", children: [
    /* @__PURE__ */ jsx(TableHeader, { children: /* @__PURE__ */ jsxs(TableRow, { className: "border-b text-left text-xs uppercase tracking-wide text-muted-foreground", children: [
      /* @__PURE__ */ jsx(TableHead, { scope: "col", className: "py-2 pr-4 font-medium", children: "Chain" }),
      /* @__PURE__ */ jsx(TableHead, { scope: "col", className: "py-2 pr-4 font-medium", children: "Type" }),
      /* @__PURE__ */ jsx(TableHead, { scope: "col", className: "py-2 pr-4 font-medium", children: "Risk" }),
      /* @__PURE__ */ jsx(TableHead, { scope: "col", className: "py-2 pr-4 font-medium", children: "Name" }),
      /* @__PURE__ */ jsx(TableHead, { scope: "col", className: "py-2 pr-4 text-right font-medium", children: "Transactions" }),
      /* @__PURE__ */ jsx(TableHead, { scope: "col", className: "py-2 font-medium", children: "Note" })
    ] }) }),
    /* @__PURE__ */ jsx(TableBody, { className: "divide-y", children: rows.map(({ chain, row, txCount, txCountNote }) => {
      const verified = isVerified(row);
      const recorded = hasRecordedView(row);
      const risk = recorded ? declaredRisk(row?.risk_level) : void 0;
      const interactive = Boolean(onSelectChain);
      return /* @__PURE__ */ jsxs(
        TableRow,
        {
          className: cn(interactive && "cursor-pointer hover:bg-accent/50"),
          ...interactive ? {
            onClick: () => onSelectChain?.(chain),
            tabIndex: 0,
            role: "button",
            "aria-label": `View ${chainDisplayName(chain)} in detail`,
            onKeyDown: (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onSelectChain?.(chain);
              }
            }
          } : {},
          children: [
            /* @__PURE__ */ jsx(TableCell, { className: "py-2 pr-4", children: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
              /* @__PURE__ */ jsx(ChainAvatar, { chain, size: "sm", showName: false }),
              /* @__PURE__ */ jsx("span", { className: "font-medium", children: chainDisplayName(chain) }),
              /* @__PURE__ */ jsx(PrimaryChainBadge, { primary: row?.is_primary_chain })
            ] }) }),
            /* @__PURE__ */ jsx(TableCell, { className: "py-2 pr-4", children: recorded && row ? /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1.5", children: [
              /* @__PURE__ */ jsx(AddressTypeBadge, { type: row.address_type }),
              isContractLike(row) && !isContractType(row.address_type) && /* @__PURE__ */ jsx("span", { className: "text-[11px] text-muted-foreground", children: "contract" })
            ] }) : /* @__PURE__ */ jsx(Muted, { children: "\u2014" }) }),
            /* @__PURE__ */ jsx(TableCell, { className: "py-2 pr-4", children: risk ? /* @__PURE__ */ jsx(RiskBadge, { level: risk }) : recorded ? /* @__PURE__ */ jsx(Muted, { children: "Unassessed" }) : /* @__PURE__ */ jsx(Muted, { children: "\u2014" }) }),
            /* @__PURE__ */ jsx(TableCell, { className: "py-2 pr-4", children: recorded && row?.name || /* @__PURE__ */ jsx(Muted, { children: "\u2014" }) }),
            /* @__PURE__ */ jsx(TableCell, { className: "py-2 pr-4 text-right tabular-nums", children: txCount == null ? /* @__PURE__ */ jsx(Muted, { title: txCountNote, children: "\u2014" }) : txCount.toLocaleString() }),
            /* @__PURE__ */ jsx(TableCell, { className: "py-2 text-xs text-muted-foreground", children: verified ? /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
              row?.notes,
              row?.lifecycle !== "verified" && /* @__PURE__ */ jsx(LifecycleBadge, { lifecycle: row?.lifecycle })
            ] }) : noteForUnverified(row, recorded) })
          ]
        },
        chain
      );
    }) })
  ] }) });
}
function Muted({
  children,
  title
}) {
  return /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", title, children });
}
function noteForUnverified(row, recorded) {
  const queued = isBeingMapped(row);
  if (recorded) {
    return queued ? "Recorded for you \u2014 queued for verification" : "Recorded for you \u2014 not verified yet";
  }
  return queued ? "Active on-chain \u2014 queued for verification" : "Active on-chain, not verified yet";
}
function AddressAttributesGrid({
  row,
  chain,
  roles,
  subjectiveScopeLabel,
  subjectiveAnnotated = false,
  logoUrl,
  className
}) {
  const risk = declaredRisk(row.risk_level);
  const color = addressColorOf(row);
  const deployer = str(row.deployer);
  const deployedAt = num(row.deployed_at);
  const source = sourceLabel(row.source);
  const approval = approvalLabel(row.is_human_approved);
  const notes = str(row.notes);
  const aliases = row.aliases ?? [];
  const storedType = str(row.address_type);
  const derived = React26.useMemo(() => {
    const found = addressTypeFromRoles(roles);
    return found && found.type !== storedType ? found : void 0;
  }, [roles, storedType]);
  const contractIsNews = isContractLike(row) && !isContractType(storedType);
  const shows = React26.useCallback(
    (field) => showsRecordedValue(row, field, subjectiveAnnotated),
    [row, subjectiveAnnotated]
  );
  const showType = shows("address_type");
  const showRisk = shows("risk_level");
  const showSeverity = shows("severity");
  const showPrimaryChain = shows("is_primary_chain");
  const showConfidence = row.confidence != null && Number(row.confidence) < 1;
  const classified = showType || showRisk || showSeverity || showPrimaryChain || Boolean(derived) || contractIsNews || Boolean(str(row.name)) || Boolean(notes) || aliases.length > 0 || Boolean(logoUrl || color);
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-4", className), children: [
    /* @__PURE__ */ jsxs(
      Section,
      {
        title: "Classification",
        hint: subjectiveScopeLabel ? subjectiveAnnotated ? `As recorded for ${subjectiveScopeLabel} \u2014 other tenancy tiers may classify this differently.` : `The shared record \u2014 nothing has been recorded for ${subjectiveScopeLabel}.` : void 0,
        children: [
          !classified && // Said once, rather than as a grid of defaults. The alternative is
          // four rows that each look like a judgement and together say nothing.
          /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Nothing has been classified for this address yet \u2014 no type, risk or severity has been recorded." }),
          (showType || derived || contractIsNews) && /* @__PURE__ */ jsx(Attr, { label: "Type", children: /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-wrap items-center gap-1.5", children: [
            /* @__PURE__ */ jsx(AddressTypeBadge, { type: row.address_type }),
            derived && /* @__PURE__ */ jsx(
              AddressTypeBadge,
              {
                type: derived.type,
                className: "border-dashed",
                title: `Not recorded on this row \u2014 read from its \u201C${derived.role}\u201D membership, which is where pool discovery writes it. The shared record still classifies it as ${ADDRESS_TYPE_LABEL[storedType] ?? storedType ?? "unknown"}.`
              }
            ),
            contractIsNews && /* @__PURE__ */ jsx(Badge, { variant: "secondary", className: "font-normal", title: "Has code on-chain.", children: "contract" })
          ] }) }),
          showRisk && /* @__PURE__ */ jsx(Attr, { label: "Risk", children: risk ? /* @__PURE__ */ jsx(RiskBadge, { level: risk }) : (
            // The same three-state wording the list cell uses. A dash would
            // read as "no data reached us", which is a different fact from
            // "the read arrived and nobody had assessed this".
            /* @__PURE__ */ jsx(
              "span",
              {
                className: "text-xs text-muted-foreground",
                title: "Nobody has recorded a risk level for this address, and no catalog overlay carries one.",
                children: "Unassessed"
              }
            )
          ) }),
          str(row.name) && /* @__PURE__ */ jsx(Attr, { label: "Name", children: row.name }),
          notes && /* @__PURE__ */ jsx(Attr, { label: "Note", children: /* @__PURE__ */ jsx("span", { className: "whitespace-pre-wrap", children: notes }) }),
          showSeverity && str(row.severity) && /* @__PURE__ */ jsx(Attr, { label: "Severity", children: severityLabel(row.severity) }),
          showPrimaryChain && /* "Chain role", not "Primary chain": the badge answers with either
             "Primary chain" or "Secondary", so labelling the ROW with one of
             the two answers made it read "Primary chain: Secondary" on every
             address whose primary chain is a different one — a label and a
             value contradicting each other, two rows under Risk. A label is the
             question; the badge is the answer. */
          /* @__PURE__ */ jsx(Attr, { label: "Chain role", children: /* @__PURE__ */ jsx(PrimaryChainBadge, { primary: row.is_primary_chain, showWhenFalse: true }) }),
          aliases.length > 0 && /* @__PURE__ */ jsx(Attr, { label: "Also known as", children: aliases.join(", ") }),
          (logoUrl || color) && /* @__PURE__ */ jsx(Attr, { label: "Logo", children: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
            /* @__PURE__ */ jsx(AddressAvatar, { logoUrl, color, name: str(row.name) }),
            /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: logoUrl ? `Set for ${chainDisplayName(chain)}` : "Colour only" })
          ] }) })
        ]
      }
    ),
    (deployer || deployedAt) && /* @__PURE__ */ jsxs(Section, { title: "On-chain facts", hint: "The same for everyone \u2014 read from the chain.", children: [
      deployer && /* @__PURE__ */ jsx(Attr, { label: "Deployed by", children: /* @__PURE__ */ jsx(AddressDisplay, { address: deployer, chain }) }),
      deployedAt ? /* @__PURE__ */ jsx(Attr, { label: "Deployed", children: /* @__PURE__ */ jsx("span", { title: formatTimestamp(deployedAt), children: formatRelativeTime(deployedAt) }) }) : null
    ] }),
    (str(row.lifecycle) || source || approval) && /* @__PURE__ */ jsxs(
      Section,
      {
        title: "How this was recorded",
        hint: "The platform's own record of this row \u2014 not something the chain says.",
        children: [
          str(row.lifecycle) && /* @__PURE__ */ jsx(Attr, { label: "Catalog state", children: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
            /* @__PURE__ */ jsx(LifecycleBadge, { lifecycle: row.lifecycle }),
            /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: lifecycleLabel(row.lifecycle) })
          ] }) }),
          source && /* @__PURE__ */ jsx(Attr, { label: "Recorded by", children: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
            source,
            showConfidence && /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
              Math.round(Number(row.confidence) * 100),
              "% confidence"
            ] })
          ] }) }),
          approval && /* @__PURE__ */ jsx(Attr, { label: "Approval", children: approval })
        ]
      }
    )
  ] });
}
function Section({
  title,
  hint,
  children
}) {
  return /* @__PURE__ */ jsxs("section", { children: [
    /* @__PURE__ */ jsx("h4", { className: "text-xs font-medium uppercase tracking-wide text-muted-foreground", children: title }),
    hint && /* @__PURE__ */ jsx("p", { className: "mt-0.5 text-[11px] text-muted-foreground", children: hint }),
    /* @__PURE__ */ jsx("dl", { className: "mt-2 grid grid-cols-[9rem_minmax(0,1fr)] items-center gap-x-4 gap-y-2.5 text-sm", children })
  ] });
}
function Attr({ label, children }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("dt", { className: "text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx("dd", { className: "text-foreground", children })
  ] });
}
var COUNTED = /* @__PURE__ */ new Set(["erc721", "erc1155", "nft"]);
function TokenDefinitionGrid({
  token,
  standard,
  logoUrl,
  className
}) {
  const facts = token.facts;
  const ticker = safeTicker(token.symbol);
  const name = chainText(token.name, { maxChars: 80 });
  const category = tokenCategoryLabel(facts?.category);
  const providerLabels = (facts?.providerCategories ?? []).map((label) => chainText(label, { maxChars: 40 }).text).filter(Boolean);
  const confidence = facts ? tokenConfidence(facts) : void 0;
  const approval = approvalLabel(facts?.isHumanApproved);
  const sources = facts?.sources ?? [];
  const counted = COUNTED.has(standard.kind);
  const evidence = facts?.evidence ?? [];
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-4", className), children: [
    /* @__PURE__ */ jsxs(Section2, { title: "Token", children: [
      /* @__PURE__ */ jsxs(Attr2, { label: "Standard", children: [
        /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-wrap items-center gap-x-2 gap-y-1", children: [
          /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "font-normal", children: standard.label }),
          /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: standard.basisText })
        ] }),
        standard.storedDisagrees && /* @__PURE__ */ jsx("span", { className: "mt-1 block text-xs text-muted-foreground", children: standard.storedDisagrees })
      ] }),
      /* @__PURE__ */ jsxs(Attr2, { label: "Category", children: [
        category ? /* @__PURE__ */ jsx("span", { children: category }) : /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: TOKEN_CATEGORY_UNKNOWN_REASON }),
        providerLabels.length > 0 && /* @__PURE__ */ jsxs(
          "span",
          {
            className: "mt-1 block text-xs text-muted-foreground",
            title: "Free-form labels a data provider attached. They are not the token's classified role.",
            children: [
              "Provider labels: ",
              providerLabels.join(", ")
            ]
          }
        )
      ] }),
      /* @__PURE__ */ jsxs(Attr2, { label: "Symbol", children: [
        ticker.text ? /* @__PURE__ */ jsx("span", { title: ticker.title, children: ticker.text }) : /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "Not recorded on the definition." }),
        token.impersonates && /* @__PURE__ */ jsx(CounterfeitMark, { claim: token.impersonates, className: "ml-2" })
      ] }),
      name.text && /* @__PURE__ */ jsx(Attr2, { label: "Name", children: /* @__PURE__ */ jsx("span", { title: name.title, children: name.text }) }),
      /* @__PURE__ */ jsx(Attr2, { label: "Decimals", children: token.decimals != null ? /* @__PURE__ */ jsx("span", { className: "tabular-nums", children: token.decimals }) : /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: counted ? "None \u2014 an NFT is counted, not divided." : "Not recorded \u2014 amounts in this token cannot be scaled and are shown raw." }) }),
      /* @__PURE__ */ jsx(Attr2, { label: "Logo", children: /* @__PURE__ */ jsx(TokenLogo, { logoUri: facts?.logoUri, logoUrl, name: ticker.text || name.text }) }),
      token.isSpam && /* @__PURE__ */ jsx(Attr2, { label: "Spam", children: /* @__PURE__ */ jsx("span", { className: "text-xs text-risk-medium", children: "A data provider flags this token as possible spam." }) })
    ] }),
    /* @__PURE__ */ jsxs(
      Section2,
      {
        title: "How this was recorded",
        hint: "The platform's own record of this token \u2014 not something the chain says.",
        children: [
          /* @__PURE__ */ jsx(Attr2, { label: "Catalog state", children: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
            /* @__PURE__ */ jsx(LifecycleBadge, { lifecycle: facts?.lifecycle }),
            lifecycleLabel(facts?.lifecycle ?? "candidate").toLowerCase() !== (facts?.lifecycle ?? "candidate") && /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: lifecycleLabel(facts?.lifecycle ?? "candidate") })
          ] }) }),
          /* @__PURE__ */ jsx(Attr2, { label: "Confidence", children: confidence?.scored ? /* @__PURE__ */ jsxs("span", { className: "tabular-nums", children: [
            confidence.percent,
            "%"
          ] }) : /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: confidence?.reason ?? "Not scored \u2014 the definition carries no confidence." }) }),
          sources.length > 0 && /* @__PURE__ */ jsx(Attr2, { label: "Recorded by", children: sources.map((source, index) => /* @__PURE__ */ jsxs(React26.Fragment, { children: [
            index > 0 && ", ",
            /* @__PURE__ */ jsx(SourceName, { value: source })
          ] }, `${source}:${index}`)) }),
          approval && /* @__PURE__ */ jsx(Attr2, { label: "Approval", children: approval }),
          facts?.isVerified && /* @__PURE__ */ jsx(Attr2, { label: "Source code", children: /* @__PURE__ */ jsx(
            "span",
            {
              title: "Source verification says the contract's code is published. A counterfeit token can be verified too.",
              children: "Verified by a data provider"
            }
          ) }),
          facts?.securityScore != null && /* @__PURE__ */ jsxs(Attr2, { label: "Security score", children: [
            /* @__PURE__ */ jsxs("span", { className: "tabular-nums", children: [
              facts.securityScore,
              " / 100"
            ] }),
            /* @__PURE__ */ jsx("span", { className: "ml-2 text-xs text-muted-foreground", children: "the provider\u2019s score, not ours" })
          ] }),
          facts?.lastVerifiedAt ? /* @__PURE__ */ jsx(Attr2, { label: "Last verified", children: /* @__PURE__ */ jsx("span", { title: formatTimestamp(facts.lastVerifiedAt), children: formatRelativeTime(facts.lastVerifiedAt) }) }) : null
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      Section2,
      {
        title: "Evidence",
        hint: "Each source that asserted this definition, with its own confidence.",
        note: evidence.length > 0 ? void 0 : sources.length > 0 ? `No per-source evidence is stored for this definition. It names ${sources.length === 1 ? "its source" : `${sources.length} sources`} above, but not what each one asserted or how sure it was.` : "No per-source evidence is stored for this definition, and it does not name who wrote it.",
        children: evidence.map((item, index) => /* @__PURE__ */ jsx(EvidenceRow, { evidence: item }, index))
      }
    )
  ] });
}
function TokenLogo({
  logoUri,
  logoUrl,
  name
}) {
  const ref = tokenLogoRef(logoUri);
  const img = useSignedCdnImage(logoUrl);
  const [failed, setFailed] = React26.useState(null);
  if (failed !== null && failed === logoUrl) {
    return /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
      "A logo is stored, but it could not be loaded from ",
      hostOf(logoUrl) ?? "its source",
      "."
    ] });
  }
  if (logoUrl && img.src) {
    return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(
        "img",
        {
          src: img.src,
          ...img.crossOrigin ? { crossOrigin: img.crossOrigin } : {},
          alt: name ? `${name} logo` : "Token logo",
          className: "h-7 w-7 shrink-0 rounded-md border border-border object-cover",
          onError: () => setFailed(logoUrl)
        }
      ),
      ref?.kind === "url" && /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
        "from ",
        hostOf(ref.url) ?? "an external source"
      ] })
    ] });
  }
  let reason = "No logo is stored for this token.";
  if (ref?.kind === "unrenderable") reason = `A logo is stored as \u201C${ref.stored}\u201D, which this page cannot display.`;
  else if (ref?.kind === "key") reason = "A logo is stored in the asset bucket, but this app has no CDN configured to show it.";
  return /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: reason });
}
function hostOf(url) {
  if (!url) return void 0;
  try {
    return new URL(url).host || void 0;
  } catch {
    return void 0;
  }
}
var looksLikeUserId = (value) => /^[a-z0-9-]+\|./i.test(value);
function SourceName({ value, kind }) {
  const person = kind === "user" || value !== void 0 && looksLikeUserId(value);
  const known = useActorNameIfKnown(person ? value : null);
  if (person) {
    return /* @__PURE__ */ jsx("span", { title: value ? `User ID: ${value}` : void 0, children: known ?? "A person" });
  }
  if (value) return /* @__PURE__ */ jsx(Fragment, { children: sourceLabel(value) ?? value });
  return /* @__PURE__ */ jsx(Fragment, { children: sourceLabel(kind) ?? "Unnamed source" });
}
function EvidenceRow({ evidence }) {
  const who = /* @__PURE__ */ jsx(SourceName, { value: evidence.sourceId, kind: evidence.sourceKind });
  const reasons = [...evidence.reasons, ...evidence.signals.map((signal) => `signal: ${signal}`)];
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("dt", { className: "text-muted-foreground", children: evidence.url ? /* @__PURE__ */ jsx("a", { href: evidence.url, target: "_blank", rel: "noreferrer noopener", className: "underline underline-offset-2", children: who }) : who }),
    /* @__PURE__ */ jsxs("dd", { className: "text-foreground", children: [
      /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-wrap items-center gap-x-2", children: [
        evidence.confidence !== void 0 ? /* @__PURE__ */ jsxs("span", { className: "tabular-nums", children: [
          Math.round(evidence.confidence * 100),
          "%"
        ] }) : /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "no confidence given" }),
        evidence.assertedAt ? /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", title: formatTimestamp(evidence.assertedAt), children: formatRelativeTime(evidence.assertedAt) }) : null
      ] }),
      reasons.length > 0 && /* @__PURE__ */ jsx("span", { className: "block text-xs text-muted-foreground", children: reasons.join(" \xB7 ") })
    ] })
  ] });
}
function Section2({
  title,
  hint,
  note,
  children
}) {
  return /* @__PURE__ */ jsxs("section", { children: [
    /* @__PURE__ */ jsx("h4", { className: "text-xs font-medium uppercase tracking-wide text-muted-foreground", children: title }),
    hint && /* @__PURE__ */ jsx("p", { className: "mt-0.5 text-[11px] text-muted-foreground", children: hint }),
    note ? /* @__PURE__ */ jsx("p", { className: "mt-2 text-xs text-muted-foreground", children: note }) : /* @__PURE__ */ jsx("dl", { className: "mt-2 grid grid-cols-[9rem_minmax(0,1fr)] items-center gap-x-4 gap-y-2.5 text-sm", children })
  ] });
}
function Attr2({ label, children }) {
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("dt", { className: "text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx("dd", { className: "min-w-0 text-foreground", children })
  ] });
}
function EntityMembershipCard({
  chain,
  membership,
  loading,
  error,
  promotable = [],
  busy,
  failed,
  onSetPrimary,
  onRemove,
  onPromote,
  renderEntityLink,
  picker,
  roleField,
  footnote,
  className
}) {
  const chainName2 = chainDisplayName(chain);
  const shownConfidence = scoredConfidence(membership?.confidence, membership ?? void 0);
  return /* @__PURE__ */ jsxs(Card, { className: cn("lg:col-span-2", className), children: [
    /* @__PURE__ */ jsx(CardHeader, { children: /* @__PURE__ */ jsxs(CardTitle, { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(ChainAvatar, { chain, size: "sm", showName: false }),
      "Entity membership on ",
      chainName2
    ] }) }),
    /* @__PURE__ */ jsx(CardContent, { className: "space-y-3", children: loading ? /* @__PURE__ */ jsx(Skeleton, { className: "h-9 w-full" }) : error ? /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: "Entity mapping is unavailable here (it may require elevated permissions)." }) : /* @__PURE__ */ jsxs(Fragment, { children: [
      membership ? /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2 text-sm", children: [
        /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "Owned by" }),
        renderEntityLink ? renderEntityLink(
          membership.entity,
          /* @__PURE__ */ jsx("span", { className: "font-medium hover:underline", children: membership.entity.label })
        ) : /* @__PURE__ */ jsx("span", { className: "font-medium", children: membership.entity.label }),
        membership.role && /* @__PURE__ */ jsx(Badge, { variant: "secondary", className: "font-normal", children: membershipRoleLabel(membership.role) }),
        shownConfidence !== void 0 && /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
          Math.round(shownConfidence * 100),
          "% confidence"
        ] }),
        membership.isHumanApproved && /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "font-normal", children: approvalLabel(true) }),
        /* @__PURE__ */ jsxs("div", { className: "ml-auto flex items-center gap-2", children: [
          onSetPrimary && /* @__PURE__ */ jsxs(
            Button,
            {
              size: "sm",
              variant: "outline",
              disabled: busy,
              onClick: () => onSetPrimary(membership.entity.id),
              title: `Make this the entity's main address on ${chainName2}`,
              children: [
                /* @__PURE__ */ jsx(Star, { className: "mr-1 h-3.5 w-3.5" }),
                "Set as main address"
              ]
            }
          ),
          onRemove && /* @__PURE__ */ jsx(
            Button,
            {
              size: "sm",
              variant: "ghost",
              disabled: busy,
              onClick: () => onRemove(membership.entity.id),
              children: "Remove"
            }
          )
        ] })
      ] }) : /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
        /* @__PURE__ */ jsxs("p", { className: "text-sm text-muted-foreground", children: [
          "This address isn't mapped to an entity on ",
          chainName2,
          " yet."
        ] }),
        promotable.map((entity) => /* @__PURE__ */ jsxs(
          "div",
          {
            className: "flex flex-wrap items-center gap-2 rounded-md border border-dashed px-3 py-2 text-sm",
            children: [
              /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "Attributed to" }),
              /* @__PURE__ */ jsx("span", { className: "font-medium", children: entity.label }),
              /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "by a catalog overlay \u2014 a display claim, not a membership." }),
              onPromote && /* @__PURE__ */ jsx(
                Button,
                {
                  size: "sm",
                  variant: "outline",
                  className: "ml-auto",
                  disabled: busy,
                  title: `Map this address to ${entity.label} on ${chainName2}`,
                  onClick: () => onPromote(entity.id),
                  children: "Promote to membership"
                }
              )
            ]
          },
          entity.id
        ))
      ] }),
      footnote,
      (picker || roleField) && /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2 border-t pt-3", children: [
        /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: membership ? "Change entity" : "Map to entity" }),
        roleField,
        picker
      ] }),
      failed && /* @__PURE__ */ jsx("p", { className: "text-xs text-destructive", children: "Failed to update the mapping." })
    ] }) })
  ] });
}
function HashDisplay({
  hash,
  chain,
  type = "tx",
  copyable = true,
  href,
  showExplorerIcon = false,
  className,
  monospace = true,
  canonicalTxId,
  internalHref,
  showInternalIcon = false,
  internalNewTab = false,
  onDrilldown,
  tooltipRows,
  tooltipHeaderRight,
  richTooltip
}) {
  const normalized = normalizeTxHash(hash, chain);
  const handleCopy = React26.useCallback(
    (e) => {
      e.preventDefault();
      e.clipboardData.setData("text/plain", normalized);
    },
    [normalized]
  );
  const link = href ?? (chain ? getExplorerUrl(normalized, chain, type) : null) ?? void 0;
  const target = React26.useMemo(
    () => ({ kind: "transaction", id: canonicalTxId ?? normalized, chain, label: shortenHash(normalized) }),
    [canonicalTxId, normalized, chain]
  );
  const handleInternalClick = React26.useCallback(
    (e) => {
      if (!opensInApp(e)) return;
      if (!onDrilldown) return;
      e.preventDefault();
      e.stopPropagation();
      onDrilldown(target);
    },
    [onDrilldown, target]
  );
  const text = /* @__PURE__ */ jsx(MiddleEllipsis, { value: normalized, kind: "hash", monospace, title: normalized });
  let value;
  if (internalHref) {
    value = /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 max-w-full items-center gap-1", children: [
      /* @__PURE__ */ jsxs(
        "a",
        {
          href: internalHref,
          target: internalNewTab ? "_blank" : void 0,
          rel: internalNewTab ? "noreferrer noopener" : void 0,
          onClick: internalNewTab ? (e) => e.stopPropagation() : handleInternalClick,
          className: "inline-flex items-center gap-1 hover:underline",
          children: [
            text,
            showInternalIcon && /* @__PURE__ */ jsx(ArrowUpRight, { className: "h-3 w-3 shrink-0", "aria-hidden": true })
          ]
        }
      ),
      showExplorerIcon && link && /* @__PURE__ */ jsx(
        "a",
        {
          href: link,
          target: "_blank",
          rel: "noreferrer noopener",
          className: "shrink-0 text-muted-foreground hover:text-foreground",
          "aria-label": "Open in block explorer",
          onClick: (e) => e.stopPropagation(),
          children: /* @__PURE__ */ jsx(ExternalLink, { className: "h-3 w-3" })
        }
      )
    ] });
  } else if (onDrilldown) {
    value = /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        onClick: (e) => {
          e.stopPropagation();
          onDrilldown(target);
        },
        className: "inline-flex min-w-0 max-w-full items-center gap-1 hover:underline",
        children: text
      }
    );
  } else if (link) {
    value = /* @__PURE__ */ jsxs("a", { href: link, className: "inline-flex min-w-0 max-w-full items-center gap-1 hover:underline", target: "_blank", rel: "noreferrer noopener", children: [
      text,
      showExplorerIcon && /* @__PURE__ */ jsx(ExternalLink, { className: "h-3 w-3" })
    ] });
  } else {
    value = text;
  }
  const enableTooltip = richTooltip ?? Boolean(onDrilldown || tooltipRows && tooltipRows.length || tooltipHeaderRight);
  if (enableTooltip) {
    const actions = [];
    if (onDrilldown) {
      actions.push({ icon: Search, label: "Investigate", onClick: () => onDrilldown(target) });
    }
    if (link) {
      actions.push({ icon: ExternalLink, label: "Explorer", onClick: () => window.open(link, "_blank", "noopener,noreferrer") });
    }
    value = /* @__PURE__ */ jsx(
      RichTooltip,
      {
        title: type === "block" ? "Block" : "Transaction",
        subtitle: /* @__PURE__ */ jsx("span", { className: "font-mono", children: normalized }),
        headerRight: tooltipHeaderRight,
        rows: tooltipRows,
        actions,
        children: value
      }
    );
  }
  return (
    // `min-w-0 max-w-full`: an inline box is sized shrink-to-fit from its
    // content and happily overflows its block parent, so in any narrow
    // container this span kept its full width and painted straight out of the
    // card — while `.authe-middle-ellipsis` inside it (max-width:100%, head
    // truncates, tail kept) was built to shrink and never got the chance.
    // `min-w-0` alone is not enough: the cap is what bounds it to the parent.
    // Found on the address page's details list at 375px, where a 66-character
    // tx hash ran ~30px past the screen.
    /* @__PURE__ */ jsxs(
      "span",
      {
        className: cn("inline-flex min-w-0 max-w-full items-center gap-2 text-muted-foreground", className),
        onCopy: handleCopy,
        children: [
          value,
          copyable && /* @__PURE__ */ jsx(CopyButton, { value: normalized })
        ]
      }
    )
  );
}
var OPEN = "\u201C";
var CLOSE = "\u201D";
function ChainWrittenText({
  value,
  kind = "ticker",
  fallback = null,
  quoted = true,
  source,
  sourceKind = "contract",
  maxChars,
  className
}) {
  const cleaned = React26.useMemo(
    () => kind === "ticker" && maxChars === void 0 ? safeTicker(value) : chainText(value, { maxChars }),
    [value, kind, maxChars]
  );
  const text = typeof cleaned === "string" ? cleaned : cleaned.text;
  const full = typeof cleaned === "string" ? cleaned : cleaned.title;
  if (!text) return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  const title = source ? `${full} \u2014 written by the contract at ${source}` : full;
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn("text-muted-foreground", className),
      title,
      "data-chain-written": "true",
      "aria-label": `${full}, ${sourceKind === "memo" ? "an asset symbol supplied in the memo" : "a name written by the token contract"}`,
      children: quoted ? `${OPEN}${text}${CLOSE}` : text
    }
  );
}
function TokenAmount({
  amount,
  decimals,
  symbol,
  symbolSource,
  chain,
  priceUsd,
  showUsd = false,
  precision = 6,
  className
}) {
  const native = chain ? nativeTokenMeta(chain) : {};
  const dec = decimals ?? native.decimals ?? 18;
  const chainWritten = symbol != null && symbol !== "";
  const sym = chainWritten ? safeTicker(symbol).text : native.symbol;
  const symTitle = chainWritten ? safeTicker(symbol).title : native.symbol;
  const unlimited = isUnlimitedAmount(typeof amount === "number" ? null : amount);
  const formatted = unlimited ? "Unlimited" : formatTokenAmount(
    amount,
    { symbol: sym, decimals: dec, priceUsd },
    { maxFractionDigits: precision, withSymbol: false, withUsd: showUsd }
  );
  const full = typeof amount === "number" ? String(amount) : formatTokenDisplay(amount, dec, { maxFractionDigits: dec });
  const title = unlimited ? `No limit \u2014 the maximum an approval can carry (${String(amount)} base units)` : symTitle ? `${full} ${symTitle}` : full;
  return /* @__PURE__ */ jsxs("span", { className: cn("inline-flex items-center gap-1 tabular-nums", className), title, children: [
    /* @__PURE__ */ jsx("span", { children: formatted }),
    sym && (chainWritten ? (
      // Quoted, because a symbol is a claim the contract makes and not our
      // description of what moved — `opti-line.top ✅` was a real one.
      /* @__PURE__ */ jsx(ChainWrittenText, { value: symbol, sourceKind: symbolSource, className: "font-normal" })
    ) : /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: sym }))
  ] });
}
function SeenOn({
  label,
  at,
  chainId
}) {
  return /* @__PURE__ */ jsxs("div", { className: "rounded-md border p-3", children: [
    /* @__PURE__ */ jsx("div", { className: "text-muted-foreground", children: label }),
    /* @__PURE__ */ jsx("div", { className: "font-medium", title: at ? formatTimestamp(at) : void 0, children: at ? formatRelativeTime(at) : "\u2014" }),
    chainId ? /* @__PURE__ */ jsxs("div", { className: "mt-0.5 text-[11px] text-muted-foreground", children: [
      "on ",
      chainDisplayName(chainId)
    ] }) : null
  ] });
}
function AddressActivityCard({
  activity,
  loading,
  chainLogoResolver,
  emptyState,
  className
}) {
  if (loading) {
    return /* @__PURE__ */ jsx("div", { className: cn("flex items-center justify-center rounded-md border p-8", className), children: /* @__PURE__ */ jsx(Spinner, {}) });
  }
  if (!activity) {
    return /* @__PURE__ */ jsx("div", { className: cn("rounded-md border p-6 text-center text-sm text-muted-foreground", className), children: emptyState ?? "No activity data." });
  }
  const summary = summarizeActivity(activity);
  const chains = Object.values(activity.chains ?? {});
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-4", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
      /* @__PURE__ */ jsx("span", { className: "text-xs font-medium text-muted-foreground", children: "Active on" }),
      activity.active_chain_ids?.length ? activity.active_chain_ids.map((id) => /* @__PURE__ */ jsx(
        ChainAvatar,
        {
          chain: id,
          size: "sm",
          showName: true,
          logoResolver: chainLogoResolver
        },
        id
      )) : /* @__PURE__ */ jsx("span", { className: "text-sm text-muted-foreground", children: "no chains" }),
      activity.refreshed_at ? /* @__PURE__ */ jsxs(
        "span",
        {
          className: "ml-auto text-[11px] text-muted-foreground",
          title: formatTimestamp(activity.refreshed_at),
          children: [
            "refreshed ",
            formatRelativeTime(activity.refreshed_at)
          ]
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsx(
      AddressActivityStats,
      {
        activity,
        includeSeen: false,
        className: "rounded-md border bg-muted/20 p-4"
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-3 text-xs", children: [
      /* @__PURE__ */ jsx(
        SeenOn,
        {
          label: "First seen",
          at: summary.firstSeenAt,
          ...activity.first_seen_chain_id ? { chainId: activity.first_seen_chain_id } : {}
        }
      ),
      /* @__PURE__ */ jsx(
        SeenOn,
        {
          label: "Last seen",
          at: summary.lastSeenAt,
          ...activity.last_seen_chain_id ? { chainId: activity.last_seen_chain_id } : {}
        }
      )
    ] }),
    chains.length > 0 ? /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ jsx("div", { className: "text-xs font-medium text-muted-foreground", children: "Per-chain breakdown" }),
      /* @__PURE__ */ jsx("div", { className: "divide-y rounded-md border", children: chains.map((c) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3 px-3 py-2 text-sm", children: [
        /* @__PURE__ */ jsx(ChainAvatar, { chain: c.chain_id, size: "sm", showName: true, logoResolver: chainLogoResolver }),
        /* @__PURE__ */ jsxs("div", { className: "ml-auto flex items-center gap-2", children: [
          /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "font-mono text-[10px]", children: [
            (c.tx_count ?? 0).toLocaleString(),
            " tx"
          ] }),
          c.nft_count ? /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "font-mono text-[10px]", children: [
            c.nft_count.toLocaleString(),
            " nft"
          ] }) : null,
          c.token_transfer_count ? /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "font-mono text-[10px]", children: [
            c.token_transfer_count.toLocaleString(),
            " xfer"
          ] }) : null
        ] })
      ] }, c.chain_id)) })
    ] }) : null
  ] });
}
function ChainFeedFilter({
  options,
  selected,
  onSelect,
  totalCount,
  allLabel = "All chains",
  onRefresh,
  refreshing = false,
  disabled = false,
  className
}) {
  if (options.length < 2 && !onRefresh) return null;
  return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-wrap items-center gap-1.5", className), children: [
    options.length > 1 && /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        FilterChip,
        {
          active: selected === null,
          disabled,
          count: totalCount,
          onClick: () => onSelect(null),
          children: allLabel
        }
      ),
      options.map((option) => /* @__PURE__ */ jsxs(
        FilterChip,
        {
          active: selected === option.value,
          disabled,
          count: option.count,
          countUnknown: option.count == null && Boolean(option.note),
          title: option.note,
          onClick: () => onSelect(option.value),
          children: [
            /* @__PURE__ */ jsx(ChainAvatar, { chain: option.value, size: "sm", showName: false }),
            option.label
          ]
        },
        option.value
      ))
    ] }),
    onRefresh && /* @__PURE__ */ jsxs(
      Button,
      {
        type: "button",
        size: "sm",
        variant: "ghost",
        className: "ml-auto",
        disabled: disabled || refreshing,
        onClick: onRefresh,
        title: "Fetch the newest transactions for this selection",
        children: [
          /* @__PURE__ */ jsx(RefreshCw, { className: cn("mr-1.5 h-3.5 w-3.5", refreshing && "animate-spin") }),
          refreshing ? "Refreshing\u2026" : "Refresh"
        ]
      }
    )
  ] });
}
function HoldingsPanel({
  title,
  chain,
  description,
  meta,
  actions,
  loading = false,
  loadingRows = 3,
  error,
  onRetry,
  empty = false,
  emptyTitle,
  emptyDescription,
  footer,
  children,
  className
}) {
  const showContent = !loading && error == null && !empty;
  return /* @__PURE__ */ jsxs(Card, { className, children: [
    /* @__PURE__ */ jsxs(CardHeader, { className: "flex flex-row flex-wrap items-start justify-between gap-2 space-y-0", children: [
      /* @__PURE__ */ jsxs("div", { className: "min-w-0", children: [
        /* @__PURE__ */ jsxs("h3", { className: "flex items-center gap-2 text-base font-semibold leading-none tracking-tight", children: [
          chain && /* @__PURE__ */ jsx(ChainAvatar, { chain, size: "sm", showName: "sr-only" }),
          title
        ] }),
        description && /* @__PURE__ */ jsx("p", { className: "mt-1 text-xs text-muted-foreground", children: description })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex shrink-0 items-center gap-3", children: [
        meta && !loading ? /* @__PURE__ */ jsx("span", { className: "text-sm text-muted-foreground", children: meta }) : null,
        actions
      ] })
    ] }),
    /* @__PURE__ */ jsx(CardContent, { children: error != null ? /* @__PURE__ */ jsx(ErrorState, { error, onRetry, size: "sm" }) : loading ? /* @__PURE__ */ jsx(HoldingsSkeleton, { rows: loadingRows }) : empty ? /* @__PURE__ */ jsx(
      EmptyState,
      {
        size: "sm",
        title: emptyTitle ?? "Nothing held here",
        description: emptyDescription
      }
    ) : children }),
    showContent && footer ? /* @__PURE__ */ jsx(CardFooter, { className: "justify-center pt-0", children: footer }) : null
  ] });
}
function HoldingsSkeleton({ rows }) {
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3", "aria-busy": "true", "aria-live": "polite", children: [
    /* @__PURE__ */ jsx("span", { className: "sr-only", children: "Loading\u2026" }),
    Array.from({ length: rows }, (_, i) => /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-3 rounded-md border p-3", children: [
      /* @__PURE__ */ jsx(Skeleton, { className: "h-9 w-9 shrink-0 rounded-md" }),
      /* @__PURE__ */ jsxs("div", { className: "min-w-0 flex-1 space-y-2", children: [
        /* @__PURE__ */ jsx(Skeleton, { className: "h-3.5 w-1/3" }),
        /* @__PURE__ */ jsx(Skeleton, { className: "h-3 w-1/2" })
      ] }),
      /* @__PURE__ */ jsx(Skeleton, { className: "h-3.5 w-16 shrink-0" })
    ] }, i))
  ] });
}
function useAddressBalances(chain, address, query = {}, options = {}) {
  return useQuery(
    (client, signal) => client.get(walletDataPaths.balances(chain, address), {
      query: { ...query.limit ? { limit: query.limit } : {} },
      signal,
      cacheTtlMs: 0
    }),
    { deps: [chain, address, query.limit], enabled: Boolean(chain && address), ...options }
  );
}
function useAddressDefi(chain, address, query = {}, options = {}) {
  return useQuery(
    (client, signal) => client.get(walletDataPaths.defi(chain, address), {
      query: {
        ...query.chain ? { chain: query.chain } : {},
        ...query.protocol ? { protocol: query.protocol } : {}
      },
      signal,
      cacheTtlMs: 0
    }),
    { deps: [chain, address, query.chain, query.protocol], enabled: Boolean(chain && address), ...options }
  );
}
function useAddressNfts(chain, address, query = {}, options = {}) {
  return useQuery(
    (client, signal) => client.get(walletDataPaths.nfts(chain, address), {
      query: {
        ...query.limit ? { limit: query.limit } : {},
        ...query.cursor ? { cursor: query.cursor } : {}
      },
      signal,
      cacheTtlMs: 0
    }),
    { deps: [chain, address, query.limit, query.cursor], enabled: Boolean(chain && address), ...options }
  );
}
function useAddressNftsPaged(chain, address, query = {}, options = {}) {
  const client = useApiClient();
  const [cursor, setCursor] = React26.useState(void 0);
  const [pages, setPages] = React26.useState(void 0);
  if (useDepsChanged([client, chain, address, query.limit])) {
    setCursor(void 0);
    setPages(void 0);
  }
  const result = useAddressNfts(
    chain,
    address,
    { ...query, cursor },
    {
      ...options,
      onSuccess: (data, envelope) => {
        if (data) setPages((prev) => {
          if (cursor && prev && data.unavailable) return { ...prev, unavailable: data.unavailable };
          return mergeWalletNftPages(cursor ? prev : void 0, data);
        });
        options.onSuccess?.(data, envelope);
      }
    }
  );
  const { refetch } = result;
  const refresh = React26.useCallback(() => {
    setPages(void 0);
    if (cursor === void 0) refetch();
    else setCursor(void 0);
  }, [cursor, refetch]);
  const nextCursor = pages?.next_cursor ?? void 0;
  return {
    page: pages,
    // Loading means "nothing accumulated to show yet", which is not the same as
    // the underlying query's `isLoading`: switching chain leaves the previous
    // chain's `data` in place, so the query reports a refetch rather than a
    // load, and keying off it would flash "No NFTs held" over the new chain
    // before its first page arrives. A "Load more" keeps the grid on screen.
    isLoading: pages === void 0 && (result.isLoading || result.isFetching),
    isFetching: result.isFetching,
    error: result.error,
    // Keep the disabled Loading control in place until this page settles.
    hasMore: Boolean(nextCursor && (result.isFetching || nextCursor !== cursor)),
    loadMore: React26.useCallback(() => {
      if (!result.isFetching && nextCursor && nextCursor !== cursor) setCursor(nextCursor);
    }, [nextCursor, cursor, result.isFetching]),
    retry: refetch,
    refresh
  };
}
function useNftCollection(chain, address, query = {}, options = {}) {
  return useQuery(
    (client, signal) => client.get(walletDataPaths.nftCollection(chain, address), {
      query: {
        ...query.limit ? { limit: query.limit } : {},
        ...query.cursor ? { cursor: query.cursor } : {}
      },
      signal,
      cacheTtlMs: 0
    }),
    { deps: [chain, address, query.limit, query.cursor], enabled: Boolean(chain && address), ...options }
  );
}
function useAddressDomain(chain, address, options = {}) {
  return useQuery(
    (client, signal) => client.get(walletDataPaths.domain(chain, address), {
      signal,
      cacheTtlMs: 0
    }),
    { deps: [chain, address], enabled: Boolean(chain && address), ...options }
  );
}
var CRITICALITY_TONE_CLASS = {
  [EventCriticality.CRITICAL]: "bg-risk-critical/15 text-risk-critical border-risk-critical/30",
  [EventCriticality.HIGH]: "bg-risk-high/15 text-risk-high border-risk-high/30",
  [EventCriticality.MEDIUM]: "bg-risk-medium/15 text-risk-medium border-risk-medium/30",
  [EventCriticality.LOW]: "bg-muted text-muted-foreground border-border",
  [EventCriticality.SUCCESS]: "bg-risk-none/15 text-risk-none border-risk-none/30"
};
var CRITICALITY_DOT_CLASS = {
  [EventCriticality.CRITICAL]: "bg-risk-critical",
  [EventCriticality.HIGH]: "bg-risk-high",
  [EventCriticality.MEDIUM]: "bg-risk-medium",
  [EventCriticality.LOW]: "bg-muted-foreground",
  [EventCriticality.SUCCESS]: "bg-risk-none"
};
function CriticalityBadge({ level, dot, className }) {
  if (dot) {
    return /* @__PURE__ */ jsx(
      "span",
      {
        role: "img",
        "aria-label": criticalityLabel(level),
        className: cn("inline-block h-2 w-2 shrink-0 rounded-full", CRITICALITY_DOT_CLASS[level], className)
      }
    );
  }
  return /* @__PURE__ */ jsx(Badge, { variant: "outline", className: cn("border", CRITICALITY_TONE_CLASS[level], className), children: criticalityLabel(level) });
}
var STYLES = {
  [FinalityState.UNKNOWN]: "bg-muted text-muted-foreground border-border",
  [FinalityState.MEMPOOL]: "bg-violet-500/15 text-violet-600 dark:text-violet-400 border-violet-500/30",
  [FinalityState.PENDING]: "bg-finality-pending/15 text-finality-pending border-finality-pending/30",
  [FinalityState.OBSERVED]: "bg-sky-500/15 text-sky-600 dark:text-sky-400 border-sky-500/30",
  [FinalityState.CONFIRMED]: "bg-finality-confirmed/15 text-finality-confirmed border-finality-confirmed/30",
  [FinalityState.FINALIZED]: "bg-finality-finalized/15 text-finality-finalized border-finality-finalized/30",
  [FinalityState.REORGED]: "bg-finality-reorged/15 text-finality-reorged border-finality-reorged/30"
};
var LABELS = {
  [FinalityState.UNKNOWN]: "Unknown",
  [FinalityState.MEMPOOL]: "Mempool",
  [FinalityState.PENDING]: "Pending",
  [FinalityState.OBSERVED]: "Observed",
  [FinalityState.CONFIRMED]: "Confirmed",
  [FinalityState.FINALIZED]: "Finalized",
  [FinalityState.REORGED]: "Reorged"
};
function FinalityPill({ state, confirmations, className }) {
  const detail = confirmations ? ` (${confirmations.current}/${confirmations.required})` : "";
  return /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: cn("border", STYLES[state], className), children: [
    LABELS[state],
    detail
  ] });
}
function PulseDot() {
  return /* @__PURE__ */ jsxs("span", { className: "relative inline-flex h-1.5 w-1.5", "aria-hidden": true, children: [
    /* @__PURE__ */ jsx("span", { className: "absolute inline-flex h-full w-full animate-ping rounded-full bg-amber-400 opacity-75" }),
    /* @__PURE__ */ jsx("span", { className: "relative inline-flex h-1.5 w-1.5 rounded-full bg-amber-500" })
  ] });
}
function SagaPill({
  label,
  missing = [],
  complete,
  total,
  confirmed = true,
  reach,
  stopped = false,
  className
}) {
  const awaiting = missing.length > 0;
  const counted = total != null && total > 1;
  const unreachable = awaiting && !counted && reach?.kind === "uncovered";
  const settled = unreachable || awaiting && stopped;
  let detail;
  if (counted) {
    detail = `${complete ?? 0} of ${total} messages`;
  } else if (unreachable && reach) {
    detail = `${missing.join(" + ")} \xB7 ${missingLegLabel(reach, { confirmed })}`;
  } else if (awaiting && stopped) {
    detail = `${missing.join(" + ")} never seen`;
  } else if (awaiting) {
    detail = confirmed ? `awaiting ${missing.join(" + ")}` : `${missing.join(" + ")} not in view`;
  } else {
    detail = "complete";
  }
  const title = unreachable && reach ? `${missing.join(" and ")} ${missingLegReason(reach, { confirmed })}` : awaiting && stopped ? `Stopped waiting for the ${missing.join(" and ")} leg \u2014 it was never seen before the deadline` : awaiting ? confirmed ? `Still waiting on the ${missing.join(" and ")} leg` : `No ${missing.join(" or ")} leg among the loaded transactions \u2014 it may exist outside this view` : "Every leg this protocol expects is present";
  return /* @__PURE__ */ jsxs(
    Badge,
    {
      variant: "outline",
      className: cn(
        "gap-1.5 border font-normal",
        settled ? "border-border bg-muted text-muted-foreground" : awaiting ? "border-amber-500/30 bg-amber-500/15 text-amber-700 dark:text-amber-400" : "border-emerald-500/30 bg-emerald-500/15 text-emerald-700 dark:text-emerald-400",
        className
      ),
      title,
      children: [
        awaiting && !settled ? /* @__PURE__ */ jsx(PulseDot, {}) : null,
        label ? /* @__PURE__ */ jsx("span", { className: "font-medium", children: label }) : null,
        /* @__PURE__ */ jsx("span", { className: label ? "opacity-80" : void 0, children: detail })
      ]
    }
  );
}
var STYLES2 = {
  blue: "bg-deploy-blue/15 text-deploy-blue border-deploy-blue/30",
  green: "bg-deploy-green/15 text-deploy-green border-deploy-green/30",
  blue_green: "bg-deploy-mixed/15 text-deploy-mixed border-deploy-mixed/30"
};
var LABELS2 = {
  blue: "Blue",
  green: "Green",
  blue_green: "Blue/Green"
};
function DeploymentColourBadge({
  colour,
  className
}) {
  const key = colour;
  const style = STYLES2[key];
  return /* @__PURE__ */ jsx(Badge, { variant: "outline", className: cn("border", style, className), children: LABELS2[key] ?? colour });
}
var CONTINENT_STYLES = {
  us: "bg-deploy-green/15 text-deploy-green border-deploy-green/30",
  eu: "bg-deploy-blue/15 text-deploy-blue border-deploy-blue/30",
  ap: "bg-risk-medium/15 text-risk-medium border-risk-medium/30",
  in: "bg-risk-high/15 text-risk-high border-risk-high/30"
};
function RegionTag({ region, variant = "id", className }) {
  const info = AWS_REGIONS[region];
  const continent = info?.continent;
  const label = variant === "alias" ? info?.alias ?? region : variant === "name" ? info?.name ?? region : region;
  return /* @__PURE__ */ jsx(
    Badge,
    {
      variant: "outline",
      className: cn("border font-mono", continent ? CONTINENT_STYLES[continent] : void 0, className),
      title: info ? `${info.name} (${info.alias})` : region,
      children: label
    }
  );
}
var STYLES3 = {
  prd: "bg-risk-critical/15 text-risk-critical border-risk-critical/30",
  sandbox: "bg-risk-medium/15 text-risk-medium border-risk-medium/30",
  dev: "bg-deploy-blue/15 text-deploy-blue border-deploy-blue/30",
  local: "bg-muted text-muted-foreground border-border"
};
function EnvBadge({ env, className }) {
  return /* @__PURE__ */ jsx(
    Badge,
    {
      variant: "outline",
      className: cn("border uppercase", STYLES3[env] ?? STYLES3.local, className),
      children: env
    }
  );
}
var STYLES4 = {
  blue: "bg-deploy-blue/15 text-deploy-blue border-deploy-blue/30",
  green: "bg-deploy-green/15 text-deploy-green border-deploy-green/30",
  latest: "bg-risk-medium/15 text-risk-medium border-risk-medium/30",
  stagevar: "bg-risk-medium/15 text-risk-medium border-risk-medium/30",
  unknown: "bg-muted text-foreground"
};
function tone(alias) {
  if (alias === "blue" || alias === "green") return alias;
  if (alias === AUTHORIZER_LATEST) return "latest";
  if (isStageVariableAlias(alias)) return "stagevar";
  return "unknown";
}
function AuthorizerAliasBadge({
  alias,
  className
}) {
  const label = alias && alias.length > 0 ? alias : "unknown";
  return /* @__PURE__ */ jsx(Badge, { variant: "outline", className: cn("border font-mono", STYLES4[tone(alias)], className), title: label, children: label });
}
function LayerVersionBadge({
  layer,
  mismatched = false,
  className
}) {
  const label = layer.name ? `${layer.name}:${layer.version || "?"}` : layer.arn;
  return /* @__PURE__ */ jsx(
    Badge,
    {
      variant: "outline",
      title: layer.arn || label,
      className: cn(
        "border font-mono",
        mismatched ? "bg-risk-high/15 text-risk-high border-risk-high/30" : "bg-muted text-foreground",
        className
      ),
      children: label
    }
  );
}
var STYLES5 = {
  ok: "bg-deploy-green/15 text-deploy-green border-deploy-green/30",
  info: "bg-deploy-blue/15 text-deploy-blue border-deploy-blue/30",
  warning: "bg-risk-high/15 text-risk-high border-risk-high/30",
  error: "bg-risk-critical/15 text-risk-critical border-risk-critical/30"
};
function resolve(summary, diverged) {
  if (summary) {
    if (summary.errors > 0) return { tone: "error", label: `${summary.errors} error${summary.errors > 1 ? "s" : ""}` };
    if (summary.warnings > 0)
      return { tone: "warning", label: `${summary.warnings} warning${summary.warnings > 1 ? "s" : ""}` };
    if (summary.info > 0) return { tone: "info", label: "Info" };
    return { tone: "ok", label: "In sync" };
  }
  if (diverged === void 0) return { tone: "ok", label: "\u2014" };
  return diverged ? { tone: "warning", label: "Drift" } : { tone: "ok", label: "In sync" };
}
function VersionDriftBadge({
  summary,
  diverged,
  className
}) {
  const { tone: tone2, label } = resolve(summary, diverged);
  return /* @__PURE__ */ jsx(Badge, { variant: "outline", className: cn("border", STYLES5[tone2], className), children: label });
}
var TONE2 = {
  in_sync: "bg-deploy-green/15 text-deploy-green border-deploy-green/30",
  promote_available: "bg-risk-medium/15 text-risk-medium border-risk-medium/30",
  unpinned: "bg-risk-high/15 text-risk-high border-risk-high/30",
  no_green: "bg-risk-high/15 text-risk-high border-risk-high/30",
  no_functions: "bg-muted text-muted-foreground border-border",
  unknown: "bg-muted text-muted-foreground border-border"
};
var ICON = {
  in_sync: CheckCircle2,
  promote_available: ArrowUpCircle,
  unpinned: PinOff,
  no_green: CircleSlash,
  no_functions: PackageX,
  unknown: HelpCircle
};
var TITLE = {
  in_sync: "Live (green) is on the latest deployed (blue) build.",
  promote_available: "A newer build is deployed (blue) but not yet promoted to live (green).",
  unpinned: "Live (green) points at $LATEST, so every deploy goes live without a promotion. Promote a published version to pin it.",
  no_green: "Nothing is live: no promotion is recorded and no green alias could be read.",
  no_functions: "This application has no Lambda functions in this region (a Terraform-only or retired repo), so nothing can be live.",
  unknown: "Live and latest can't be compared: the latest (blue) version is unknown, or the functions' versions carry no application version."
};
function VersionSyncBadge({
  state,
  hideIcon,
  className
}) {
  const Icon = ICON[state];
  return /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: cn("gap-1 border", TONE2[state], className), title: TITLE[state], children: [
    !hideIcon && /* @__PURE__ */ jsx(Icon, { className: "h-3.5 w-3.5" }),
    VERSION_SYNC_LABEL[state]
  ] });
}
function StalenessBadge({
  timestampMs,
  thresholdDays = STALE_AFTER_DAYS,
  nowMs,
  className
}) {
  if (timestampMs == null) {
    return /* @__PURE__ */ jsx("span", { className: cn("text-muted-foreground", className), children: "\u2014" });
  }
  const days = daysSinceMs(timestampMs, nowMs);
  const relative = formatRelativeTime(timestampMs, { unit: "milliseconds", nowMs });
  const stale = days != null && days >= thresholdDays;
  if (!stale) {
    return /* @__PURE__ */ jsx("span", { className: cn("text-muted-foreground tabular-nums", className), children: relative });
  }
  return /* @__PURE__ */ jsxs(
    Badge,
    {
      variant: "outline",
      className: cn("gap-1 border bg-risk-medium/15 text-risk-medium border-risk-medium/30", className),
      title: days != null ? `No blue/green activity for ${days} days` : void 0,
      children: [
        /* @__PURE__ */ jsx(AlertTriangle, { className: "h-3.5 w-3.5" }),
        "Stale \xB7 ",
        relative
      ]
    }
  );
}
var TONE3 = {
  external: "bg-deploy-green/15 text-deploy-green border-deploy-green/30",
  internal: "bg-deploy-blue/15 text-deploy-blue border-deploy-blue/30",
  data: "bg-risk-medium/15 text-risk-medium border-risk-medium/30",
  "front-end": "bg-brand/15 text-brand border-brand/30"
};
function AppCategoryBadge({ category, className }) {
  return /* @__PURE__ */ jsx(Badge, { variant: "outline", className: cn("border", TONE3[category], className), children: APP_CATEGORY_LABEL[category] });
}
function EntityCard({
  name,
  entityType,
  tags = [],
  avatarUrl,
  description,
  className,
  children
}) {
  const initials = name.split(/\s+/).map((word) => word[0]?.toUpperCase()).filter(Boolean).slice(0, 2).join("");
  return /* @__PURE__ */ jsxs(Card, { className: cn("overflow-hidden", className), children: [
    /* @__PURE__ */ jsxs(CardHeader, { className: "flex flex-row items-center gap-3 p-4", children: [
      /* @__PURE__ */ jsx("div", { className: "flex h-10 w-10 items-center justify-center rounded-full bg-muted text-sm font-semibold text-muted-foreground", children: avatarUrl ? /* @__PURE__ */ jsx("img", { alt: name, src: avatarUrl, className: "h-10 w-10 rounded-full object-cover" }) : initials || "?" }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-1 flex-col", children: [
        /* @__PURE__ */ jsx(CardTitle, { className: "text-base", children: name }),
        entityType && /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: entityType })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(CardContent, { className: "space-y-3 p-4 pt-0", children: [
      description && /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: description }),
      tags.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: tags.map((t) => /* @__PURE__ */ jsx(Badge, { variant: "secondary", children: t }, t)) }),
      children
    ] })
  ] });
}
function NetFlowRow({ entry }) {
  const inflow = entry.net >= 0n;
  const magnitude = inflow ? entry.net : -entry.net;
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between gap-3 py-1.5", children: [
    /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-2", children: [
      inflow ? /* @__PURE__ */ jsx(ArrowDownLeft, { className: "h-4 w-4 text-finality-finalized" }) : /* @__PURE__ */ jsx(ArrowUpRight, { className: "h-4 w-4 text-risk-high" }),
      /* @__PURE__ */ jsx(
        TokenAmount,
        {
          amount: magnitude,
          decimals: entry.decimals,
          symbol: entry.symbol ?? void 0,
          chain: entry.chainId ?? void 0
        }
      )
    ] }),
    entry.netUsd != null && /* @__PURE__ */ jsxs("span", { className: cn("text-sm tabular-nums", inflow ? "text-finality-finalized" : "text-risk-high"), children: [
      inflow ? "+" : "\u2212",
      formatUsd(Math.abs(entry.netUsd))
    ] })
  ] });
}
function NetFlow({
  transfers,
  focalAddress,
  mode = "swap",
  showTotal = true,
  className
}) {
  const entries = React26.useMemo(() => {
    if (mode === "swap") {
      const { sent, received } = summarizeSwap(transfers, focalAddress);
      return [...received, ...sent];
    }
    return [...computeNetFlow(transfers, focalAddress).values()];
  }, [transfers, focalAddress, mode]);
  const totalUsd = React26.useMemo(() => aggregateNetUsd(entries), [entries]);
  if (entries.length === 0) {
    return /* @__PURE__ */ jsx("p", { className: cn("text-sm text-muted-foreground", className), children: "No net movement." });
  }
  return /* @__PURE__ */ jsxs("div", { className: cn("divide-y divide-border", className), children: [
    entries.map((entry) => /* @__PURE__ */ jsx(NetFlowRow, { entry }, entry.tokenKey)),
    showTotal && totalUsd !== 0 && /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between gap-3 pt-2 text-sm font-medium", children: [
      /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "Net" }),
      /* @__PURE__ */ jsxs("span", { className: cn("tabular-nums", totalUsd >= 0 ? "text-finality-finalized" : "text-risk-high"), children: [
        totalUsd >= 0 ? "+" : "\u2212",
        formatUsd(Math.abs(totalUsd))
      ] })
    ] })
  ] });
}
var HIDDEN_AMOUNT_TITLE = "The chain's privacy protocol hides this amount. Only what it disclosed is shown.";
function isZeroAmount(amount) {
  try {
    return BigInt(amount) === 0n;
  } catch {
    return false;
  }
}
function resolveUsd({
  amount,
  decimals,
  symbol,
  chain,
  valueUsd,
  priceUsd
}) {
  if (valueUsd != null) return valueUsd;
  if (priceUsd == null) return null;
  const native = chain ? nativeTokenMeta(chain) : {};
  const dec = decimals ?? native.decimals ?? 18;
  const formatted = formatTokenAmount(
    amount,
    { symbol: symbol ?? native.symbol, decimals: dec, priceUsd },
    { withSymbol: false, withUsd: true }
  );
  const match = formatted.match(/\$([0-9.,]+)/);
  if (!match) return null;
  const parsed = Number(match[1].replace(/,/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
}
function TokenValue({
  amount,
  decimals,
  symbol,
  symbolSource,
  chain,
  valueUsd,
  priceUsd,
  direction,
  priceQuality,
  layout = "stacked",
  precision = 6,
  amountHidden = false,
  className
}) {
  if (amountHidden && isZeroAmount(amount)) {
    return /* @__PURE__ */ jsx("span", { className: cn("text-xs italic text-muted-foreground", className), title: HIDDEN_AMOUNT_TITLE, children: "Hidden" });
  }
  const unlimited = isUnlimitedAmount(typeof amount === "number" ? null : amount);
  const usd = unlimited ? null : resolveUsd({ amount, decimals, symbol, chain, valueUsd, priceUsd });
  const directionColor = direction === "in" ? "text-finality-finalized" : direction === "out" ? "text-risk-high" : void 0;
  const Arrow = direction === "in" ? ArrowDownLeft : direction === "out" ? ArrowUpRight : null;
  const sign = direction === "in" ? "+" : direction === "out" ? "\u2212" : "";
  const coverage = typeof priceQuality?.coverage === "number" ? priceQuality.coverage : null;
  const priced = typeof priceQuality?.legs_priced === "number" ? priceQuality.legs_priced : null;
  const seen = typeof priceQuality?.legs_seen === "number" ? priceQuality.legs_seen : null;
  const derived = typeof priceQuality?.legs_derived === "number" ? priceQuality.legs_derived : 0;
  const age = typeof priceQuality?.quote_max_age_seconds === "number" ? priceQuality.quote_max_age_seconds : null;
  const qualityLabel = priceQuality && Object.keys(priceQuality).length ? priced === 0 ? "Price unavailable" : coverage != null && coverage < 1 ? `${Math.round(coverage * 100)}% priced` : derived > 0 ? "Includes estimates" : "Priced" : null;
  const qualityDetail = [
    priced != null && seen != null ? `${priced} of ${seen} movements priced` : null,
    derived > 0 ? `${derived} estimated from trades` : null,
    age != null ? `Oldest quote: ${Math.round(age)} seconds before the transaction` : null,
    priced === 0 ? "No usable historical quote; value is unknown." : null
  ].filter(Boolean).join(". ");
  const quality = qualityLabel ? /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", title: qualityDetail, children: qualityLabel }) : null;
  const hiddenPart = amountHidden ? /* @__PURE__ */ jsx("span", { className: "text-xs italic text-muted-foreground", title: HIDDEN_AMOUNT_TITLE, children: "+ hidden" }) : null;
  const rawLine = usd != null && !amountHidden && isZeroAmount(amount) ? null : /* @__PURE__ */ jsx(
    TokenAmount,
    {
      amount,
      decimals,
      symbol,
      symbolSource,
      chain,
      precision,
      className: cn("text-xs text-muted-foreground", directionColor && "opacity-90")
    }
  );
  if (layout === "inline") {
    return /* @__PURE__ */ jsxs("span", { className: cn("inline-flex items-center gap-1.5", className), children: [
      Arrow && /* @__PURE__ */ jsx(Arrow, { className: cn("h-3.5 w-3.5", directionColor) }),
      rawLine,
      hiddenPart,
      quality,
      usd != null && /* @__PURE__ */ jsxs("span", { className: cn("text-xs font-semibold tabular-nums", directionColor), children: [
        sign,
        formatUsd(Math.abs(usd))
      ] })
    ] });
  }
  return /* @__PURE__ */ jsxs("span", { className: cn("inline-flex flex-col items-end leading-tight", className), children: [
    usd != null ? /* @__PURE__ */ jsxs("span", { className: cn("inline-flex items-center gap-1 text-sm font-semibold tabular-nums", directionColor), children: [
      Arrow && /* @__PURE__ */ jsx(Arrow, { className: "h-3.5 w-3.5" }),
      sign,
      formatUsd(Math.abs(usd))
    ] }) : Arrow && /* @__PURE__ */ jsx(Arrow, { className: cn("h-3.5 w-3.5", directionColor) }),
    rawLine,
    hiddenPart,
    quality
  ] });
}
var RELATION_COPY = {
  attached_to: {
    label: "Attached",
    title: "Someone attributed this item to that resource"
  },
  contains: {
    label: "Contains",
    title: "A curated group names this as a member"
  },
  owns: {
    label: "Owns",
    title: "The authoritative address\u2194entity mapping says the entity owns this address"
  },
  has_leg: {
    label: "Leg",
    title: "One leg of a cross-chain saga the grouping engine found"
  }
};
function RelationBadge({
  relation,
  label,
  className
}) {
  const copy = RELATION_COPY[relation];
  return /* @__PURE__ */ jsx(
    Badge,
    {
      variant: "outline",
      className: cn("text-[10px] font-normal", className),
      title: copy.title,
      children: label ?? copy.label
    }
  );
}
function relationLabel(relation) {
  return RELATION_COPY[relation].label;
}
function TeamShareField({
  teams,
  value,
  onChange,
  loading = false,
  label = "Share with teams",
  description = "Members of the selected teams can see this; what they can do is set by their team role.",
  hideWhenEmpty = true
}) {
  const toggle = (id, checked) => onChange(checked ? [...value, id] : value.filter((t) => t !== id));
  if (!loading && hideWhenEmpty && teams.length === 0) return null;
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsx(Label, { children: label }),
    description ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: description }) : null,
    loading ? /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: "Loading teams\u2026" }) : /* @__PURE__ */ jsx("div", { className: "space-y-1.5", children: teams.map((team) => /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-2 text-sm", children: [
      /* @__PURE__ */ jsx(
        Checkbox,
        {
          checked: value.includes(team.id),
          onCheckedChange: (checked) => toggle(team.id, Boolean(checked))
        }
      ),
      /* @__PURE__ */ jsx("span", { children: team.name })
    ] }, team.id)) })
  ] });
}
function visibilityFieldState(value, options) {
  return {
    // The caller's configured default, NOT `private`. A form seeded with a
    // hard-coded fallback showed "Only me" on a surface whose untouched write
    // would land tenant-wide — the control and its effect disagreeing, which is
    // the one thing a visibility picker must never do.
    visibility: value.visibility ?? { scope: options.defaultScope },
    options: options.writeScopes.filter((scope) => scope !== "team" || options.teamCount > 0).map((scope) => ({ value: scope, label: WRITE_SCOPE_LABEL[scope] }))
  };
}
var ATTRIBUTE_FIELDS = {
  visibility: {
    render: ({ value, patch, disabled, idFor, teamOptions, writeScopes, defaultScope }) => {
      const { visibility, options } = visibilityFieldState(value, {
        writeScopes,
        defaultScope,
        teamCount: teamOptions.length
      });
      const selected = visibility.teamIds ?? teamOptions.map((t) => t.id);
      return /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
        /* @__PURE__ */ jsx(Label, { htmlFor: idFor("visibility"), children: "Visible to" }),
        /* @__PURE__ */ jsx(
          EnumSelect,
          {
            id: idFor("visibility"),
            value: visibility.scope,
            disabled,
            options,
            onChange: (scope) => patch({
              visibility: {
                scope,
                teamIds: scope === "team" ? selected : void 0
              }
            })
          }
        ),
        visibility.scope === "team" ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            TeamShareField,
            {
              teams: [...teamOptions],
              value: [...selected],
              onChange: (teamIds) => patch({ visibility: { scope: "team", teamIds } }),
              loading: false,
              label: "Teams",
              description: "Members of these teams can see this attribution.",
              hideWhenEmpty: false
            }
          ),
          selected.length === 0 ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "No team selected \u2014 this will be saved private to you." }) : null
        ] }) : null
      ] });
    }
  },
  confidence: {
    render: ({ value, patch, disabled, idFor }) => {
      const stated = value.confidence !== void 0;
      return /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-baseline justify-between", children: [
          /* @__PURE__ */ jsx(Label, { htmlFor: idFor("confidence"), children: "Confidence" }),
          /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: stated ? `${Math.round((value.confidence ?? 0) * 100)}%` : "not stated" })
        ] }),
        /* @__PURE__ */ jsx(
          Slider,
          {
            id: idFor("confidence"),
            disabled,
            min: 0,
            max: 100,
            step: 5,
            value: [stated ? (value.confidence ?? 1) * 100 : 100],
            onValueChange: ([next]) => patch({ confidence: (next ?? 100) / 100 })
          }
        ),
        stated && /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            disabled,
            className: "text-xs text-muted-foreground underline-offset-2 hover:underline",
            onClick: () => patch({ confidence: void 0 }),
            children: "Clear"
          }
        )
      ] });
    }
  },
  reason: {
    wide: true,
    render: ({ value, patch, disabled }) => /* @__PURE__ */ jsx(Field, { label: "Why", children: /* @__PURE__ */ jsx(
      Textarea,
      {
        rows: 2,
        maxLength: 2e3,
        disabled,
        value: value.reason ?? "",
        placeholder: "What makes this attribution hold?",
        onChange: (e) => patch({ reason: e.target.value || void 0 })
      }
    ) })
  },
  evidenceUrl: {
    wide: true,
    render: ({ value, patch, disabled }) => /* @__PURE__ */ jsx(Field, { label: "Source link", children: /* @__PURE__ */ jsx(
      Input,
      {
        type: "url",
        inputMode: "url",
        maxLength: 2048,
        disabled,
        value: value.evidenceUrl ?? "",
        placeholder: "https://\u2026",
        onChange: (e) => patch({ evidenceUrl: e.target.value || void 0 })
      }
    ) })
  },
  validFrom: {
    render: ({ value, patch, disabled }) => /* @__PURE__ */ jsx(Field, { label: "Valid from", children: /* @__PURE__ */ jsx(
      Input,
      {
        type: "date",
        disabled,
        value: toDateInput(value.validFrom),
        onChange: (e) => patch({ validFrom: fromDateInput(e.target.value) })
      }
    ) })
  },
  validTo: {
    render: ({ value, patch, disabled }) => /* @__PURE__ */ jsx(Field, { label: "Valid to", children: /* @__PURE__ */ jsx(
      Input,
      {
        type: "date",
        disabled,
        value: toDateInput(value.validTo),
        onChange: (e) => patch({ validTo: fromDateInput(e.target.value) })
      }
    ) })
  }
};
function toDateInput(seconds) {
  if (seconds === void 0) return "";
  return new Date(seconds * 1e3).toISOString().slice(0, 10);
}
function fromDateInput(value) {
  if (!value) return void 0;
  const ms = Date.parse(`${value}T00:00:00Z`);
  return Number.isNaN(ms) ? void 0 : Math.floor(ms / 1e3);
}
function AssignmentAttributesForm({
  accepts,
  value,
  onChange,
  disabled = false,
  teamOptions = [],
  writeScopes,
  defaultScope,
  className
}) {
  const instanceId = React26.useId();
  const idFor = React26.useCallback(
    (suffix) => `${instanceId}-${suffix}`,
    [instanceId]
  );
  const patch = React26.useCallback(
    (next) => onChange({ ...value, ...next }),
    [onChange, value]
  );
  if (accepts.length === 0) return null;
  const ctx = {
    value,
    patch,
    disabled,
    idFor,
    teamOptions,
    writeScopes,
    defaultScope
  };
  return /* @__PURE__ */ jsx("div", { className: cn("grid grid-cols-2 gap-3", className), children: accepts.map((key) => {
    const spec = ATTRIBUTE_FIELDS[key];
    if (!spec) return null;
    return /* @__PURE__ */ jsx("div", { className: cn(spec.wide && "col-span-2"), children: spec.render(ctx) }, key);
  }) });
}
function useCatalogAdvanced() {
  return useEntitlement(ENTITLEMENT.CATALOG_ADVANCED);
}
function useCatalogPromote() {
  return usePermission("catalog", "promote");
}
var BASIC_ATTRIBUTE_KEYS = ["visibility"];
function offeredAttributeKeys(accepts, advanced) {
  return advanced ? accepts : accepts.filter((key) => BASIC_ATTRIBUTE_KEYS.includes(key));
}
var ADVANCED_WRITE_SCOPES = ["team"];
var SHARED_WRITE_SCOPES = ["org", "customer"];
function isCatalogWriteResource(resource) {
  return WRITE_PATH[resource] === "overlay" || resource === "primary";
}
function offeredWriteScopes(resource, writeScopes, advanced, offered, canPromote = false) {
  const catalog = isCatalogWriteResource(resource);
  const scopes = writeScopes.filter(
    (scope) => !(catalog && !advanced && ADVANCED_WRITE_SCOPES.includes(scope)) && !(catalog && !canPromote && SHARED_WRITE_SCOPES.includes(scope))
  );
  return offeredOptions(scopes, offered, (scope) => WRITE_SCOPE_RUNG[scope]);
}
function basicWriteScope(resource, scope, advanced, canPromote = true) {
  if (!isCatalogWriteResource(resource)) return scope;
  if (!canPromote && SHARED_WRITE_SCOPES.includes(scope)) return "tenant";
  if (advanced) return scope;
  return ADVANCED_WRITE_SCOPES.includes(scope) ? "private" : scope;
}
function basicVisibility(resource, visibility, advanced, canPromote = true) {
  const scope = basicWriteScope(resource, visibility.scope, advanced, canPromote);
  return scope === visibility.scope ? visibility : { scope };
}
function basicAttributes(resource, attributes, advanced, canPromote = true) {
  if (advanced) {
    if (!attributes.visibility || canPromote) return attributes;
    return { ...attributes, visibility: basicVisibility(resource, attributes.visibility, advanced, canPromote) };
  }
  const out = {};
  if (attributes.visibility) out.visibility = basicVisibility(resource, attributes.visibility, advanced, canPromote);
  return out;
}
var BASIC_ATTRIBUTION_TARGETS = ["overlay"];
function offeredAttributionTargets(targets, advanced) {
  return advanced ? targets : targets.filter((t) => BASIC_ATTRIBUTION_TARGETS.includes(t));
}
function basicCatalogDraft(draft, advanced) {
  if (advanced) return draft;
  const out = {
    ...draft,
    chains: void 0,
    primaryChains: void 0,
    lifecycle: void 0,
    severity: void 0
  };
  if (draft.kind !== "address") out.riskLevel = void 0;
  if (draft.kind === "address") out.primaryEntityId = void 0;
  if (draft.kind === "label") {
    out.address = void 0;
    out.chain = void 0;
  }
  if (draft.kind === "group") {
    out.memberTagIds = void 0;
    out.memberLabelIds = void 0;
    out.memberEntityIds = void 0;
  }
  return out;
}
var BASIC_SUBJECT_KINDS = ["address", "transaction"];
function catalogSubjectOffered(kind, advanced) {
  return advanced || BASIC_SUBJECT_KINDS.includes(kind);
}
var CATALOG_ADVANCED_NOT_INCLUDED = "This catalog feature isn't included in your plan.";
var PERM003 = ErrorCode.PERM003.code;
function isCatalogAdvancedRefusal(error) {
  if (error == null) return false;
  const body = toErrorResponse(error).error;
  if (errorCodeOf(body) !== PERM003) return false;
  const details = body.details;
  const missing = details && typeof details === "object" ? details.missing_entitlements : void 0;
  return Array.isArray(missing) && missing.includes(ENTITLEMENT.CATALOG_ADVANCED);
}
function catalogAdvancedRefusalMessage(error) {
  return isCatalogAdvancedRefusal(error) ? CATALOG_ADVANCED_NOT_INCLUDED : void 0;
}
function catalogWriteErrorMessage(error, fallback) {
  return catalogAdvancedRefusalMessage(error) ?? (error instanceof Error && error.message ? error.message : fallback);
}
var SCOPE_ICON = {
  private: Lock,
  team: Users,
  tenant: Building2,
  org: Building2,
  customer: Globe
};
var SCOPE_PREF_ANCHOR = {
  write: "scope-default-visibility",
  read: "scope-default-view"
};
var ScopeHintContext = React26.createContext(null);
var FALLBACK = {
  prefs: READ_ONLY_SCOPE_PREFS,
  policies: ATTRIBUTION_POLICIES
};
function ScopeHintProvider({
  prefs,
  policies = ATTRIBUTION_POLICIES,
  teamIds,
  onConfigure,
  children
}) {
  const value = React26.useMemo(
    () => ({
      prefs: prefs ?? FALLBACK.prefs,
      policies,
      ...teamIds ? { teamIds } : {},
      ...onConfigure ? { onConfigure } : {}
    }),
    [onConfigure, policies, prefs, teamIds]
  );
  return /* @__PURE__ */ jsx(ScopeHintContext.Provider, { value, children });
}
function useScopeHintContext() {
  return React26.useContext(ScopeHintContext) ?? FALLBACK;
}
function useScopeHints() {
  return useFeatureFlag(SCOPE_HINT_FLAG);
}
function HintPill({
  icon: PillIcon,
  prefix,
  value,
  title,
  subtitle,
  rows,
  content,
  actions,
  onAction,
  actionLabel = "Change the default",
  tone: tone2 = "muted",
  wide = false
}) {
  const shown = useScopeHints();
  if (!shown) return null;
  const warn = tone2 === "warning";
  const resolvedActions = actions && actions.length > 0 ? actions.map((each) => ({ label: each.label, onClick: each.onClick })) : onAction ? [{ label: actionLabel, onClick: onAction }] : void 0;
  return /* @__PURE__ */ jsx(
    RichTooltip,
    {
      title,
      subtitle,
      rows,
      content,
      actions: resolvedActions,
      side: "top",
      align: "end",
      ...wide ? { className: "w-80" } : {},
      children: /* @__PURE__ */ jsxs(
        "span",
        {
          className: "inline-flex max-w-full items-center gap-1 rounded-full border border-dashed px-1.5 py-0.5 text-[10px] font-normal normal-case tracking-normal " + (warn ? "border-amber-500/50 bg-amber-500/10 text-amber-700 dark:text-amber-400" : "border-border text-muted-foreground"),
          children: [
            /* @__PURE__ */ jsx(PillIcon, { className: "h-2.5 w-2.5 shrink-0" }),
            /* @__PURE__ */ jsx("span", { className: "shrink-0", children: prefix }),
            /* @__PURE__ */ jsx("span", { className: warn ? "truncate" : "truncate text-foreground", children: value })
          ]
        }
      )
    }
  );
}
function AttributionWriteHint({
  subject,
  kinds,
  defaultVisibility,
  shared = false
}) {
  const { prefs, policies, onConfigure } = useScopeHintContext();
  const scopes = React26.useMemo(() => effectiveScopes(prefs, policies), [policies, prefs]);
  const catalogAdvanced = useCatalogAdvanced();
  const catalogPromote = useCatalogPromote();
  const ladder = useLadderShared();
  const state = writeHintState(subject, kinds, defaultVisibility, {
    shared,
    // The un-raised preference, so a raise can be claimed only when it happened.
    // Keyed by KIND: the write-scope preference is per catalog kind, and the
    // resource names for the four kinds are the kinds themselves. Narrowed the
    // way the write narrows it, or a withheld "team" default reads as a change.
    configuredScope: (kind) => basicWriteScope(kind, scopes.writeScope(kind), catalogAdvanced, catalogPromote)
  });
  if (state.kind === "fixed") {
    return /* @__PURE__ */ jsx(
      HintPill,
      {
        icon: Building2,
        prefix: "Visible to",
        value: "everyone in your tenant",
        title: "Tenant-wide, always",
        subtitle: `Attribution on a ${subject.kind.replace("_", " ")} carries no per-user visibility, so there is nothing to configure.`
      }
    );
  }
  const rows = state.kind === "uniform" ? [{ label: "Applies to", value: state.perKind.map((e) => KIND_LABEL[e.kind]).join(", ") }] : (
    // Per kind only when they differ — the case a single summary would
    // misreport, and the one hit after retuning one preference row and
    // forgetting the others.
    state.perKind.map(({ kind, scope }) => ({
      label: KIND_LABEL[kind],
      value: WRITE_SCOPE_LABEL[scope]
    }))
  );
  if (state.scope === "team") {
    rows.push({
      label: "Teams",
      value: state.teamIds.length > 0 ? `${state.teamIds.length} team${state.teamIds.length === 1 ? "" : "s"}` : "none picked \u2014 falls back to private"
    });
  }
  if (state.raised) {
    rows.push({
      label: "Raised",
      value: "This case is shared, so your private default is written tenant-wide."
    });
  }
  if (!ladder && state.scope !== "team") return null;
  return /* @__PURE__ */ jsx(
    HintPill,
    {
      icon: state.scope ? SCOPE_ICON[state.scope] : Eye,
      prefix: "New:",
      value: state.scope ? WRITE_SCOPE_LABEL[state.scope] : "varies by kind",
      title: "Where new attribution goes",
      subtitle: state.scope ? WRITE_SCOPE_MEANING[state.scope] : "These kinds default to different tiers.",
      rows,
      ...onConfigure ? { onAction: () => onConfigure("write") } : {}
    }
  );
}
var RESOURCE_SUBJECT = {
  transaction: "Transactions",
  address: "Counterparties",
  entity: "Entities",
  label: "Labels",
  tag: "Tags",
  group: "Groups",
  primary: "Primary choices",
  protocol: "Protocol decoding",
  actor: "Actors",
  situation: "Situations",
  watch: "Watches",
  tracer: "Tracers",
  alertRule: "Alert rules",
  groupingRule: "Grouping rules",
  pipeline: "Pipelines",
  savedView: "Saved views"
};
function resolvedSubjects(policies, scopes, resource, resources) {
  const subjects = (resources ?? [resource]).map((each) => ({
    resource: each,
    state: readHintState(policyFor(each, policies), scopes.readScope(each))
  })).filter((each) => each.state.visible);
  const tiers = new Set(subjects.map((each) => each.state.scope));
  return { subjects, agreed: tiers.size === 1 ? subjects[0].state : null };
}
function resolvedRows(subjects, agreed, covers) {
  if (!agreed) {
    return subjects.map((each) => ({
      label: RESOURCE_SUBJECT[each.resource],
      value: RESOLVE_SCOPE_LABEL[each.state.scope]
    }));
  }
  if (covers) return [{ label: "Applies to", value: covers }];
  if (subjects.length > 1) {
    return [
      { label: "Applies to", value: subjects.map((e) => RESOURCE_SUBJECT[e.resource]).join(", ") }
    ];
  }
  return [];
}
function resolvedMeaning(agreed) {
  if (!agreed) {
    return "These subjects open at different tiers, so the chips in one column are not comparable with the next.";
  }
  return agreed.ownView ? "Your own view \u2014 your private overlays on top of the shared tiers." : `Resolved as ${RESOLVE_SCOPE_LABEL[agreed.scope].toLowerCase()} sees it, which drops narrower overlays, including your own private ones.`;
}
function ResolvedScopeHint({
  resource = "address",
  resources,
  covers
}) {
  const ladder = useLadderShared();
  const { prefs, policies, onConfigure } = useScopeHintContext();
  const scopes = effectiveScopes(prefs, policies);
  const { subjects, agreed } = resolvedSubjects(policies, scopes, resource, resources);
  if (subjects.length === 0 || !ladder) return null;
  const rows = resolvedRows(subjects, agreed, covers);
  return /* @__PURE__ */ jsx(
    HintPill,
    {
      icon: Eye,
      prefix: "Reading:",
      value: agreed ? RESOLVE_SCOPE_LABEL[agreed.scope] : "varies by subject",
      title: "Which tier these resolved at",
      subtitle: resolvedMeaning(agreed),
      rows: rows.length > 0 ? rows : void 0,
      ...onConfigure ? { onAction: () => onConfigure("read") } : {}
    }
  );
}
var ROW_SCOPE_COPY = {
  user: {
    icon: Lock,
    value: "only you",
    meaning: "You authored this privately. Teammates do not see it, and neither do the chips they resolve."
  },
  tenant: {
    icon: Building2,
    value: "your tenant",
    meaning: "Everyone in your tenant can see it and attach it."
  },
  org: {
    icon: Building2,
    value: "your org",
    meaning: "Shared with every workspace in your organization. Changing it for everyone needs the catalog promote permission; any workspace can customise how it reads for itself."
  },
  customer: {
    icon: Building2,
    value: "your customer",
    meaning: "Shared with every workspace of your customer. Changing it for everyone needs the catalog promote permission; any workspace can customise how it reads for itself."
  },
  // The ladder's top rung. The WORDS stay "platform" — that is what a reader
  // calls it — while the key is the rung's canonical name, so this table cannot
  // drift from `commons.tenancy.ladder` the way the old `platform` key did.
  global: {
    icon: Globe,
    value: "everyone (platform default)",
    meaning: "A platform-wide default. Shared with every tenant, so it is read-only here."
  }
};
function CatalogTenancyHint({
  row,
  noun = "row"
}) {
  if (!row) return null;
  const ownership = deriveCatalogOwnership(row);
  const copy = ROW_SCOPE_COPY[ownership.scope];
  const rows = [{ label: "Scope", value: ownership.label }];
  if (ownership.tier) rows.push({ label: "Tier", value: ownership.tier });
  if (ownership.readOnly) {
    rows.push({
      label: "Editing",
      value: ownership.isSystemDefault ? "Read-only \u2014 platform defaults are managed centrally." : "Read-only for you."
    });
  }
  return /* @__PURE__ */ jsx(
    HintPill,
    {
      icon: copy.icon,
      prefix: "Visible to",
      value: copy.value,
      title: `This ${noun} lives in ${ownership.label.toLowerCase()}`,
      subtitle: copy.meaning,
      rows
    }
  );
}
var DEFAULT_OPTION = "__default__";
var RESOURCE_LABEL = {
  actor: "Actors",
  situation: "Situations",
  watch: "Watches",
  transaction: "Transactions",
  address: "Addresses",
  entity: "Entities",
  label: "Labels",
  tag: "Tags",
  group: "Groups",
  primary: "Primary choices",
  protocol: "Protocol decoding",
  tracer: "Tracers",
  alertRule: "Alert rules",
  groupingRule: "Grouping rules",
  pipeline: "Pipelines",
  savedView: "Saved views"
};
var WRITE_HINT = {
  transaction: "",
  address: "Overlays you attach to an address",
  entity: "New entities bound to an address",
  label: "New labels + graph label attaches",
  tag: "New tags + graph tag attaches",
  group: "New groups bound to an address",
  // Not who can SEE something: which rung a primary you choose is written at —
  // your own, or everyone's below the rung you pick.
  primary: "Who a primary you pick applies to \u2014 what an address leads with, an entity's headline address",
  protocol: "",
  actor: "",
  situation: "",
  watch: "Visibility of new watches; recipients are configured separately",
  // These five are authored ROWS rather than overlays, so the hint names what
  // is being created rather than what it is attached to.
  tracer: "New flow tracers you create",
  alertRule: "New alert rules (rules carry no tenancy rung \u2014 teams or just you)",
  groupingRule: "New grouping rules you author",
  pipeline: "New pipeline definitions you save",
  savedView: "New saved views (the \u201CShared\u201D choice in the save dialog)"
};
function defaultOptionLabel(inheritedLabel, source) {
  return source === "product" ? `Default (${inheritedLabel})` : `Default (${inheritedLabel} \u2014 ${SCOPE_SOURCE_LABEL[source]})`;
}
function enforcedNotice(resolved) {
  if (!resolved.enforced) return void 0;
  const who = enforcedBySentence(resolved.enforced);
  if (resolved.locked) {
    return resolved.enforced.allowed.length === 0 ? { locked: true, note: `${who}: no visibility is allowed here, so new ones can't be created.` } : { locked: true, note: who };
  }
  return { locked: false, note: `Some options are hidden \u2014 ${who.charAt(0).toLowerCase()}${who.slice(1)}.` };
}
function ScopeRow({
  title,
  hint,
  ariaLabel,
  value,
  options,
  defaultLabel,
  overridden,
  warning,
  enforced,
  onChange
}) {
  const locked = enforced?.locked === true;
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between gap-4 py-3", children: [
    /* @__PURE__ */ jsxs("div", { className: "min-w-0", children: [
      /* @__PURE__ */ jsx("div", { className: "text-sm font-medium text-foreground", children: title }),
      /* @__PURE__ */ jsx("div", { className: "text-xs text-muted-foreground", children: hint }),
      overridden && !locked ? /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: "mt-1 text-xs text-muted-foreground underline underline-offset-2 hover:text-foreground",
          onClick: () => onChange(null),
          children: "Use the default"
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-end gap-1", children: [
      /* @__PURE__ */ jsxs(
        Select,
        {
          value,
          disabled: locked,
          onValueChange: (next) => onChange(next === DEFAULT_OPTION ? null : next),
          children: [
            /* @__PURE__ */ jsx(
              SelectTrigger,
              {
                className: "h-8 w-[190px]",
                "aria-label": ariaLabel,
                ...locked ? { "data-enforced": "locked" } : {},
                children: /* @__PURE__ */ jsx(SelectValue, {})
              }
            ),
            /* @__PURE__ */ jsxs(SelectContent, { children: [
              /* @__PURE__ */ jsx(SelectItem, { value: DEFAULT_OPTION, children: defaultLabel }),
              options.map((option) => /* @__PURE__ */ jsx(SelectItem, { value: option.value, children: option.label }, option.value))
            ] })
          ]
        }
      ),
      enforced ? /* @__PURE__ */ jsxs(
        "p",
        {
          className: "flex max-w-[190px] items-start justify-end gap-1 text-right text-[11px] leading-snug text-muted-foreground",
          "data-testid": "scope-row-enforced",
          children: [
            /* @__PURE__ */ jsx(Lock, { className: "mt-px h-3 w-3 shrink-0", "aria-hidden": true }),
            /* @__PURE__ */ jsx("span", { children: enforced.note })
          ]
        }
      ) : null,
      warning && !locked ? /* @__PURE__ */ jsx("p", { className: "max-w-[190px] text-right text-[11px] leading-snug text-amber-700 dark:text-amber-400", children: warning }) : null
    ] })
  ] });
}
function useScrollToHash(ids) {
  const key = ids.join(",");
  React26.useEffect(() => {
    if (typeof window === "undefined") return;
    const hash = window.location.hash.replace(/^#/, "");
    if (!hash || !key.split(",").includes(hash)) return;
    const frame = window.requestAnimationFrame(() => {
      document.getElementById(hash)?.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    return () => window.cancelAnimationFrame(frame);
  }, [key]);
}
function ScopePreferencesPanel({
  extraReadRows,
  notice,
  footer,
  className
}) {
  const { prefs, policies, teamIds } = useScopeHintContext();
  const entitled = useEntitled();
  const catalogAdvanced = useCatalogAdvanced();
  const catalogPromote = useCatalogPromote();
  const offeredLadder = useOfferedRungs();
  const sharedLadder = useLadderShared();
  const scopes = effectiveScopes(prefs, policies);
  const noTeams = teamIds != null && teamIds.length === 0;
  const gap = React26.useMemo(() => attributionLadderGap(policies), [policies]);
  useScrollToHash(Object.values(SCOPE_PREF_ANCHOR));
  return /* @__PURE__ */ jsxs("div", { className, children: [
    notice,
    /* @__PURE__ */ jsxs(Card, { id: SCOPE_PREF_ANCHOR.write, className: "mb-4 scroll-mt-20", children: [
      /* @__PURE__ */ jsxs(CardHeader, { children: [
        /* @__PURE__ */ jsx(CardTitle, { children: "Default visibility" }),
        /* @__PURE__ */ jsxs(CardDescription, { children: [
          "Who can see what you create, by default. Overlays \u2014 the labels, tags, groups and entities you attach to an address or a graph node \u2014 plus the things you author outright, like a tracer or a saved view. You can still change it each time; this is only where it starts.",
          " ",
          sharedLadder ? "Not every row offers every tier: an alert rule carries no tenancy rung, so it can only be yours or your teams\u2019." : "Not every row offers every choice: an alert rule can only be yours or your teams\u2019.",
          " ",
          "A \u201CSpecific teams\u201D default with no team chosen falls back to private."
        ] })
      ] }),
      /* @__PURE__ */ jsx(CardContent, { className: "divide-y divide-border", children: writeScopeResources(policies).filter((resource) => entitled(policies[resource].writeCapability)).filter(
        (resource) => offeredWriteScopes(resource, policyFor(resource, policies).writeScopes, catalogAdvanced, offeredLadder, catalogPromote).length > 1
      ).map((resource) => {
        const policy = policyFor(resource, policies);
        const resolved = scopes.resolveWrite(resource);
        const enforced = enforcedNotice(resolved);
        return /* @__PURE__ */ jsx(
          ScopeRow,
          {
            title: RESOURCE_LABEL[resource],
            hint: WRITE_HINT[resource],
            ariaLabel: `Default visibility for ${RESOURCE_LABEL[resource]}`,
            value: enforced?.locked ? policy.writeScopes.length > 0 ? resolved.value : DEFAULT_OPTION : resolved.source === "user" ? resolved.value : DEFAULT_OPTION,
            ...enforced ? { enforced } : {},
            defaultLabel: defaultOptionLabel(
              writeScopeLabel(resolved.inherited, sharedLadder),
              resolved.inheritedSource
            ),
            overridden: resolved.source === "user",
            ...basicWriteScope(resource, resolved.value, catalogAdvanced, catalogPromote) !== resolved.value && SHARED_WRITE_SCOPES.includes(resolved.value) ? {
              // A shared-rung default held by someone without the grant.
              warning: "Writing for a whole org or customer needs the catalog promote permission, so this writes for your workspace."
            } : basicWriteScope(resource, resolved.value, catalogAdvanced, catalogPromote) !== resolved.value ? {
              // A default saved (or published) before the plan withheld
              // team sharing. The writes narrow it, and the row says so.
              warning: "Sharing with specific teams isn't included in your plan, so this writes privately \u2014 only you will see it."
            } : noTeams && resolved.value === "team" ? {
              warning: "You are not in any team, so this writes privately \u2014 only you will see it."
            } : {},
            options: offeredWriteScopes(resource, policy.writeScopes, catalogAdvanced, offeredLadder, catalogPromote).concat(
              resolved.source === "user" && !offeredWriteScopes(
                resource,
                policy.writeScopes,
                catalogAdvanced,
                offeredLadder,
                catalogPromote
              ).includes(resolved.value) ? [resolved.value] : []
            ).map((scope) => ({
              value: scope,
              label: writeScopeLabel(scope, sharedLadder)
            })),
            onChange: (next) => prefs.setWriteScope(resource, next === null ? null : next)
          },
          resource
        );
      }) })
    ] }),
    /* @__PURE__ */ jsxs(Card, { id: SCOPE_PREF_ANCHOR.read, className: "mb-4 scroll-mt-20", children: [
      /* @__PURE__ */ jsxs(CardHeader, { children: [
        /* @__PURE__ */ jsx(CardTitle, { children: "Default view scope" }),
        /* @__PURE__ */ jsx(CardDescription, { children: sharedLadder ? "Which tenancy tier reads open at, per resource. \u201CYour view\u201D keeps your personal overlays on top of the shared tiers; a wider tier reads as that tier sees it, which drops your own private overlays from what you are looking at." : "What each read opens at. \u201CYour view\u201D keeps your own overlays on top of the workspace\u2019s; reading as the workspace drops your private ones from what you are looking at." })
      ] }),
      /* @__PURE__ */ jsxs(CardContent, { className: "divide-y divide-border", children: [
        extraReadRows,
        readScopeResources(policies).filter((resource) => entitled(policies[resource].readCapability)).filter(
          (resource) => offeredOptions(policyFor(resource, policies).resolveScopes, offeredLadder, readScopeRung).length > 1
        ).map((resource) => {
          const policy = policyFor(resource, policies);
          const resolved = scopes.resolveRead(resource);
          const enforced = enforcedNotice(resolved);
          return /* @__PURE__ */ jsx(
            ScopeRow,
            {
              title: RESOURCE_LABEL[resource],
              hint: policy.readHint ?? "Tier the resolved overlays open at",
              ariaLabel: `Default resolve scope for ${RESOURCE_LABEL[resource]}`,
              value: enforced?.locked || resolved.source === "user" ? resolved.value : DEFAULT_OPTION,
              ...enforced ? { enforced } : {},
              defaultLabel: defaultOptionLabel(
                resolveScopeLabel(resolved.inherited, sharedLadder),
                resolved.inheritedSource
              ),
              overridden: resolved.source === "user",
              options: offeredOptions(policy.resolveScopes, offeredLadder, readScopeRung).concat(
                resolved.source === "user" && !offeredOptions(policy.resolveScopes, offeredLadder, readScopeRung).includes(
                  resolved.value
                ) ? [resolved.value] : []
              ).map((scope) => ({
                value: scope,
                label: resolveScopeLabel(scope, sharedLadder)
              })),
              onChange: (next) => prefs.setResolveScope(
                resource,
                next === null ? null : next
              )
            },
            resource
          );
        }),
        gap.length > 0 && sharedLadder ? /* @__PURE__ */ jsxs("p", { className: "pt-3 text-xs text-muted-foreground", children: [
          "Transaction feeds can be read at",
          " ",
          gap.map((tier) => txScope(tier).label).join(" and "),
          ", but attribution cannot yet be resolved there \u2014 chips on those feeds fall back to the tier chosen above."
        ] }) : null,
        /* @__PURE__ */ jsxs("p", { className: "pt-3 text-xs text-muted-foreground", children: [
          "Reading addresses as",
          " ",
          resolveScopeLabel(scopes.readScope("address"), sharedLadder).toLowerCase(),
          "; new address overlays go to",
          " ",
          writeScopeLabel(
            basicWriteScope("address", scopes.writeScope("address"), catalogAdvanced, catalogPromote),
            sharedLadder
          ).toLowerCase(),
          "."
        ] })
      ] })
    ] }),
    footer
  ] });
}
function RecordScopeHint({
  label,
  description,
  writesLandIn = null,
  noun = "rows",
  onSwitch,
  switchLabel
}) {
  const ladder = useLadderShared();
  const mismatched = Boolean(writesLandIn) && writesLandIn !== label;
  if (!ladder && !mismatched) return null;
  const rows = [];
  if (description) rows.push({ label: "Holds", value: description });
  if (writesLandIn) rows.push({ label: "Your writes land in", value: writesLandIn });
  return /* @__PURE__ */ jsx(
    HintPill,
    {
      icon: mismatched ? Layers : Database,
      prefix: `${noun[0].toUpperCase()}${noun.slice(1)} from:`,
      value: mismatched ? `${label} \u2014 writes go to ${writesLandIn}` : label,
      title: mismatched ? "You are reading a different tier than you write to" : "Which tier these came from",
      subtitle: mismatched ? `The same record is stored once per tier, so anything you ingest lands in ${writesLandIn} and will not appear in this list.` : `Every ${noun.replace(/s$/, "")} here comes from the ${label.toLowerCase()} partition. The same record can also exist at other tiers.`,
      rows: rows.length > 0 ? rows : void 0,
      tone: mismatched ? "warning" : "muted",
      ...onSwitch ? { onAction: onSwitch } : {},
      ...switchLabel ? { actionLabel: switchLabel } : {}
    }
  );
}
function txRecordScope(scope, { writesLandIn = null, noun, onSwitch, switchLabel } = {}) {
  const def = txScope(scope);
  return {
    label: def.label,
    description: def.description,
    writesLandIn: writesLandIn ? txScope(writesLandIn).label : null,
    ...noun ? { noun } : {},
    ...onSwitch ? { onSwitch } : {},
    ...switchLabel ? { switchLabel } : {}
  };
}
function TxScopeHint({
  scope,
  writesLandIn = null,
  noun,
  onSwitch,
  switchLabel
}) {
  return /* @__PURE__ */ jsx(
    RecordScopeHint,
    {
      ...txRecordScope(scope, {
        writesLandIn,
        ...noun ? { noun } : {},
        ...onSwitch ? { onSwitch } : {},
        ...switchLabel ? { switchLabel } : {}
      })
    }
  );
}
function ScopeAxisBlock({
  heading,
  note,
  rows,
  meaning
}) {
  return /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("div", { className: "text-[10px] font-medium uppercase tracking-wide text-muted-foreground", children: heading }),
    /* @__PURE__ */ jsx("dl", { className: "mt-1 space-y-0.5", children: rows.map((row, i) => /* @__PURE__ */ jsxs("div", { className: "flex items-baseline justify-between gap-3", children: [
      /* @__PURE__ */ jsx("dt", { className: "shrink-0 text-xs text-muted-foreground", children: row.label }),
      /* @__PURE__ */ jsx("dd", { className: "min-w-0 truncate text-right text-xs font-medium", children: row.value })
    ] }, i)) }),
    meaning ? /* @__PURE__ */ jsx("p", { className: "mt-1 text-[11px] leading-snug text-muted-foreground", children: meaning }) : null,
    note ? /* @__PURE__ */ jsx("p", { className: "mt-1 text-[11px] italic leading-snug text-muted-foreground", children: note }) : null
  ] });
}
function SurfaceScopeHint({
  records = null,
  recordOwner = "These records",
  recordOwnerNote,
  resource = "address",
  resources,
  covers
}) {
  const ladder = useLadderShared();
  const { prefs, policies, onConfigure } = useScopeHintContext();
  const scopes = effectiveScopes(prefs, policies);
  const { subjects, agreed } = resolvedSubjects(policies, scopes, resource, resources);
  if (subjects.length === 0 || !ladder) return records ? /* @__PURE__ */ jsx(RecordScopeHint, { ...records }) : null;
  if (!records) {
    return /* @__PURE__ */ jsx(
      ResolvedScopeHint,
      {
        resource,
        ...resources ? { resources } : {},
        ...covers ? { covers } : {}
      }
    );
  }
  const noun = records.noun ?? "rows";
  const nounLabel = `${noun[0].toUpperCase()}${noun.slice(1)}`;
  const attrLabel = agreed ? RESOLVE_SCOPE_LABEL[agreed.scope] : null;
  const { mismatched, attributionNotable } = surfaceHintState(
    records,
    subjects.map((each) => each.state)
  );
  const recordRows = [{ label: nounLabel, value: records.label }];
  if (records.writesLandIn) {
    recordRows.push({ label: "Your writes land in", value: records.writesLandIn });
  }
  const attrRows = [
    { label: "Attribution", value: attrLabel ?? "varies by subject" },
    ...resolvedRows(subjects, agreed, covers)
  ];
  const actions = [];
  if (records.onSwitch) {
    actions.push({
      label: records.switchLabel ?? `Change where ${noun} come from`,
      onClick: records.onSwitch
    });
  }
  if (onConfigure) {
    actions.push({ label: "Change the default", onClick: () => onConfigure("read") });
  }
  return /* @__PURE__ */ jsx(
    HintPill,
    {
      wide: true,
      icon: mismatched ? Layers : attributionNotable ? Eye : Database,
      prefix: "Scope:",
      value: mismatched ? `${records.label} \u2014 writes go to ${records.writesLandIn}` : !agreed ? `${records.label} \xB7 attribution varies` : attributionNotable ? `${records.label} \xB7 attribution ${attrLabel}` : records.label,
      title: mismatched ? "You are reading a different tier than you write to" : "Two tiers decide what you see",
      content: /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
        /* @__PURE__ */ jsx("p", { className: "text-[11px] leading-snug text-muted-foreground", children: mismatched ? `The same record is stored once per tier, so anything you ingest lands in ${records.writesLandIn} and will not appear here.` : `Which partition these ${noun} came from, and which tier the chips on them resolved at.` }),
        /* @__PURE__ */ jsx(
          ScopeAxisBlock,
          {
            heading: recordOwner,
            ...recordOwnerNote ? { note: recordOwnerNote } : {},
            rows: recordRows,
            ...records.description ? { meaning: records.description } : {}
          }
        ),
        /* @__PURE__ */ jsx("div", { className: "border-t pt-2", children: /* @__PURE__ */ jsx(
          ScopeAxisBlock,
          {
            heading: "Your settings",
            note: "Personal \u2014 changing this affects nobody else's view.",
            rows: attrRows,
            meaning: resolvedMeaning(agreed)
          }
        ) })
      ] }),
      ...actions.length > 0 ? { actions } : {},
      tone: mismatched ? "warning" : "muted"
    }
  );
}
function offeredAccepts(subject, kind, advanced) {
  return offeredAttributeKeys(attributionCapability(subject, kind).accepts, advanced);
}
function commitsOnPick(subject, kind, commit, advanced = true) {
  return commit !== "form" || offeredAccepts(subject, kind, advanced).length === 0;
}
function offersRefine(subject, kind, commit, advanced = true) {
  return commit === "on-pick-then-refine" && offeredAccepts(subject, kind, advanced).length > 0;
}
var ATTRIBUTE_LABEL = {
  reason: "the reason",
  evidenceUrl: "the evidence link",
  confidence: "the confidence",
  validFrom: "the start of the window",
  validTo: "the end of the window",
  visibility: "the visibility"
};
var attributeLabel = (key) => ATTRIBUTE_LABEL[key] ?? key;
function usePendingAttribution({
  subject,
  commit = "on-pick",
  defaults,
  onCommit
}) {
  const advanced = useCatalogAdvanced();
  const canPromote = useCatalogPromote();
  const [held, setHeld] = React26.useState(null);
  const [refinable, setRefinable] = React26.useState(null);
  const [busyKinds, setBusyKinds] = React26.useState(
    () => /* @__PURE__ */ new Set()
  );
  const [error, setError] = React26.useState(null);
  const isBusy = React26.useCallback((kind) => busyKinds.has(kind), [busyKinds]);
  const subjectRef = React26.useRef(subjectKey(subject));
  React26.useEffect(() => {
    const key = subjectKey(subject);
    if (subjectRef.current !== key) {
      subjectRef.current = key;
      setHeld(null);
      setRefinable(null);
      setError(null);
    }
  }, [subject]);
  const write = React26.useCallback(
    async (kind, candidate, attributes, cleared = []) => {
      setBusyKinds((prev) => new Set(prev).add(kind));
      setError(null);
      try {
        const sendable = basicAttributes(
          kind,
          pruneToCapability(subject, kind, attributes),
          advanced,
          canPromote
        );
        const sendableCleared = advanced ? cleared : cleared.filter((key) => offeredAttributeKeys([key], advanced).length > 0);
        await onCommit(kind, candidate, sendable, sendableCleared);
        return true;
      } catch (e) {
        setError(catalogWriteErrorMessage(e, "Could not attach"));
        return false;
      } finally {
        setBusyKinds((prev) => {
          if (!prev.has(kind)) return prev;
          const next = new Set(prev);
          next.delete(kind);
          return next;
        });
      }
    },
    [advanced, canPromote, onCommit, subject]
  );
  const pick2 = React26.useCallback(
    (kind, candidate) => {
      const attributes = basicAttributes(kind, { ...defaults?.(kind) }, advanced, canPromote);
      if (!commitsOnPick(subject, kind, commit, advanced)) {
        setRefinable(null);
        setHeld({ kind, candidate, attributes });
        setError(null);
        return;
      }
      void (async () => {
        const ok = await write(kind, candidate, attributes);
        if (!ok) return;
        setHeld(null);
        setRefinable(
          offersRefine(subject, kind, commit, advanced) ? { kind, candidate, attributes, written: attributes, open: false } : null
        );
      })();
    },
    [advanced, canPromote, commit, defaults, subject, write]
  );
  const setAttributes = React26.useCallback((attributes) => {
    setHeld((h) => h ? { ...h, attributes } : h);
    setRefinable((r) => r?.open ? { ...r, attributes } : r);
  }, []);
  const save = React26.useCallback(() => {
    const active = held ?? (refinable?.open ? refinable : null);
    if (!active) return;
    void (async () => {
      const baseline = active.written;
      const cleared = clearedAttributes(baseline, active.attributes);
      const ok = await write(active.kind, active.candidate, active.attributes, cleared);
      if (!ok) return;
      setHeld(null);
      setRefinable(null);
    })();
  }, [held, refinable, write]);
  return {
    pick: pick2,
    held,
    refinable,
    setAttributes,
    save,
    cancel: React26.useCallback(() => {
      setHeld(null);
      setError(null);
    }, []),
    openRefine: React26.useCallback(() => {
      setRefinable((r) => r ? { ...r, open: true } : r);
    }, []),
    dismissRefine: React26.useCallback(() => setRefinable(null), []),
    isBusy,
    error
  };
}
function AttributionAttributesPanel({
  subject,
  active,
  written,
  teamOptions,
  busy,
  confirmLabel = "Attach",
  onChange,
  onCancel,
  onSave
}) {
  const advanced = useCatalogAdvanced();
  const canPromote = useCatalogPromote();
  const accepts = offeredAttributeKeys(
    attributionCapability(subject, active.kind).accepts,
    advanced
  );
  const missing = missingRequired(subject, active.kind, active.attributes);
  const { prefs, policies } = useScopeHintContext();
  const resource = active.kind;
  const policy = policyFor(resource, policies);
  const offeredLadder = useOfferedRungs();
  const writeScopes = offeredWriteScopes(resource, policy.writeScopes, advanced, offeredLadder, canPromote);
  const enforced = enforcedWriteOf(policy);
  const blocked = isWriteBlocked(policy);
  const defaultScope = basicWriteScope(
    resource,
    effectiveScopes(prefs, policies).writeScope(resource),
    advanced,
    canPromote
  );
  const cleared = clearedAttributes(written, active.attributes);
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3 rounded-md border bg-muted/30 p-3", children: [
    /* @__PURE__ */ jsxs("p", { className: "text-sm", children: [
      confirmLabel === "Attach" ? "Attaching" : "Detail for",
      " ",
      /* @__PURE__ */ jsx("span", { className: "font-medium", children: active.candidate.name })
    ] }),
    /* @__PURE__ */ jsx(
      AssignmentAttributesForm,
      {
        accepts,
        value: active.attributes,
        onChange,
        disabled: busy,
        teamOptions,
        writeScopes,
        defaultScope
      }
    ),
    enforced && accepts.includes("visibility") ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", "data-testid": "attach-visibility-enforced", children: blocked ? `${enforcedBySentence(enforced)}: no visibility is allowed for this, so it can't be attached.` : `Visibility options are limited. ${enforcedBySentence(enforced)}.` }) : null,
    cleared.length > 0 && /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
      "Saving removes",
      " ",
      /* @__PURE__ */ jsx("span", { className: "font-medium", children: cleared.map(attributeLabel).join(", ") }),
      " ",
      "from this attribution. Everything you have not changed stays as it is."
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-end gap-2", children: [
      /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: onCancel, disabled: busy, children: "Cancel" }),
      /* @__PURE__ */ jsxs(Button, { size: "sm", onClick: onSave, disabled: busy || missing.length > 0 || blocked, children: [
        busy && /* @__PURE__ */ jsx(Spinner, { size: "sm", className: "mr-1.5" }),
        confirmLabel
      ] })
    ] })
  ] });
}
function AttributionRefinePrompt({
  refinable,
  onOpen,
  onDismiss
}) {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between gap-2 rounded-md border border-dashed bg-muted/20 px-2 py-1.5", children: [
    /* @__PURE__ */ jsxs("p", { className: "min-w-0 truncate text-xs text-muted-foreground", children: [
      "Attached ",
      /* @__PURE__ */ jsx("span", { className: "font-medium text-foreground", children: refinable.candidate.name })
    ] }),
    /* @__PURE__ */ jsxs("span", { className: "flex shrink-0 items-center gap-1", children: [
      /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", className: "h-6 px-2 text-xs", onClick: onOpen, children: "Add detail" }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "sm",
          className: "h-6 px-2 text-xs text-muted-foreground",
          onClick: onDismiss,
          children: "Dismiss"
        }
      )
    ] })
  ] });
}
var DEFAULT_DEBOUNCE_MS = 200;
function useDebounced(value, ms = DEFAULT_DEBOUNCE_MS) {
  const [debounced, setDebounced] = React26.useState(value);
  React26.useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), ms);
    return () => clearTimeout(timer);
  }, [value, ms]);
  return debounced;
}
function ambiguousNames(candidates) {
  const seen = /* @__PURE__ */ new Set();
  const twice = /* @__PURE__ */ new Set();
  for (const c of candidates) {
    const key = (c.name ?? "").trim().toLowerCase();
    if (!key) continue;
    if (seen.has(key)) twice.add(key);
    seen.add(key);
  }
  return twice;
}
function CatalogItemPicker({
  label,
  loadCandidates,
  onPick,
  onCreate,
  selectedIds,
  resolveLogoUrl,
  disabled,
  busy,
  className,
  triggerClassName
}) {
  const [open, setOpen] = React26.useState(false);
  const [query, setQuery] = React26.useState("");
  const [candidates, setCandidates] = React26.useState([]);
  const [loading, setLoading] = React26.useState(false);
  const [creating, setCreating] = React26.useState(false);
  const debouncedQuery = useDebounced(query, 200);
  const resourceRevision = useResourceRevision(open ? CATALOG_RESOURCES : []);
  const selected = React26.useMemo(() => new Set(selectedIds ?? []), [selectedIds]);
  React26.useEffect(() => {
    if (!open) return void 0;
    let cancelled = false;
    setLoading(true);
    loadCandidates(debouncedQuery).then((items) => {
      if (!cancelled) setCandidates(items);
    }).catch(() => {
      if (!cancelled) setCandidates([]);
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [open, debouncedQuery, loadCandidates, resourceRevision]);
  const pick2 = (option) => {
    if (selected.has(option.id) || option.ineligible) return;
    onPick(option);
    setOpen(false);
    setQuery("");
  };
  const trimmed = query.trim();
  const showCreate = Boolean(onCreate) && trimmed.length > 0 && !loading && !candidates.some((c) => c.name.trim().toLowerCase() === trimmed.toLowerCase());
  const ambiguous = React26.useMemo(() => ambiguousNames(candidates), [candidates]);
  const create = async () => {
    if (!onCreate || !trimmed || creating) return;
    setCreating(true);
    try {
      await onCreate(trimmed);
      setOpen(false);
      setQuery("");
    } finally {
      setCreating(false);
    }
  };
  return /* @__PURE__ */ jsxs(
    Popover,
    {
      open,
      onOpenChange: disabled ? void 0 : (next) => {
        setOpen(next);
        if (!next) setQuery("");
      },
      children: [
        /* @__PURE__ */ jsxs(
          PopoverTrigger,
          {
            type: "button",
            disabled: disabled || busy,
            className: cn(
              "inline-flex h-8 items-center gap-1.5 rounded-md border border-dashed bg-background px-2.5 text-sm text-muted-foreground hover:bg-accent/50 disabled:cursor-not-allowed disabled:opacity-50",
              triggerClassName
            ),
            children: [
              busy ? /* @__PURE__ */ jsx(Spinner, { size: "sm" }) : /* @__PURE__ */ jsx(Plus, { className: "h-3.5 w-3.5" }),
              "Add ",
              label.toLowerCase()
            ]
          }
        ),
        /* @__PURE__ */ jsxs(PopoverContent, { align: "start", className: cn("w-72 p-0", className), children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 border-b px-2.5 py-2", children: [
            /* @__PURE__ */ jsx(Search, { className: "h-4 w-4 text-muted-foreground" }),
            /* @__PURE__ */ jsx(
              Input,
              {
                autoFocus: true,
                value: query,
                placeholder: `Search ${label.toLowerCase()} by name\u2026`,
                onChange: (e) => setQuery(e.target.value),
                className: "h-7 border-0 px-0 shadow-none focus-visible:ring-0"
              }
            ),
            loading && /* @__PURE__ */ jsx(Spinner, { size: "sm" })
          ] }),
          /* @__PURE__ */ jsxs("div", { className: "max-h-64 overflow-y-auto p-1", children: [
            !loading && candidates.length === 0 && !showCreate ? /* @__PURE__ */ jsx("p", { className: "px-2 py-6 text-center text-sm text-muted-foreground", children: query ? "No matches" : "Type to search" }) : candidates.map((c) => {
              const isSelected = selected.has(c.id);
              const logoUrl = c.logo ? resolveLogoUrl?.(c.logo) : void 0;
              const disambiguator = !c.ineligible && c.origin && ambiguous.has((c.name ?? "").trim().toLowerCase()) ? c.origin : void 0;
              return /* @__PURE__ */ jsxs(
                "button",
                {
                  type: "button",
                  disabled: isSelected || Boolean(c.ineligible),
                  onClick: () => pick2(c),
                  title: c.ineligible,
                  className: "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left hover:bg-accent disabled:cursor-default disabled:opacity-60",
                  children: [
                    logoUrl ? /* @__PURE__ */ jsx("img", { src: logoUrl, alt: "", className: "h-4 w-4 rounded-sm object-cover" }) : c.color ? /* @__PURE__ */ jsx(ColorSwatch, { color: c.color, size: "sm" }) : /* @__PURE__ */ jsx("span", { className: "h-4 w-4" }),
                    /* @__PURE__ */ jsxs("span", { className: "flex-1 min-w-0", children: [
                      /* @__PURE__ */ jsx("span", { className: "block truncate text-sm", children: c.name }),
                      (c.ineligible ?? disambiguator) && /* @__PURE__ */ jsx("span", { className: "block truncate text-xs text-muted-foreground", children: c.ineligible ?? disambiguator })
                    ] }),
                    isSelected && /* @__PURE__ */ jsx(Check, { className: "h-4 w-4 text-primary" })
                  ]
                },
                c.id
              );
            }),
            showCreate && /* @__PURE__ */ jsxs(
              "button",
              {
                type: "button",
                disabled: creating,
                onClick: () => void create(),
                className: "mt-0.5 flex w-full items-center gap-2 rounded-md border-t px-2 py-1.5 text-left hover:bg-accent disabled:cursor-default disabled:opacity-60",
                children: [
                  creating ? /* @__PURE__ */ jsx(Spinner, { size: "sm" }) : /* @__PURE__ */ jsx(Plus, { className: "h-4 w-4 text-muted-foreground" }),
                  /* @__PURE__ */ jsxs("span", { className: "flex-1 truncate text-sm", children: [
                    "Create ",
                    /* @__PURE__ */ jsxs("span", { className: "font-medium", children: [
                      "\u201C",
                      trimmed,
                      "\u201D"
                    ] })
                  ] })
                ]
              }
            )
          ] })
        ] })
      ]
    }
  );
}
function AttributionEditor({
  subject,
  kinds,
  attached,
  loadCandidates,
  onCommit,
  onRemove,
  canRemove,
  renderEntityLink,
  onCreate,
  commit = "on-pick",
  defaults,
  teamOptions,
  readOnly = false,
  renderKindLabel,
  renderChip,
  className
}) {
  const flow = usePendingAttribution({ subject, commit, defaults, onCommit });
  const subjectOffered = catalogSubjectOffered(subject.kind, useCatalogAdvanced());
  const { held, refinable } = flow;
  const active = held ?? (refinable?.open ? refinable : null);
  const removal = useRemoval(onRemove);
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-3", className), children: [
    kinds.map((kind) => /* @__PURE__ */ jsx(
      KindRow,
      {
        kind,
        items: attached[BUNDLE_KEY[kind]] ?? [],
        busy: flow.isBusy(kind),
        removing: removal.pending,
        readOnly,
        pickable: subjectOffered,
        label: renderKindLabel?.(kind),
        loadCandidates,
        onPick: (k, option) => flow.pick(k, option),
        onRemove: onRemove && removal.remove,
        canRemove,
        renderEntityLink,
        renderChip,
        onCreate
      },
      kind
    )),
    refinable && !refinable.open && /* @__PURE__ */ jsx(
      AttributionRefinePrompt,
      {
        refinable,
        onOpen: flow.openRefine,
        onDismiss: flow.dismissRefine
      }
    ),
    active && /* @__PURE__ */ jsx(
      AttributionAttributesPanel,
      {
        subject,
        active,
        written: held ? void 0 : refinable?.written,
        teamOptions,
        busy: flow.isBusy(active.kind),
        confirmLabel: held ? "Attach" : "Save",
        onChange: flow.setAttributes,
        onCancel: held ? flow.cancel : flow.dismissRefine,
        onSave: flow.save
      }
    ),
    (flow.error || removal.error) && /* @__PURE__ */ jsx("p", { role: "alert", className: "text-sm text-destructive", children: flow.error || removal.error })
  ] });
}
function useRemoval(onRemove) {
  const [pending, setPending] = React26.useState(null);
  const [error, setError] = React26.useState(null);
  const remove = React26.useCallback(
    (kind, catalogId) => {
      if (!onRemove) return;
      setPending(`${kind}:${catalogId}`);
      setError(null);
      void (async () => {
        try {
          await onRemove(kind, catalogId);
        } catch (e) {
          setError(e instanceof Error ? e.message : "Could not remove");
        } finally {
          setPending(null);
        }
      })();
    },
    [onRemove]
  );
  return { remove, pending, error };
}
function KindRow({
  kind,
  items,
  busy,
  removing,
  readOnly,
  pickable,
  label,
  loadCandidates,
  onPick,
  onRemove,
  canRemove,
  renderEntityLink,
  renderChip,
  onCreate
}) {
  const load = React26.useCallback(
    (search) => loadCandidates(kind, search),
    [kind, loadCandidates]
  );
  const create = React26.useMemo(
    () => onCreate ? (name) => onCreate(kind, name) : void 0,
    [kind, onCreate]
  );
  const withRemove = React26.useMemo(
    () => ({
      [BUNDLE_KEY[kind]]: items.map(
        (item) => readOnly || !onRemove || canRemove?.(kind, item) === false ? item : {
          ...item,
          onRemove: () => onRemove(kind, item.id),
          removeDisabled: busy || removing === `${kind}:${item.id}`
        }
      )
    }),
    [busy, canRemove, items, kind, onRemove, readOnly, removing]
  );
  return /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
    label,
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
      /* @__PURE__ */ jsx(
        AttributionChips,
        {
          bundle: withRemove,
          renderEntityLink,
          ...renderChip ? { renderChip } : {},
          kinds: [kind],
          floorMode: "mark",
          max: Math.max(items.length, 1),
          empty: readOnly ? /* @__PURE__ */ jsx("span", { className: "text-sm text-muted-foreground", children: "None" }) : null
        }
      ),
      !readOnly && pickable && /* @__PURE__ */ jsx(
        CatalogItemPicker,
        {
          label: kind,
          loadCandidates: load,
          onPick: (option) => onPick(kind, option),
          onCreate: create,
          selectedIds: items.map((i) => i.id),
          busy
        }
      )
    ] })
  ] });
}
function membershipCellKey(chain, address) {
  return `${chain}|${address}`;
}
function MembershipMatrix({
  chains,
  rows,
  onToggleMember,
  onSetPrimary,
  onHidePrimary,
  headlines,
  onUseInheritedPrimary,
  pending,
  readOnly = false,
  empty,
  renderAddress,
  className
}) {
  const headlineAddress = React26.useMemo(() => {
    const out = /* @__PURE__ */ new Map();
    for (const row of rows) {
      for (const [chain, cell] of Object.entries(row.cells)) {
        if (cell?.state === "primary" && !out.has(chain)) out.set(chain, row.address);
      }
    }
    return out;
  }, [rows]);
  if (rows.length === 0) {
    return /* @__PURE__ */ jsx("div", { className: cn("rounded-md border p-6 text-center text-sm text-muted-foreground", className), children: empty ?? "No addresses mapped to this entity yet." });
  }
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-2", className), children: [
    /* @__PURE__ */ jsx("div", { className: "overflow-x-auto rounded-md border", children: /* @__PURE__ */ jsxs(Table, { className: "w-full border-collapse text-sm", children: [
      /* @__PURE__ */ jsx(TableHeader, { children: /* @__PURE__ */ jsxs(TableRow, { className: "border-b bg-muted/40", children: [
        /* @__PURE__ */ jsx(TableHead, { scope: "col", className: "sticky left-0 z-10 bg-muted/40 px-3 py-2 text-left font-medium", children: "Address" }),
        chains.map((chain) => {
          const headline = headlineAddress.get(chain);
          const info = headlines?.[chain];
          const chainName2 = chainDisplayName(chain) || chain;
          return /* @__PURE__ */ jsx(TableHead, { scope: "col", className: "px-2 py-2 text-center font-medium", children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center gap-0.5", children: [
            /* @__PURE__ */ jsx(ChainAvatar, { chain, size: "sm", showName: "sr-only" }),
            onHidePrimary && !readOnly && headline ? /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                "aria-label": `No headline address on ${chainName2}`,
                title: `No headline address on ${chainName2} \u2014 hides the one shown without choosing another`,
                disabled: pending === membershipCellKey(chain, headline),
                onClick: () => onHidePrimary(chain, headline),
                className: "inline-flex h-5 w-4 items-center justify-center rounded text-muted-foreground hover:text-foreground disabled:opacity-50",
                children: /* @__PURE__ */ jsx(StarOff, { className: "h-3 w-3" })
              }
            ) : null,
            !headline && info?.hiddenBy ? (
              // "None" is a choice somebody made; say whose, so an empty
              // column is not read as "nobody has picked one yet".
              /* @__PURE__ */ jsxs(
                "span",
                {
                  className: "inline-flex h-5 w-4 items-center justify-center text-muted-foreground/70",
                  title: `No headline address on ${chainName2} \u2014 ${info.hiddenBy} chose none`,
                  children: [
                    /* @__PURE__ */ jsx(StarOff, { className: "h-3 w-3", "aria-hidden": true }),
                    /* @__PURE__ */ jsx("span", { className: "sr-only", children: `No headline address on ${chainName2}: ${info.hiddenBy} chose none` })
                  ]
                }
              )
            ) : null,
            !headline && info?.hiddenBy && info.own && onUseInheritedPrimary && !readOnly ? /* @__PURE__ */ jsx(
              "button",
              {
                type: "button",
                "aria-label": `Use the inherited headline on ${chainName2}`,
                title: `Use inherited \u2014 take back your "no headline" on ${chainName2}`,
                onClick: () => onUseInheritedPrimary(chain),
                className: "inline-flex h-5 w-4 items-center justify-center rounded text-muted-foreground hover:text-foreground",
                children: /* @__PURE__ */ jsx(Undo2, { className: "h-3 w-3" })
              }
            ) : null
          ] }) }, chain);
        })
      ] }) }),
      /* @__PURE__ */ jsx(TableBody, { children: rows.map((row) => /* @__PURE__ */ jsxs(TableRow, { className: "border-b last:border-0", children: [
        /* @__PURE__ */ jsx(
          TableHead,
          {
            scope: "row",
            className: "sticky left-0 z-10 bg-background px-3 py-1.5 text-left font-normal",
            children: renderAddress ? renderAddress(row) : /* @__PURE__ */ jsx(AddressDisplay, { address: row.address, label: row.name ?? void 0 })
          }
        ),
        chains.map((chain) => /* @__PURE__ */ jsx(TableCell, { className: "px-1 py-1 text-center", children: /* @__PURE__ */ jsx(
          Cell,
          {
            address: row.address,
            chain,
            cell: row.cells[chain],
            busy: pending === membershipCellKey(chain, row.address),
            readOnly,
            onToggleMember,
            onSetPrimary,
            setBy: headlines?.[chain]?.setBy
          }
        ) }, chain))
      ] }, row.address)) })
    ] }) }),
    /* @__PURE__ */ jsx(
      Legend,
      {
        interactive: !readOnly && Boolean(onToggleMember),
        superseded: rows.some(
          (row) => Object.values(row.cells).some((cell) => cell?.active === false)
        )
      }
    )
  ] });
}
var STATE_STYLE = {
  primary: "border-primary bg-primary/10 text-primary",
  member: "border-emerald-500/40 bg-emerald-500/10 text-emerald-700 dark:text-emerald-400",
  none: "border-dashed border-muted-foreground/30 text-muted-foreground"
};
function Cell({
  address,
  chain,
  cell,
  busy,
  readOnly,
  onToggleMember,
  onSetPrimary,
  setBy
}) {
  const state = cell?.state ?? "none";
  const isMember = state !== "none";
  const isPrimary = state === "primary";
  const unknown = cell?.known === false;
  const superseded = cell?.active === false;
  const canToggle = Boolean(onToggleMember) && !readOnly;
  const rows = [
    {
      label: "Membership",
      value: superseded ? `${MEMBERSHIP_LABEL[state]} until recently` : MEMBERSHIP_LABEL[state]
    },
    ...superseded ? [{ label: "Status", value: "Superseded \u2014 no longer current" }] : [],
    ...cell?.role ? [{ label: "Role", value: membershipRoleLabel(cell.role) }] : [],
    ...cell?.tier ? [{ label: "In the entity", value: TIER_LABEL[cell.tier] }] : [],
    ...cell?.addressType ? [
      {
        label: "Address type",
        value: ADDRESS_TYPE_LABEL[cell.addressType] ?? cell.addressType
      }
    ] : [],
    ...cell?.isContract != null ? [{ label: "Code", value: cell.isContract ? "Contract" : "No code" }] : [],
    ...unknown ? [{ label: "On this chain", value: "Never seen" }] : []
  ];
  const mark = busy ? /* @__PURE__ */ jsx(Spinner, { size: "sm" }) : state === "primary" ? /* @__PURE__ */ jsx(Star, { className: cn("h-3.5 w-3.5", !superseded && "fill-current") }) : state === "member" ? /* @__PURE__ */ jsx("span", { "aria-hidden": true, children: superseded ? "\u25CB" : "\u25CF" }) : /* @__PURE__ */ jsx("span", { "aria-hidden": true, className: "text-xs", children: unknown ? "\xB7" : "\u2013" });
  const chainName2 = chainDisplayName(chain) || chain;
  const label = superseded ? `${MEMBERSHIP_LABEL[state]} on ${chainName2}, superseded` : `${MEMBERSHIP_LABEL[state]} on ${chainName2}`;
  const summary = [label, ...rows.slice(1).map((r) => `${r.label}: ${r.value}`)].join(" \xB7 ");
  return /* @__PURE__ */ jsxs("div", { className: "inline-flex items-center gap-0.5", children: [
    /* @__PURE__ */ jsx(RichTooltip, { title: cell?.role ? membershipRoleLabel(cell.role) : MEMBERSHIP_LABEL[state], rows, children: /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        "aria-label": summary,
        "aria-pressed": isMember,
        title: summary,
        disabled: !canToggle || busy,
        onClick: canToggle ? () => onToggleMember?.(address, chain, !isMember) : void 0,
        className: cn(
          "inline-flex h-6 w-6 items-center justify-center rounded border",
          STATE_STYLE[state],
          unknown && "opacity-50",
          // Desaturated as well as faded: on a grid where colour carries the
          // membership state, draining the colour is what says "this was true
          // once" without inventing a fourth state's palette.
          superseded && "border-dashed opacity-60 grayscale",
          canToggle && !busy ? "hover:bg-accent" : "cursor-default"
        ),
        children: mark
      }
    ) }),
    onSetPrimary && !readOnly && isMember && /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        "aria-label": isPrimary ? `Remove as headline address on ${chainName2}` : `Make headline address on ${chainName2}`,
        "aria-pressed": isPrimary,
        title: isPrimary ? `Remove as headline address on ${chainName2}${setBy ? ` (${setBy})` : ""}` : `Make headline address on ${chainName2}`,
        ...isPrimary && setBy ? { "data-headline-set-by": setBy } : {},
        disabled: busy,
        onClick: () => onSetPrimary(address, chain, !isPrimary),
        className: cn(
          "inline-flex h-6 w-4 items-center justify-center rounded disabled:opacity-50",
          isPrimary ? "text-primary hover:text-muted-foreground" : "text-muted-foreground hover:text-primary"
        ),
        children: /* @__PURE__ */ jsx(Star, { className: cn("h-3 w-3", isPrimary && "fill-current") })
      }
    )
  ] });
}
var MEMBERSHIP_LABEL = {
  primary: "Headline address",
  member: "Member",
  none: "Not a member"
};
var TIER_LABEL = {
  core: "Core \u2014 part of what the entity is",
  derived: "Generated \u2014 a factory or per-token deployment"
};
function Legend({
  interactive,
  superseded
}) {
  return /* @__PURE__ */ jsxs("p", { className: "flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground", children: [
    /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1", children: [
      /* @__PURE__ */ jsx(Star, { className: "h-3 w-3 fill-current text-primary" }),
      " Headline on that chain"
    ] }),
    /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1", children: [
      /* @__PURE__ */ jsx("span", { className: "text-emerald-600 dark:text-emerald-400", children: "\u25CF" }),
      " Member"
    ] }),
    superseded && /* @__PURE__ */ jsx("span", { className: "inline-flex items-center gap-1", children: "\u25CB Was a member, superseded" }),
    /* @__PURE__ */ jsx("span", { className: "inline-flex items-center gap-1", children: "\u2013 Not a member" }),
    /* @__PURE__ */ jsx("span", { className: "inline-flex items-center gap-1", children: "\xB7 Never seen on that chain" }),
    interactive && /* @__PURE__ */ jsx("span", { children: "Click a cell to claim or release it, or the star to set the headline." })
  ] });
}
function RoleCombobox({
  value,
  onChange,
  suggestions = MEMBERSHIP_ROLE_SUGGESTIONS,
  placeholder = "Role (optional) \u2014 e.g. treasury",
  disabled,
  id,
  className
}) {
  const [open, setOpen] = React26.useState(false);
  const needle = value.trim().toLowerCase();
  const matches = React26.useMemo(() => {
    if (!needle) return suggestions;
    const hits = suggestions.filter(
      (s) => s.value.toLowerCase().includes(needle) || s.label.toLowerCase().includes(needle)
    );
    return hits.length > 0 ? hits : suggestions;
  }, [needle, suggestions]);
  const picked = membershipRoleSuggestion(value);
  return /* @__PURE__ */ jsxs("div", { className: cn("relative", className), children: [
    /* @__PURE__ */ jsx(
      Input,
      {
        id,
        value,
        disabled,
        placeholder,
        onChange: (e) => onChange(e.target.value),
        onFocus: () => setOpen(true),
        className: "pr-8",
        autoComplete: "off"
      }
    ),
    /* @__PURE__ */ jsxs(Popover, { open: open && !disabled, onOpenChange: setOpen, children: [
      /* @__PURE__ */ jsx(
        PopoverTrigger,
        {
          type: "button",
          disabled,
          "aria-label": "Suggested roles",
          className: "absolute right-1 top-1 inline-flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground hover:bg-accent disabled:opacity-50",
          children: /* @__PURE__ */ jsx(ChevronDown, { className: "h-4 w-4" })
        }
      ),
      /* @__PURE__ */ jsxs(
        PopoverContent,
        {
          align: "end",
          className: "w-72 p-1",
          onOpenAutoFocus: (e) => e.preventDefault(),
          children: [
            /* @__PURE__ */ jsx("p", { className: "px-2 py-1.5 text-xs text-muted-foreground", children: "Suggestions \u2014 or type your own." }),
            matches.map((s) => /* @__PURE__ */ jsxs(
              "button",
              {
                type: "button",
                onClick: () => {
                  onChange(s.value);
                  setOpen(false);
                },
                className: "flex w-full items-start gap-2 rounded-md px-2 py-1.5 text-left hover:bg-accent",
                children: [
                  /* @__PURE__ */ jsxs("span", { className: "flex-1 min-w-0", children: [
                    /* @__PURE__ */ jsx("span", { className: "block truncate text-sm", children: s.label }),
                    /* @__PURE__ */ jsx("span", { className: "block truncate text-xs text-muted-foreground", children: s.hint })
                  ] }),
                  picked?.value === s.value && /* @__PURE__ */ jsx(Check, { className: "mt-0.5 h-4 w-4 text-primary" })
                ]
              },
              s.value
            ))
          ]
        }
      )
    ] }),
    value.trim() && !picked && /* @__PURE__ */ jsx("p", { className: "mt-1 text-xs text-muted-foreground", children: "Custom role \u2014 stored as typed, shared with everyone in the tenant." })
  ] });
}
function usePrimaryWriteTarget() {
  const { prefs, policies } = useScopeHintContext();
  const advanced = useCatalogAdvanced();
  const canPromote = useCatalogPromote();
  return React26.useMemo(() => {
    const policy = policyFor("primary", policies);
    const scope = basicWriteScope(
      "primary",
      effectiveScopes(prefs, policies).writeScope("primary"),
      advanced,
      canPromote
    );
    const rule = enforcedWriteOf(policy);
    return {
      scope,
      rung: primaryWriteRung(scope),
      blocked: isWriteBlocked(policy),
      ...rule ? { enforcedNote: `${enforcedBySentence(rule)}.` } : {}
    };
  }, [advanced, canPromote, policies, prefs]);
}
function liveStatusFromConnection(status) {
  switch (status) {
    case "open":
      return "live";
    case "connecting":
    case "reconnecting":
    case "degraded":
      return "connecting";
    case "error":
      return "offline";
    default:
      return "paused";
  }
}
var DOT = {
  live: "bg-finality-finalized",
  paused: "bg-muted-foreground",
  connecting: "bg-finality-pending",
  offline: "bg-risk-high"
};
var LABEL = {
  live: "Live",
  paused: "Paused",
  connecting: "Connecting",
  offline: "Offline"
};
var STATUS_HINT = {
  live: "Connected and receiving live updates.",
  paused: "Live updates are paused \u2014 using the last fetched page.",
  connecting: "Establishing the live connection\u2026",
  offline: "The live connection is unavailable; falling back to refresh."
};
function LiveIndicator({
  status,
  count,
  onToggle,
  label,
  className,
  details,
  detailsTitle = "Live feed"
}) {
  const pulsing = status === "live" || status === "connecting";
  const pill = /* @__PURE__ */ jsxs(
    "span",
    {
      className: cn(
        "inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs font-medium",
        details && "cursor-default",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs("span", { className: "relative inline-flex h-2 w-2", children: [
          pulsing && /* @__PURE__ */ jsx("span", { className: cn("absolute inline-flex h-full w-full animate-ping rounded-full opacity-75", DOT[status]) }),
          /* @__PURE__ */ jsx("span", { className: cn("relative inline-flex h-2 w-2 rounded-full", DOT[status]) })
        ] }),
        /* @__PURE__ */ jsx("span", { children: label ?? LABEL[status] }),
        typeof count === "number" && count > 0 && /* @__PURE__ */ jsxs("span", { className: "rounded-full bg-brand/15 px-1.5 text-[11px] text-brand", children: [
          count,
          " new"
        ] }),
        onToggle && /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            onClick: onToggle,
            "aria-label": status === "paused" ? "Resume live updates" : "Pause live updates",
            className: "inline-flex items-center text-muted-foreground transition-colors hover:text-foreground",
            children: status === "paused" ? /* @__PURE__ */ jsx(Play, { className: "h-3.5 w-3.5" }) : /* @__PURE__ */ jsx(Pause, { className: "h-3.5 w-3.5" })
          }
        )
      ]
    }
  );
  if (!details) return pill;
  return /* @__PURE__ */ jsxs(HoverCard, { openDelay: 120, closeDelay: 80, children: [
    /* @__PURE__ */ jsx(HoverCardTrigger, { asChild: true, children: pill }),
    /* @__PURE__ */ jsxs(HoverCardContent, { align: "end", className: "w-72 text-sm", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 font-medium", children: [
        /* @__PURE__ */ jsx("span", { className: cn("inline-flex h-2 w-2 rounded-full", DOT[status]) }),
        detailsTitle
      ] }),
      /* @__PURE__ */ jsx("p", { className: "mt-1 text-xs text-muted-foreground", children: STATUS_HINT[status] }),
      /* @__PURE__ */ jsx("div", { className: "mt-3", children: details })
    ] })
  ] });
}
function effectiveLiveMode(mode, liveAvailable) {
  return mode === "live" && !liveAvailable ? "interval" : mode;
}
function liveModeOptions({
  liveAvailable = true,
  modes,
  liveHidden = false,
  liveUnavailableReason
} = {}) {
  const offered = modes ?? LIVE_MODES.filter((value) => !(liveHidden && value === "live"));
  return LIVE_MODES.filter((value) => offered.includes(value)).map((value) => ({
    value,
    label: LIVE_MODE_LABELS[value],
    disabled: value === "live" && !liveAvailable,
    title: value === "live" && !liveAvailable ? liveUnavailableReason ?? "Live streaming isn't available here yet \u2014 using auto-refresh." : void 0
  }));
}
function LiveModeControl({
  mode,
  onChange,
  liveAvailable = true,
  modes,
  liveHidden = false,
  liveUnavailableReason,
  size = "sm",
  className
}) {
  const options = liveModeOptions({ liveAvailable, modes, liveHidden, liveUnavailableReason });
  if (options.length < 2) return null;
  return /* @__PURE__ */ jsx(
    ViewModeToggle,
    {
      "aria-label": "Live update mode",
      options,
      value: allowedLiveMode(
        effectiveLiveMode(mode, liveAvailable),
        options.map((o) => o.value)
      ),
      onChange,
      size,
      className
    }
  );
}

// src/domain/chainQuery.ts
function matchesChainQuery(option, query) {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  return option.slug.toLowerCase().includes(q) || option.label.toLowerCase().includes(q) || option.value.toLowerCase().includes(q);
}
function ChainMultiSelect({
  value,
  onChange,
  "aria-label": ariaLabel,
  valueKind = "slug",
  chains,
  evmOnly = false,
  includeTestnets = false,
  sort = "name",
  fallback = "skip",
  allChainsLabel = "All chains",
  clearLabel = "Clear \u2014 applies to all chains",
  placeholder = "Search chains\u2026",
  disabled,
  id,
  className
}) {
  const [open, setOpen] = React26.useState(false);
  const [query, setQuery] = React26.useState("");
  const registryVersion = useChainRegistryVersion();
  const options = React26.useMemo(
    () => {
      return chainSelectOptions({ valueKind, chains, evmOnly, includeTestnets, sort, fallback, keep: value });
    },
    [valueKind, chains, evmOnly, includeTestnets, sort, fallback, value, registryVersion]
  );
  const filtered = React26.useMemo(
    () => options.filter((c) => matchesChainQuery(c, query)),
    [options, query]
  );
  const selected = new Set(value);
  const toggle = (next) => {
    const picked = new Set(selected);
    if (picked.has(next)) picked.delete(next);
    else picked.add(next);
    onChange([...picked]);
  };
  const selectedChains = options.filter((c) => selected.has(c.value));
  return /* @__PURE__ */ jsxs(Popover, { open, onOpenChange: disabled ? void 0 : setOpen, children: [
    /* @__PURE__ */ jsx(
      PopoverTrigger,
      {
        id,
        type: "button",
        "aria-label": ariaLabel,
        disabled,
        className: cn(
          "flex min-h-9 w-full flex-wrap items-center gap-1 rounded-md border bg-background px-2 py-1 text-left text-sm hover:bg-accent/50 disabled:cursor-not-allowed disabled:opacity-50",
          className
        ),
        children: selectedChains.length === 0 ? /* @__PURE__ */ jsx("span", { className: "px-1 text-muted-foreground", children: allChainsLabel }) : selectedChains.map((c) => /* @__PURE__ */ jsxs(Badge, { variant: "secondary", className: "gap-1 pl-1", children: [
          /* @__PURE__ */ jsx(ChainAvatar, { chain: c.slug, size: "sm", showName: false }),
          c.label,
          /* @__PURE__ */ jsx(
            "span",
            {
              role: "button",
              tabIndex: -1,
              "aria-label": `Remove ${c.label}`,
              onClick: (e) => {
                e.stopPropagation();
                toggle(c.value);
              },
              className: "ml-0.5 rounded-sm hover:text-destructive",
              children: /* @__PURE__ */ jsx(X, { className: "h-3 w-3" })
            }
          )
        ] }, c.value))
      }
    ),
    /* @__PURE__ */ jsxs(PopoverContent, { align: "start", className: "w-72 p-0", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 border-b px-2.5 py-2", children: [
        /* @__PURE__ */ jsx(Search, { className: "h-4 w-4 text-muted-foreground" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            autoFocus: true,
            value: query,
            placeholder,
            onChange: (e) => setQuery(e.target.value),
            className: "h-7 border-0 px-0 shadow-none focus-visible:ring-0"
          }
        )
      ] }),
      /* @__PURE__ */ jsx("div", { className: "max-h-64 overflow-y-auto p-1", children: filtered.length === 0 ? /* @__PURE__ */ jsx("p", { className: "px-2 py-6 text-center text-sm text-muted-foreground", children: "No chains found" }) : filtered.map((c) => /* @__PURE__ */ jsxs(
        "label",
        {
          className: "flex cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 hover:bg-accent",
          children: [
            /* @__PURE__ */ jsx(Checkbox, { checked: selected.has(c.value), onCheckedChange: () => toggle(c.value) }),
            /* @__PURE__ */ jsx(ChainAvatar, { chain: c.slug, size: "sm", showName: false }),
            /* @__PURE__ */ jsx("span", { className: "flex-1 truncate text-sm", children: c.label }),
            c.isTestnet && /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "text-[10px]", children: "testnet" })
          ]
        },
        c.value
      )) }),
      value.length > 0 && /* @__PURE__ */ jsx("div", { className: "border-t p-1.5", children: /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          onClick: () => onChange([]),
          className: "w-full rounded-md px-2 py-1 text-left text-xs text-muted-foreground hover:bg-accent hover:text-foreground",
          children: clearLabel
        }
      ) })
    ] })
  ] });
}
function ChainSelect({
  value,
  onChange,
  valueKind = "slug",
  evmOnly = false,
  allowedChains,
  includeTestnets = false,
  sort = "name",
  fallback = "skip",
  allowAny = false,
  anyLabel = "Any chain",
  anyValue = "",
  showAvatar = true,
  placeholder = "Select chain\u2026",
  disabled,
  id,
  className
}) {
  const [open, setOpen] = React26.useState(false);
  const [query, setQuery] = React26.useState("");
  const registryVersion = useChainRegistryVersion();
  const options = React26.useMemo(
    () => {
      return chainSelectOptions({ valueKind, evmOnly, includeTestnets, sort, fallback, keep: [value] }).filter((option) => !allowedChains || allowedChains.includes(toCanonicalChainId(option.slug) ?? option.slug));
    },
    [valueKind, evmOnly, includeTestnets, sort, fallback, allowedChains, value, registryVersion]
  );
  const filtered = React26.useMemo(
    () => options.filter((option) => matchesChainQuery(option, query)),
    [options, query]
  );
  const isAny = allowAny && value === anyValue;
  const selected = isAny ? null : options.find((option) => option.value === value) ?? null;
  const showAny = allowAny && (!query.trim() || anyLabel.toLowerCase().includes(query.trim().toLowerCase()));
  const pick2 = (next) => {
    onChange(next);
    setOpen(false);
    setQuery("");
  };
  return /* @__PURE__ */ jsxs(
    Popover,
    {
      open,
      onOpenChange: (next) => {
        if (disabled) return;
        setOpen(next);
        if (!next) setQuery("");
      },
      children: [
        /* @__PURE__ */ jsx(PopoverTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            id,
            role: "combobox",
            "aria-expanded": open,
            "aria-haspopup": "listbox",
            disabled,
            className: cn(
              "flex h-9 w-full items-center justify-between whitespace-nowrap rounded-md border border-input bg-transparent px-3 py-2 text-sm shadow-sm ring-offset-background focus:outline-none focus:ring-1 focus:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
              className
            ),
            children: [
              /* @__PURE__ */ jsx("span", { className: "flex min-w-0 items-center gap-2", children: isAny ? /* @__PURE__ */ jsx("span", { className: "truncate", children: anyLabel }) : selected ? /* @__PURE__ */ jsxs(Fragment, { children: [
                showAvatar && /* @__PURE__ */ jsx(ChainAvatar, { chain: selected.slug, size: "sm", showName: false }),
                /* @__PURE__ */ jsx("span", { className: "truncate", children: selected.label })
              ] }) : /* @__PURE__ */ jsx("span", { className: "truncate text-muted-foreground", children: placeholder }) }),
              /* @__PURE__ */ jsx(ChevronDown, { className: "h-4 w-4 shrink-0 opacity-50" })
            ]
          }
        ) }),
        /* @__PURE__ */ jsxs(PopoverContent, { align: "start", className: "w-72 p-0", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 border-b px-2.5 py-2", children: [
            /* @__PURE__ */ jsx(Search, { className: "h-4 w-4 text-muted-foreground", "aria-hidden": true }),
            /* @__PURE__ */ jsx(
              Input,
              {
                autoFocus: true,
                value: query,
                placeholder: "Search chains\u2026",
                "aria-label": "Search chains",
                onChange: (e) => setQuery(e.target.value),
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    if (showAny && !query.trim()) pick2(anyValue);
                    else if (filtered[0]) pick2(filtered[0].value);
                  }
                },
                className: "h-7 border-0 px-0 shadow-none focus-visible:ring-0"
              }
            )
          ] }),
          /* @__PURE__ */ jsxs("div", { role: "listbox", className: "max-h-64 overflow-y-auto p-1", children: [
            showAny ? /* @__PURE__ */ jsxs(
              "button",
              {
                type: "button",
                role: "option",
                "aria-selected": isAny,
                onClick: () => pick2(anyValue),
                className: "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm hover:bg-accent",
                children: [
                  /* @__PURE__ */ jsx("span", { className: "flex-1 truncate", children: anyLabel }),
                  isAny ? /* @__PURE__ */ jsx(Check, { className: "h-4 w-4" }) : null
                ]
              }
            ) : null,
            filtered.length === 0 && !showAny ? /* @__PURE__ */ jsx("p", { className: "px-2 py-6 text-center text-sm text-muted-foreground", children: "No chains found" }) : filtered.map((option) => {
              const isSelected = !isAny && option.value === value;
              return /* @__PURE__ */ jsxs(
                "button",
                {
                  type: "button",
                  role: "option",
                  "aria-selected": isSelected,
                  onClick: () => pick2(option.value),
                  className: "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm hover:bg-accent",
                  children: [
                    showAvatar && /* @__PURE__ */ jsx(ChainAvatar, { chain: option.slug, size: "sm", showName: false }),
                    /* @__PURE__ */ jsx("span", { className: "flex-1 truncate", children: option.label }),
                    option.isTestnet && /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "text-[10px]", children: "testnet" }),
                    isSelected ? /* @__PURE__ */ jsx(Check, { className: "h-4 w-4" }) : null
                  ]
                },
                option.value
              );
            })
          ] })
        ] })
      ]
    }
  );
}
var SECTIONS = [
  { kind: "tag", label: "Tags", field: "tagIds" },
  { kind: "label", label: "Labels", field: "labelIds" },
  { kind: "entity", label: "Entities", field: "entityIds" }
];
function GroupMemberPicker({
  value,
  onChange,
  loadCandidates,
  resolveSelected,
  resolveLogoUrl,
  disabled,
  className
}) {
  const [cache, setCache] = React26.useState({});
  const cacheKey = (kind, id) => `${kind}:${id}`;
  const remember = React26.useCallback((kind, items, replaceIds = []) => {
    if (items.length === 0 && replaceIds.length === 0) return;
    setCache((prev) => {
      const next = { ...prev };
      for (const id of replaceIds) delete next[cacheKey(kind, id)];
      for (const item of items) next[cacheKey(kind, item.id)] = item;
      return next;
    });
  }, []);
  return /* @__PURE__ */ jsx("div", { className: cn("space-y-3", className), children: SECTIONS.map(({ kind, label, field }) => /* @__PURE__ */ jsx(
    MemberSection,
    {
      kind,
      label,
      ids: value[field],
      onChangeIds: (ids) => onChange({ ...value, [field]: ids }),
      loadCandidates,
      resolveSelected,
      resolveLogoUrl,
      cache,
      remember,
      disabled
    },
    kind
  )) });
}
function MemberSection({
  kind,
  label,
  ids,
  onChangeIds,
  loadCandidates,
  resolveSelected,
  resolveLogoUrl,
  cache,
  remember,
  disabled
}) {
  const [open, setOpen] = React26.useState(false);
  const [query, setQuery] = React26.useState("");
  const [candidates, setCandidates] = React26.useState([]);
  const [loading, setLoading] = React26.useState(false);
  const debouncedQuery = useDebounced(query, 200);
  const resourceRevision = useResourceRevision(open || ids.length > 0 ? CATALOG_RESOURCES : []);
  const selected = new Set(ids);
  React26.useEffect(() => {
    if (!open) return void 0;
    let cancelled = false;
    setLoading(true);
    loadCandidates(kind, debouncedQuery).then((items) => {
      if (cancelled) return;
      setCandidates(items);
      remember(kind, items);
    }).catch(() => {
      if (!cancelled) setCandidates([]);
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [open, debouncedQuery, kind, loadCandidates, remember, resourceRevision]);
  React26.useEffect(() => {
    if (!resolveSelected) return void 0;
    const missing = resourceRevision > 0 ? ids : ids.filter((id) => !cache[`${kind}:${id}`]);
    if (missing.length === 0) return void 0;
    let cancelled = false;
    resolveSelected(kind, missing).then((items) => {
      if (!cancelled) remember(kind, items, missing);
    }).catch(() => void 0);
    return () => {
      cancelled = true;
    };
  }, [kind, ids.join(","), resolveSelected, remember, resourceRevision]);
  const toggle = (id) => {
    const next = new Set(selected);
    if (next.has(id)) next.delete(id);
    else next.add(id);
    onChangeIds([...next]);
  };
  const labelFor = (id) => cache[`${kind}:${id}`] ?? { id, name: shortenIdentifier(id) };
  return /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: label }),
      /* @__PURE__ */ jsxs("span", { className: "text-[10px] text-muted-foreground", children: [
        ids.length,
        " selected"
      ] })
    ] }),
    ids.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: ids.map((id) => {
      const c = labelFor(id);
      return /* @__PURE__ */ jsxs(Badge, { variant: "secondary", className: "gap-1 pl-1", children: [
        c.color ? /* @__PURE__ */ jsx(ColorSwatch, { color: c.color, size: "sm" }) : null,
        /* @__PURE__ */ jsx("span", { className: "max-w-[160px] truncate", children: c.name }),
        /* @__PURE__ */ jsx(
          "span",
          {
            role: "button",
            tabIndex: -1,
            "aria-label": `Remove ${c.name}`,
            onClick: () => !disabled && toggle(id),
            className: "ml-0.5 cursor-pointer rounded-sm px-0.5 hover:text-destructive",
            children: "\xD7"
          }
        )
      ] }, id);
    }) }),
    /* @__PURE__ */ jsxs(Popover, { open, onOpenChange: disabled ? void 0 : setOpen, children: [
      /* @__PURE__ */ jsxs(
        PopoverTrigger,
        {
          type: "button",
          disabled,
          className: "flex h-9 w-full items-center gap-2 rounded-md border bg-background px-2 text-left text-sm text-muted-foreground hover:bg-accent/50 disabled:cursor-not-allowed disabled:opacity-50",
          children: [
            /* @__PURE__ */ jsx(Search, { className: "h-4 w-4" }),
            "Add ",
            label.toLowerCase(),
            "\u2026"
          ]
        }
      ),
      /* @__PURE__ */ jsxs(PopoverContent, { align: "start", className: "w-72 p-0", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 border-b px-2.5 py-2", children: [
          /* @__PURE__ */ jsx(Search, { className: "h-4 w-4 text-muted-foreground" }),
          /* @__PURE__ */ jsx(
            Input,
            {
              autoFocus: true,
              value: query,
              placeholder: `Search ${label.toLowerCase()}\u2026`,
              onChange: (e) => setQuery(e.target.value),
              className: "h-7 border-0 px-0 shadow-none focus-visible:ring-0"
            }
          ),
          loading && /* @__PURE__ */ jsx(Spinner, { size: "sm" })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "max-h-64 overflow-y-auto p-1", children: !loading && candidates.length === 0 ? /* @__PURE__ */ jsx("p", { className: "px-2 py-6 text-center text-sm text-muted-foreground", children: query ? "No matches" : "Type to search" }) : candidates.map((c) => {
          const isSelected = selected.has(c.id);
          const logoUrl = c.logo ? resolveLogoUrl?.(c.logo) : void 0;
          return /* @__PURE__ */ jsxs(
            "button",
            {
              type: "button",
              onClick: () => toggle(c.id),
              className: "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left hover:bg-accent",
              children: [
                logoUrl ? /* @__PURE__ */ jsx("img", { src: logoUrl, alt: "", className: "h-4 w-4 rounded-sm object-cover" }) : c.color ? /* @__PURE__ */ jsx(ColorSwatch, { color: c.color, size: "sm" }) : /* @__PURE__ */ jsx("span", { className: "h-4 w-4" }),
                /* @__PURE__ */ jsx("span", { className: "flex-1 truncate text-sm", children: c.name }),
                isSelected && /* @__PURE__ */ jsx(Check, { className: "h-4 w-4 text-primary" })
              ]
            },
            c.id
          );
        }) })
      ] })
    ] })
  ] });
}
var RISK_LEVELS = ["safe", "low", "medium", "high", "severe"];
var SEVERITIES = ["info", "low", "medium", "high", "critical"];
var UNSET = "__unset__";
function CatalogItemForm({
  value,
  onChange,
  errors,
  onUploadLogo,
  resolveLogoUrl,
  includeTestnets,
  loadGroupCandidates,
  resolveGroupSelected,
  disabled,
  lockName,
  canSetLifecycle = false,
  advanced: advancedProp,
  className
}) {
  const planAdvanced = useCatalogAdvanced();
  const advanced = advancedProp ?? planAdvanced;
  const [logoPreview, setLogoPreview] = React26.useState(
    value.logo ? { key: value.logo, url: resolveLogoUrl?.(value.logo) } : null
  );
  const set = (patch) => onChange({ ...value, ...patch });
  const fieldError = (name) => errors?.[name]?.[0];
  const hasColor = value.kind === "tag" || value.kind === "label" || value.kind === "group" || value.kind === "entity";
  const hasRisk = value.kind === "address" || advanced && (value.kind === "label" || value.kind === "entity");
  const hasSeverity = advanced;
  const showLifecycle = canSetLifecycle && advanced;
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-4", className), children: [
    /* @__PURE__ */ jsx(
      Field,
      {
        label: "Name",
        error: fieldError("name"),
        required: true,
        hint: lockName ? "The id is derived from the name, so it can't be renamed \u2014 create a new row instead." : void 0,
        children: /* @__PURE__ */ jsx(
          Input,
          {
            value: value.name,
            disabled: disabled || lockName,
            readOnly: lockName,
            onChange: (e) => set({ name: e.target.value }),
            "aria-invalid": Boolean(fieldError("name"))
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(Field, { label: "Description", error: fieldError("description"), children: /* @__PURE__ */ jsx(
      Textarea,
      {
        rows: 2,
        value: value.description ?? "",
        disabled,
        onChange: (e) => set({ description: e.target.value })
      }
    ) }),
    value.kind === "address" && /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-3", children: [
      /* @__PURE__ */ jsx(Field, { label: "Address", error: fieldError("address"), required: true, children: /* @__PURE__ */ jsx(
        Input,
        {
          value: value.address,
          disabled,
          onChange: (e) => set({ address: e.target.value })
        }
      ) }),
      /* @__PURE__ */ jsx(Field, { label: "Chain", error: fieldError("chain"), required: true, children: /* @__PURE__ */ jsx(
        ChainSelect,
        {
          value: value.chain ?? "",
          disabled,
          includeTestnets,
          onChange: (chain) => set({ chain })
        }
      ) })
    ] }),
    value.kind === "label" && advanced && /* @__PURE__ */ jsx(
      Field,
      {
        label: "Bound address",
        error: fieldError("address"),
        hint: "Optional \u2014 leave blank for a global label. Chain scope comes from \u201CApplies to chains\u201D below.",
        children: /* @__PURE__ */ jsx(
          Input,
          {
            value: value.address ?? "",
            disabled,
            onChange: (e) => set({ address: e.target.value })
          }
        )
      }
    ),
    value.kind === "tag" && /* @__PURE__ */ jsx(Field, { label: "Category", error: fieldError("category"), children: /* @__PURE__ */ jsx(
      Input,
      {
        value: value.category ?? "",
        disabled,
        onChange: (e) => set({ category: e.target.value })
      }
    ) }),
    value.kind === "entity" && /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-3 gap-3", children: [
      /* @__PURE__ */ jsx(Field, { label: "Type", error: fieldError("entityType"), children: /* @__PURE__ */ jsx(
        EnumSelect,
        {
          value: value.entityType ?? DEFAULT_ENTITY_TYPE,
          options: entityTypeOptions(value.entityType),
          disabled,
          onChange: (entityType) => set({ entityType })
        }
      ) }),
      /* @__PURE__ */ jsx(Field, { label: "Website", error: fieldError("website"), children: /* @__PURE__ */ jsx(
        Input,
        {
          placeholder: "https://\u2026",
          value: value.website ?? "",
          disabled,
          onChange: (e) => set({ website: e.target.value })
        }
      ) }),
      /* @__PURE__ */ jsx(Field, { label: "Twitter / X", error: fieldError("twitter"), children: /* @__PURE__ */ jsx(
        Input,
        {
          placeholder: "@handle",
          value: value.twitter ?? "",
          disabled,
          onChange: (e) => set({ twitter: e.target.value })
        }
      ) })
    ] }),
    value.kind === "group" && advanced && loadGroupCandidates && /* @__PURE__ */ jsx(Field, { label: "Members", hint: "Tags, labels, and entities that belong to this group.", children: /* @__PURE__ */ jsx(
      GroupMemberPicker,
      {
        value: {
          tagIds: value.memberTagIds ?? [],
          labelIds: value.memberLabelIds ?? [],
          entityIds: value.memberEntityIds ?? []
        },
        disabled,
        loadCandidates: loadGroupCandidates,
        resolveSelected: resolveGroupSelected,
        resolveLogoUrl,
        onChange: (m) => set({
          memberTagIds: m.tagIds,
          memberLabelIds: m.labelIds,
          memberEntityIds: m.entityIds
        })
      }
    ) }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-end gap-4", children: [
      hasColor && /* @__PURE__ */ jsx(Field, { label: "Colour", children: /* @__PURE__ */ jsx(
        ColorPicker,
        {
          value: value.color,
          disabled,
          onChange: (c) => set({ color: c ?? void 0 })
        }
      ) }),
      hasRisk && /* @__PURE__ */ jsx(Field, { label: "Risk level", hint: "Leave unassessed unless you are making the call", children: /* @__PURE__ */ jsx(
        OptionSelect,
        {
          value: value.riskLevel,
          disabled,
          onChange: (v) => set({ riskLevel: v }),
          options: RISK_LEVELS,
          unsetLabel: "Not assessed"
        }
      ) }),
      hasSeverity && /* @__PURE__ */ jsx(Field, { label: "Severity", hint: "Leave unassessed unless you are making the call", children: /* @__PURE__ */ jsx(
        OptionSelect,
        {
          value: value.severity,
          disabled,
          onChange: (v) => set({ severity: v }),
          options: SEVERITIES,
          unsetLabel: "Not assessed"
        }
      ) }),
      showLifecycle && /* @__PURE__ */ jsx(
        Field,
        {
          label: "Status",
          hint: "Verified silences \u201CAwaiting review\u201D \u2014 only mark it if you stand behind the row.",
          children: /* @__PURE__ */ jsx(
            OptionSelect,
            {
              value: value.lifecycle,
              disabled,
              onChange: (v) => set({ lifecycle: v }),
              options: CATALOG_LIFECYCLES,
              labels: CATALOG_LIFECYCLE_LABEL,
              unsetLabel: "Leave as the platform sets it"
            }
          )
        }
      )
    ] }),
    onUploadLogo && /* @__PURE__ */ jsx(Field, { label: "Logo", children: /* @__PURE__ */ jsx(
      LogoUpload,
      {
        value: logoPreview,
        disabled,
        onUpload: onUploadLogo,
        onChange: (next) => {
          setLogoPreview(next);
          set({ logo: next?.key });
        }
      }
    ) }),
    value.kind !== "address" && advanced && /* @__PURE__ */ jsx(Field, { label: "Applies to chains", hint: "Leave empty to apply to all chains", children: /* @__PURE__ */ jsx(
      ChainMultiSelect,
      {
        value: value.chains ?? [],
        disabled,
        includeTestnets,
        onChange: (chains) => set({ chains })
      }
    ) }),
    value.kind !== "address" && advanced && /* @__PURE__ */ jsx(
      Field,
      {
        label: "Primary chains",
        error: fieldError("primaryChains"),
        hint: "The chain(s) this is primarily / canonically used on \u2014 must be within \u201CApplies to chains\u201D (optional)",
        children: /* @__PURE__ */ jsx(
          ChainMultiSelect,
          {
            value: value.primaryChains ?? [],
            disabled,
            includeTestnets,
            onChange: (primaryChains) => set({ primaryChains })
          }
        )
      }
    )
  ] });
}
function OptionSelect({
  value,
  onChange,
  options,
  disabled,
  unsetLabel,
  labels
}) {
  return /* @__PURE__ */ jsxs(
    NativeSelect,
    {
      value: value ?? UNSET,
      disabled,
      onChange: (e) => onChange(e.target.value === UNSET ? void 0 : e.target.value),
      className: labels ? void 0 : "capitalize",
      children: [
        unsetLabel !== void 0 && /* @__PURE__ */ jsx("option", { value: UNSET, children: unsetLabel }),
        options.map((o) => /* @__PURE__ */ jsx("option", { value: o, className: labels ? void 0 : "capitalize", children: labels?.[o] ?? o }, o))
      ]
    }
  );
}
function FundsFlowColumns({
  flow,
  sourceTitle = "Source of funds",
  destinationTitle = "Destination of funds",
  pinned = [],
  onPin,
  onInspect,
  onExclude,
  attributionPending,
  nameOf,
  lookalikeOf,
  dense,
  selection,
  counterpartyLimit,
  className
}) {
  return (
    // Side by side when the PANEL is wide enough, not the window: the same
    // columns sit in a narrow rail beside a table, in a story step, and across a
    // full-width card, and a viewport breakpoint split a 24rem rail in two.
    /* @__PURE__ */ jsx("div", { className: cn("@container", className), children: /* @__PURE__ */ jsxs("div", { className: cn("grid gap-6 @lg:grid-cols-2", dense && "gap-4"), children: [
      /* @__PURE__ */ jsx(
        FundsFlowSide,
        {
          title: sourceTitle,
          side: flow.source,
          direction: "in",
          pinned,
          onPin,
          onInspect,
          onExclude,
          attributionPending,
          nameOf,
          lookalikeOf,
          selection,
          counterpartyLimit
        }
      ),
      /* @__PURE__ */ jsx(
        FundsFlowSide,
        {
          title: destinationTitle,
          side: flow.destination,
          direction: "out",
          pinned,
          onPin,
          onInspect,
          onExclude,
          attributionPending,
          nameOf,
          lookalikeOf,
          selection,
          counterpartyLimit
        }
      )
    ] }) })
  );
}
function assetsLine(assets) {
  if (!assets || assets.length === 0) return null;
  const shown = assets.slice(0, 3).map(formatAssetAmountWithSymbol);
  const more = assets.length - shown.length;
  return more > 0 ? `${shown.join(" \xB7 ")} \xB7 +${more}` : shown.join(" \xB7 ");
}
function LookalikeChip({ mimics }) {
  if (!mimics) return null;
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: "shrink-0 rounded border border-risk-high/50 px-1 text-risk-high",
      title: `Address poisoning: a lookalike of ${mimics}. Its transfers moved nothing; it is here to be copy-pasted by mistake.`,
      children: [
        "lookalike of ",
        shortenAddress(mimics)
      ]
    }
  );
}
function FundsFlowSide({
  title,
  side,
  direction,
  pinned = [],
  onPin,
  onInspect,
  onExclude,
  attributionPending,
  nameOf,
  lookalikeOf,
  selection,
  counterpartyLimit
}) {
  const arrow = direction === "out" ? "\u2192" : "\u2190";
  const [opened, setOpened] = React26.useState(() => /* @__PURE__ */ new Set());
  const onThisSide = selection?.direction === direction ? selection : null;
  const unpricedSide = side.usdTotal === 0 && side.unpricedCount > 0;
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-baseline justify-between gap-2", children: [
      /* @__PURE__ */ jsx("span", { className: "text-xs font-medium", children: title }),
      /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
        unpricedSide ? "" : formatUsd(side.usdTotal, { compact: true }),
        side.unpricedCount > 0 ? `${unpricedSide ? "" : " \xB7 "}${side.unpricedCount} unpriced` : ""
      ] })
    ] }),
    side.buckets.length === 0 ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Nothing on this side." }) : /* @__PURE__ */ jsx("ul", { className: "space-y-1.5", children: side.buckets.map((bucket) => {
      const notable = NOTABLE_CATEGORIES.includes(bucket.category);
      const muted = UNKNOWN_CATEGORIES.includes(bucket.category);
      const alarming = ALARMING_CATEGORIES.includes(bucket.category);
      const isPinned = pinned.includes(bucket.category);
      const assets = assetsLine(bucket.assets);
      const hidden = Math.max(bucket.counterparties - bucket.top.length, 0);
      const bucketSelected = onThisSide?.category === bucket.category;
      const chips = bucket.top.filter((cp) => cp.transactionIds?.length);
      const limited = counterpartyLimit !== void 0 && !opened.has(bucket.category);
      const shownChips = limited ? chips.filter((cp, index) => index < counterpartyLimit || cp.address === onThisSide?.counterparty) : chips;
      const folded = chips.length - shownChips.length;
      return /* @__PURE__ */ jsxs(
        "li",
        {
          className: cn(
            "space-y-0.5",
            // The whole bucket when the bucket was inspected; only the chip
            // when one counterparty in it was.
            bucketSelected && !onThisSide?.counterparty && "-mx-1.5 rounded-md bg-primary/5 px-1.5 py-1 ring-1 ring-primary/40"
          ),
          "aria-current": bucketSelected && !onThisSide?.counterparty ? "true" : void 0,
          children: [
            /* @__PURE__ */ jsxs("div", { className: "flex items-baseline justify-between gap-2 text-xs", children: [
              /* @__PURE__ */ jsxs(
                "span",
                {
                  className: cn(
                    "flex items-center gap-1",
                    notable && "font-medium",
                    alarming ? "text-amber-700 dark:text-amber-400" : muted ? "text-muted-foreground" : void 0
                  ),
                  children: [
                    alarming ? /* @__PURE__ */ jsx(AlertTriangle, { className: "h-3 w-3", "aria-hidden": true }) : null,
                    bucket.category === "resolving" ? /* @__PURE__ */ jsx(Loader2, { className: "h-3 w-3 animate-spin", "aria-hidden": true }) : null,
                    categoryLabel(bucket.category),
                    onPin ? /* @__PURE__ */ jsx(
                      "button",
                      {
                        type: "button",
                        className: cn("text-muted-foreground hover:text-foreground", isPinned && "text-foreground"),
                        "aria-label": isPinned ? `Unpin ${bucket.category}` : `Keep ${bucket.category} at the top`,
                        title: isPinned ? "Pinned \u2014 held at the top whatever its size" : "Keep at the top whatever its size",
                        onClick: () => onPin(bucket.category),
                        children: isPinned ? /* @__PURE__ */ jsx(Pin, { className: "h-2.5 w-2.5" }) : /* @__PURE__ */ jsx(PinOff, { className: "h-2.5 w-2.5 opacity-40" })
                      }
                    ) : null
                  ]
                }
              ),
              /* @__PURE__ */ jsx("span", { className: "tabular-nums text-muted-foreground", children: unpricedSide ? "unpriced" : `${formatUsd(bucket.usd, { compact: true })} \xB7 ${formatShare(bucket.share)}` })
            ] }),
            unpricedSide ? null : /* @__PURE__ */ jsx("div", { className: "h-1 w-full overflow-hidden rounded-full bg-muted", children: /* @__PURE__ */ jsx(
              "div",
              {
                className: cn(
                  "h-full rounded-full",
                  alarming ? "bg-amber-500" : muted ? "bg-muted-foreground/30" : "bg-primary/60"
                ),
                style: { width: `${Math.max(bucket.share * 100, 1)}%` }
              }
            ) }),
            /* @__PURE__ */ jsxs("p", { className: "text-[10px] text-muted-foreground", children: [
              bucket.counterparties,
              " counterpart",
              bucket.counterparties === 1 ? "y" : "ies",
              " \xB7",
              " ",
              onInspect && bucket.transactionIds?.length ? /* @__PURE__ */ jsxs(
                "button",
                {
                  type: "button",
                  className: "underline underline-offset-2 hover:text-foreground",
                  "aria-label": `Show ${bucket.transactionIds.length} ${categoryLabel(bucket.category)} ${direction === "in" ? "source" : "destination"} transactions`,
                  onClick: () => onInspect({ direction, category: bucket.category }),
                  children: [
                    bucket.transactions,
                    " tx \u2014 inspect"
                  ]
                }
              ) : /* @__PURE__ */ jsxs(Fragment, { children: [
                bucket.transactions,
                " tx"
              ] }),
              assets ? /* @__PURE__ */ jsxs("span", { className: "tabular-nums", children: [
                " \xB7 ",
                assets
              ] }) : null
            ] }),
            onInspect ? /* @__PURE__ */ jsxs("ul", { className: "flex flex-wrap gap-1", children: [
              shownChips.map((cp) => /* @__PURE__ */ jsxs(
                "li",
                {
                  className: cn(
                    "inline-flex max-w-full items-center gap-1 rounded border px-1.5 py-0.5 text-[10px]",
                    bucketSelected && onThisSide?.counterparty === cp.address && "border-primary bg-primary/5 ring-1 ring-primary/40"
                  ),
                  "aria-current": bucketSelected && onThisSide?.counterparty === cp.address ? "true" : void 0,
                  children: [
                    /* @__PURE__ */ jsx(AddressDisplay, { address: cp.address, chain: cp.chainId, fallbackLabel: nameOf?.(cp.address, cp.chainId) || void 0, presentation: "inline", size: "sm", className: "max-w-[16rem]" }),
                    /* @__PURE__ */ jsx(LookalikeChip, { mimics: lookalikeOf?.(cp.address) }),
                    /* @__PURE__ */ jsxs(
                      "button",
                      {
                        type: "button",
                        className: "px-1.5 py-0.5 hover:bg-muted",
                        title: `Inspect ${cp.transactions} transactions involving ${cp.address}; pins unchanged`,
                        onClick: () => onInspect({ direction, category: bucket.category, counterparty: cp.address }),
                        children: [
                          cp.transactions,
                          " tx \u2014 inspect"
                        ]
                      }
                    ),
                    onExclude && !attributionPending ? /* @__PURE__ */ jsx(
                      "button",
                      {
                        type: "button",
                        className: "border-l px-1 py-0.5 text-muted-foreground hover:text-foreground",
                        "aria-label": `Rule out ${nameOf?.(cp.address) || cp.address}`,
                        title: "Rule this counterparty out of both totals (shared case setting)",
                        onClick: () => onExclude(cp.address),
                        children: /* @__PURE__ */ jsx(X, { className: "h-2.5 w-2.5" })
                      }
                    ) : null
                  ]
                },
                cp.address
              )),
              folded > 0 || counterpartyLimit !== void 0 && opened.has(bucket.category) && chips.length > counterpartyLimit ? /* @__PURE__ */ jsx("li", { children: /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  className: "rounded border border-dashed px-1.5 py-0.5 text-[10px] text-muted-foreground hover:text-foreground",
                  "aria-expanded": !limited,
                  onClick: () => setOpened((prev) => {
                    const next = new Set(prev);
                    if (next.has(bucket.category)) next.delete(bucket.category);
                    else next.add(bucket.category);
                    return next;
                  }),
                  children: limited ? `+${folded} more` : "Show fewer"
                }
              ) }) : null
            ] }) : null,
            bucket.top.some((c) => c.remoteChains && c.remoteChains.length > 0) ? (
              // Where a bridge sent the money is the next place to look — the
              // one fact about this bucket a reader acts on.
              /* @__PURE__ */ jsx("ul", { className: "flex flex-wrap gap-1 pt-0.5", children: bucket.top.filter((c) => c.remoteChains && c.remoteChains.length > 0).map((c) => /* @__PURE__ */ jsxs(
                "li",
                {
                  className: "inline-flex items-center gap-1 rounded-full border px-1.5 py-0.5 text-[10px]",
                  title: c.address,
                  children: [
                    arrow,
                    " ",
                    c.remoteChains.map((chain) => chainDisplayName(chain)).join(", "),
                    c.protocol ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
                      "via ",
                      c.protocol
                    ] }) : null
                  ]
                },
                c.address
              )) })
            ) : null,
            onExclude && !attributionPending && !onInspect ? /* @__PURE__ */ jsx("ul", { className: "flex flex-wrap gap-1 pt-0.5", children: bucket.top.map((counterparty) => {
              const name = nameOf?.(counterparty.address, counterparty.chainId)?.trim() || null;
              return /* @__PURE__ */ jsxs("li", { className: "inline-flex max-w-full items-center gap-1 rounded border border-dashed px-1.5 py-0.5", children: [
                /* @__PURE__ */ jsx(AddressDisplay, { address: counterparty.address, chain: counterparty.chainId, fallbackLabel: name ?? void 0, presentation: "inline", size: "sm", className: "max-w-[16rem]" }),
                /* @__PURE__ */ jsx(LookalikeChip, { mimics: lookalikeOf?.(counterparty.address) }),
                /* @__PURE__ */ jsx(
                  "button",
                  {
                    type: "button",
                    className: "shrink-0 text-muted-foreground hover:text-foreground",
                    "aria-label": `Rule out ${name ?? counterparty.address}`,
                    title: `Rule ${name ? `${name} (${counterparty.address})` : counterparty.address} out of both sides (${formatUsd(counterparty.usd, { compact: true })}, ${counterparty.transactions} tx)`,
                    onClick: () => onExclude(counterparty.address),
                    children: /* @__PURE__ */ jsx(X, { className: "h-2.5 w-2.5 shrink-0" })
                  }
                )
              ] }, counterparty.address);
            }) }) : null,
            hidden > 0 && (onInspect || onExclude && !attributionPending) ? /* @__PURE__ */ jsxs("p", { className: "text-[10px] text-muted-foreground", children: [
              hidden,
              " more not shown \u2014 the ",
              bucket.top.length,
              " largest by value are listed."
            ] }) : null
          ]
        },
        bucket.category
      );
    }) })
  ] });
}
function groupHops(hops) {
  const groups = /* @__PURE__ */ new Map();
  for (const hop of hops) {
    const key = `${hop.direction}|${hop.remoteChain ?? ""}|${hop.protocol ?? ""}`;
    const group = groups.get(key) ?? {
      direction: hop.direction,
      remoteChain: hop.remoteChain,
      protocol: hop.protocol,
      count: 0,
      expected: false,
      amounts: /* @__PURE__ */ new Map()
    };
    group.count += 1;
    group.expected ||= hop.expected;
    if (hop.asset && hop.amount !== null) {
      const seen = group.amounts.get(hop.asset.key) ?? { label: assetSymbol(hop.asset), amount: 0 };
      seen.amount += hop.amount;
      group.amounts.set(hop.asset.key, seen);
    }
    groups.set(key, group);
  }
  return [...groups.values()];
}
function coverageText(cited, decoded, loading) {
  if (cited === 0) return null;
  if (decoded >= cited) return `${cited} transaction${cited === 1 ? "" : "s"}`;
  if (loading) return `decoding ${decoded} of ${cited} transactions\u2026`;
  return `${decoded} of ${cited} transactions decoded \u2014 the rest carry no value graph yet`;
}
function StepFlowSummary({
  onInspect,
  flow,
  cited,
  decoded,
  unreadable = 0,
  nameOf,
  loading,
  attributionPending,
  asserted = [],
  comparisons = [],
  stepName: stepName2 = (index) => `step ${index + 1}`,
  transfers = [],
  onRemoveTransfer,
  onOpenTransfer,
  pricing,
  onReprice,
  repricing,
  repriced,
  title = "Money in this step",
  className
}) {
  const hasFlow = !!flow && (flow.moves > 0 || flow.hops.length > 0);
  const hopGroups = flow ? groupHops(flow.hops) : [];
  const coverage = coverageText(cited, decoded, loading);
  const ambiguousSymbols = ambiguousAssetSymbols(flow?.assets ?? []);
  if (cited === 0 && asserted.length === 0 && transfers.length === 0) return null;
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-2 rounded-md border bg-muted/20 p-3", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-baseline justify-between gap-2", children: [
      /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1.5 text-xs font-medium", children: [
        title,
        loading ? /* @__PURE__ */ jsx(Loader2, { className: "h-3 w-3 animate-spin text-muted-foreground", "aria-hidden": true }) : null
      ] }),
      coverage ? /* @__PURE__ */ jsx("span", { className: "text-[11px] text-muted-foreground", children: coverage }) : null
    ] }),
    flow && flow.assets.length > 0 ? (
      // What crossed the step's edge, per asset — never summed across assets.
      /* @__PURE__ */ jsx("ul", { className: "flex flex-wrap gap-1.5", "aria-label": "Amounts that crossed this step", children: flow.assets.map((total) => /* @__PURE__ */ jsxs("li", { className: "rounded-md border bg-background px-2 py-0.5 text-xs tabular-nums", children: [
        /* @__PURE__ */ jsx("span", { className: "font-medium", children: formatAssetAmountWithSymbol(total) }),
        ambiguousSymbols.has(assetSymbol(total.asset)) && total.asset.chainId ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          " on ",
          chainDisplayName(total.asset.chainId)
        ] }) : null,
        /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          " ",
          "\xB7 ",
          total.usd === null ? "unpriced" : formatUsd(total.usd, { compact: true })
        ] })
      ] }, total.asset.key)) })
    ) : null,
    comparisons.length > 0 ? /* @__PURE__ */ jsx("ul", { className: "space-y-0.5", children: comparisons.map((c) => /* @__PURE__ */ jsxs(
      "li",
      {
        className: cn(
          "text-xs",
          isNotableRatio(c.ratio) ? "font-medium text-amber-700 dark:text-amber-400" : "text-muted-foreground"
        ),
        children: [
          formatRatio(c.ratio),
          " the ",
          c.symbol,
          " of ",
          stepName2(c.against.index),
          " ",
          /* @__PURE__ */ jsxs("span", { className: "font-normal text-muted-foreground", children: [
            "(",
            formatAssetAmount(c.amount),
            " vs ",
            formatAssetAmount(c.against.amount),
            c.basis === "asserted" || c.against.basis === "asserted" ? ", against an asserted figure" : "",
            ")"
          ] })
        ]
      },
      c.symbol
    )) }) : null,
    hopGroups.length > 0 ? /* @__PURE__ */ jsx("ul", { className: "space-y-0.5", "aria-label": "Bridge hops", children: hopGroups.map((g) => {
      const amounts = [...g.amounts.values()].map((a) => `${formatAssetAmount(a.amount)} ${a.label}`).join(" \xB7 ");
      return /* @__PURE__ */ jsxs("li", { className: "flex flex-wrap items-center gap-1 text-xs", children: [
        /* @__PURE__ */ jsx(ArrowLeftRight, { className: "h-3 w-3 text-muted-foreground", "aria-hidden": true }),
        /* @__PURE__ */ jsxs("span", { className: "font-medium", children: [
          g.direction === "out" ? "\u2192" : "\u2190",
          " ",
          g.remoteChain ? chainDisplayName(g.remoteChain) : "another chain"
        ] }),
        g.protocol ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          "via ",
          g.protocol
        ] }) : null,
        /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          "\xB7 ",
          g.count,
          " transfer",
          g.count === 1 ? "" : "s",
          amounts ? ` \xB7 ${amounts}` : ""
        ] }),
        g.expected ? /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "text-[10px] font-normal", children: [
          g.direction === "out" ? "arrival" : "departure",
          " expected, not observed"
        ] }) : null
      ] }, `${g.direction}${g.remoteChain}${g.protocol}`);
    }) }) : null,
    transfers.length > 0 ? /* @__PURE__ */ jsx("ul", { className: "space-y-0.5", "aria-label": "Cited cross-chain transfers", children: transfers.map((t) => /* @__PURE__ */ jsxs("li", { className: "flex flex-wrap items-center gap-1.5 text-xs", children: [
      onOpenTransfer ? /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: "font-mono text-[11px] underline-offset-2 hover:underline",
          title: "Show this transfer and its legs on the cross-chain tab",
          onClick: () => onOpenTransfer(t.key),
          children: t.label
        }
      ) : /* @__PURE__ */ jsx("span", { className: "font-mono text-[11px]", children: t.label }),
      /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
        "\xB7 ",
        t.legsObserved,
        " of ",
        t.legsExpected,
        " leg",
        t.legsExpected === 1 ? "" : "s"
      ] }),
      /* @__PURE__ */ jsx(Badge, { variant: t.complete ? "secondary" : "outline", className: "text-[10px] font-normal", children: t.state }),
      onRemoveTransfer ? /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          className: "text-muted-foreground hover:text-foreground",
          "aria-label": `Take ${t.label} out of this step`,
          title: "Take this transfer out of the step (its transactions stay cited)",
          onClick: () => onRemoveTransfer(t.key),
          children: /* @__PURE__ */ jsx(X, { className: "h-3 w-3" })
        }
      ) : null
    ] }, t.key)) }) : null,
    hasFlow && flow && (flow.source.buckets.length > 0 || flow.destination.buckets.length > 0) ? /* @__PURE__ */ jsxs(Fragment, { children: [
      unreadable > 0 ? /* @__PURE__ */ jsx("p", { className: "text-[11px] text-amber-700 dark:text-amber-500", children: unreadable === 1 ? "1 movement couldn\u2019t be read \u2014 its asset is unknown, so it is missing from the totals and from both sides below." : `${unreadable} movements couldn\u2019t be read \u2014 their assets are unknown, so they are missing from the totals and from both sides below.` }) : null,
      /* @__PURE__ */ jsx(
        FundsFlowColumns,
        {
          flow,
          dense: true,
          attributionPending,
          onInspect,
          nameOf
        }
      )
    ] }) : cited > 0 && !loading ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: decoded === 0 ? "None of this step's transactions has a decoded value graph yet, so there is nothing to total." : "The decoded transactions moved no value across this step's edge." }) : null,
    flow && (flow.passThrough > 0 || (flow.transit ?? 0) > 0 || flow.unpricedMoves > 0) ? /* @__PURE__ */ jsxs("p", { className: "text-[11px] text-muted-foreground", children: [
      flow.passThrough > 0 ? `${flow.passThrough} wallet${flow.passThrough === 1 ? "" : "s"} only passed money through, so counted once, not twice.` : "",
      (flow.transit ?? 0) > 0 ? ` ${flow.transit} bridge contract${flow.transit === 1 ? "" : "s"} carried money between chains inside this step, so ${flow.transit === 1 ? "it is" : "they are"} not counted as a source or destination.` : "",
      flow.unpricedMoves > 0 ? ` ${unpricedReason(pricing, flow.unpricedMoves, flow.unpricedQuotedElsewhere ?? 0) ?? ""}` : "",
      onReprice && repriced && (flow.repriceable?.length ?? 0) > 0 ? /* @__PURE__ */ jsx("span", { className: "text-foreground", children: " Re-ran them: the price sources still have no quote at that time." }) : onReprice && (flow.repriceable?.length ?? 0) > 0 ? (
        // The remedy beside the sentence that names it, scoped to exactly the
        // transactions it would change — never the whole step.
        /* @__PURE__ */ jsxs(Fragment, { children: [
          " ",
          /* @__PURE__ */ jsxs(
            "button",
            {
              type: "button",
              className: "inline-flex items-center gap-1 font-medium text-foreground underline-offset-2 hover:underline disabled:opacity-50",
              disabled: repricing,
              title: "Process these transactions again so their movements pick up a price",
              onClick: () => onReprice(flow.repriceable),
              children: [
                repricing ? /* @__PURE__ */ jsx(Loader2, { className: "h-3 w-3 animate-spin", "aria-hidden": true }) : /* @__PURE__ */ jsx(RotateCcw, { className: "h-3 w-3", "aria-hidden": true }),
                "Re-run ",
                flow.repriceable.length,
                " transaction",
                flow.repriceable.length === 1 ? "" : "s"
              ]
            }
          )
        ] })
      ) : null
    ] }) : null,
    asserted.length > 0 ? (
      // Beside the observed figures, never inside them.
      /* @__PURE__ */ jsxs("div", { className: "space-y-1 rounded-md border border-dashed p-2", children: [
        /* @__PURE__ */ jsxs("p", { className: "flex items-center gap-1 text-[11px] font-medium", children: [
          /* @__PURE__ */ jsx(Quote, { className: "h-3 w-3", "aria-hidden": true }),
          "Asserted \u2014 not observed on-chain"
        ] }),
        /* @__PURE__ */ jsx("ul", { className: "space-y-0.5", children: asserted.map((a) => {
          const value = assertedValue(a);
          return /* @__PURE__ */ jsxs("li", { className: "text-xs", children: [
            /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
              a.direction === "in" ? "In" : "Out",
              " \xB7 "
            ] }),
            /* @__PURE__ */ jsxs("span", { className: "font-medium tabular-nums", title: a.amount, children: [
              value === null ? a.amount || "\u2014" : formatAssetAmount(value),
              " ",
              a.symbol
            ] }),
            a.chain ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
              " on ",
              chainDisplayName(a.chain)
            ] }) : null,
            a.source ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
              " ",
              "\u2014",
              " ",
              /^https?:\/\//.test(a.source) ? /* @__PURE__ */ jsx("a", { href: a.source, target: "_blank", rel: "noreferrer noopener", className: "underline", children: "source" }) : a.source
            ] }) : /* @__PURE__ */ jsx("span", { className: "text-amber-700 dark:text-amber-400", children: " \u2014 no source given" })
          ] }, a.id);
        }) })
      ] })
    ) : null
  ] });
}
var DIRECTIONS = [
  { value: "in", label: "In" },
  { value: "out", label: "Out" }
];
function defaultId() {
  return `asserted-${Date.now().toString(36)}-${randomHex(4)}`;
}
function AssertedAmountsEditor({
  value,
  onChange,
  disabled,
  newId = defaultId,
  className
}) {
  const patch = (id, next) => onChange(value.map((row) => row.id === id ? { ...row, ...next } : row));
  const remove = (id) => onChange(value.filter((row) => row.id !== id));
  const add = () => onChange([...value, newAssertedAmount(newId())]);
  const full = value.length >= MAX_ASSERTED_AMOUNTS;
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-1.5", className), children: [
    value.map((row) => {
      const malformed = row.amount !== "" && !isDecimalAmount(row.amount);
      return /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-[4.5rem_1fr_5rem_10rem_1fr_auto] items-center gap-1.5", children: [
        /* @__PURE__ */ jsx(
          EnumSelect,
          {
            value: row.direction,
            options: DIRECTIONS,
            disabled,
            onChange: (direction) => patch(row.id, { direction }),
            className: "h-7 text-xs"
          }
        ),
        /* @__PURE__ */ jsx(
          Input,
          {
            value: row.amount,
            disabled,
            inputMode: "decimal",
            placeholder: "200000000",
            "aria-label": "Amount",
            "aria-invalid": malformed,
            title: malformed ? "A plain decimal, like 1250000.5 \u2014 this one would not be saved" : void 0,
            onChange: (e) => patch(row.id, { amount: e.target.value }),
            className: cn("h-7 text-xs tabular-nums", malformed && "border-destructive")
          }
        ),
        /* @__PURE__ */ jsx(
          Input,
          {
            value: row.symbol,
            disabled,
            placeholder: "NES",
            "aria-label": "Asset",
            onChange: (e) => patch(row.id, { symbol: e.target.value }),
            className: "h-7 text-xs"
          }
        ),
        /* @__PURE__ */ jsx(
          ChainSelect,
          {
            value: row.chain,
            valueKind: CANONICAL_CHAIN_VALUE_KIND,
            allowAny: true,
            anyLabel: "No chain",
            anyValue: "",
            disabled,
            onChange: (chain) => patch(row.id, { chain })
          }
        ),
        /* @__PURE__ */ jsx(
          Input,
          {
            value: row.source,
            disabled,
            placeholder: "Source \u2014 advisory URL, subpoena return\u2026",
            "aria-label": "Source",
            onChange: (e) => patch(row.id, { source: e.target.value }),
            className: cn("h-7 text-xs", !row.source && row.amount && "border-amber-500/60")
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            type: "button",
            size: "sm",
            variant: "ghost",
            className: "h-7 w-7 p-0",
            "aria-label": "Remove this amount",
            disabled,
            onClick: () => remove(row.id),
            children: /* @__PURE__ */ jsx(Trash2, { className: "h-3.5 w-3.5" })
          }
        )
      ] }, row.id);
    }),
    /* @__PURE__ */ jsxs(
      Button,
      {
        type: "button",
        size: "sm",
        variant: "ghost",
        className: "h-7 px-2 text-xs",
        disabled: disabled || full,
        onClick: add,
        title: full ? `At most ${MAX_ASSERTED_AMOUNTS} amounts per step` : void 0,
        children: [
          /* @__PURE__ */ jsx(Plus, { className: "mr-1 h-3 w-3" }),
          "State an amount nobody can observe"
        ]
      }
    )
  ] });
}
var FIELD_GROUPS = triggerFieldOptions();
var DEFAULT_FIELD = FIELD_GROUPS[0]?.fields[0]?.path ?? "canonical.value_usd";
function useRowKeys(length) {
  const next = React26.useRef(0);
  const [keys, setKeys] = React26.useState(
    () => Array.from({ length }, () => `row-${next.current++}`)
  );
  React26.useEffect(() => {
    setKeys((current) => {
      if (current.length === length) return current;
      if (current.length < length) {
        return [...current, ...Array.from({ length: length - current.length }, () => `row-${next.current++}`)];
      }
      return current.slice(0, length);
    });
  }, [length]);
  return {
    keys,
    onInsert: () => setKeys((current) => [...current, `row-${next.current++}`]),
    onRemove: (index) => setKeys((current) => current.filter((_, i) => i !== index))
  };
}
function useFlatCondition(condition, onChange) {
  const flat = React26.useMemo(() => flattenCondition(condition), [condition]);
  const nested = flat == null;
  const predicates = React26.useMemo(() => flat?.predicates ?? [], [flat]);
  const derived = flat?.match ?? "all";
  const [pending, setPending] = React26.useState(null);
  const match = predicates.length < 2 ? pending ?? derived : derived;
  const rows = useRowKeys(predicates.length);
  const emit = (nextPredicates, nextMatch) => onChange(conditionFromPredicates(nextPredicates, nextMatch));
  const patch = (index, fields) => emit(
    predicates.map((p, i) => i === index ? { ...p, ...fields } : p),
    match
  );
  return {
    predicates,
    match,
    nested,
    rowKeys: rows.keys,
    setField: (index, field) => {
      const ops = operatorsForField(field);
      const current = predicates[index];
      const op = ops.includes(current.op) ? current.op : ops[0];
      patch(index, { field, op, value: isUnaryOperator(op) ? void 0 : "" });
    },
    setOperator: (index, op) => {
      const current = predicates[index];
      patch(index, {
        op,
        value: isUnaryOperator(op) ? void 0 : coerceValue(current.field, op, valueText(current.value))
      });
    },
    setValue: (index, raw) => {
      const current = predicates[index];
      patch(index, { value: coerceValue(current.field, current.op, raw) });
    },
    add: () => {
      rows.onInsert();
      emit([...predicates, predicate(DEFAULT_FIELD, "==", "")], match);
    },
    remove: (index) => {
      rows.onRemove(index);
      emit(
        predicates.filter((_, i) => i !== index),
        match
      );
    },
    setMatch: (nextMatch) => {
      if (nested) return;
      setPending(nextMatch);
      if (predicates.length >= 2) emit(predicates, nextMatch);
    }
  };
}
var LOOKS = {
  compact: {
    row: "space-y-1.5 rounded-md border p-2",
    field: "h-8 text-xs",
    operator: "h-8 w-32 text-xs",
    value: "h-8 flex-1 text-xs",
    problem: "text-[11px]",
    empty: "text-[11px] text-muted-foreground",
    remove: { className: "h-8 px-2 text-risk-critical", content: "\u2715" }
  },
  comfortable: {
    row: "flex flex-wrap items-center gap-2",
    field: "w-52",
    operator: "w-40",
    value: "w-56",
    problem: "w-full text-xs",
    empty: "text-sm text-muted-foreground",
    remove: { className: "text-destructive hover:text-destructive", content: "Remove" }
  }
};
function ConditionRows({
  state,
  density = "comfortable",
  emptyDescription = "No conditions \u2014 add one to start matching.",
  className
}) {
  const look = LOOKS[density];
  const compact = density === "compact";
  return /* @__PURE__ */ jsxs("div", { className: cn(compact ? "space-y-3" : "space-y-2", className), children: [
    state.predicates.length === 0 && /* @__PURE__ */ jsx("p", { className: look.empty, children: emptyDescription }),
    state.predicates.map((p, index) => {
      const def = getTriggerField(p.field);
      const unary = isUnaryOperator(p.op);
      const enumSelect = def?.valueType === "enum" && def.enumValues && !isListOperator(p.op);
      const problem = predicateProblem(p);
      return /* @__PURE__ */ jsxs("div", { className: look.row, children: [
        /* @__PURE__ */ jsxs(Select, { value: p.field, onValueChange: (field) => state.setField(index, field), children: [
          /* @__PURE__ */ jsx(SelectTrigger, { className: look.field, "aria-label": `Field for condition ${index + 1}`, children: /* @__PURE__ */ jsx(SelectValue, {}) }),
          /* @__PURE__ */ jsx(SelectContent, { children: FIELD_GROUPS.map((group) => /* @__PURE__ */ jsxs(SelectGroup, { children: [
            /* @__PURE__ */ jsx(SelectLabel, { children: group.label }),
            group.fields.map((field) => /* @__PURE__ */ jsx(SelectItem, { value: field.path, children: field.label }, field.path))
          ] }, group.group)) })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: compact ? "flex items-center gap-1.5" : "contents", children: [
          /* @__PURE__ */ jsxs(Select, { value: p.op, onValueChange: (op) => state.setOperator(index, op), children: [
            /* @__PURE__ */ jsx(SelectTrigger, { className: look.operator, "aria-label": `Operator for ${p.field}`, children: /* @__PURE__ */ jsx(SelectValue, {}) }),
            /* @__PURE__ */ jsx(SelectContent, { children: operatorsForField(p.field).map((op) => /* @__PURE__ */ jsx(SelectItem, { value: op, children: TRIGGER_OPERATOR_LABELS[op] }, op)) })
          ] }),
          !unary && (enumSelect ? /* @__PURE__ */ jsxs(Select, { value: valueText(p.value), onValueChange: (v) => state.setValue(index, v), children: [
            /* @__PURE__ */ jsx(SelectTrigger, { className: look.value, "aria-label": `Value for ${p.field}`, children: /* @__PURE__ */ jsx(SelectValue, { placeholder: "Select\u2026" }) }),
            /* @__PURE__ */ jsx(SelectContent, { children: def.enumValues.map((option) => /* @__PURE__ */ jsx(SelectItem, { value: option, children: option }, option)) })
          ] }) : /* @__PURE__ */ jsx(
            Input,
            {
              className: look.value,
              value: valueText(p.value),
              "aria-label": `Value for ${p.field}`,
              "aria-invalid": problem?.tone === "error" || void 0,
              placeholder: isListOperator(p.op) ? "a, b, c" : "value",
              onChange: (e) => state.setValue(index, e.target.value)
            }
          )),
          /* @__PURE__ */ jsx(
            Button,
            {
              type: "button",
              variant: "ghost",
              size: "sm",
              className: look.remove.className,
              "aria-label": `Remove condition on ${p.field}`,
              onClick: () => state.remove(index),
              children: look.remove.content
            }
          )
        ] }),
        problem ? /* @__PURE__ */ jsx(
          "p",
          {
            className: cn(
              look.problem,
              problem.tone === "error" ? "text-destructive" : "text-muted-foreground"
            ),
            children: problem.message
          }
        ) : null
      ] }, state.rowKeys[index]);
    }),
    /* @__PURE__ */ jsx(Button, { variant: "outline", size: "sm", onClick: state.add, children: "Add condition" })
  ] });
}
var CHIP = "inline-flex shrink-0 items-center border-sky-500/30 bg-sky-500/10 px-1 text-[10px] font-medium leading-4 text-sky-700 dark:text-sky-400";
var HOVER = "hover:bg-sky-500/20";
function StepCitationChips({
  steps,
  onSelect,
  action = "open it",
  max = 3,
  className
}) {
  if (steps.length === 0) return null;
  const select = (event, actIds) => {
    event.stopPropagation();
    onSelect?.(actIds);
  };
  const all = steps.map((s) => s.actId);
  if (steps.length === 1) {
    const step = steps[0];
    const title = `In the story: ${stepName(step)}.${onSelect ? ` Click to ${action}.` : ""}`;
    return onSelect ? /* @__PURE__ */ jsxs("button", { type: "button", className: cn(CHIP, HOVER, "rounded border", className), title, onClick: (e) => select(e, all), children: [
      "Step ",
      step.index + 1
    ] }) : /* @__PURE__ */ jsxs("span", { className: cn(CHIP, "rounded border", className), title, children: [
      "Step ",
      step.index + 1
    ] });
  }
  const shown = steps.slice(0, max);
  const rest = steps.length - shown.length;
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: cn("inline-flex shrink-0 items-stretch overflow-hidden rounded border border-sky-500/30", className),
      role: "group",
      "aria-label": `In the story: ${stepsLabel(steps)}`,
      children: [
        onSelect ? /* @__PURE__ */ jsx(
          "button",
          {
            type: "button",
            className: cn(CHIP, HOVER, "border-0"),
            title: `In the story: ${steps.map(stepName).join("; ")}. Click to ${action} \u2014 all ${steps.length} steps together.`,
            onClick: (e) => select(e, all),
            children: "Steps"
          }
        ) : /* @__PURE__ */ jsx("span", { className: cn(CHIP, "border-0"), title: `In the story: ${steps.map(stepName).join("; ")}`, children: "Steps" }),
        shown.map(
          (step) => onSelect ? /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              className: cn(CHIP, HOVER, "border-0 border-l tabular-nums"),
              title: `${stepName(step)}. Click to ${action}.`,
              "aria-label": `Step ${step.index + 1}`,
              onClick: (e) => select(e, [step.actId]),
              children: step.index + 1
            },
            step.actId
          ) : /* @__PURE__ */ jsx("span", { className: cn(CHIP, "border-0 border-l tabular-nums"), title: stepName(step), children: step.index + 1 }, step.actId)
        ),
        rest > 0 ? onSelect ? /* @__PURE__ */ jsxs(
          "button",
          {
            type: "button",
            className: cn(CHIP, HOVER, "border-0 border-l"),
            title: `And ${steps.slice(max).map(stepName).join("; ")}. Click to ${action} \u2014 all ${steps.length} steps together.`,
            onClick: (e) => select(e, all),
            children: [
              "+",
              rest
            ]
          }
        ) : /* @__PURE__ */ jsxs("span", { className: cn(CHIP, "border-0 border-l"), title: steps.slice(max).map(stepName).join("; "), children: [
          "+",
          rest
        ] }) : null
      ]
    }
  );
}
function AddressFieldGrid({
  value,
  onChange,
  disabled,
  riskLevels,
  mode = "create",
  fieldOrigin,
  scopeLabel,
  showCatalogMeta = false,
  lifecycles = [],
  severities = [],
  provenance
}) {
  const tierCutoffs = useTierCutoffs();
  const contract = isContractType(value.address_type);
  const override = mode === "override";
  const catalogMeta = showCatalogMeta && !override;
  const originOf2 = (key) => override ? fieldOrigin?.[key] : void 0;
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-3 sm:grid-cols-3", children: [
      /* @__PURE__ */ jsx(OriginField, { label: "Type", origin: originOf2("address_type"), children: /* @__PURE__ */ jsx(
        EnumSelect,
        {
          value: value.address_type,
          disabled,
          onChange: (v) => onChange("address_type", v),
          options: ADDRESS_TYPES.map((t) => ({ value: t, label: ADDRESS_TYPE_LABEL[t] ?? t }))
        }
      ) }),
      /* @__PURE__ */ jsx(OriginField, { label: "Risk level", origin: originOf2("risk_level"), children: /* @__PURE__ */ jsx(
        EnumSelect,
        {
          value: value.risk_level,
          disabled,
          onChange: (v) => onChange("risk_level", v),
          options: riskLevels.map((r) => ({
            value: r,
            label: /* @__PURE__ */ jsx("span", { className: "capitalize", children: r })
          }))
        }
      ) }),
      /* @__PURE__ */ jsx(OriginField, { label: "Name", origin: originOf2("name"), children: /* @__PURE__ */ jsx(
        Input,
        {
          value: value.name,
          disabled,
          onChange: (e) => onChange("name", e.target.value),
          placeholder: "USD Coin"
        }
      ) })
    ] }),
    override ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(OriginField, { label: "Note", origin: originOf2("notes"), children: /* @__PURE__ */ jsx(
        Textarea,
        {
          value: value.notes ?? "",
          disabled,
          onChange: (e) => onChange("notes", e.target.value),
          rows: 3,
          placeholder: "What should the next person to open this address know?"
        }
      ) }),
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-3 sm:grid-cols-2", children: [
        /* @__PURE__ */ jsx(OriginField, { label: "Severity", origin: originOf2("severity"), children: /* @__PURE__ */ jsx(
          EnumSelect,
          {
            value: value.severity ?? "",
            disabled,
            onChange: (v) => onChange("severity", v),
            options: severities.map((s) => ({
              value: s,
              label: /* @__PURE__ */ jsx("span", { className: "capitalize", children: s })
            }))
          }
        ) }),
        /* @__PURE__ */ jsx(OriginField, { label: "Also known as (comma-separated)", origin: originOf2("aliases"), children: /* @__PURE__ */ jsx(
          Input,
          {
            value: value.aliases ?? "",
            disabled,
            onChange: (e) => onChange("aliases", e.target.value),
            placeholder: "Circle, USD Coin"
          }
        ) })
      ] }),
      contract ? /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
        /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-3 sm:grid-cols-2", children: [
          /* @__PURE__ */ jsx(OriginField, { label: "Deployed by", origin: originOf2("deployer"), children: /* @__PURE__ */ jsx(
            Input,
            {
              value: value.deployer ?? "",
              disabled,
              onChange: (e) => onChange("deployer", e.target.value),
              placeholder: "0x\u2026",
              className: "font-mono text-xs"
            }
          ) }),
          /* @__PURE__ */ jsx(OriginField, { label: "Deployed at", origin: originOf2("deployed_at"), children: /* @__PURE__ */ jsx(
            Input,
            {
              type: "datetime-local",
              value: value.deployed_at ?? "",
              disabled,
              onChange: (e) => onChange("deployed_at", e.target.value)
            }
          ) })
        ] }),
        /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: "Read from the chain where we could. Fill these in when the creation trace was missing, or correct them when it was wrong." })
      ] }) : null,
      /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: scopeLabel ? `Saved for ${scopeLabel}. The shared record is unchanged, and other tenants keep their own view.` : "Saved as your own view. The shared record is unchanged, and other tenants keep their own view." })
    ] }) : null,
    contract && !override ? /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-3", children: [
        /* @__PURE__ */ jsx(OriginField, { label: "Symbol", children: /* @__PURE__ */ jsx(
          Input,
          {
            value: value.symbol,
            disabled,
            onChange: (e) => onChange("symbol", e.target.value),
            placeholder: "USDC"
          }
        ) }),
        /* @__PURE__ */ jsx(OriginField, { label: "Decimals", children: /* @__PURE__ */ jsx(
          Input,
          {
            type: "number",
            value: value.decimals,
            disabled,
            onChange: (e) => onChange("decimals", e.target.value),
            placeholder: "18"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: "Symbol & decimals apply to token/contract rows." })
    ] }) : null,
    catalogMeta ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-3 sm:grid-cols-3", children: [
        /* @__PURE__ */ jsx(OriginField, { label: "Lifecycle", children: /* @__PURE__ */ jsx(
          EnumSelect,
          {
            value: value.lifecycle ?? "",
            disabled,
            onChange: (v) => onChange("lifecycle", v),
            options: lifecycles.map((l) => ({
              value: l,
              label: /* @__PURE__ */ jsx("span", { className: "capitalize", children: l })
            }))
          }
        ) }),
        /* @__PURE__ */ jsx(OriginField, { label: "Severity", children: /* @__PURE__ */ jsx(
          EnumSelect,
          {
            value: value.severity ?? "",
            disabled,
            onChange: (v) => onChange("severity", v),
            options: severities.map((s) => ({
              value: s,
              label: /* @__PURE__ */ jsx("span", { className: "capitalize", children: s })
            }))
          }
        ) }),
        /* @__PURE__ */ jsx(OriginField, { label: "Primary entity id", children: /* @__PURE__ */ jsx(
          Input,
          {
            value: value.primary_entity_id ?? "",
            disabled,
            onChange: (e) => onChange("primary_entity_id", e.target.value),
            placeholder: "entity_\u2026",
            className: "font-mono text-xs"
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx(OriginField, { label: "Aliases (comma-separated)", children: /* @__PURE__ */ jsx(
        Input,
        {
          value: value.aliases ?? "",
          disabled,
          onChange: (e) => onChange("aliases", e.target.value),
          placeholder: "Circle, USD Coin"
        }
      ) }),
      provenance && /* @__PURE__ */ jsx("div", { className: "rounded-md border bg-muted/20 p-2", children: /* @__PURE__ */ jsx(
        WhyPanel,
        {
          confidence: provenance.confidence,
          cutoffs: tierCutoffs,
          lifecycle: value.lifecycle,
          explanation: provenance.explanation,
          evidence: provenance.evidence
        }
      ) })
    ] }) : null
  ] });
}
function OriginField({
  label,
  origin,
  children
}) {
  return /* @__PURE__ */ jsx(
    Field,
    {
      labelClassName: "text-xs",
      label: /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1.5", children: [
        label,
        origin === "own" && /* @__PURE__ */ jsx(
          "span",
          {
            className: "text-[10px] uppercase tracking-wide text-primary",
            title: "You set this value",
            children: "yours"
          }
        ),
        origin === "inherited" && /* @__PURE__ */ jsx(
          "span",
          {
            className: "text-[10px] uppercase tracking-wide text-muted-foreground",
            title: "Inherited from a wider tier \u2014 saving makes it yours",
            children: "inherited"
          }
        )
      ] }),
      children
    }
  );
}
function CatalogFieldOverridesEditor({
  value,
  onChange,
  base,
  errors,
  onUploadLogo,
  resolveLogoUrl,
  includeTestnets,
  disabled,
  className
}) {
  const chains = Object.keys(value);
  const setChains = (next) => {
    const out = {};
    for (const c of next) out[c] = value[c] ?? {};
    onChange(out);
  };
  const setChain = (chain, patch) => {
    onChange({ ...value, [chain]: { ...value[chain], ...patch } });
  };
  const resetChain = (chain) => {
    onChange({ ...value, [chain]: {} });
  };
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-3", className), children: [
    /* @__PURE__ */ jsx(
      Field,
      {
        label: "Chains with overrides",
        labelClassName: "text-xs",
        hint: "Leave empty for none. Fields you leave blank inherit the base row for that chain.",
        children: /* @__PURE__ */ jsx(
          ChainMultiSelect,
          {
            value: chains,
            disabled,
            includeTestnets,
            allChainsLabel: "Add a chain to override\u2026",
            clearLabel: "Remove all overrides",
            onChange: setChains
          }
        )
      }
    ),
    chains.length > 0 && /* @__PURE__ */ jsx("div", { className: "space-y-2", children: chains.map((chain) => /* @__PURE__ */ jsx(
      OverrideCard,
      {
        chain,
        value: value[chain] ?? {},
        base,
        errors,
        disabled,
        resolveLogoUrl,
        onUploadLogo: onUploadLogo ? (file) => onUploadLogo(chain, file) : void 0,
        onPatch: (patch) => setChain(chain, patch),
        onReset: () => resetChain(chain)
      },
      chain
    )) })
  ] });
}
function OverrideCard({
  chain,
  value,
  base,
  errors,
  disabled,
  resolveLogoUrl,
  onUploadLogo,
  onPatch,
  onReset
}) {
  const [logoPreview, setLogoPreview] = React26.useState(
    value.logo ? { key: value.logo, url: resolveLogoUrl?.(value.logo) } : null
  );
  const empty = isEmptyFieldOverrides(value);
  const err = (field) => errors?.[`${chain}.${field}`]?.[0];
  const aliasesText = (value.aliases ?? []).join(", ");
  return /* @__PURE__ */ jsxs("div", { className: "rounded-md border p-3", children: [
    /* @__PURE__ */ jsxs("div", { className: "mb-2 flex items-center justify-between", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(ChainAvatar, { chain, size: "sm", showName: true }),
        !empty && /* @__PURE__ */ jsx("span", { className: "text-[10px] text-muted-foreground", children: "overriding" })
      ] }),
      /* @__PURE__ */ jsxs(
        "button",
        {
          type: "button",
          disabled: disabled || empty,
          onClick: onReset,
          className: "inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground disabled:opacity-40",
          children: [
            /* @__PURE__ */ jsx(RotateCcw, { className: "h-3 w-3" }),
            " Reset"
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-2 gap-3", children: [
        /* @__PURE__ */ jsx(OField, { label: "Name", error: err("name"), children: /* @__PURE__ */ jsx(
          Input,
          {
            value: value.name ?? "",
            disabled,
            placeholder: base?.name ?? "Inherit",
            onChange: (e) => onPatch({ name: e.target.value })
          }
        ) }),
        /* @__PURE__ */ jsx(OField, { label: "Colour", error: err("color"), children: /* @__PURE__ */ jsx(ColorPicker, { value: value.color, disabled, onChange: (c) => onPatch({ color: c ?? void 0 }) }) })
      ] }),
      /* @__PURE__ */ jsx(OField, { label: "Description", error: err("description"), children: /* @__PURE__ */ jsx(
        Textarea,
        {
          rows: 2,
          value: value.description ?? "",
          disabled,
          placeholder: base?.description ?? "Inherit",
          onChange: (e) => onPatch({ description: e.target.value })
        }
      ) }),
      /* @__PURE__ */ jsx(OField, { label: "Aliases", error: err("aliases"), hint: "Comma-separated. Replaces the base aliases for this chain.", children: /* @__PURE__ */ jsx(
        Input,
        {
          value: aliasesText,
          disabled,
          placeholder: (base?.aliases ?? []).join(", ") || "Inherit",
          onChange: (e) => onPatch({
            aliases: e.target.value.split(",").map((s) => s.trim()).filter(Boolean)
          })
        }
      ) }),
      onUploadLogo && /* @__PURE__ */ jsx(OField, { label: "Logo", children: /* @__PURE__ */ jsx(
        LogoUpload,
        {
          value: logoPreview,
          disabled,
          onUpload: onUploadLogo,
          onChange: (next) => {
            setLogoPreview(next);
            onPatch({ logo: next?.key });
          }
        }
      ) })
    ] })
  ] });
}
function OField({
  label,
  error,
  hint,
  children
}) {
  return /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
    /* @__PURE__ */ jsx(Label, { className: "text-xs", children: label }),
    children,
    error ? /* @__PURE__ */ jsx("p", { className: "text-xs text-destructive", children: error }) : hint ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: hint }) : null
  ] });
}
var KIND_CAPTION = {
  tag: "Primary tag",
  label: "Primary label",
  group: "Primary group",
  entity: "Primary entity"
};
function StarIcon(props) {
  return /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": true, ...props, children: /* @__PURE__ */ jsx("path", { d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" }) });
}
function PrimaryAssociation({
  kind,
  name,
  color,
  logo,
  chain,
  showCaption = true,
  onClick,
  size = "md",
  className
}) {
  const interactive = typeof onClick === "function";
  const Comp = interactive ? "button" : "div";
  const caption = chain ? `${KIND_CAPTION[kind]} \xB7 ${chain}` : KIND_CAPTION[kind];
  return /* @__PURE__ */ jsxs(
    Comp,
    {
      type: interactive ? "button" : void 0,
      onClick,
      "data-kind": kind,
      "data-primary": "true",
      "aria-label": `${caption}: ${name}`,
      className: cn(
        "inline-flex items-center gap-2 rounded-lg border border-brand/40 bg-brand/5 text-left",
        size === "sm" ? "px-2 py-1" : "px-2.5 py-1.5",
        interactive && "transition-colors hover:bg-brand/10 focus:outline-none focus:ring-2 focus:ring-brand/40",
        className
      ),
      children: [
        /* @__PURE__ */ jsx(StarIcon, { className: cn("shrink-0 text-amber-500", size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4") }),
        logo ? /* @__PURE__ */ jsx(
          "img",
          {
            src: logo,
            alt: "",
            "aria-hidden": true,
            className: cn("shrink-0 rounded-full object-cover", size === "sm" ? "h-4 w-4" : "h-5 w-5")
          }
        ) : color ? /* @__PURE__ */ jsx(
          "span",
          {
            "aria-hidden": true,
            className: cn("shrink-0 rounded-full ring-1 ring-border", size === "sm" ? "h-2.5 w-2.5" : "h-3 w-3"),
            style: { backgroundColor: color }
          }
        ) : null,
        /* @__PURE__ */ jsxs("span", { className: "min-w-0", children: [
          /* @__PURE__ */ jsx("span", { className: cn("block truncate font-semibold text-foreground", size === "sm" ? "text-xs" : "text-sm"), children: name }),
          showCaption && /* @__PURE__ */ jsx("span", { className: "block truncate text-[10px] uppercase tracking-wide text-muted-foreground", children: caption })
        ] })
      ]
    }
  );
}
var ADDRESS_RE = /^0x[0-9a-fA-F]{40}$/;
var MAX_DEPTH = 12;
var HEX_BLOB_RE = /^(0x)?[0-9a-fA-F]{48,}$/;
var AUTO_COLLAPSE_DEPTH = 2;
var LARGE_ARRAY = 8;
var LARGE_TUPLE = 16;
function isAddressType(type) {
  return !!type && /^(address|pubkey|publicKey)(\[\])*$/.test(type.trim());
}
function looksLikeAddress(value) {
  return typeof value === "string" && ADDRESS_RE.test(value);
}
function isArrayType(type) {
  return !!type && type.trim().endsWith("[]");
}
function elementType(type) {
  if (!type) return void 0;
  return type.replace(/\[\d*\]$/, "") || void 0;
}
function isTupleType(type) {
  return !!type && type.trim().startsWith("tuple");
}
function isBytesType(type) {
  return !!type && /^bytes\d*$/.test(type.trim());
}
function isNumericType(type) {
  return !!type && /^(u?int)\d*$/.test(type.trim());
}
function isRecord(value) {
  return !!value && typeof value === "object" && !Array.isArray(value);
}
function isLong(value) {
  return value.length > 24;
}
function hexToDecimal(value) {
  if (!/^0x[0-9a-fA-F]+$/.test(value)) return void 0;
  try {
    return BigInt(value).toString(10);
  } catch {
    return void 0;
  }
}
function TypeChip({ type, className }) {
  if (!type) return null;
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn(
        "rounded bg-muted px-1 py-px font-mono text-[10px] leading-tight text-muted-foreground",
        className
      ),
      title: type,
      children: type
    }
  );
}
function defaultAddress(address, opts) {
  return /* @__PURE__ */ jsx(
    AddressDisplay,
    {
      address,
      chain: opts.chain,
      onDrilldown: opts.onAddressDrilldown,
      showExplorerIcon: !opts.onAddressDrilldown
    }
  );
}
function ScalarValue({ value, type }) {
  if (value == null) return /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "\u2014" });
  if (typeof value === "boolean" || type === "bool") {
    const truthy = value === true || value === "true";
    return /* @__PURE__ */ jsx("span", { className: cn("font-mono text-sm", truthy ? "text-emerald-500" : "text-muted-foreground"), children: String(value) });
  }
  const text = typeof value === "bigint" ? value.toString() : String(value);
  if (isBytesType(type) || text.startsWith("0x") && isLong(text) || HEX_BLOB_RE.test(text)) {
    const decimal = isNumericType(type) ? hexToDecimal(text) : void 0;
    return /* @__PURE__ */ jsxs("span", { className: "inline-flex max-w-full items-center gap-1 align-middle", children: [
      /* @__PURE__ */ jsx(MiddleEllipsis, { value: text, kind: "hash", title: decimal ? `${text} (${decimal})` : text }),
      /* @__PURE__ */ jsx(CopyButton, { value: text })
    ] });
  }
  return /* @__PURE__ */ jsx("span", { className: cn("break-words text-sm", (isNumericType(type) || typeof value === "number") && "font-mono"), children: text });
}
function FieldRow({
  label,
  type,
  stacked = false,
  children
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex min-w-0 flex-col gap-0.5 py-1",
        !stacked && "sm:flex-row sm:items-baseline sm:gap-3"
      ),
      children: [
        (label != null || type) && /* @__PURE__ */ jsxs("div", { className: cn("flex min-w-0 items-center gap-1.5", !stacked && "shrink-0 sm:w-40"), children: [
          label != null && /* @__PURE__ */ jsx("span", { className: "break-all text-xs font-medium text-foreground", children: label }),
          /* @__PURE__ */ jsx(TypeChip, { type })
        ] }),
        /* @__PURE__ */ jsx("div", { className: "min-w-0 flex-1", children })
      ]
    }
  );
}
function NestedBlock({ children }) {
  return /* @__PURE__ */ jsx("div", { className: "divide-y divide-border/40 rounded-md border border-border/60 bg-muted/20 px-2.5", children });
}
function CollapsibleBlock({
  summary,
  defaultOpen,
  children
}) {
  const [open, setOpen] = React26.useState(defaultOpen);
  return /* @__PURE__ */ jsxs(Collapsible, { open, onOpenChange: setOpen, className: "min-w-0", children: [
    /* @__PURE__ */ jsxs(CollapsibleTrigger, { className: "group inline-flex items-center gap-1 rounded text-xs text-muted-foreground hover:text-foreground", children: [
      /* @__PURE__ */ jsx(ChevronRight, { className: cn("h-3.5 w-3.5 shrink-0 transition-transform", open && "rotate-90") }),
      /* @__PURE__ */ jsx("span", { className: "font-mono", children: summary })
    ] }),
    /* @__PURE__ */ jsx(CollapsibleContent, { className: "pt-1", children })
  ] });
}
var GENERIC_KINDS = /* @__PURE__ */ new Set([
  "address",
  "integer",
  "bool",
  "bytes",
  "string",
  "chain",
  "cbor",
  "code",
  "text",
  "call",
  "abi",
  "token_amount"
]);
function isGenericDecodedKind(kind) {
  return !!kind && GENERIC_KINDS.has(kind);
}
function asText(value) {
  if (value == null) return "";
  return typeof value === "bigint" ? value.toString() : String(value);
}
function asRawJson(value) {
  try {
    return JSON.stringify(value, (_k, v) => typeof v === "bigint" ? v.toString() : v) ?? "";
  } catch {
    return String(value);
  }
}
function enrichedDecoded(value) {
  if (!isEnriched(value)) return void 0;
  const inner = value[DECODED_ENVELOPE_MARKER];
  return isRecord(inner) ? inner.decoded : void 0;
}
function KindBadge({ kind, className }) {
  const label = kind.replace(/^.*\./, "").replace(/_/g, " ");
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: cn(
        "rounded bg-muted px-1 py-px text-[10px] font-medium uppercase tracking-wide text-muted-foreground",
        className
      ),
      title: kind,
      children: label
    }
  );
}
function AmountText({ text }) {
  if (isUnlimitedAmount(text)) {
    return /* @__PURE__ */ jsx(
      "span",
      {
        className: "text-sm font-medium",
        title: `No limit \u2014 the maximum an approval can carry (${text} base units)`,
        children: "Unlimited"
      }
    );
  }
  return /* @__PURE__ */ jsx("span", { className: "font-mono text-sm", children: text });
}
function RawToggle({ raw }) {
  const [open, setOpen] = React26.useState(false);
  const text = asText(raw);
  if (!text) return null;
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1 align-middle", children: [
    /* @__PURE__ */ jsx(
      "button",
      {
        type: "button",
        onClick: () => setOpen((v) => !v),
        className: "rounded px-1 text-[10px] text-muted-foreground hover:bg-muted hover:text-foreground",
        children: open ? "hide raw" : "raw"
      }
    ),
    open && /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 items-center gap-1", children: [
      /* @__PURE__ */ jsx(MiddleEllipsis, { value: text, kind: "hash" }),
      /* @__PURE__ */ jsx(CopyButton, { value: text })
    ] })
  ] });
}
function CodeBlock({ children }) {
  return /* @__PURE__ */ jsx("pre", { className: "max-h-64 min-w-0 overflow-auto rounded-md border border-border/60 bg-muted/30 p-2 font-mono text-xs", children });
}
function CborView({
  decoded,
  raw,
  chain,
  renderAddress,
  onAddressDrilldown,
  renderKind,
  depth
}) {
  const d = isRecord(decoded) ? decoded : {};
  const js = typeof d.possible_js_code === "string" ? d.possible_js_code.trim() : "";
  const kvSource = isRecord(d.possible_key_value_pairs) ? d.possible_key_value_pairs : void 0;
  const kv = kvSource ? Object.entries(kvSource).filter(([k, v]) => k && v != null && String(v).trim()) : [];
  const cborData = isRecord(d.cbor_data) ? d.cbor_data : void 0;
  const allStrings = Array.isArray(cborData?.strings) ? cborData.strings.filter((s) => typeof s === "string" && s.trim().length > 0) : [];
  const shownInKv = new Set(kv.flatMap(([k, v]) => [k, String(v)]));
  const strings = allStrings.filter((s) => !shownInKv.has(s));
  return /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-1.5", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
      /* @__PURE__ */ jsx(KindBadge, { kind: "cbor" }),
      /* @__PURE__ */ jsx(RawToggle, { raw })
    ] }),
    js && /* @__PURE__ */ jsx(CodeBlock, { children: js }),
    kv.length > 0 && /* @__PURE__ */ jsx(NestedBlock, { children: kv.map(([k, v]) => /* @__PURE__ */ jsx(FieldRow, { label: k, stacked: true, children: /* @__PURE__ */ jsx("span", { className: "break-words text-sm", children: String(v) }) }, k)) }),
    strings.length > 0 && /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-1", children: strings.map((s, i) => /* @__PURE__ */ jsx("span", { className: "rounded bg-muted px-1.5 py-0.5 font-mono text-xs break-all", children: s }, i)) }),
    !js && kv.length === 0 && strings.length === 0 && /* @__PURE__ */ jsx("span", { className: "text-sm text-muted-foreground", children: "CBOR document" }),
    /* @__PURE__ */ jsx(CollapsibleBlock, { summary: "full structure", defaultOpen: false, children: /* @__PURE__ */ jsx(
      DecodedValue,
      {
        value: decoded,
        chain,
        renderAddress,
        onAddressDrilldown,
        renderKind,
        depth: depth + 1
      }
    ) })
  ] });
}
function CallView({
  decoded,
  raw,
  chain,
  renderAddress,
  onAddressDrilldown,
  renderKind,
  depth = 0
}) {
  const call = isRecord(decoded) ? decoded : void 0;
  const heading = call ? asText(call.signature) || asText(call.label) : "";
  const params = call && Array.isArray(call.params) ? call.params : [];
  return /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-1", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
      heading ? /* @__PURE__ */ jsx("span", { className: "break-all font-mono text-xs font-semibold text-foreground", children: heading }) : null,
      /* @__PURE__ */ jsx(KindBadge, { kind: "call" }),
      /* @__PURE__ */ jsx(RawToggle, { raw })
    ] }),
    params.length > 0 ? /* @__PURE__ */ jsx(NestedBlock, { children: params.map((p, i) => {
      const param = isRecord(p) ? p : {};
      const pType = asText(param.type) || void 0;
      return /* @__PURE__ */ jsx(FieldRow, { label: asText(param.name) || `[${i}]`, type: pType, stacked: true, children: /* @__PURE__ */ jsx(
        DecodedValue,
        {
          value: param.value,
          type: pType,
          display: param.display,
          semanticType: typeof param.semantic_type === "string" ? param.semantic_type : void 0,
          chain,
          renderAddress,
          onAddressDrilldown,
          renderKind,
          depth: depth + 1
        }
      ) }, asText(param.name) || i);
    }) }) : /* @__PURE__ */ jsx("span", { className: "text-sm text-muted-foreground", children: "No parameters" })
  ] });
}
function EnrichedValue({
  kind,
  display: display2,
  raw,
  decoded,
  chain,
  renderAddr,
  renderAddress,
  onAddressDrilldown,
  renderKind,
  depth
}) {
  switch (kind) {
    case "address": {
      const addr = asText(display2) || asText(raw);
      const own = isRecord(decoded) ? asText(decoded.chain_id) : "";
      const addrChain = own || chain;
      const render = own ? (a) => renderAddress ? renderAddress(a, { chain: own }) : defaultAddress(a, { chain: own, onAddressDrilldown }) : renderAddr;
      return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-wrap items-center gap-1.5", children: [
        isValidAddress(addr, addrChain) ? render(addr) : /* @__PURE__ */ jsx("span", { className: "font-mono text-sm", children: addr }),
        /* @__PURE__ */ jsx(RawToggle, { raw })
      ] });
    }
    case "chain": {
      const chainId = isRecord(decoded) ? asText(decoded.chain_id) : "";
      const name = asText(display2) || (isRecord(decoded) ? asText(decoded.chain_name) : "") || chainId;
      return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-wrap items-center gap-1.5", children: [
        chainId ? /* @__PURE__ */ jsx(ChainAvatar, { chain: chainId, size: "sm", showName: false }) : null,
        /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", children: name || "chain" }),
        /* @__PURE__ */ jsx(KindBadge, { kind: "chain" }),
        /* @__PURE__ */ jsx(RawToggle, { raw })
      ] });
    }
    case "token_amount": {
      const d = isRecord(decoded) ? decoded : void 0;
      if (d && (d.amount != null || d.value != null)) {
        return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-wrap items-center gap-1.5", children: [
          /* @__PURE__ */ jsx(
            TokenValue,
            {
              amount: asText(d.amount ?? d.value),
              decimals: typeof d.decimals === "number" ? d.decimals : void 0,
              symbol: asText(d.symbol) || void 0,
              symbolSource: d.symbol_source === "memo" ? "memo" : "contract",
              precision: typeof d.decimals === "number" && Number.isInteger(d.decimals) && d.decimals >= 0 && d.decimals <= 36 ? d.decimals : 6,
              chain,
              layout: "inline"
            }
          ),
          /* @__PURE__ */ jsx(RawToggle, { raw })
        ] });
      }
      return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1.5", children: [
        /* @__PURE__ */ jsx(AmountText, { text: asText(display2) }),
        /* @__PURE__ */ jsx(RawToggle, { raw })
      ] });
    }
    case "integer": {
      return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1.5", children: [
        /* @__PURE__ */ jsx(AmountText, { text: asText(display2) }),
        /* @__PURE__ */ jsx(RawToggle, { raw })
      ] });
    }
    case "bool": {
      const truthy = display2 === true || display2 === "true";
      return /* @__PURE__ */ jsx("span", { className: cn("font-mono text-sm", truthy ? "text-emerald-500" : "text-muted-foreground"), children: String(display2 ?? "") });
    }
    case "bytes": {
      const structured = [decoded, display2, raw].find((slot) => isRecord(slot) || Array.isArray(slot));
      if (structured !== void 0) {
        const rawIsScalar = raw != null && !isRecord(raw) && !Array.isArray(raw);
        return /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-1", children: [
          rawIsScalar && /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
            /* @__PURE__ */ jsx(KindBadge, { kind: "bytes" }),
            /* @__PURE__ */ jsx(RawToggle, { raw })
          ] }),
          /* @__PURE__ */ jsx(
            DecodedValue,
            {
              value: structured,
              chain,
              renderAddress,
              onAddressDrilldown,
              renderKind,
              depth: depth + 1
            }
          )
        ] });
      }
      const text = asText(display2) || asText(raw);
      const rawText = asText(raw);
      return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-wrap items-center gap-1.5", children: [
        text.startsWith("0x") && isLong(text) ? /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 items-center gap-1", children: [
          /* @__PURE__ */ jsx(MiddleEllipsis, { value: text, kind: "hash" }),
          /* @__PURE__ */ jsx(CopyButton, { value: text })
        ] }) : /* @__PURE__ */ jsx("span", { className: "break-all font-mono text-sm", children: text || "\u2014" }),
        rawText && rawText !== text && /* @__PURE__ */ jsx(RawToggle, { raw })
      ] });
    }
    case "string": {
      const text = asText(display2);
      const rawText = asText(raw);
      return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-wrap items-center gap-1.5", children: [
        /* @__PURE__ */ jsx("span", { className: "break-words text-sm", children: text || "\u2014" }),
        rawText && rawText !== text && /* @__PURE__ */ jsx(RawToggle, { raw })
      ] });
    }
    case "abi": {
      const label = asText(display2);
      const hasStructure = isRecord(decoded) || Array.isArray(decoded);
      if (!hasStructure) {
        return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-wrap items-center gap-1.5", children: [
          label ? /* @__PURE__ */ jsx("span", { className: "break-words text-sm font-medium", children: label }) : null,
          /* @__PURE__ */ jsx(KindBadge, { kind: "abi" }),
          /* @__PURE__ */ jsx(RawToggle, { raw })
        ] });
      }
      return /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-1", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
          label ? /* @__PURE__ */ jsx("span", { className: "text-xs font-semibold text-foreground", children: label }) : null,
          /* @__PURE__ */ jsx(KindBadge, { kind: "abi" }),
          /* @__PURE__ */ jsx(RawToggle, { raw })
        ] }),
        /* @__PURE__ */ jsx(
          DecodedValue,
          {
            value: decoded,
            chain,
            renderAddress,
            onAddressDrilldown,
            renderKind,
            depth: depth + 1
          }
        )
      ] });
    }
    case "code": {
      return /* @__PURE__ */ jsx(CodeBlock, { children: asText(display2) });
    }
    case "cbor": {
      return /* @__PURE__ */ jsx(
        CborView,
        {
          decoded,
          raw,
          chain,
          renderAddress,
          onAddressDrilldown,
          renderKind,
          depth
        }
      );
    }
    case "call": {
      return /* @__PURE__ */ jsx(
        CallView,
        {
          decoded,
          raw,
          chain,
          renderAddress,
          onAddressDrilldown,
          renderKind,
          depth
        }
      );
    }
    case "text": {
      return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-wrap items-center gap-1.5", children: [
        /* @__PURE__ */ jsx("span", { className: "break-words text-sm", children: asText(display2) || "\u2014" }),
        /* @__PURE__ */ jsx(KindBadge, { kind: "text" }),
        /* @__PURE__ */ jsx(RawToggle, { raw })
      ] });
    }
    default: {
      return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-wrap items-center gap-1.5", children: [
        /* @__PURE__ */ jsx("span", { className: "break-words text-sm", children: asText(display2) }),
        /* @__PURE__ */ jsx(KindBadge, { kind }),
        /* @__PURE__ */ jsx(RawToggle, { raw })
      ] });
    }
  }
}
function tupleFields(value, components) {
  if (Array.isArray(value)) {
    return value.map((v, i) => {
      const comp = components?.[i];
      return { name: comp?.name || `[${i}]`, type: comp?.type, value: v, components: comp?.components };
    });
  }
  if (isRecord(value)) {
    return Object.entries(value).map(([key, v]) => {
      const comp = components?.find((c) => c.name === key);
      return { name: key, type: comp?.type, value: v, components: comp?.components };
    });
  }
  return [];
}
function DecodedValue({
  value,
  type,
  components,
  display: display2,
  semanticType,
  chain,
  renderAddress,
  onAddressDrilldown,
  renderKind,
  depth = 0,
  className
}) {
  const opts = { chain, onAddressDrilldown};
  const renderAddr = renderAddress ? (addr) => renderAddress(addr, { chain }) : (addr) => defaultAddress(addr, opts);
  if (typeof value === "string" && isUnlimitedAmount(value)) {
    return /* @__PURE__ */ jsx(AmountText, { text: value });
  }
  const kind = semanticType ?? kindOf(value);
  if (kind) {
    const shown = display2 !== void 0 ? display2 : displayOf(value);
    const raw = rawOf(value);
    const decoded = enrichedDecoded(value);
    const custom = renderKind?.({ kind, display: shown, raw, decoded, chain, depth });
    const content = custom ?? /* @__PURE__ */ jsx(
      EnrichedValue,
      {
        kind,
        display: shown,
        raw,
        decoded,
        chain,
        renderAddr,
        renderAddress,
        onAddressDrilldown,
        renderKind,
        depth
      }
    );
    if (kind === "call") {
      const inner = isRecord(value) && isRecord(value[DECODED_ENVELOPE_MARKER]) ? value[DECODED_ENVELOPE_MARKER] : {};
      const own = isRecord(decoded) ? decoded : {};
      const score = typeof inner.confidence === "number" ? recordedConfidence({ confidence: inner.confidence, confidence_scored: true }) : recordedConfidence(own);
      const evidence = Array.isArray(own.evidence) ? own.evidence : isRecord(own.evidence) ? [own.evidence] : [];
      return /* @__PURE__ */ jsx(
        ReadConfidenceBoundary,
        {
          score,
          evidence,
          subject: "Nested decoded call",
          rawFallback: /* @__PURE__ */ jsx(RawToggle, { raw }),
          children: content
        }
      );
    }
    return /* @__PURE__ */ jsx("span", { className: cn("min-w-0", className), children: content });
  }
  if (isAddressType(type) && typeof value === "string" && value) {
    return /* @__PURE__ */ jsx("span", { className, children: renderAddr(value) });
  }
  if (depth < MAX_DEPTH) {
    if (Array.isArray(value) || isArrayType(type) && Array.isArray(value)) {
      const elType = elementType(type);
      if (value.length === 0) {
        return /* @__PURE__ */ jsx("span", { className: cn("text-sm text-muted-foreground", className), children: "[] (empty)" });
      }
      return /* @__PURE__ */ jsx("div", { className: cn("min-w-0", className), children: /* @__PURE__ */ jsx(
        CollapsibleBlock,
        {
          summary: `${value.length} ${value.length === 1 ? "item" : "items"}`,
          defaultOpen: depth < AUTO_COLLAPSE_DEPTH && value.length <= LARGE_ARRAY,
          children: /* @__PURE__ */ jsx(NestedBlock, { children: value.map((item, i) => /* @__PURE__ */ jsx(FieldRow, { label: `[${i}]`, type: elType, stacked: depth >= 1, children: /* @__PURE__ */ jsx(
            DecodedValue,
            {
              value: item,
              type: elType,
              components,
              chain,
              renderAddress,
              onAddressDrilldown,
              renderKind,
              depth: depth + 1
            }
          ) }, i)) })
        }
      ) });
    }
    if (isTupleType(type) || isRecord(value)) {
      const fields = tupleFields(value, components);
      if (fields.length > 0) {
        return /* @__PURE__ */ jsx("div", { className: cn("min-w-0", className), children: /* @__PURE__ */ jsx(
          CollapsibleBlock,
          {
            summary: `${fields.length} ${fields.length === 1 ? "field" : "fields"}`,
            defaultOpen: depth < AUTO_COLLAPSE_DEPTH && fields.length <= LARGE_TUPLE,
            children: /* @__PURE__ */ jsx(NestedBlock, { children: fields.map((f, i) => /* @__PURE__ */ jsx(FieldRow, { label: f.name, type: f.type, stacked: depth >= 1, children: /* @__PURE__ */ jsx(
              DecodedValue,
              {
                value: f.value,
                type: f.type,
                components: f.components,
                display: f.display,
                semanticType: f.semanticType,
                chain,
                renderAddress,
                onAddressDrilldown,
                renderKind,
                depth: depth + 1
              }
            ) }, f.name || i)) })
          }
        ) });
      }
    }
  }
  if (looksLikeAddress(value)) {
    return /* @__PURE__ */ jsx("span", { className, children: renderAddr(value) });
  }
  if (Array.isArray(value) || isRecord(value)) {
    return /* @__PURE__ */ jsxs("span", { className: cn("inline-flex max-w-full flex-wrap items-center gap-1.5", className), children: [
      /* @__PURE__ */ jsx("span", { className: "text-sm text-muted-foreground", children: Array.isArray(value) ? `${value.length} ${value.length === 1 ? "item" : "items"}, nested too deep to expand` : "Nested too deep to expand" }),
      /* @__PURE__ */ jsx(RawToggle, { raw: asRawJson(value) })
    ] });
  }
  return /* @__PURE__ */ jsx("span", { className, children: /* @__PURE__ */ jsx(ScalarValue, { value, type }) });
}
function DecodedParamList({
  params,
  chain,
  renderAddress,
  onAddressDrilldown,
  renderKind,
  showTypes = true,
  className,
  emptyLabel = "No parameters"
}) {
  if (params.length === 0) {
    return /* @__PURE__ */ jsx("p", { className: cn("text-sm text-muted-foreground", className), children: emptyLabel });
  }
  return /* @__PURE__ */ jsx("div", { className: cn("min-w-0 divide-y divide-border/40 overflow-x-auto", className), children: params.map((p, i) => /* @__PURE__ */ jsx(FieldRow, { label: p.name || `[${i}]`, type: showTypes ? p.type : void 0, children: /* @__PURE__ */ jsx(
    DecodedValue,
    {
      value: p.value,
      type: p.type,
      components: p.components,
      display: p.display,
      semanticType: p.semanticType,
      chain,
      renderAddress,
      onAddressDrilldown,
      renderKind
    }
  ) }, p.name || i)) });
}
function SectionLabel({ children }) {
  return /* @__PURE__ */ jsx("p", { className: "text-[10px] font-medium uppercase tracking-wide text-muted-foreground", children });
}
function sourceLabel3(source) {
  return source.replace(/[_-]+/g, " ");
}
function AbiRungBadge({ scope }) {
  const rung = scopeRungLabel(scope);
  if (!rung) return null;
  return /* @__PURE__ */ jsxs(
    Badge,
    {
      variant: "outline",
      className: "font-normal",
      "data-abi-rung": scope,
      title: `Decoded with the ABI saved at the ${rung.toLowerCase()} level. A narrower level's ABI wins over a wider one's for this contract.`,
      children: [
        rung,
        " ABI"
      ]
    }
  );
}
function DecodedCall({
  label,
  signature,
  address,
  source,
  abiScope,
  params = [],
  returnParams = [],
  proxyChain = [],
  chain,
  renderAddress,
  onAddressDrilldown,
  renderKind,
  className
}) {
  const hasReturns = returnParams.length > 0;
  const renderAddr = renderAddress ? (addr) => renderAddress(addr, { chain }) : void 0;
  const name = label || (signature ? signature.split("(")[0] : void 0);
  const vocab = chainDecodeVocabulary(chain);
  return /* @__PURE__ */ jsxs("div", { className: cn("space-y-3", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-x-2 gap-y-1", children: [
      name ? /* @__PURE__ */ jsx("code", { className: "font-mono text-sm font-semibold text-foreground", children: name }) : /* @__PURE__ */ jsxs("span", { className: "text-sm text-muted-foreground", children: [
        "Unknown ",
        vocab.entrypoint
      ] }),
      source && /* @__PURE__ */ jsx(Badge, { variant: "secondary", className: "font-normal capitalize", children: sourceLabel3(source) }),
      /* @__PURE__ */ jsx(AbiRungBadge, { scope: abiScope })
    ] }),
    signature && name !== signature && /* @__PURE__ */ jsx("code", { className: "block break-all font-mono text-xs text-muted-foreground", children: signature }),
    address && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2 text-xs text-muted-foreground", children: [
      /* @__PURE__ */ jsx("span", { className: "shrink-0", children: vocab.targetLabel }),
      renderAddr ? renderAddr(address) : /* @__PURE__ */ jsx(
        AddressDisplay,
        {
          address,
          chain,
          onDrilldown: onAddressDrilldown,
          showExplorerIcon: !onAddressDrilldown
        }
      )
    ] }),
    proxyChain.length > 0 && /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
      "Resolved through proxy: ",
      /* @__PURE__ */ jsx("span", { className: "font-mono", children: proxyChain.join(" \u2192 ") })
    ] }),
    hasReturns ? /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ jsx(SectionLabel, { children: "Arguments" }),
      /* @__PURE__ */ jsx(
        DecodedParamList,
        {
          params,
          chain,
          renderAddress,
          onAddressDrilldown,
          renderKind,
          emptyLabel: "No arguments"
        }
      )
    ] }) : /* @__PURE__ */ jsx(
      DecodedParamList,
      {
        params,
        chain,
        renderAddress,
        onAddressDrilldown,
        renderKind
      }
    ),
    hasReturns && /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ jsx(SectionLabel, { children: "Returns" }),
      /* @__PURE__ */ jsx(
        DecodedParamList,
        {
          params: returnParams,
          chain,
          renderAddress,
          onAddressDrilldown,
          renderKind
        }
      )
    ] })
  ] });
}
function hasWithheldContent(outcomes) {
  return (outcomes ?? []).some((o) => o.action === "withhold");
}
function WithheldNotice({
  outcomes,
  what = "reading",
  onConfigure,
  className
}) {
  const withheld = React26.useMemo(
    () => outcomes.filter((o) => o.action === "withhold"),
    [outcomes]
  );
  if (withheld.length === 0) return null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex flex-wrap items-center gap-2 rounded-md border border-dashed border-border px-2.5 py-1.5 text-xs",
        className
      ),
      children: [
        /* @__PURE__ */ jsxs(HoverCard, { children: [
          /* @__PURE__ */ jsx(HoverCardTrigger, { asChild: true, children: /* @__PURE__ */ jsx("button", { type: "button", className: cn(badgeVariants({ variant: "outline" }), "cursor-help font-normal"), children: withheld.length === 1 ? `1 ${what} withheld` : `${withheld.length} ${what}s withheld` }) }),
          /* @__PURE__ */ jsxs(HoverCardContent, { className: "w-96 space-y-2 text-xs", children: [
            /* @__PURE__ */ jsx("div", { className: "font-medium text-foreground", children: "Withheld during processing" }),
            /* @__PURE__ */ jsx(GateOutcomeList, { outcomes: withheld }),
            /* @__PURE__ */ jsx("div", { className: "border-t border-border pt-1.5 text-muted-foreground", children: "These recorded decisions explain withheld results. Stored diagnostics are bounded and older records may lack calculation details." })
          ] })
        ] }),
        /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "This result did not reach the minimum confidence used during processing." }),
        onConfigure ? /* @__PURE__ */ jsx(
          Button,
          {
            variant: "link",
            size: "sm",
            className: "h-auto p-0 text-xs",
            onClick: onConfigure,
            children: "View current policy"
          }
        ) : null
      ]
    }
  );
}
function GateOutcomeList({
  outcomes
}) {
  return /* @__PURE__ */ jsx("ul", { className: "space-y-1.5", children: outcomes.map((o, i) => /* @__PURE__ */ jsxs("li", { className: "space-y-0.5", children: [
    /* @__PURE__ */ jsx("div", { className: "text-foreground", children: o.reason }),
    /* @__PURE__ */ jsxs("div", { className: "font-mono text-[11px] text-muted-foreground", children: [
      o.subject ? `${o.subject} \xB7 ` : "",
      "scored ",
      formatConfidence(o.confidence, 2),
      ", needed",
      " ",
      formatConfidence(o.floor, 2),
      o.floor_is_configured === false ? " (domain default)" : ""
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "text-muted-foreground", children: [
      "Threshold source: ",
      o.floor_source ?? (o.floor_is_configured === false ? "domain_default" : "not recorded \u2014 the original scope or pipeline cannot be identified"),
      o.floor_path ? ` \xB7 ${o.floor_path}` : "",
      o.action_source ? ` \xB7 action from ${o.action_source}` : ""
    ] }),
    o.score_components ? /* @__PURE__ */ jsx("div", { className: "text-muted-foreground", children: o.score_components.method === "source_base_scaled_producer_score" && typeof o.score_components.effective_source_base === "number" && typeof o.score_components.signal_factor === "number" ? `Source base ${formatConfidence(o.score_components.effective_source_base, 2)} \xD7 signal factor ${o.score_components.signal_factor} = ${formatConfidence(o.confidence, 2)} (rounded).` : "The score uses the producer's recorded evidence." }) : /* @__PURE__ */ jsx("div", { className: "text-muted-foreground", children: "Score calculation was not recorded on this result." }),
    o.score_explanation?.map((line, index) => /* @__PURE__ */ jsx("div", { className: "text-muted-foreground", children: line }, index))
  ] }, `${o.domain}:${o.subject ?? ""}:${i}`)) });
}
var ACTION_DONE = {
  withhold: "withheld",
  flag: "marked low-confidence",
  demote: "forced to low"
};
var ACTION_HEADING = {
  withhold: "Withheld by the processing confidence policy",
  flag: "Kept and marked by the processing confidence policy",
  demote: "Forced to low by the processing confidence policy"
};
function ConfidenceGateNotice({
  outcomes,
  processing,
  omitted = 0,
  truncated = 0,
  onConfigure,
  className
}) {
  const groups = React26.useMemo(() => {
    const out = /* @__PURE__ */ new Map();
    for (const o of outcomes) {
      if (!(o.action in ACTION_DONE)) continue;
      const key = `${o.domain}|${o.action}`;
      const group = out.get(key) ?? { domain: o.domain, action: String(o.action), items: [] };
      group.items.push(o);
      out.set(key, group);
    }
    return [...out.values()];
  }, [outcomes]);
  if (groups.length === 0 && omitted === 0 && truncated === 0) return null;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex flex-wrap items-center gap-2 rounded-md border border-dashed border-border px-2.5 py-1.5 text-xs",
        className
      ),
      "data-testid": "confidence-gate-notice",
      children: [
        groups.map((g) => /* @__PURE__ */ jsxs(HoverCard, { children: [
          /* @__PURE__ */ jsx(HoverCardTrigger, { asChild: true, children: /* @__PURE__ */ jsxs(
            "button",
            {
              type: "button",
              className: cn(
                badgeVariants({ variant: "outline" }),
                "cursor-help font-normal",
                g.action === "withhold" ? "border-destructive/50" : "border-amber-500/50"
              ),
              children: [
                domainLabel(g.domain),
                " \xB7 ",
                g.items.length,
                " ",
                ACTION_DONE[g.action]
              ]
            }
          ) }),
          /* @__PURE__ */ jsxs(HoverCardContent, { className: "w-96 space-y-2 text-xs", children: [
            /* @__PURE__ */ jsx("div", { className: "font-medium text-foreground", children: ACTION_HEADING[g.action] }),
            /* @__PURE__ */ jsxs("div", { className: "text-muted-foreground", children: [
              "Execution scope: ",
              processing?.scope ?? "not recorded",
              ".",
              processing?.pipelineId ? ` Pipeline: ${processing.pipelineId}${processing.pipelineRevision ? ` \xB7 revision ${processing.pipelineRevision}` : ""}.` : " Pipeline: not recorded."
            ] }),
            /* @__PURE__ */ jsx(GateOutcomeList, { outcomes: g.items }),
            /* @__PURE__ */ jsx("div", { className: "border-t border-border pt-1.5 text-muted-foreground", children: g.action === "withhold" ? "These are decisions recorded when this body was processed. Changing the current policy requires reprocessing to change this stored result." : "The score shown is the one this check judged. A graph's \u201CEvidence\u201D badge scores a node's decode, which is a different number." }),
            onConfigure ? (
              // Per CHECK, not per notice: a transaction judged by three checks
              // has three different rows to open, and the footer link can only
              // name one of them.
              /* @__PURE__ */ jsxs(
                Button,
                {
                  variant: "link",
                  size: "sm",
                  className: "h-auto p-0 text-xs",
                  onClick: () => onConfigure([g.domain]),
                  children: [
                    "View current ",
                    domainLabel(g.domain).toLowerCase(),
                    " policy"
                  ]
                }
              )
            ) : null
          ] })
        ] }, `${g.domain}|${g.action}`)),
        omitted > 0 ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          "+",
          omitted,
          " more not listed"
        ] }) : null,
        truncated > 0 ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          truncated,
          " decisions exceeded the ledger limit; details are incomplete."
        ] }) : null,
        /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "This result did not reach the minimum confidence used during processing." }),
        /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          processing?.scope ? `Recorded execution scope: ${processing.scope}. ` : "Original execution scope was not recorded. ",
          "Current settings may differ. Changing processing settings requires reprocessing existing results."
        ] }),
        onConfigure ? /* @__PURE__ */ jsx(
          Button,
          {
            variant: "link",
            size: "sm",
            className: "h-auto p-0 text-xs",
            onClick: () => onConfigure(groups.map((g) => g.domain)),
            children: "View current policy"
          }
        ) : null
      ]
    }
  );
}
function withheldSummary(outcomes) {
  const withheld = (outcomes ?? []).filter((o) => o.action === "withhold");
  if (withheld.length === 0) return null;
  const domains = [...new Set(withheld.map((o) => o.domain))];
  const label = GATE_ACTION_LABELS.withhold?.toLowerCase() ?? "dropped";
  return `${withheld.length} ${label} by the confidence policy (${domains.join(", ")})`;
}
var INHERIT = "__inherit__";
function inheritedFrom(ladder, path, tier, tierLabels) {
  const found = inheritedValue(ladder, path, tier);
  return found ? { value: found.value, from: tierLabels[found.tier] ?? found.tier } : null;
}
var COLLAPSE_AT = 4;
var COLLAPSE_SETTINGS_AT = 8;
function Disclosure({
  open,
  onToggle,
  title,
  hint,
  count,
  children
}) {
  return /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
    /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        onClick: onToggle,
        "aria-expanded": open,
        className: "flex w-full items-start justify-between gap-3 rounded-md border border-border bg-muted/20 px-3 py-2 text-left hover:bg-muted/40",
        children: [
          /* @__PURE__ */ jsxs("span", { className: "min-w-0", children: [
            /* @__PURE__ */ jsxs("span", { className: "flex items-center gap-1.5 text-sm font-medium text-foreground", children: [
              open ? /* @__PURE__ */ jsx(ChevronDown, { className: "h-4 w-4 shrink-0" }) : /* @__PURE__ */ jsx(ChevronRight, { className: "h-4 w-4 shrink-0" }),
              title
            ] }),
            hint ? /* @__PURE__ */ jsx("span", { className: "mt-0.5 block pl-5.5 text-xs text-muted-foreground", children: hint }) : null
          ] }),
          count ? /* @__PURE__ */ jsx("span", { className: "shrink-0 pt-0.5 text-xs text-muted-foreground", children: count }) : null
        ]
      }
    ),
    open ? children : null
  ] });
}
function MaybeDisclosure({
  collapsed,
  open,
  onToggle,
  title,
  hint,
  count,
  children
}) {
  if (!collapsed) {
    return /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("div", { className: "text-sm font-medium text-foreground", children: title }),
        hint ? /* @__PURE__ */ jsx("div", { className: "text-xs text-muted-foreground", children: hint }) : null
      ] }),
      children
    ] });
  }
  return /* @__PURE__ */ jsx(Disclosure, { open, onToggle, title, hint, count, children });
}
function PolicyFilter({
  value,
  onChange,
  found
}) {
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "relative min-w-0 flex-1", children: [
      /* @__PURE__ */ jsx(Search, { className: "pointer-events-none absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" }),
      /* @__PURE__ */ jsx(
        Input,
        {
          value,
          onChange: (e) => onChange(e.target.value),
          placeholder: "Find a check or setting \u2014 protocol detection, floors.risk, a provider\u2026",
          "aria-label": "Filter the confidence policy",
          className: "h-8 pl-8 text-xs"
        }
      )
    ] }),
    value.trim() ? /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsxs("span", { className: "shrink-0 text-xs text-muted-foreground", children: [
        found,
        " ",
        found === 1 ? "match" : "matches"
      ] }),
      /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", className: "h-8 px-2 text-xs", onClick: () => onChange(""), children: "Clear" })
    ] }) : null
  ] });
}
var PolicyOwnerContext = React26.createContext(void 0);
function ConfidencePolicyPanel({
  ladder,
  domains,
  knobs = [],
  knobsOnly = false,
  readOnlyKnobs = [],
  ownedBy,
  cutoffs,
  defaultActions,
  supportedActions,
  platformFloors,
  baseTables,
  riskRules,
  activity,
  activityWindowDays = 7,
  enforcement,
  tier,
  tierLabels,
  onSave,
  onPreview,
  onClear,
  focus,
  busy = false,
  className
}) {
  const rows = React26.useMemo(
    () => knobsOnly ? [] : domainsToShow(ladder, domains),
    [ladder, domains, knobsOnly]
  );
  const allKnobRows = React26.useMemo(() => knobsToShow(knobs), [knobs]);
  const [query, setQuery] = React26.useState("");
  const matches = React26.useCallback(
    (...parts) => {
      const q = query.trim().toLowerCase();
      if (!q) return true;
      return parts.some((part) => part?.toLowerCase().includes(q));
    },
    [query]
  );
  const filterKeys = React26.useCallback(
    (keys, pathFor, labelFor) => keys.filter((key) => matches(key, labelFor(key), pathFor(key))),
    [matches]
  );
  const knobRows = React26.useMemo(
    () => allKnobRows.filter((knob) => matches(knobLabel(knob), knob)),
    [allKnobRows, matches]
  );
  const [edits, setEdits] = React26.useState({});
  const [seen, setSeen] = React26.useState({
    tier,
    ladder
  });
  if (seen.tier !== tier || seen.ladder !== ladder) {
    setSeen({ tier, ladder });
    setEdits({});
  }
  const readOnly = !onSave;
  const valueFor = (path) => {
    if (path in edits) return edits[path];
    return originOf(ladder, path)?.value;
  };
  const ownValueFor = (path) => {
    if (path in edits) return edits[path];
    const origin = originOf(ladder, path);
    return knobStatus(origin, tier) === "own" ? origin?.value : void 0;
  };
  const set = (path, value) => setEdits((prev) => {
    const next = { ...prev };
    if (value === INHERIT || value === "" || value === void 0) {
      next[path] = void 0;
    } else {
      next[path] = value;
    }
    return next;
  });
  const candidate = React26.useMemo(
    () => candidateSection(ownSectionOf(ladder, tier), edits),
    [edits, ladder, tier]
  );
  const changed = React26.useMemo(
    () => changedKnobs(ownSectionOf(ladder, tier), candidate),
    [candidate, ladder, tier]
  );
  const dirty = Object.keys(edits).length > 0 && changed.length > 0;
  const problems = React26.useMemo(
    () => localProblems(candidate, domains, enforcement, platformFloors, supportedActions),
    [candidate, domains, enforcement, platformFloors, supportedActions]
  );
  const inertByDomain = React26.useMemo(() => {
    const out = {};
    for (const item of inertOrigins(ladder, enforcement)) {
      const [channel, domain = ""] = item.origin.path.split(".");
      if (channel === "base_overrides" && baseTables?.[domain]) continue;
      if (!out[domain]) out[domain] = [];
      out[domain].push(item);
    }
    return out;
  }, [ladder, enforcement, baseTables]);
  const removed = (path) => path in edits && edits[path] === void 0;
  const remove = (path) => set(path, void 0);
  const [tunableRows, referenceRows] = React26.useMemo(() => {
    const tunable = [];
    const reference = [];
    for (const domain of rows) {
      if (!matches(domainLabel(domain), `floors.${domain}`)) continue;
      const group = policyRowGroup({
        enforcementStatus: enforcementFor(enforcement, domain, tier)?.status,
        platform: platformFloors?.[domain],
        floor: valueFor(`floors.${domain}`),
        action: valueFor(`gate_actions.${domain}`)
      });
      const actionable = group === "tunable" || (inertByDomain[domain]?.length ?? 0) > 0;
      (actionable ? tunable : reference).push(domain);
    }
    return [tunable, reference];
  }, [rows, matches, enforcement, tier, platformFloors, edits, ladder, inertByDomain]);
  const domainRow = (domain) => /* @__PURE__ */ jsx(
    DomainRow,
    {
      domain,
      ladder,
      tier,
      tierLabels,
      activity: activitySummary(activity, domain, activityWindowDays),
      withheld: activityWithheld(activity, domain),
      floor: ownValueFor(`floors.${domain}`),
      action: ownValueFor(`gate_actions.${domain}`),
      defaultAction: defaultActions?.[domain],
      supported: supportedActions?.[domain],
      platform: platformFloors?.[domain],
      enforcement: enforcementFor(enforcement, domain, tier),
      inert: inertByDomain[domain] ?? [],
      removed,
      onRemove: remove,
      readOnly,
      onFloor: (v) => set(`floors.${domain}`, v),
      onAction: (v) => set(`gate_actions.${domain}`, v)
    },
    domain
  );
  const filtering = query.trim().length > 0;
  const focusRows = React26.useMemo(
    () => (focus == null ? [] : typeof focus === "string" ? [focus] : [...focus]).filter(Boolean),
    [focus]
  );
  const weightMatches = React26.useMemo(() => {
    let total = cutoffs ? filterKeys(Object.keys(cutoffs), (k) => `tier_cutoffs.${k}`, (k) => CUTOFF_LABELS[k] ?? k).length : 0;
    for (const [domain, defaults] of Object.entries(baseTables ?? {})) {
      total += filterKeys(Object.keys(defaults), (k) => `base_overrides.${domain}.${k}`, (k) => k).length;
    }
    return total + (knobsOnly ? 0 : riskRuleGroups(riskRules, matches).reduce((n, g) => n + 1 + g.signals.length, 0));
  }, [cutoffs, baseTables, filterKeys, riskRules, matches, knobsOnly]);
  const found = tunableRows.length + referenceRows.length + knobRows.length + weightMatches;
  const [showReference, setShowReference] = React26.useState(false);
  const [showKnobs, setShowKnobs] = React26.useState(null);
  const knobsAuthored = React26.useMemo(
    () => knobRows.filter((knob) => knobStatus(originOf(ladder, knob), tier) === "own").length,
    [knobRows, ladder, tier]
  );
  const knobSummary = `${knobRows.length} ${knobRows.length === 1 ? "setting" : "settings"}${knobsAuthored > 0 ? ` \xB7 ${knobsAuthored} set here` : ""}`;
  const knobsCollapsible = !knobsOnly && knobRows.length >= COLLAPSE_SETTINGS_AT;
  const knobsForced = !knobsCollapsible || filtering || focusRows.some((row) => knobRows.includes(row));
  const knobsOpen = knobsForced || (showKnobs ?? knobsAuthored > 0);
  const referenceOpen = referenceRows.length < COLLAPSE_AT || filtering || focusRows.some((row) => referenceRows.includes(row)) || showReference;
  const rootRef = React26.useRef(null);
  const [flash, setFlash] = React26.useState([]);
  React26.useEffect(() => {
    if (focusRows.length === 0) return;
    const timer = window.setTimeout(() => {
      const found2 = focusRows.filter(
        (row) => rootRef.current?.querySelector(`[data-policy-row="${CSS.escape(row)}"]`) != null
      );
      if (found2.length === 0) return;
      setFlash(found2);
      const first = rootRef.current?.querySelector(`[data-policy-row="${CSS.escape(found2[0])}"]`);
      if (first instanceof HTMLElement) first.scrollIntoView?.({ block: "center" });
    }, 60);
    return () => window.clearTimeout(timer);
  }, [focusRows, referenceOpen, tunableRows, referenceRows, knobRows]);
  React26.useEffect(() => {
    if (flash.length === 0) return;
    const timer = window.setTimeout(() => setFlash([]), 2600);
    return () => window.clearTimeout(timer);
  }, [flash]);
  const [preview, setPreview] = React26.useState({ status: "idle" });
  React26.useEffect(() => {
    if (!onPreview || !dirty) {
      setPreview({ status: "idle" });
      return;
    }
    let live = true;
    setPreview({ status: "loading" });
    const timer = setTimeout(() => {
      onPreview(candidate).then(
        (result) => {
          if (live) setPreview({ status: "ready", result });
        },
        () => {
          if (live) setPreview({ status: "unavailable" });
        }
      );
    }, 400);
    return () => {
      live = false;
      clearTimeout(timer);
    };
  }, [onPreview, candidate, dirty]);
  const serverRefuses = preview.status === "ready" && (preview.result.save_problems?.length ?? 0) > 0;
  return /* @__PURE__ */ jsx(PolicyOwnerContext.Provider, { value: ownedBy, children: /* @__PURE__ */ jsxs("div", { ref: rootRef, className: cn("space-y-3", className), children: [
    flash.length > 0 ? /* @__PURE__ */ jsx("style", { children: flash.map(
      (row) => `[data-policy-row="${row.replace(/["\\]/g, "")}"]{box-shadow:inset 0 0 0 2px hsl(var(--primary)/0.6)}`
    ).join("") }) : null,
    /* @__PURE__ */ jsx(LadderSummary, { ladder, tierLabels, tier }),
    ladder?.problems?.length ? /* @__PURE__ */ jsx(
      ProblemList,
      {
        title: "This policy has problems",
        items: ladder.problems,
        tone: "warn"
      }
    ) : null,
    knobsOnly ? null : /* @__PURE__ */ jsx(PolicyFilter, { value: query, onChange: setQuery, found }),
    !knobsOnly && tunableRows.length > 0 && /* @__PURE__ */ jsx(PolicyTable, { columns: DOMAIN_COLUMNS, children: tunableRows.map(domainRow) }),
    knobsOnly || referenceRows.length === 0 ? null : referenceRows.length < COLLAPSE_AT ? /* @__PURE__ */ jsx(PolicyTable, { columns: DOMAIN_COLUMNS, children: referenceRows.map(domainRow) }) : /* @__PURE__ */ jsx(
      Disclosure,
      {
        open: referenceOpen,
        onToggle: () => setShowReference((v) => !v),
        title: `${referenceRows.length} more ${referenceRows.length === 1 ? "check has" : "checks have"} nothing to set`,
        hint: "Checks nothing enforces yet, and checks that weight evidence without ever gating it. Listed with their reason.",
        children: /* @__PURE__ */ jsx(PolicyTable, { columns: DOMAIN_COLUMNS, children: referenceRows.map(domainRow) })
      }
    ),
    filtering && found === 0 ? /* @__PURE__ */ jsxs("div", { className: "rounded-md border border-dashed border-border px-3 py-6 text-center text-xs text-muted-foreground", children: [
      "Nothing here matches \u201C",
      query.trim(),
      "\u201D. Every check the server resolves is listed on this screen, so a name that matches nothing is not one this platform judges."
    ] }) : null,
    knobRows.length ? (
      // `knobsOnly` is Settings › Defaults, where these knobs ARE the
      // surface — a disclosure there would hide the whole page behind a
      // chevron. Here they are the second half of a long policy, and worth
      // one only once there are enough of them.
      /* @__PURE__ */ jsx(
        MaybeDisclosure,
        {
          collapsed: knobsCollapsible,
          open: knobsOpen,
          onToggle: () => setShowKnobs((v) => !(v ?? knobsAuthored > 0)),
          title: knobsOnly ? "What appears in your catalog views" : "Before we treat something as fact",
          hint: knobsOnly ? "Choose Inherit to use the default from the scope above. Confidence filtering does not change who may access a finding." : "These settings govern recording, review and the confidence required when reading findings.",
          count: knobsOpen ? void 0 : knobSummary,
          children: /* @__PURE__ */ jsx(PolicyTable, { columns: KNOB_COLUMNS, children: knobRows.map((knob) => /* @__PURE__ */ jsx(
            KnobRow,
            {
              knob,
              ladder,
              tier,
              tierLabels,
              value: ownValueFor(knob),
              readOnly: readOnly || readOnlyKnobs.includes(knob),
              onChange: (v) => set(knob, v)
            },
            knob
          )) })
        }
      )
    ) : null,
    problems.length ? /* @__PURE__ */ jsx(
      ProblemList,
      {
        title: "These changes wouldn't do what they look like",
        items: problems,
        tone: "warn"
      }
    ) : null,
    cutoffs && Object.keys(cutoffs).length ? /* @__PURE__ */ jsx(
      WeightTable,
      {
        title: "Where the confidence badges sit",
        blurb: "Every score on the platform is bucketed into high, medium or low against these two lines. Moving them changes what is badged, not what is computed.",
        rows: filterKeys(
          Object.keys(cutoffs).sort().reverse(),
          (key) => `tier_cutoffs.${key}`,
          (key) => CUTOFF_LABELS[key] ?? key
        ),
        focus,
        pathFor: (key) => `tier_cutoffs.${key}`,
        labelFor: (key) => CUTOFF_LABELS[key] ?? key,
        helpFor: (key) => CUTOFF_HELP[key],
        defaults: cutoffs,
        ladder,
        tier,
        tierLabels,
        readOnly,
        valueFor: ownValueFor,
        onSet: set
      }
    ) : null,
    Object.entries(baseTables ?? {}).map(([domain, defaults]) => /* @__PURE__ */ jsx(
      WeightTable,
      {
        collapsible: true,
        focus,
        filtering,
        title: weightTableTitle(domain),
        blurb: "What an assertion from each source is worth before anything else is taken into account. Lower one you do not trust; a source left alone keeps the platform value.",
        rows: filterKeys(
          weightRows(defaults, ladder, domain),
          (key) => `base_overrides.${domain}.${key}`,
          (key) => key
        ),
        pathFor: (key) => `base_overrides.${domain}.${key}`,
        labelFor: (key) => key,
        helpFor: () => void 0,
        defaults,
        ladder,
        tier,
        tierLabels,
        readOnly,
        valueFor: ownValueFor,
        onSet: set,
        inertReasonFor: (path) => inertReason(path, enforcement),
        removed,
        mono: true
      },
      domain
    )),
    knobsOnly ? null : /* @__PURE__ */ jsx(
      RiskRulesTable,
      {
        groups: riskRuleGroups(riskRules, matches),
        ladder,
        tier,
        tierLabels,
        readOnly,
        valueFor: ownValueFor,
        onSet: set,
        focus: focusRows,
        filtering
      }
    ),
    readOnly || !dirty ? null : /* @__PURE__ */ jsx(
      PreviewSummary,
      {
        state: preview,
        ladder,
        tierLabels
      }
    ),
    readOnly ? null : /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(
        Button,
        {
          size: "sm",
          disabled: !dirty || busy || problems.length > 0 || serverRefuses,
          onClick: () => void onSave?.(candidate),
          children: busy ? "Saving\u2026" : tier === "user" ? "Save your policy" : `Save ${tierLabels[tier] ?? tier} policy`
        }
      ),
      onClear ? /* @__PURE__ */ jsx(
        ClearOverridesButton,
        {
          settings: sectionSettings(ownSectionOf(ladder, tier)),
          scopeLabel: ownedBy ? `${ownedBy}'s ${tierLabels[tier] ?? tier}` : tier === "user" ? "your personal" : `the ${tierLabels[tier] ?? tier}`,
          busy,
          onClear
        }
      ) : null,
      dirty ? /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
        changed.length,
        " change",
        changed.length === 1 ? "" : "s",
        " not saved"
      ] }) : null
    ] })
  ] }) });
}
var CLEAR_PREVIEW_LIMIT = 8;
function ClearOverridesButton({
  settings,
  scopeLabel,
  busy,
  onClear
}) {
  if (settings.length === 0) {
    return /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", disabled: true, title: "Nothing is saved at this scope", children: "Clear this scope's overrides" });
  }
  const shown = settings.slice(0, CLEAR_PREVIEW_LIMIT);
  const more = settings.length - shown.length;
  const noun = `${settings.length} setting${settings.length === 1 ? "" : "s"}`;
  return /* @__PURE__ */ jsxs(AlertDialog, { children: [
    /* @__PURE__ */ jsx(AlertDialogTrigger, { asChild: true, children: /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", disabled: busy, children: "Clear this scope's overrides" }) }),
    /* @__PURE__ */ jsxs(AlertDialogContent, { children: [
      /* @__PURE__ */ jsxs(AlertDialogHeader, { children: [
        /* @__PURE__ */ jsxs(AlertDialogTitle, { children: [
          "Clear ",
          scopeLabel,
          " confidence policy?"
        ] }),
        /* @__PURE__ */ jsx(AlertDialogDescription, { asChild: true, children: /* @__PURE__ */ jsxs("div", { className: "space-y-2 text-sm", children: [
          /* @__PURE__ */ jsxs("p", { children: [
            "This removes ",
            noun,
            " saved at this scope:"
          ] }),
          /* @__PURE__ */ jsxs("ul", { className: "list-disc space-y-0.5 pl-5 text-foreground", children: [
            shown.map((line) => /* @__PURE__ */ jsx("li", { children: line }, line)),
            more > 0 ? /* @__PURE__ */ jsxs("li", { className: "text-muted-foreground", children: [
              "and ",
              more,
              " more"
            ] }) : null
          ] }),
          /* @__PURE__ */ jsx("p", { children: "Each one goes back to what it inherits from a wider scope, and new runs are judged that way. There is no undo \u2014 putting them back means entering them again." })
        ] }) })
      ] }),
      /* @__PURE__ */ jsxs(AlertDialogFooter, { children: [
        /* @__PURE__ */ jsx(AlertDialogCancel, { children: "Keep them" }),
        /* @__PURE__ */ jsxs(
          AlertDialogAction,
          {
            className: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            onClick: () => void onClear(),
            children: [
              "Clear ",
              noun
            ]
          }
        )
      ] })
    ] })
  ] });
}
function DomainRow({
  domain,
  ladder,
  tier,
  tierLabels,
  activity,
  withheld,
  floor,
  action,
  defaultAction,
  supported,
  platform,
  enforcement,
  inert,
  removed,
  onRemove,
  readOnly,
  onFloor,
  onAction
}) {
  const { offered, unsupported } = offeredGateActions(supported, action);
  const floorOrigin = originOf(ladder, `floors.${domain}`);
  const inheritedFloor = inheritedFrom(ladder, `floors.${domain}`, tier, tierLabels);
  const inheritedAction = inheritedFrom(ladder, `gate_actions.${domain}`, tier, tierLabels);
  const effectiveAction = action ?? inheritedAction?.value ?? defaultAction;
  const defaultActionLabel = defaultAction ? GATE_ACTION_LABELS[defaultAction] ?? defaultAction : void 0;
  const inheritLabel = inheritedAction ? `Inherit \u2014 ${(GATE_ACTION_LABELS[inheritedAction.value] ?? String(inheritedAction.value)).toLowerCase()} (${inheritedAction.from})` : defaultActionLabel ? `Inherit \u2014 ${defaultActionLabel.toLowerCase()}` : "Inherit";
  const actionOrigin = originOf(ladder, `gate_actions.${domain}`);
  const provenance = floorOrigin ?? actionOrigin;
  const provenancePath = floorOrigin ? `floors.${domain}` : `gate_actions.${domain}`;
  const status = knobStatus(provenance, tier);
  const floorless = policyRowGroup({
    platform,
    floor: floor ?? inheritedFloor?.value,
    action: action ?? inheritedAction?.value
  }) === "reference";
  const platformValue = platform?.value ?? null;
  const floorPlaceholder = inheritedFloor != null ? String(inheritedFloor.value) : platformValue !== null ? String(platformValue) : "inherit";
  const floorInForce = floor != null && floor !== "" ? Number(floor) : inheritedFloor != null ? Number(inheritedFloor.value) : platformValue;
  const savedNotInEffect = inert.length ? /* @__PURE__ */ jsx(
    SavedNotInEffect,
    {
      items: inert,
      tier,
      tierLabels,
      readOnly,
      removed,
      onRemove,
      showReason: enforcement?.status !== "not_enforced"
    }
  ) : null;
  if (enforcement?.status === "not_enforced") {
    return /* @__PURE__ */ jsxs(TableRow, { "data-policy-row": domain, className: POLICY_ROW, children: [
      /* @__PURE__ */ jsxs(PolicyCell, { children: [
        /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
          /* @__PURE__ */ jsx("span", { className: "font-medium text-foreground", children: domainLabel(domain) }),
          /* @__PURE__ */ jsx(
            Badge,
            {
              variant: "outline",
              className: "font-normal text-amber-700 dark:text-amber-400",
              title: enforcement.reason,
              children: "Not enforced yet"
            }
          )
        ] }),
        DOMAIN_HELP[domain] ? /* @__PURE__ */ jsx("div", { className: "mt-0.5 max-w-md text-xs leading-relaxed text-muted-foreground", children: DOMAIN_HELP[domain] }) : null,
        /* @__PURE__ */ jsx("div", { className: "mt-1 max-w-md text-xs leading-relaxed text-muted-foreground", children: enforcement.reason })
      ] }),
      /* @__PURE__ */ jsx(PolicyCell, { colSpan: 2, children: savedNotInEffect ?? /* @__PURE__ */ jsx("div", { className: "max-w-xs text-xs leading-relaxed text-muted-foreground", children: "Nothing to set until this check is enforced." }) }),
      /* @__PURE__ */ jsx(PolicyCell, { label: "Set by", children: /* @__PURE__ */ jsx(
        SetByBadge,
        {
          status,
          origin: provenance,
          tierLabels,
          title: enforcement.reason
        }
      ) })
    ] });
  }
  const conditionalNote = enforcement?.status === "conditional" ? /* @__PURE__ */ jsxs("div", { className: "mt-1 max-w-md text-xs leading-relaxed text-muted-foreground", children: [
    /* @__PURE__ */ jsx("span", { className: "text-foreground", children: "Only on some pipelines." }),
    " ",
    enforcement.reason
  ] }) : null;
  if (floorless) {
    return /* @__PURE__ */ jsxs(TableRow, { "data-policy-row": domain, className: POLICY_ROW, children: [
      /* @__PURE__ */ jsxs(PolicyCell, { children: [
        /* @__PURE__ */ jsx("div", { className: "font-medium text-foreground", children: domainLabel(domain) }),
        DOMAIN_HELP[domain] ? /* @__PURE__ */ jsx("div", { className: "mt-0.5 max-w-md text-xs leading-relaxed text-muted-foreground", children: DOMAIN_HELP[domain] }) : null,
        conditionalNote,
        savedNotInEffect ? /* @__PURE__ */ jsx("div", { className: "mt-1.5", children: savedNotInEffect }) : null
      ] }),
      /* @__PURE__ */ jsx(PolicyCell, { label: "Minimum confidence", className: "text-xs text-muted-foreground", children: "No floor" }),
      /* @__PURE__ */ jsx(PolicyCell, { label: "Below that, we", children: /* @__PURE__ */ jsx("div", { className: "max-w-xs text-xs leading-relaxed text-muted-foreground", children: platform?.detail ?? "This check never gates, so there is nothing to set here." }) }),
      /* @__PURE__ */ jsx(PolicyCell, { label: "Set by", children: /* @__PURE__ */ jsx(
        SetByBadge,
        {
          status,
          origin: provenance,
          tierLabels,
          title: "This check has no floor; its weights are tuned in the tables below."
        }
      ) })
    ] });
  }
  return /* @__PURE__ */ jsxs(TableRow, { "data-policy-row": domain, className: POLICY_ROW, children: [
    /* @__PURE__ */ jsxs(PolicyCell, { children: [
      /* @__PURE__ */ jsx("div", { className: "font-medium text-foreground", children: domainLabel(domain) }),
      DOMAIN_HELP[domain] ? /* @__PURE__ */ jsx("div", { className: "mt-0.5 max-w-md text-xs leading-relaxed text-muted-foreground", children: DOMAIN_HELP[domain] }) : null,
      conditionalNote,
      savedNotInEffect ? /* @__PURE__ */ jsx("div", { className: "mt-1.5", children: savedNotInEffect }) : null,
      activity ? /* @__PURE__ */ jsx(
        "div",
        {
          className: cn(
            "mt-1 text-xs tabular-nums",
            // Coloured only when something was actually removed. A floor that
            // judged everything and dropped nothing is the reassuring case and
            // must not read as a warning.
            withheld > 0 ? "text-amber-600 dark:text-amber-500" : "text-muted-foreground"
          ),
          children: activity
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsxs(PolicyCell, { label: "Minimum confidence", children: [
      readOnly ? /* @__PURE__ */ jsx("span", { className: "font-mono tabular-nums", children: floorOrigin ? formatKnobValue(floorOrigin.value) : platformValue !== null ? formatKnobValue(platformValue) : "\u2014" }) : /* @__PURE__ */ jsx(
        Input,
        {
          type: "number",
          min: 0,
          max: 1,
          step: 0.05,
          value: floor == null ? "" : String(floor),
          placeholder: floorPlaceholder,
          onChange: (e) => onFloor(e.target.value),
          className: "h-8 w-28 font-mono tabular-nums",
          "aria-label": `Minimum confidence for ${domainLabel(domain)}`
        }
      ),
      platform && platformValue !== null ? /* @__PURE__ */ jsxs(
        "div",
        {
          className: "mt-1 max-w-[11rem] text-xs leading-relaxed text-muted-foreground",
          title: platform.config_key ? `A pipeline can change this default with ${platform.config_key}.` : void 0,
          children: [
            !readOnly ? /* @__PURE__ */ jsxs("span", { className: "block text-foreground", children: [
              "Effective here: ",
              formatKnobValue(floorInForce),
              (floor == null || floor === "") && inheritedFloor ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
                " \xB7 from ",
                inheritedFloor.from
              ] }) : null
            ] }) : null,
            readOnly && !floorOrigin ? null : /* @__PURE__ */ jsxs(Fragment, { children: [
              "Platform default: ",
              formatKnobValue(platformValue),
              " (reference)"
            ] }),
            platform.detail ? /* @__PURE__ */ jsx("span", { className: "block", children: platform.detail }) : null
          ]
        }
      ) : null
    ] }),
    /* @__PURE__ */ jsxs(PolicyCell, { label: "Below that, we", children: [
      readOnly ? /* @__PURE__ */ jsx("span", { children: effectiveAction ? GATE_ACTION_LABELS[effectiveAction] ?? effectiveAction : "\u2014" }) : /* @__PURE__ */ jsxs(
        Select,
        {
          value: action ?? INHERIT,
          onValueChange: (v) => onAction(v === INHERIT ? "" : v),
          children: [
            /* @__PURE__ */ jsx(
              SelectTrigger,
              {
                className: "h-8 w-52",
                "aria-label": `Below the floor for ${domainLabel(domain)}`,
                children: /* @__PURE__ */ jsx(SelectValue, { placeholder: "inherit" })
              }
            ),
            /* @__PURE__ */ jsxs(SelectContent, { children: [
              /* @__PURE__ */ jsx(SelectItem, { value: INHERIT, children: inheritLabel }),
              offered.map((a) => /* @__PURE__ */ jsx(SelectItem, { value: a, title: GATE_ACTION_HELP[a], children: GATE_ACTION_LABELS[a] }, a))
            ] })
          ]
        }
      ),
      effectiveAction ? /* @__PURE__ */ jsxs("div", { className: "mt-1 max-w-xs text-xs leading-relaxed text-muted-foreground", children: [
        !action && inheritedAction ? /* @__PURE__ */ jsxs("span", { className: "text-foreground", children: [
          "From ",
          inheritedAction.from,
          ":",
          " ",
          GATE_ACTION_LABELS[inheritedAction.value] ?? String(inheritedAction.value),
          ".",
          " "
        ] }) : !action && defaultActionLabel ? /* @__PURE__ */ jsxs("span", { className: "text-foreground", children: [
          "Platform default: ",
          defaultActionLabel,
          ".",
          " "
        ] }) : null,
        GATE_ACTION_HELP[effectiveAction]
      ] }) : null,
      unsupported ? /* @__PURE__ */ jsx("div", { className: "mt-1 max-w-xs text-xs leading-relaxed text-amber-600 dark:text-amber-500", children: `This check can only ${(supported ?? []).map((a) => ACTION_VERBS[a] ?? a).join(" or ")}, so this setting behaves as the nearest weaker one it supports.` }) : null
    ] }),
    /* @__PURE__ */ jsx(PolicyCell, { label: "Set by", children: /* @__PURE__ */ jsx(
      SetByBadge,
      {
        status,
        origin: provenance,
        tierLabels,
        title: explainKnob(ladder, provenancePath, tierLabels)
      }
    ) })
  ] });
}
function SavedNotInEffect({
  items,
  tier,
  tierLabels,
  readOnly,
  removed,
  onRemove,
  showReason
}) {
  return /* @__PURE__ */ jsx("ul", { className: "space-y-1", children: items.map(({ origin, reason }) => {
    const own = origin.tier === tier;
    const gone = removed(origin.path);
    return /* @__PURE__ */ jsxs("li", { className: "max-w-md text-xs leading-relaxed", title: reason, children: [
      /* @__PURE__ */ jsxs("span", { className: "flex flex-wrap items-center gap-x-2 gap-y-0.5", children: [
        /* @__PURE__ */ jsx("span", { className: "font-medium text-amber-700 dark:text-amber-400", children: gone ? "Removed \u2014 save to apply" : "Saved, not in effect" }),
        /* @__PURE__ */ jsxs("span", { className: cn("text-foreground", gone && "line-through opacity-60"), children: [
          settingLabel(origin.path),
          " ",
          /* @__PURE__ */ jsx("span", { className: "font-mono tabular-nums", children: formatKnobValue(
            origin.value,
            typeof origin.value === "number" ? "probability" : void 0
          ) })
        ] }),
        own ? null : /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
          "set at ",
          tierLabels[origin.tier] ?? origin.tier
        ] }),
        own && !readOnly && !gone ? /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            variant: "ghost",
            className: "h-6 px-2 text-xs",
            onClick: () => onRemove(origin.path),
            "aria-label": `Remove ${settingLabel(origin.path)}`,
            children: "Remove"
          }
        ) : null
      ] }),
      showReason ? /* @__PURE__ */ jsxs("span", { className: "block text-muted-foreground", children: [
        "Nothing evaluates it: ",
        reason
      ] }) : null
    ] }, origin.path);
  }) });
}
function KnobRow({
  knob,
  ladder,
  tier,
  tierLabels,
  value,
  readOnly,
  onChange
}) {
  const origin = originOf(ladder, knob);
  const status = knobStatus(origin, tier);
  const kind = knobKind(knob);
  const inForce = inheritedFrom(ladder, knob, tier, tierLabels);
  return /* @__PURE__ */ jsxs(TableRow, { "data-policy-row": knob, className: POLICY_ROW, children: [
    /* @__PURE__ */ jsxs(PolicyCell, { children: [
      /* @__PURE__ */ jsx("div", { className: "font-medium text-foreground", children: knobLabel(knob) }),
      KNOB_HELP[knob] ? /* @__PURE__ */ jsx("div", { className: "mt-0.5 max-w-md text-xs leading-relaxed text-muted-foreground", children: KNOB_HELP[knob] }) : null
    ] }),
    /* @__PURE__ */ jsx(PolicyCell, { label: "Value", colSpan: 2, children: readOnly ? /* @__PURE__ */ jsx("span", { className: kind === "boolean" ? "" : "font-mono tabular-nums", children: origin ? formatKnobValue(origin.value, kind) : "\u2014" }) : kind === "boolean" ? /* @__PURE__ */ jsxs(
      Select,
      {
        value: value === void 0 || value === null ? INHERIT : String(value),
        onValueChange: (v) => onChange(v === INHERIT ? void 0 : v === "true"),
        children: [
          /* @__PURE__ */ jsx(SelectTrigger, { className: "h-8 w-40", children: /* @__PURE__ */ jsx(SelectValue, { placeholder: "inherit" }) }),
          /* @__PURE__ */ jsxs(SelectContent, { children: [
            /* @__PURE__ */ jsx(SelectItem, { value: INHERIT, children: inForce ? `Inherit \u2014 ${formatKnobValue(inForce.value, kind).toLowerCase()} (${inForce.from})` : "Inherit" }),
            /* @__PURE__ */ jsx(SelectItem, { value: "true", children: "On" }),
            /* @__PURE__ */ jsx(SelectItem, { value: "false", children: "Off" })
          ] })
        ]
      }
    ) : /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsx(
        Input,
        {
          type: "number",
          min: 0,
          max: kind === "probability" ? 1 : void 0,
          step: kind === "probability" ? 0.05 : 1,
          value: value == null ? "" : String(value),
          placeholder: inForce ? String(inForce.value) : "inherit",
          onChange: (e) => onChange(e.target.value === "" ? void 0 : Number(e.target.value)),
          className: "h-8 w-28 font-mono tabular-nums",
          "aria-label": knobLabel(knob)
        }
      ),
      kind === "days" ? /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "days \xB7 0 = off" }) : kind === "count" ? /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "sources" }) : null
    ] }) }),
    /* @__PURE__ */ jsx(PolicyCell, { label: "Set by", children: /* @__PURE__ */ jsx(
      SetByBadge,
      {
        status,
        origin,
        tierLabels,
        title: explainKnob(ladder, knob, tierLabels, kind)
      }
    ) })
  ] });
}
function WeightTable({
  title,
  blurb,
  rows,
  pathFor,
  labelFor,
  helpFor,
  defaults,
  ladder,
  tier,
  tierLabels,
  readOnly,
  valueFor,
  onSet,
  inertReasonFor,
  removed,
  mono = false,
  collapsible = false,
  focus,
  filtering = false
}) {
  const shown = rows;
  const [open, setOpen] = React26.useState(false);
  const wanted = focus == null ? [] : typeof focus === "string" ? [focus] : focus;
  const holdsFocus = shown.some((key) => wanted.includes(pathFor(key)));
  const worthHiding = collapsible && rows.length >= COLLAPSE_AT;
  const isOpen = !worthHiding || open || holdsFocus || filtering;
  if (!rows.length) return null;
  const table = /* @__PURE__ */ jsx(PolicyTable, { columns: mono ? WEIGHT_SOURCE_COLUMNS : WEIGHT_COLUMNS, scroll: true, children: shown.map((key) => {
    const path = pathFor(key);
    const origin = originOf(ladder, path);
    const status = knobStatus(origin, tier);
    const platform = defaults[key];
    const current = valueFor(path);
    const inherited = inheritedFrom(ladder, path, tier, tierLabels);
    const inert = inertReasonFor?.(path) ?? null;
    return /* @__PURE__ */ jsxs(TableRow, { "data-policy-row": path, className: POLICY_ROW, children: [
      /* @__PURE__ */ jsxs(PolicyCell, { dense: true, children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            className: cn(
              "font-medium text-foreground",
              mono && "font-mono text-xs"
            ),
            children: labelFor(key)
          }
        ),
        helpFor(key) ? /* @__PURE__ */ jsx("div", { className: "mt-0.5 max-w-md text-xs leading-relaxed text-muted-foreground", children: helpFor(key) }) : null
      ] }),
      /* @__PURE__ */ jsx(PolicyCell, { dense: true, label: "Worth", children: inert ? (
        // Nothing reads this weight: no input, and a saved one is
        // named with a remove (see `SavedNotInEffect`).
        origin && origin.tier !== "base" ? /* @__PURE__ */ jsx(
          SavedNotInEffect,
          {
            items: [{ origin, reason: inert }],
            tier,
            tierLabels,
            readOnly,
            removed: removed ?? (() => false),
            onRemove: (p) => onSet(p, void 0),
            showReason: true
          }
        ) : /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", title: inert, children: "Not in effect" })
      ) : readOnly ? /* @__PURE__ */ jsx("span", { className: "font-mono tabular-nums", children: formatKnobValue(
        origin ? origin.value : platform,
        "probability"
      ) }) : /* @__PURE__ */ jsx(
        Input,
        {
          type: "number",
          min: 0,
          max: 1,
          step: 0.05,
          value: current == null ? "" : String(current),
          placeholder: inherited ? String(inherited.value) : platform == null ? "inherit" : String(platform),
          onChange: (e) => onSet(
            path,
            e.target.value === "" ? void 0 : e.target.value
          ),
          className: "h-8 w-28 font-mono tabular-nums",
          "aria-label": `${labelFor(key)} weight`
        }
      ) }),
      /* @__PURE__ */ jsx(PolicyCell, { dense: true, label: "Platform value", className: "text-xs text-muted-foreground tabular-nums", children: platform == null ? "no longer defined" : formatKnobValue(platform, "probability") }),
      /* @__PURE__ */ jsx(PolicyCell, { dense: true, label: "Set by", children: /* @__PURE__ */ jsx(
        SetByBadge,
        {
          status,
          origin,
          tierLabels,
          title: explainKnob(ladder, path, tierLabels, "probability")
        }
      ) })
    ] }, key);
  }) });
  if (worthHiding) {
    return /* @__PURE__ */ jsx(
      Disclosure,
      {
        open: isOpen,
        onToggle: () => setOpen((v) => !v),
        title,
        hint: blurb,
        count: `${shown.length} ${shown.length === 1 ? "source" : "sources"}`,
        children: table
      }
    );
  }
  return /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("div", { className: "text-sm font-medium text-foreground", children: title }),
      /* @__PURE__ */ jsx("div", { className: "text-xs text-muted-foreground", children: blurb })
    ] }),
    table
  ] });
}
function riskRuleGroups(rules, matches) {
  if (!rules) return [];
  return rules.policies.map((policy) => {
    const own = rules.signals.filter((s) => s.policy_id === policy.id);
    const policyMatches = matches(policy.label, policy.id, `risk_policies.${policy.id}.max_score`);
    return {
      policy,
      signals: policyMatches ? own : own.filter((s) => matches(s.label, s.id, `risk_signals.${s.id}.weight`)),
      policyMatches
    };
  }).filter((g) => g.policyMatches || g.signals.length > 0).map(({ policy, signals }) => ({ policy, signals }));
}
var RISK_COLUMNS = [
  { label: "Rule" },
  { label: "Points", className: "w-32" },
  { label: "Switched on", className: "w-52" },
  { label: "Platform value", className: "w-32" },
  { label: "Set by", className: "w-44" }
];
function RiskRulesTable({
  groups,
  ladder,
  tier,
  tierLabels,
  readOnly,
  valueFor,
  onSet,
  focus,
  filtering
}) {
  const [open, setOpen] = React26.useState(null);
  const paths = groups.flatMap((g) => [
    `risk_policies.${g.policy.id}.max_score`,
    `risk_policies.${g.policy.id}.enabled`,
    ...g.signals.flatMap((s) => [`risk_signals.${s.id}.weight`, `risk_signals.${s.id}.enabled`])
  ]);
  const authored = paths.filter((path) => knobStatus(originOf(ladder, path), tier) === "own").length;
  const holdsFocus = focus.some((row) => paths.includes(row));
  if (groups.length === 0) return null;
  const isOpen = filtering || holdsFocus || (open ?? authored > 0);
  const signals = groups.reduce((n, g) => n + g.signals.length, 0);
  return /* @__PURE__ */ jsx(
    Disclosure,
    {
      open: isOpen,
      onToggle: () => setOpen(!isOpen),
      title: "How much each risk signal counts",
      hint: "A transaction's risk score adds up the signals it matches, capped at each rule's ceiling. Change what a signal is worth, switch one off, or move a ceiling; a row left alone keeps the platform value.",
      count: `${signals} ${signals === 1 ? "signal" : "signals"}${authored ? ` \xB7 ${authored} set here` : ""}`,
      children: /* @__PURE__ */ jsx(PolicyTable, { columns: RISK_COLUMNS, children: groups.flatMap((g) => [
        /* @__PURE__ */ jsx(
          RiskRuleRow,
          {
            base: `risk_policies.${g.policy.id}`,
            pointsField: "max_score",
            label: g.policy.label,
            help: `${g.policy.description} Ceiling: the most this rule can add.`,
            platformPoints: g.policy.max_score,
            platformEnabled: g.policy.enabled,
            ladder,
            tier,
            tierLabels,
            readOnly,
            valueFor,
            onSet
          },
          g.policy.id
        ),
        ...g.signals.map((signal) => /* @__PURE__ */ jsx(
          RiskRuleRow,
          {
            base: `risk_signals.${signal.id}`,
            pointsField: "weight",
            label: signal.label,
            help: signal.description,
            severity: signal.severity,
            platformPoints: signal.weight,
            platformEnabled: signal.enabled,
            ladder,
            tier,
            tierLabels,
            readOnly,
            valueFor,
            onSet,
            nested: true
          },
          signal.id
        ))
      ]) })
    }
  );
}
function RiskRuleRow({
  base,
  pointsField,
  label,
  help: help2,
  severity,
  platformPoints,
  platformEnabled,
  ladder,
  tier,
  tierLabels,
  readOnly,
  valueFor,
  onSet,
  nested = false
}) {
  const pointsPath = `${base}.${pointsField}`;
  const enabledPath = `${base}.enabled`;
  const pointsOrigin = originOf(ladder, pointsPath);
  const enabledOrigin = originOf(ladder, enabledPath);
  const points = valueFor(pointsPath);
  const enabled = valueFor(enabledPath);
  const inheritedPoints = inheritedFrom(ladder, pointsPath, tier, tierLabels);
  const inheritedEnabled = inheritedFrom(ladder, enabledPath, tier, tierLabels);
  const inForce = (value, fallback) => value === void 0 ? fallback : value;
  const effectivePoints = inForce(pointsOrigin?.value, platformPoints);
  const effectiveEnabled = inForce(enabledOrigin?.value, platformEnabled) !== false;
  const shown = [pointsOrigin, enabledOrigin].find((o) => knobStatus(o, tier) === "own") ?? pointsOrigin ?? enabledOrigin;
  const onOff = (v) => v === false ? "Off" : "On";
  return /* @__PURE__ */ jsxs(TableRow, { "data-policy-row": pointsPath, className: POLICY_ROW, children: [
    /* @__PURE__ */ jsxs(PolicyCell, { dense: true, children: [
      /* @__PURE__ */ jsxs("div", { className: cn("flex flex-wrap items-center gap-1.5", nested && "pl-4"), children: [
        /* @__PURE__ */ jsx("span", { className: cn("text-foreground", nested ? "text-sm" : "font-medium"), children: label }),
        severity ? /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "h-5 px-1.5 text-[10px] font-normal capitalize", children: severity }) : null,
        /* @__PURE__ */ jsx("code", { className: "font-mono text-[11px] text-muted-foreground", children: base.split(".")[1] })
      ] }),
      /* @__PURE__ */ jsx("div", { className: cn("mt-0.5 max-w-md text-xs leading-relaxed text-muted-foreground", nested && "pl-4"), children: help2 })
    ] }),
    /* @__PURE__ */ jsxs(PolicyCell, { dense: true, label: pointsField === "max_score" ? "Ceiling" : "Points", children: [
      pointsField === "max_score" ? /* @__PURE__ */ jsx("span", { className: "mr-1.5 text-xs text-muted-foreground", children: "max" }) : null,
      readOnly ? /* @__PURE__ */ jsx("span", { className: "font-mono tabular-nums", children: String(effectivePoints) }) : /* @__PURE__ */ jsx(
        Input,
        {
          type: "number",
          min: RISK_POINTS_MIN,
          max: RISK_POINTS_MAX,
          step: 5,
          value: points == null ? "" : String(points),
          placeholder: String(inheritedPoints ? inheritedPoints.value : platformPoints),
          onChange: (e) => onSet(pointsPath, e.target.value === "" ? void 0 : e.target.value),
          className: "inline-flex h-8 w-24 font-mono tabular-nums",
          "aria-label": `${label} ${pointsField === "weight" ? "points" : "ceiling"}`
        }
      )
    ] }),
    /* @__PURE__ */ jsx(PolicyCell, { dense: true, label: "Switched on", children: readOnly ? /* @__PURE__ */ jsx("span", { className: "text-sm", children: effectiveEnabled ? "On" : "Off" }) : /* @__PURE__ */ jsxs(
      Select,
      {
        value: enabled === true ? "on" : enabled === false ? "off" : INHERIT,
        onValueChange: (v) => onSet(enabledPath, v === INHERIT ? void 0 : v === "on"),
        children: [
          /* @__PURE__ */ jsx(SelectTrigger, { className: "h-8 w-48 text-xs", "aria-label": `${label} switched on`, children: /* @__PURE__ */ jsx(SelectValue, {}) }),
          /* @__PURE__ */ jsxs(SelectContent, { children: [
            /* @__PURE__ */ jsxs(SelectItem, { value: INHERIT, children: [
              "Inherit \u2014 ",
              onOff(inheritedEnabled ? inheritedEnabled.value : platformEnabled),
              inheritedEnabled ? ` (${inheritedEnabled.from})` : ""
            ] }),
            /* @__PURE__ */ jsx(SelectItem, { value: "on", children: "On" }),
            /* @__PURE__ */ jsx(SelectItem, { value: "off", children: "Off" })
          ] })
        ]
      }
    ) }),
    /* @__PURE__ */ jsxs(PolicyCell, { dense: true, label: "Platform value", className: "text-xs text-muted-foreground tabular-nums", children: [
      platformPoints,
      platformEnabled ? "" : " \xB7 off"
    ] }),
    /* @__PURE__ */ jsx(PolicyCell, { dense: true, label: "Set by", children: /* @__PURE__ */ jsx(
      SetByBadge,
      {
        status: knobStatus(shown, tier),
        origin: shown,
        tierLabels,
        title: explainKnob(ladder, pointsPath, tierLabels, "points")
      }
    ) })
  ] });
}
function PreviewSummary({
  state,
  ladder,
  tierLabels
}) {
  if (state.status === "idle") return null;
  if (state.status === "loading") {
    return /* @__PURE__ */ jsx("div", { className: "text-xs text-muted-foreground", children: "Checking what this changes\u2026" });
  }
  if (state.status === "unavailable") {
    return /* @__PURE__ */ jsx("div", { className: "text-xs text-muted-foreground", children: "Couldn't check what this changes. Your edits are still safe to save; the server validates them again." });
  }
  const before = new Map(
    (ladder?.origins ?? []).map((o) => [o.path, o])
  );
  const changes = (state.result.origins ?? []).filter((o) => {
    const prior = before.get(o.path);
    return JSON.stringify(prior?.value ?? null) !== JSON.stringify(o.value ?? null);
  });
  const removed = [...before.values()].filter(
    (o) => !(state.result.origins ?? []).some((n) => n.path === o.path)
  );
  const serverProblems = state.result.save_problems ?? state.result.problems ?? [];
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    serverProblems.length ? /* @__PURE__ */ jsx(
      ProblemList,
      {
        title: "The server would refuse this",
        items: serverProblems,
        tone: "warn"
      }
    ) : null,
    /* @__PURE__ */ jsxs("div", { className: "rounded-md border border-border bg-muted/30 px-3 py-2 text-sm", children: [
      /* @__PURE__ */ jsx("div", { className: "font-medium", children: changes.length + removed.length === 0 ? "No effective change" : `${changes.length + removed.length} value${changes.length + removed.length === 1 ? "" : "s"} would change` }),
      changes.length + removed.length === 0 ? /* @__PURE__ */ jsx("div", { className: "mt-0.5 text-xs text-muted-foreground", children: "These edits resolve to what is already in force \u2014 usually because a finer scope already overrides them." }) : /* @__PURE__ */ jsxs("ul", { className: "mt-1 space-y-0.5 text-xs text-muted-foreground", children: [
        changes.map((o) => /* @__PURE__ */ jsxs("li", { className: "font-mono tabular-nums", children: [
          knobPathLabel(o.path),
          ":",
          " ",
          before.has(o.path) ? formatKnobValue(before.get(o.path)?.value, kindForPath(o.path)) || "\u2014" : "platform default",
          " ",
          "\u2192 ",
          /* @__PURE__ */ jsx("span", { className: "text-foreground", children: formatKnobValue(o.value, kindForPath(o.path)) }),
          " ",
          /* @__PURE__ */ jsxs("span", { className: "font-sans", children: [
            "(",
            tierLabels[o.tier] ?? o.tier,
            ")"
          ] })
        ] }, o.path)),
        removed.map((o) => /* @__PURE__ */ jsxs("li", { className: "font-mono tabular-nums", children: [
          knobPathLabel(o.path),
          ":",
          " ",
          formatKnobValue(o.value, kindForPath(o.path)),
          " \u2192",
          " ",
          /* @__PURE__ */ jsx("span", { className: "font-sans text-foreground", children: "back to the platform default" })
        ] }, o.path))
      ] })
    ] })
  ] });
}
function knobPathLabel(path) {
  if (path.startsWith("risk_signals.") || path.startsWith("risk_policies.")) return describeSetting(path);
  const floor = floorDomain(path);
  if (floor) return `${domainLabel(floor)} floor`;
  const action = actionDomain(path);
  if (action) return `${domainLabel(action)} action`;
  return knobLabel(path);
}
function kindForPath(path) {
  return floorDomain(path) ? "probability" : knobKind(path);
}
function SetByBadge({
  status,
  origin,
  tierLabels,
  title
}) {
  const owner = React26.useContext(PolicyOwnerContext);
  if (status === "default" || !origin) {
    return /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "font-normal text-muted-foreground", title, children: "Platform default" });
  }
  const label = tierLabels[origin.tier] ?? origin.tier;
  if (status === "own") {
    return /* @__PURE__ */ jsx(Badge, { variant: "default", title: owner ? `Set at this scope for ${owner}. ${title}` : title, children: owner ? "Set here" : "Your setting" });
  }
  return /* @__PURE__ */ jsxs(Badge, { variant: "secondary", className: "font-normal", title, children: [
    "Inherited \xB7 ",
    label
  ] });
}
function LadderSummary({
  ladder,
  tierLabels,
  tier
}) {
  if (!ladder?.tiers?.length) return null;
  return /* @__PURE__ */ jsx("div", { className: "flex flex-wrap items-center gap-1.5", children: ladder.tiers.map((t) => {
    const authored = !authorsNothing(t.section);
    const active = t.tier === tier;
    const locked = t.editable === false;
    return /* @__PURE__ */ jsxs(
      "span",
      {
        title: t.note ?? (locked ? `${tierLabels[t.tier] ?? t.tier} cannot be authored here` : authored ? `${tierLabels[t.tier] ?? t.tier} sets some of this policy` : `${tierLabels[t.tier] ?? t.tier} sets nothing \u2014 it inherits`),
        className: cn(
          "rounded-full border px-2 py-0.5 text-xs",
          active ? "border-primary/60 bg-primary/10 text-foreground" : locked ? "border-dashed border-border/60 text-muted-foreground/70" : authored ? "border-border bg-muted text-foreground" : "border-dashed border-border text-muted-foreground"
        ),
        children: [
          tierLabels[t.tier] ?? t.tier,
          locked ? " \xB7 not editable" : authored ? "" : " \xB7 inherits"
        ]
      },
      t.tier
    );
  }) });
}
function ProblemList({
  title,
  items,
  tone: tone2
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "rounded-md border px-3 py-2 text-sm",
        tone2 === "warn" ? "border-amber-500/40 bg-amber-500/5 text-foreground" : "border-border"
      ),
      children: [
        /* @__PURE__ */ jsx("div", { className: "font-medium", children: title }),
        /* @__PURE__ */ jsx("ul", { className: "mt-1 list-disc space-y-0.5 pl-4 text-xs text-muted-foreground", children: items.map((p) => /* @__PURE__ */ jsx("li", { children: p }, p)) })
      ]
    }
  );
}
var DOMAIN_COLUMNS = [
  { label: "What is being judged" },
  { label: "Minimum confidence", className: "w-40" },
  { label: "Below that, we", className: "w-56" },
  { label: "Set by", className: "w-44" }
];
var KNOB_COLUMNS = [
  { label: "Setting" },
  { label: "Value", className: "w-40" },
  { label: "", className: "w-56" },
  { label: "Set by", className: "w-44" }
];
var WEIGHT_COLUMNS = [
  { label: "Setting" },
  { label: "Worth", className: "w-40" },
  { label: "Platform value", className: "w-56" },
  { label: "Set by", className: "w-44" }
];
var WEIGHT_SOURCE_COLUMNS = [{ label: "Source" }, ...WEIGHT_COLUMNS.slice(1)];
var POLICY_ROW = "border-b border-border/60 last:border-0 align-top @max-[46rem]:flex @max-[46rem]:flex-wrap @max-[46rem]:items-start @max-[46rem]:gap-x-2 @max-[46rem]:pb-1.5";
var STACKED_LABEL = "@max-[46rem]:before:mb-1 @max-[46rem]:before:block @max-[46rem]:before:text-[11px] @max-[46rem]:before:font-medium @max-[46rem]:before:uppercase @max-[46rem]:before:tracking-wide @max-[46rem]:before:text-muted-foreground @max-[46rem]:before:content-[attr(data-label)]";
function PolicyTable({
  columns,
  scroll = false,
  children
}) {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: cn(
        "@container overflow-x-auto rounded-md border border-border",
        scroll && "max-h-96 overflow-y-auto"
      ),
      children: /* @__PURE__ */ jsxs(Table, { className: "w-full text-sm @max-[46rem]:block", children: [
        /* @__PURE__ */ jsx(TableHeader, { className: cn("@max-[46rem]:hidden", scroll && "sticky top-0 bg-muted/60 backdrop-blur"), children: /* @__PURE__ */ jsx(TableRow, { className: cn("border-b border-border text-left", !scroll && "bg-muted/40"), children: columns.map((column, index) => /* @__PURE__ */ jsx(Th, { className: column.className, children: column.label }, index)) }) }),
        /* @__PURE__ */ jsx(TableBody, { className: "@max-[46rem]:block", children })
      ] })
    }
  );
}
function PolicyCell({
  label,
  dense = false,
  className,
  ...props
}) {
  return /* @__PURE__ */ jsx(
    TableCell,
    {
      "data-label": label,
      className: cn(
        "px-3 @max-[46rem]:block",
        dense ? "py-2" : "py-2.5",
        label ? cn("@max-[46rem]:py-1.5", STACKED_LABEL) : "@max-[46rem]:basis-full @max-[46rem]:pb-1",
        className
      ),
      ...props
    }
  );
}
function Th({
  children,
  className
}) {
  return /* @__PURE__ */ jsx(
    TableHead,
    {
      className: cn(
        "px-3 py-2 text-xs font-medium uppercase tracking-wide text-muted-foreground",
        className
      ),
      children
    }
  );
}
var SHADOWED_NAMED = 3;
function savedPolicyReach({
  ladder,
  section,
  tier,
  tierLabels,
  owner,
  knobsOnly = false
}) {
  const scope = (t) => t === "user" ? owner ? "the personal scope" : "your personal scope" : `the ${tierLabels[t] ?? t} scope`;
  const shadowed = shadowedSettings(ladder, section, tier);
  const named = shadowed.slice(0, SHADOWED_NAMED).map(({ path, tier: setter }) => `${describeSetting(path)} (${scope(setter)})`);
  const more = shadowed.length - named.length;
  const exceptions = `${named.join("; ")}${more > 0 ? `; and ${more} more` : ""}`;
  if (knobsOnly) {
    return shadowed.length ? `A narrower scope's own value still applies there for: ${exceptions}.` : "";
  }
  if (shadowed.length === 0) return "New runs at this scope or a narrower one are judged against it.";
  return `New runs at this scope are judged against it. Narrower runs are too, except for what their own scope sets: ${exceptions}.`;
}
function ConfidencePolicyEditor({
  policy,
  canAuthor,
  defaultTier,
  allowedTiers,
  readOnlyKnobs,
  knobs,
  knobsOnly = false,
  allowClear = true,
  owner,
  renderTierNote,
  savedDescription,
  savedAction,
  onTierChange,
  focus,
  readOnlyReason
}) {
  const [picked, setPicked] = React26.useState(null);
  const tier = picked ?? defaultTier;
  const tierLabels = React26.useMemo(() => {
    const out = {};
    for (const t of policy.data?.tiers ?? []) out[t.tier] = t.label;
    if (owner && out.user) out.user = "Personal";
    return out;
  }, [policy.data, owner]);
  const writableTiers = React26.useMemo(
    () => (policy.data?.tiers ?? []).filter((t) => t.tier !== "base" && t.editable !== false).map((t) => t.tier).filter((t) => !allowedTiers || allowedTiers.includes(t)).reverse(),
    [policy.data, allowedTiers]
  );
  const scopedData = React26.useMemo(
    () => policy.data ? policyAtScope(policy.data, tier) : null,
    [policy.data, tier]
  );
  const authoring = canAuthor && tier !== "base" && scopedData != null && policy.data?.tiers.find((t) => t.tier === tier)?.editable !== false && (!allowedTiers || allowedTiers.includes(tier));
  if (policy.status === "error") {
    return /* @__PURE__ */ jsx(ErrorState, { error: policy.error, onRetry: policy.reload });
  }
  if (policy.status === "loading") {
    return /* @__PURE__ */ jsx(Skeleton, { className: "h-64 w-full" });
  }
  const whose = owner && tier !== "system" ? `${owner}'s ` : "the ";
  const rungName = tier === "user" ? "personal" : tierLabels[tier] ?? tier;
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
    !canAuthor && readOnlyReason ? /* @__PURE__ */ jsx("div", { className: "rounded-md border border-border bg-muted/30 px-3 py-2 text-xs text-muted-foreground", children: readOnlyReason }) : null,
    writableTiers.length > 0 ? /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2 text-sm", children: [
      /* @__PURE__ */ jsx("label", { htmlFor: "confidence-policy-rung", className: "text-muted-foreground", children: "View / edit scope" }),
      /* @__PURE__ */ jsxs(
        Select,
        {
          value: tier,
          onValueChange: (v) => {
            setPicked(v);
            onTierChange?.(v);
          },
          children: [
            /* @__PURE__ */ jsx(
              SelectTrigger,
              {
                id: "confidence-policy-rung",
                className: "h-8 w-[170px]",
                "aria-label": "Confidence policy scope",
                children: /* @__PURE__ */ jsx(SelectValue, {})
              }
            ),
            /* @__PURE__ */ jsxs(SelectContent, { children: [
              writableTiers.map((t) => /* @__PURE__ */ jsx(SelectItem, { value: t, children: tierLabels[t] ?? t }, t)),
              /* @__PURE__ */ jsx(SelectItem, { value: "base", children: "Platform default (read only)" })
            ] })
          ]
        }
      )
    ] }) : null,
    /* @__PURE__ */ jsxs("div", { className: "rounded-md border border-border bg-muted/30 px-3 py-2 text-xs text-muted-foreground", children: [
      /* @__PURE__ */ jsxs("p", { className: "font-medium text-foreground", children: [
        knobsOnly ? "Current read settings" : "Current policy",
        " for ",
        tier === "user" ? "your personal scope" : `${tierLabels[tier] ?? tier} scope`
      ] }),
      /* @__PURE__ */ jsx("p", { children: knobsOnly ? "Read settings filter existing results immediately. They do not change stored processing decisions or restore results withheld during processing." : "Processing thresholds and below-floor actions apply to new runs at this scope. Narrower runs can override them; broader runs do not read them. Pipeline configuration can override these values. Existing results keep the policy used when they were processed and require reprocessing to change." }),
      !knobsOnly ? /* @__PURE__ */ jsx("p", { children: "Read settings, including Read confidence floor, filter existing results immediately." }) : null,
      !knobsOnly && policy.data?.activity ? /* @__PURE__ */ jsx("p", { children: "Recent activity includes recorded runs under earlier policies and other execution scopes." }) : null
    ] }),
    renderTierNote?.(tier),
    !scopedData ? /* @__PURE__ */ jsxs("p", { role: "status", className: "text-sm text-muted-foreground", children: [
      "This server has not provided a policy resolved for ",
      tierLabels[tier] ?? tier,
      " scope. A narrower override exists, so its values cannot be shown as this scope's policy.",
      writableTiers.includes("user") ? " Choose You to inspect your current effective policy." : "",
      " ",
      "The policy service must be updated to show this scope separately."
    ] }) : /* @__PURE__ */ jsx(
      ConfidencePolicyPanel,
      {
        focus,
        readOnlyKnobs,
        ownedBy: owner,
        ladder: scopedData,
        domains: policy.data?.vocabulary?.domains ?? [],
        knobs: knobs ?? policy.data?.vocabulary?.knobs ?? [],
        knobsOnly,
        cutoffs: policy.data?.vocabulary?.tier_cutoffs,
        defaultActions: policy.data?.vocabulary?.default_actions,
        supportedActions: policy.data?.vocabulary?.supported_actions,
        platformFloors: policy.data?.vocabulary?.platform_floors,
        baseTables: policy.data?.vocabulary?.base_tables,
        riskRules: policy.data?.vocabulary?.risk_rules,
        enforcement: policy.data?.vocabulary?.domain_enforcement,
        activity: policy.data?.activity,
        activityWindowDays: policy.data?.activity_window_days ?? 7,
        tier,
        tierLabels,
        busy: policy.busy,
        onPreview: authoring ? async (section) => {
          const preview = await policy.preview(tier, section);
          if (preview.scope_view?.tier === tier) return { ...preview, ...preview.scope_view };
          const scoped = policyAtScope({ ...scopedData, ...preview, scope_views: void 0 }, tier);
          if (!scoped) throw new Error("The server did not resolve the preview at the selected scope.");
          return { ...preview, ...scoped };
        } : void 0,
        onSave: authoring ? async (section) => {
          try {
            await policy.save(tier, section);
            const description = [
              savedPolicyReach({ ladder: policy.data, section, tier, tierLabels, owner, knobsOnly }),
              savedDescription
            ].filter(Boolean).join(" ");
            notifySuccess(
              tier === "user" ? "Saved your confidence policy" : `Saved ${whose}${rungName} confidence policy`,
              {
                ...description ? { description } : {},
                ...savedAction ? { action: savedAction } : {}
              }
            );
          } catch (err) {
            notifyError(err, { title: "Couldn't save the confidence policy." });
          }
        } : void 0,
        onClear: authoring && allowClear ? async () => {
          try {
            await policy.clear(tier);
            notifySuccess(
              tier === "user" ? "Removed your personal overrides" : `Removed ${whose}${rungName} overrides`,
              {
                description: "It goes back to what it inherits."
              }
            );
          } catch (err) {
            notifyError(err, { title: "Couldn't remove the overrides." });
          }
        } : void 0
      }
    )
  ] });
}
function fieldProblems(ctx, key, within) {
  return problemsAt(ctx.problems, key, { within }).map((problem) => problemTextAt(problem.detail, key));
}
var MAX_FORM_DEPTH = 2;
var ACTION_HERE = {
  set: "Set here",
  added: "Added here",
  edited: "Edited here",
  replaced: "Replaced here"
};
function OriginBadge({
  origin,
  tier,
  tierLabel
}) {
  if (!origin) return null;
  if (origin.tier === tier) {
    return /* @__PURE__ */ jsx(Badge, { variant: "default", className: "h-5 px-1.5 text-[10px] font-normal", "data-origin": "here", children: ACTION_HERE[origin.action] });
  }
  return /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "h-5 px-1.5 text-[10px] font-normal", "data-origin": "inherited", children: tierLabel(origin.tier) });
}
function downstreamText(note, tierLabel) {
  if (note.also?.length) {
    const setters = [...note.also, note];
    if (setters.every((setter) => setter.action === "set")) {
      const each = setters.map((setter) => `${tierLabel(setter.tier)} with ${display(setter.value)}`);
      return `Overridden by ${each.join(", then ")} \u2014 runs at each of those use their own.`;
    }
    return `${setters.map((setter) => tierLabel(setter.tier)).join(" and ")} change this \u2014 runs at each of those use their own.`;
  }
  const who = tierLabel(note.tier);
  switch (note.action) {
    case "set":
      return `${who} overrides this with ${display(note.value)} \u2014 runs at ${who} use that.`;
    case "removed":
      return `${who} removes this \u2014 runs at ${who} don't use it.`;
    case "edited":
      return `${who} edits this entry.`;
    case "replaced":
      return `${who} replaces this entry.`;
    default:
      return `${who} adds this.`;
  }
}
function DownstreamLine({ ctx, path }) {
  const note = downstreamAt(ctx.downstream, path);
  if (!note) return null;
  return /* @__PURE__ */ jsx("p", { className: "text-xs text-amber-700 dark:text-amber-400", "data-testid": "downstream-note", children: downstreamText(note, ctx.tierLabel) });
}
function DownstreamBadge({ note, ctx }) {
  if (!note) return null;
  const who = ctx.tierLabel(note.tier);
  const text = note.action === "removed" ? `removed at ${who}` : note.action === "set" ? `${who}: ${display(note.value)}` : `${note.action} at ${who}`;
  return /* @__PURE__ */ jsx(
    Badge,
    {
      variant: "outline",
      className: "h-5 border-amber-500/50 px-1.5 text-[10px] font-normal text-amber-700 dark:text-amber-400",
      title: downstreamText(note, ctx.tierLabel),
      "data-testid": "downstream-badge",
      children: text
    }
  );
}
function DownstreamAdditions({
  ctx,
  path,
  render
}) {
  const added = downstreamAddedAt(ctx.downstream, path);
  if (!added.length) return null;
  return /* @__PURE__ */ jsx("ul", { className: "space-y-0.5 text-xs text-amber-700 dark:text-amber-400", "data-testid": "downstream-added", children: added.map((entry, i) => /* @__PURE__ */ jsxs("li", { children: [
    ctx.tierLabel(entry.tier),
    " also adds ",
    render(entry.value)
  ] }, i)) });
}
function FieldShell({
  label,
  description,
  badge,
  onReset,
  lock,
  problems,
  children,
  testId
}) {
  return /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-1.5", "data-testid": testId, "data-invalid": problems?.length ? true : void 0, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
      /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-foreground", children: label }),
      badge,
      lock ? /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "h-5 px-1.5 text-[10px] font-normal text-muted-foreground", children: LOCK_BADGE[lock] }) : null,
      onReset ? /* @__PURE__ */ jsx(Button, { variant: "link", size: "sm", className: "h-auto p-0 text-xs", onClick: onReset, children: "Reset to inherited" }) : null
    ] }),
    description ? /* @__PURE__ */ jsx(Help, { text: description }) : null,
    children,
    /* @__PURE__ */ jsx(FieldProblems, { problems })
  ] });
}
function FieldProblems({ problems }) {
  if (!problems?.length) return null;
  return /* @__PURE__ */ jsx("ul", { className: "space-y-0.5 text-xs text-destructive", "data-testid": "field-problems", children: problems.map((problem, i) => /* @__PURE__ */ jsx("li", { children: problem }, i)) });
}
function Help({ text }) {
  const parts = text.split(/`([^`]+)`/g);
  return /* @__PURE__ */ jsx("p", { className: "max-w-3xl text-xs leading-relaxed text-muted-foreground", children: parts.map(
    (part, i) => i % 2 ? /* @__PURE__ */ jsx("code", { className: "rounded bg-muted px-1 font-mono text-[11px]", children: part }, i) : /* @__PURE__ */ jsx(React26.Fragment, { children: part }, i)
  ) });
}
function SchemaField({
  ctx,
  path,
  node,
  depth = 0
}) {
  const { node: resolved, nullable } = resolveNode(ctx.root, node);
  const name = path[path.length - 1];
  const kind = fieldKind(ctx.root, node);
  const lock = fieldLock(resolved, ctx.tier);
  const common = { ctx, path, node: resolved, label: fieldLabel(name, resolved), nullable };
  if (resolved["x-format"] === "parameter-declarations") return /* @__PURE__ */ jsx(Fragment, {});
  if (lock) return /* @__PURE__ */ jsx(ReadOnlyField, { ...common, lock });
  if (resolved["x-format"] === "declared-parameters") return /* @__PURE__ */ jsx(ParametersField, { ...common });
  if (kind === "string" && isChainField(ctx.root, node)) return /* @__PURE__ */ jsx(ChainField, { ...common });
  switch (kind) {
    case "boolean":
      return /* @__PURE__ */ jsx(BooleanField, { ...common });
    case "enum":
      return /* @__PURE__ */ jsx(EnumField, { ...common });
    case "integer":
    case "number":
    case "string":
      return /* @__PURE__ */ jsx(ScalarField, { ...common, kind });
    case "value-list":
      return /* @__PURE__ */ jsx(ValueListField, { ...common, chain: isChainField(ctx.root, node) });
    case "keyed-list":
      return /* @__PURE__ */ jsx(KeyedListField, { ...common, listNode: node });
    case "map":
      return /* @__PURE__ */ jsx(MapField, { ...common, listNode: node });
    case "object":
      return depth >= MAX_FORM_DEPTH ? /* @__PURE__ */ jsx(JsonField, { ...common }) : /* @__PURE__ */ jsx(ObjectField, { ...common, depth });
    default:
      return /* @__PURE__ */ jsx(JsonField, { ...common });
  }
}
function fieldInUse(ctx, path, node) {
  const key = originPath(path);
  if (ctx.primary?.has(key)) return true;
  const value = getAt(ctx.definition, path);
  const fallback = node ? resolveNode(ctx.root, node).node.default : void 0;
  const atDefault = fallback !== void 0 && JSON.stringify(value) === JSON.stringify(fallback);
  if (!atDefault && !isEmptyValue(value)) return true;
  if (getAt(ctx.draft, path) !== void 0) return true;
  const under = (k) => k === key || k.startsWith(`${key}.`);
  if (Object.keys(ctx.origins.fields).some(under)) return true;
  if (ctx.origins.removed.some((r) => under(r.path))) return true;
  if (ctx.problems?.some((problem) => problem.path && under(problem.path))) return true;
  if (ctx.downstream && (Object.keys(ctx.downstream.fields).some(under) || ctx.downstream.added.some((a) => under(a.path)))) {
    return true;
  }
  return false;
}
function FieldList({
  ctx,
  base,
  names,
  nodes,
  depth = 0
}) {
  const [more, setMore] = React26.useState(false);
  const used = names.filter((name) => fieldInUse(ctx, [...base, name], nodes[name]));
  const rest = names.filter((name) => !used.includes(name));
  const shown = more ? names : used;
  return /* @__PURE__ */ jsxs("div", { className: "space-y-4", children: [
    shown.map((name) => /* @__PURE__ */ jsx(SchemaField, { ctx, path: [...base, name], node: nodes[name], depth }, name)),
    rest.length ? /* @__PURE__ */ jsx(
      Button,
      {
        variant: "link",
        size: "sm",
        className: "h-auto p-0 text-xs",
        onClick: () => setMore((v) => !v),
        "data-testid": "more-fields",
        children: more ? "Show only fields in use" : `Show ${rest.length} more field${rest.length === 1 ? "" : "s"}`
      }
    ) : null
  ] });
}
function useScalarBinding({ ctx, path }) {
  const key = originPath(path);
  const origin = originAt(ctx.origins, key);
  const drafted = getAt(ctx.draft, path);
  const own = drafted !== void 0;
  return {
    key,
    // The rung's own value when it sets one — a scalar the rung sets IS its
    // value in the rung's view. Read from the draft rather than the preview,
    // because a draft the server cannot fold (150 in a 0–100 field) previews
    // WITHOUT it: the input fell back to the inherited 80 while the problem
    // under it described the 150 the author had just typed.
    value: own ? drafted : getAt(ctx.definition, path),
    origin,
    set: (value) => ctx.edit((patch) => setAt(patch, path, value)),
    reset: own && ctx.canEdit ? () => ctx.edit((patch) => unsetAt(patch, path)) : void 0
  };
}
function fieldLock(node, tier) {
  if (node["x-code-bound"] === true) return "code";
  if (node["x-system-only"] === true && tier !== "system") return "platform";
  return null;
}
var LOCK_BADGE = {
  code: "Set by the code",
  platform: "Platform only"
};
function ReadOnlyField({ ctx, path, node, label, lock = "platform" }) {
  const value = getAt(ctx.definition, path);
  return /* @__PURE__ */ jsx(FieldShell, { label, description: node.description, lock, testId: `field-${originPath(path)}`, children: /* @__PURE__ */ jsx("div", { className: "font-mono text-xs text-muted-foreground", children: display(value) }) });
}
function ScalarField({
  ctx,
  path,
  node,
  label,
  kind
}) {
  const { key, value, origin, set, reset } = useScalarBinding({ ctx, path });
  const shown = value === null || value === void 0 ? "" : String(value);
  const [text, setText] = React26.useState(shown);
  React26.useEffect(() => setText(shown), [shown]);
  const commit = () => {
    if (text === shown) return;
    if (text.trim() === "") {
      set(null);
      return;
    }
    if (kind === "string") {
      set(text);
      return;
    }
    const parsed = kind === "integer" ? Number.parseInt(text, 10) : Number(text);
    if (Number.isFinite(parsed)) set(parsed);
    else setText(shown);
  };
  return /* @__PURE__ */ jsxs(
    FieldShell,
    {
      label,
      description: node.description,
      badge: /* @__PURE__ */ jsx(OriginBadge, { origin, tier: ctx.tier, tierLabel: ctx.tierLabel }),
      onReset: reset,
      problems: fieldProblems(ctx, originPath(path), false),
      testId: `field-${key}`,
      children: [
        /* @__PURE__ */ jsx(
          Input,
          {
            "aria-label": label,
            "aria-invalid": problemsAt(ctx.problems, originPath(path)).length > 0 || void 0,
            className: cn(
              "max-w-md",
              kind !== "string" && "w-40",
              problemsAt(ctx.problems, originPath(path)).length > 0 && "border-destructive"
            ),
            type: kind === "string" ? "text" : "number",
            step: kind === "number" ? "any" : void 0,
            min: node.minimum,
            max: node.maximum,
            value: text,
            disabled: !ctx.canEdit,
            onChange: (event) => setText(event.target.value),
            onBlur: commit,
            onKeyDown: (event) => {
              if (event.key === "Enter") commit();
            }
          }
        ),
        /* @__PURE__ */ jsx(DownstreamLine, { ctx, path: key })
      ]
    }
  );
}
function ChainField({ ctx, path, node, label, nullable }) {
  const { key, value, origin, set, reset } = useScalarBinding({ ctx, path });
  return /* @__PURE__ */ jsxs(
    FieldShell,
    {
      label,
      description: node.description,
      badge: /* @__PURE__ */ jsx(OriginBadge, { origin, tier: ctx.tier, tierLabel: ctx.tierLabel }),
      onReset: reset,
      problems: fieldProblems(ctx, originPath(path), false),
      testId: `field-${key}`,
      children: [
        /* @__PURE__ */ jsx(
          ChainSelect,
          {
            className: "max-w-xs",
            value: chainValue(value),
            valueKind: "caip2",
            includeTestnets: true,
            allowAny: nullable,
            anyLabel: "Any chain",
            disabled: !ctx.canEdit,
            onChange: (next) => set(next || null)
          }
        ),
        /* @__PURE__ */ jsx(DownstreamLine, { ctx, path: key })
      ]
    }
  );
}
function BooleanField({ ctx, path, node, label }) {
  const { key, value, origin, set, reset } = useScalarBinding({ ctx, path });
  return /* @__PURE__ */ jsxs(
    FieldShell,
    {
      label,
      description: node.description,
      badge: /* @__PURE__ */ jsx(OriginBadge, { origin, tier: ctx.tier, tierLabel: ctx.tierLabel }),
      onReset: reset,
      problems: fieldProblems(ctx, originPath(path), false),
      testId: `field-${key}`,
      children: [
        /* @__PURE__ */ jsxs(
          NativeSelect,
          {
            "aria-label": label,
            className: "w-40",
            density: "sm",
            value: value === true ? "true" : value === false ? "false" : "",
            disabled: !ctx.canEdit,
            onChange: (event) => set(event.target.value === "true"),
            children: [
              value === void 0 || value === null ? /* @__PURE__ */ jsx("option", { value: "", children: "\u2014" }) : null,
              /* @__PURE__ */ jsx("option", { value: "true", children: "Yes" }),
              /* @__PURE__ */ jsx("option", { value: "false", children: "No" })
            ]
          }
        ),
        /* @__PURE__ */ jsx(DownstreamLine, { ctx, path: key })
      ]
    }
  );
}
function EnumField({ ctx, path, node, label }) {
  const { key, value, origin, set, reset } = useScalarBinding({ ctx, path });
  return /* @__PURE__ */ jsxs(
    FieldShell,
    {
      label,
      description: node.description,
      badge: /* @__PURE__ */ jsx(OriginBadge, { origin, tier: ctx.tier, tierLabel: ctx.tierLabel }),
      onReset: reset,
      problems: fieldProblems(ctx, originPath(path), false),
      testId: `field-${key}`,
      children: [
        /* @__PURE__ */ jsxs(
          NativeSelect,
          {
            "aria-label": label,
            className: "max-w-xs",
            density: "sm",
            value: value === null || value === void 0 ? "" : String(value),
            disabled: !ctx.canEdit,
            onChange: (event) => set(event.target.value === "" ? null : event.target.value),
            children: [
              /* @__PURE__ */ jsx("option", { value: "", children: "\u2014" }),
              (node.enum ?? []).map((option) => /* @__PURE__ */ jsx("option", { value: String(option), children: String(option) }, String(option)))
            ]
          }
        ),
        /* @__PURE__ */ jsx(DownstreamLine, { ctx, path: key })
      ]
    }
  );
}
function ValueListField({ ctx, path, node, label, chain }) {
  const key = originPath(path);
  const values = asList(getAt(ctx.definition, path));
  const removed = removedAt(ctx.origins, key).filter((r) => r.kind === "value");
  const [adding, setAdding] = React26.useState("");
  const itemKind = fieldKind(ctx.root, node.items);
  const text = (value) => chain ? chainName(value) : display(value);
  const parse = (raw) => {
    if (itemKind === "integer") return Number.parseInt(raw, 10);
    if (itemKind === "number") return Number(raw);
    return raw.trim();
  };
  const add = (value) => {
    if (value === "" || value === null || typeof value === "number" && !Number.isFinite(value)) return;
    ctx.edit((patch) => addListValue(patch, path, value));
  };
  return /* @__PURE__ */ jsxs(
    FieldShell,
    {
      label,
      description: node.description,
      problems: fieldProblems(ctx, originPath(path), true),
      testId: `field-${key}`,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-1.5", children: [
          values.length === 0 && removed.length === 0 ? /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "None" }) : null,
          values.map((value, index) => {
            const origin = originAt(ctx.origins, `${key}.${index}`);
            const own = origin?.tier === ctx.tier && origin.action === "added";
            return /* @__PURE__ */ jsxs(
              "span",
              {
                className: "inline-flex max-w-full flex-wrap items-center gap-1 rounded-md border px-1.5 py-0.5 text-xs",
                "data-testid": "list-value",
                children: [
                  /* @__PURE__ */ jsx("span", { className: cn("min-w-0 break-all", !chain && "font-mono"), title: display(value), children: text(value) }),
                  /* @__PURE__ */ jsx(OriginBadge, { origin, tier: ctx.tier, tierLabel: ctx.tierLabel }),
                  /* @__PURE__ */ jsx(DownstreamBadge, { note: downstreamAt(ctx.downstream, `${key}.${index}`), ctx }),
                  ctx.canEdit ? /* @__PURE__ */ jsx(
                    "button",
                    {
                      type: "button",
                      className: "text-muted-foreground hover:text-destructive",
                      "aria-label": `Remove ${display(value)}`,
                      onClick: () => ctx.edit((patch) => removeListValue(patch, path, value, { inherited: !own })),
                      children: "\xD7"
                    }
                  ) : null
                ]
              },
              `${String(value)}-${index}`
            );
          }),
          removed.map((entry) => /* @__PURE__ */ jsxs(
            "span",
            {
              className: "inline-flex max-w-full flex-wrap items-center gap-1 rounded-md border border-dashed px-1.5 py-0.5 text-xs text-muted-foreground line-through",
              "data-testid": "list-value-removed",
              title: `Removed at ${ctx.tierLabel(entry.tier)}`,
              children: [
                /* @__PURE__ */ jsx("span", { className: cn("min-w-0 break-all", !chain && "font-mono"), children: text(entry.value) }),
                /* @__PURE__ */ jsxs("span", { className: "no-underline", children: [
                  "\xB7 removed at ",
                  ctx.tierLabel(entry.tier)
                ] }),
                ctx.canEdit && entry.tier === ctx.tier ? /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "link",
                    size: "sm",
                    className: "h-auto p-0 text-xs no-underline",
                    onClick: () => ctx.edit((patch) => restoreListValue(patch, path, entry.value)),
                    children: "Restore"
                  }
                ) : null
              ]
            },
            `removed-${String(entry.value)}`
          ))
        ] }),
        /* @__PURE__ */ jsx(DownstreamAdditions, { ctx, path: key, render: (value) => /* @__PURE__ */ jsx("span", { className: "font-mono", children: text(value) }) }),
        ctx.canEdit ? chain ? /* @__PURE__ */ jsx(
          ChainSelect,
          {
            className: "max-w-xs",
            value: "",
            valueKind: "caip2",
            includeTestnets: true,
            placeholder: "Add a chain\u2026",
            onChange: (next) => add(next)
          }
        ) : /* @__PURE__ */ jsxs(
          "form",
          {
            className: "flex max-w-md gap-2",
            onSubmit: (event) => {
              event.preventDefault();
              add(parse(adding));
              setAdding("");
            },
            children: [
              /* @__PURE__ */ jsx(
                Input,
                {
                  "aria-label": `Add to ${label}`,
                  className: "h-8 font-mono text-xs",
                  placeholder: "Add a value",
                  value: adding,
                  onChange: (event) => setAdding(event.target.value)
                }
              ),
              /* @__PURE__ */ jsx(Button, { type: "submit", size: "sm", variant: "outline", disabled: !adding.trim(), children: "Add" })
            ]
          }
        ) : null
      ]
    }
  );
}
function MapField({ ctx, path, node, label, listNode }) {
  const key = originPath(path);
  const effective = getAt(ctx.definition, path) ?? {};
  const own = getAt(ctx.draft, path) ?? {};
  const valueNode = mapValueNode(ctx.root, listNode);
  const numeric = valueNode.type === "number" || valueNode.type === "integer";
  const suggestions = (ctx.keySuggestions?.[key] ?? []).filter((k) => !(k in effective));
  const [newKey, setNewKey] = React26.useState("");
  const [newValue, setNewValue] = React26.useState("");
  const coerce = (raw) => numeric ? Number(raw) : raw;
  const listId = `keys-${key}`;
  return /* @__PURE__ */ jsxs(
    FieldShell,
    {
      label,
      description: node.description,
      problems: fieldProblems(ctx, originPath(path), true),
      testId: `field-${key}`,
      children: [
        Object.keys({ ...effective, ...own }).length === 0 ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "None set." }) : null,
        /* @__PURE__ */ jsx("div", { className: "space-y-1.5", children: Object.entries({ ...effective, ...own }).map(([name, value]) => /* @__PURE__ */ jsx(
          MapRow,
          {
            ctx,
            path: [...path, name],
            name,
            value,
            numeric,
            own: name in own
          },
          name
        )) }),
        /* @__PURE__ */ jsx(DownstreamOnlyKeys, { ctx, mapKey: key, effective }),
        ctx.canEdit ? /* @__PURE__ */ jsxs(
          "form",
          {
            className: "flex max-w-xl flex-wrap gap-2",
            onSubmit: (event) => {
              event.preventDefault();
              const value = coerce(newValue);
              if (!newKey.trim() || numeric && !Number.isFinite(value)) return;
              ctx.edit((patch) => setAt(patch, [...path, newKey.trim()], value));
              setNewKey("");
              setNewValue("");
            },
            children: [
              /* @__PURE__ */ jsx(
                Input,
                {
                  "aria-label": `New key for ${label}`,
                  className: "h-8 w-56 font-mono text-xs",
                  placeholder: suggestions.length ? "Pick or type a key" : "Key",
                  list: listId,
                  value: newKey,
                  onChange: (event) => setNewKey(event.target.value)
                }
              ),
              /* @__PURE__ */ jsx("datalist", { id: listId, children: suggestions.map((k) => /* @__PURE__ */ jsx("option", { value: k }, k)) }),
              /* @__PURE__ */ jsx(
                Input,
                {
                  "aria-label": `Value for the new ${label} key`,
                  className: "h-8 w-28 text-xs",
                  type: numeric ? "number" : "text",
                  step: numeric ? "any" : void 0,
                  placeholder: "Value",
                  value: newValue,
                  onChange: (event) => setNewValue(event.target.value)
                }
              ),
              /* @__PURE__ */ jsx(Button, { type: "submit", size: "sm", variant: "outline", disabled: !newKey.trim() || newValue === "", children: "Add" })
            ]
          }
        ) : null
      ]
    }
  );
}
function DownstreamOnlyKeys({
  ctx,
  mapKey,
  effective
}) {
  const prefix = `${mapKey}.`;
  const rows = Object.entries(ctx.downstream?.fields ?? {}).filter(([path, note]) => path.startsWith(prefix) && note.action === "set").map(([path, note]) => ({ name: path.slice(prefix.length), note })).filter(({ name }) => !(name in effective));
  if (!rows.length) return null;
  return /* @__PURE__ */ jsx("ul", { className: "space-y-0.5 text-xs text-amber-700 dark:text-amber-400", "data-testid": "downstream-added", children: rows.map(({ name, note }) => /* @__PURE__ */ jsxs("li", { children: [
    ctx.tierLabel(note.tier),
    " also sets ",
    /* @__PURE__ */ jsx("span", { className: "font-mono", children: name }),
    " = ",
    display(note.value)
  ] }, name)) });
}
function MapRow({
  ctx,
  path,
  name,
  value,
  numeric,
  own
}) {
  const key = originPath(path);
  const shown = value === null || value === void 0 ? "" : String(value);
  const [text, setText] = React26.useState(shown);
  React26.useEffect(() => setText(shown), [shown]);
  const commit = () => {
    if (text === shown) return;
    const next = numeric ? Number(text) : text;
    if (numeric && (text.trim() === "" || !Number.isFinite(next))) {
      setText(shown);
      return;
    }
    ctx.edit((patch) => setAt(patch, path, next));
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", "data-testid": "map-row", children: [
    /* @__PURE__ */ jsx("span", { className: "w-56 truncate font-mono text-xs", title: name, children: name }),
    /* @__PURE__ */ jsx(
      Input,
      {
        "aria-label": name,
        className: "h-8 w-28 text-xs",
        type: numeric ? "number" : "text",
        step: numeric ? "any" : void 0,
        value: text,
        disabled: !ctx.canEdit,
        onChange: (event) => setText(event.target.value),
        onBlur: commit,
        onKeyDown: (event) => {
          if (event.key === "Enter") commit();
        }
      }
    ),
    /* @__PURE__ */ jsx(OriginBadge, { origin: originAt(ctx.origins, key), tier: ctx.tier, tierLabel: ctx.tierLabel }),
    /* @__PURE__ */ jsx(DownstreamBadge, { note: downstreamAt(ctx.downstream, key), ctx }),
    own && ctx.canEdit ? /* @__PURE__ */ jsx(Button, { variant: "link", size: "sm", className: "h-auto p-0 text-xs", onClick: () => ctx.edit((patch) => unsetAt(patch, path)), children: "Reset" }) : null
  ] });
}
var FILTER_FROM_ROWS = 20;
function KeyedListField({
  ctx,
  path,
  node,
  label,
  listNode
}) {
  const key = originPath(path);
  const identity = identityFields(ctx.root, listNode);
  const columns = tableColumns(ctx.root, listNode).slice(0, identity.length + 4);
  const item = itemNode(ctx.root, listNode);
  const rows = asList(getAt(ctx.definition, path));
  const removed = removedAt(ctx.origins, key).filter((r) => r.kind === "entry");
  const [editing, setEditing] = React26.useState(null);
  const editingRow = typeof editing === "number" ? rows[editing] : void 0;
  const [filter, setFilter] = React26.useState("");
  const filterable = rows.length > FILTER_FROM_ROWS;
  const query = filter.trim().toLowerCase();
  const shown = rows.map((row, index) => ({ row, index })).filter(
    ({ row }) => !filterable || !query || columns.some((column) => {
      const value = row[column];
      const chain = isChainField(ctx.root, item.properties?.[column]);
      return [display(value), chain ? chainName(value) : ""].some((text) => text.toLowerCase().includes(query));
    })
  );
  return /* @__PURE__ */ jsxs(
    FieldShell,
    {
      label,
      description: node.description,
      problems: fieldProblems(ctx, originPath(path), true),
      testId: `field-${key}`,
      children: [
        filterable ? /* @__PURE__ */ jsxs("div", { className: "flex max-w-md items-center gap-2", children: [
          /* @__PURE__ */ jsx(
            Input,
            {
              "aria-label": `Filter ${label}`,
              className: "h-8 text-xs",
              placeholder: `Filter ${rows.length} entries`,
              value: filter,
              onChange: (event) => setFilter(event.target.value)
            }
          ),
          query ? /* @__PURE__ */ jsxs("span", { className: "whitespace-nowrap text-xs text-muted-foreground", children: [
            shown.length,
            " of ",
            rows.length
          ] }) : null
        ] }) : null,
        /* @__PURE__ */ jsx("div", { className: "overflow-x-auto rounded-md border", children: /* @__PURE__ */ jsxs("table", { className: "w-full text-xs", children: [
          /* @__PURE__ */ jsx("thead", { className: "bg-muted/40 text-left text-muted-foreground", children: /* @__PURE__ */ jsxs("tr", { children: [
            columns.map((column) => /* @__PURE__ */ jsx("th", { className: "whitespace-nowrap px-2 py-1.5 font-medium", children: fieldLabel(column, resolveNode(ctx.root, item.properties?.[column]).node) }, column)),
            /* @__PURE__ */ jsx("th", { className: "px-2 py-1.5 font-medium", children: "Set by" }),
            ctx.canEdit ? /* @__PURE__ */ jsx("th", { className: "px-2 py-1.5" }) : null
          ] }) }),
          /* @__PURE__ */ jsxs("tbody", { children: [
            rows.length === 0 && removed.length === 0 ? /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { className: "px-2 py-2 text-muted-foreground", colSpan: columns.length + 2, children: "No entries." }) }) : null,
            rows.length > 0 && shown.length === 0 ? /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsxs("td", { className: "px-2 py-2 text-muted-foreground", colSpan: columns.length + 2, children: [
              "No entries match \u201C",
              filter.trim(),
              "\u201D."
            ] }) }) : null,
            shown.map(({ row, index }) => {
              const origin = originAt(ctx.origins, `${key}.${index}`);
              const own = origin?.tier === ctx.tier && origin.action === "added";
              const rowIdentity = pick(row, identity);
              return /* @__PURE__ */ jsxs(
                "tr",
                {
                  className: cn("border-t", editing === index && "bg-primary/5"),
                  "data-testid": "keyed-row",
                  children: [
                    columns.map((column) => /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5 align-top", children: /* @__PURE__ */ jsx(
                      CellValue,
                      {
                        chain: isChainField(ctx.root, item.properties?.[column]),
                        mono: column === "address" || column.endsWith("_id") || column.endsWith("_to"),
                        value: row[column],
                        origin: originAt(ctx.origins, `${key}.${index}.${column}`),
                        note: downstreamAt(ctx.downstream, `${key}.${index}.${column}`),
                        ctx
                      }
                    ) }, column)),
                    /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5 align-top", children: /* @__PURE__ */ jsxs("span", { className: "inline-flex flex-wrap items-center gap-1", children: [
                      origin ? /* @__PURE__ */ jsx(OriginBadge, { origin, tier: ctx.tier, tierLabel: ctx.tierLabel }) : /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "System" }),
                      /* @__PURE__ */ jsx(DownstreamBadge, { note: downstreamAt(ctx.downstream, `${key}.${index}`), ctx })
                    ] }) }),
                    ctx.canEdit ? /* @__PURE__ */ jsxs("td", { className: "whitespace-nowrap px-2 py-1.5 text-right align-top", children: [
                      /* @__PURE__ */ jsx(Button, { variant: "link", size: "sm", className: "h-auto p-0 text-xs", onClick: () => setEditing(index), children: "Edit" }),
                      /* @__PURE__ */ jsx("span", { className: "px-1 text-muted-foreground", children: "\xB7" }),
                      /* @__PURE__ */ jsx(
                        Button,
                        {
                          variant: "link",
                          size: "sm",
                          className: "h-auto p-0 text-xs text-destructive",
                          onClick: () => {
                            if (editing === index) setEditing(null);
                            ctx.edit((patch) => removeEntry(patch, path, identity, rowIdentity, { inherited: !own }));
                          },
                          children: "Remove"
                        }
                      )
                    ] }) : null
                  ]
                },
                `row-${index}`
              );
            }),
            removed.map((entry, index) => /* @__PURE__ */ jsxs("tr", { className: "border-t text-muted-foreground", "data-testid": "keyed-row-removed", children: [
              columns.map((column) => /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5 align-top line-through", children: /* @__PURE__ */ jsx(
                CellValue,
                {
                  chain: isChainField(ctx.root, item.properties?.[column]),
                  mono: column === "address" || column.endsWith("_id"),
                  value: entry.entry[column],
                  ctx
                }
              ) }, column)),
              /* @__PURE__ */ jsxs("td", { className: "px-2 py-1.5 align-top", children: [
                "Removed at ",
                ctx.tierLabel(entry.tier)
              ] }),
              ctx.canEdit ? /* @__PURE__ */ jsx("td", { className: "px-2 py-1.5 text-right align-top", children: entry.tier === ctx.tier ? /* @__PURE__ */ jsx(
                Button,
                {
                  variant: "link",
                  size: "sm",
                  className: "h-auto p-0 text-xs",
                  onClick: () => ctx.edit((patch) => restoreEntry(patch, path, identity, entry.identity)),
                  children: "Restore"
                }
              ) : null }) : null
            ] }, `removed-${index}`))
          ] })
        ] }) }),
        /* @__PURE__ */ jsx(
          DownstreamAdditions,
          {
            ctx,
            path: key,
            render: (value) => /* @__PURE__ */ jsx("span", { className: "font-mono", children: describeEntry(value, identity) })
          }
        ),
        editing !== null ? /* @__PURE__ */ jsx(
          EntryForm,
          {
            ctx,
            identity,
            item,
            initial: editingRow ?? {},
            existing: editing !== "new",
            onCancel: () => setEditing(null),
            onSave: (values) => {
              if (editingRow) {
                const changed = changedFields(editingRow, values, identity);
                if (Object.keys(changed).length) {
                  ctx.edit((patch) => upsertEntry(patch, path, identity, pick(editingRow, identity), changed));
                }
              } else {
                const rest = Object.fromEntries(
                  Object.entries(values).filter(([k, v]) => !identity.includes(k) && v !== null && v !== "")
                );
                ctx.edit((patch) => upsertEntry(patch, path, identity, pick(values, identity), rest));
              }
              setEditing(null);
            }
          },
          editing === "new" ? "new" : `edit-${editing}`
        ) : ctx.canEdit ? /* @__PURE__ */ jsx(Button, { variant: "outline", size: "sm", onClick: () => setEditing("new"), children: "Add entry" }) : null,
        ctx.canEdit ? /* @__PURE__ */ jsx(OwnEntryResets, { ctx, path, identity }) : null
      ]
    }
  );
}
function OwnEntryResets({
  ctx,
  path,
  identity
}) {
  const own = asList(getAt(ctx.draft, path)).filter(
    (entry) => !!entry && typeof entry === "object" && !("$patch" in entry)
  );
  const edits = own.flatMap(
    (entry) => Object.keys(entry).filter((field) => !identity.includes(field)).map((field) => ({ entry, field }))
  );
  if (!edits.length) return null;
  return /* @__PURE__ */ jsxs("details", { className: "text-xs", children: [
    /* @__PURE__ */ jsxs("summary", { className: "cursor-pointer text-muted-foreground", children: [
      edits.length,
      " field",
      edits.length === 1 ? "" : "s",
      " set at this rung"
    ] }),
    /* @__PURE__ */ jsx("ul", { className: "mt-1 space-y-0.5", children: edits.map(({ entry, field }, i) => /* @__PURE__ */ jsxs("li", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxs("span", { className: "font-mono", children: [
        describeEntry(entry, identity),
        " \xB7 ",
        field
      ] }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "link",
          size: "sm",
          className: "h-auto p-0 text-xs",
          onClick: () => ctx.edit((patch) => resetEntryField(patch, path, identity, pick(entry, identity), field)),
          children: "Reset"
        }
      )
    ] }, i)) })
  ] });
}
function EntryForm({
  ctx,
  identity,
  item,
  initial,
  existing,
  onSave,
  onCancel
}) {
  const properties = Object.entries(item.properties ?? {});
  const ordered = [
    ...properties.filter(([name]) => identity.includes(name)),
    ...properties.filter(([name]) => !identity.includes(name))
  ];
  const required = new Set(item.required ?? []);
  const [values, setValues] = React26.useState(
    () => Object.fromEntries(
      ordered.map(([name, prop]) => {
        const value = initial[name];
        if (value === null || value === void 0) return [name, ""];
        const kind = fieldKind(ctx.root, prop);
        if (isChainField(ctx.root, prop) && typeof value === "string") return [name, chainValue(value)];
        return [name, kind === "json" || typeof value === "object" ? JSON.stringify(value, null, 2) : String(value)];
      })
    )
  );
  const [error, setError] = React26.useState(null);
  const set = (name, value) => {
    setValues((all) => ({ ...all, [name]: value }));
    setError(null);
  };
  const submit = () => {
    const missing = ordered.filter(([name]) => required.has(name) && !values[name]?.trim()).map(([name, prop]) => fieldLabel(name, resolveNode(ctx.root, prop).node));
    if (missing.length) {
      setError(`${missing.join(", ")} ${missing.length === 1 ? "is" : "are"} required.`);
      return;
    }
    const out = {};
    for (const [name, prop] of ordered) {
      const raw = values[name] ?? "";
      const kind = fieldKind(ctx.root, prop);
      if (raw === "") {
        out[name] = null;
      } else if (kind === "integer") {
        out[name] = Number.parseInt(raw, 10);
      } else if (kind === "number") {
        out[name] = Number(raw);
      } else if (kind === "boolean") {
        out[name] = raw === "true";
      } else if (kind === "string" || kind === "enum") {
        out[name] = raw.trim();
      } else {
        try {
          out[name] = JSON.parse(raw);
        } catch (err) {
          setError(`${fieldLabel(name, resolveNode(ctx.root, prop).node)} isn't valid JSON: ${err.message}`);
          return;
        }
      }
    }
    onSave(out);
  };
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3 rounded-md border bg-muted/20 p-3", "data-testid": "entry-editor", children: [
    /* @__PURE__ */ jsx("p", { className: "text-sm font-medium", children: existing ? `Edit ${describeEntry(initial, identity)}` : "Add an entry" }),
    existing ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "The fields that name this entry are fixed; to move it, remove it and add a new one." }) : null,
    /* @__PURE__ */ jsx("div", { className: "grid gap-3 sm:grid-cols-2", children: ordered.map(([name, prop]) => {
      const resolved = resolveNode(ctx.root, prop);
      const kind = fieldKind(ctx.root, prop);
      const locked = existing && identity.includes(name);
      const label = fieldLabel(name, resolved.node);
      const id = `entry-${name}`;
      const wide = kind === "json" || kind === "value-list" || kind === "keyed-list" || kind === "object" || kind === "map";
      return /* @__PURE__ */ jsxs("div", { className: cn("min-w-0 space-y-1", wide && "sm:col-span-2"), children: [
        /* @__PURE__ */ jsxs("label", { htmlFor: id, className: "text-xs font-medium", children: [
          label,
          required.has(name) ? /* @__PURE__ */ jsx("span", { className: "text-destructive", children: " *" }) : null
        ] }),
        isChainField(ctx.root, prop) && kind === "string" ? /* @__PURE__ */ jsx(
          ChainSelect,
          {
            id,
            value: values[name] ?? "",
            valueKind: "caip2",
            includeTestnets: true,
            allowAny: resolved.nullable,
            anyLabel: "Any chain",
            disabled: locked,
            onChange: (next) => set(name, next)
          }
        ) : kind === "boolean" ? /* @__PURE__ */ jsxs(NativeSelect, { id, density: "sm", value: values[name], disabled: locked, onChange: (e) => set(name, e.target.value), children: [
          /* @__PURE__ */ jsx("option", { value: "", children: "\u2014" }),
          /* @__PURE__ */ jsx("option", { value: "true", children: "Yes" }),
          /* @__PURE__ */ jsx("option", { value: "false", children: "No" })
        ] }) : kind === "enum" ? /* @__PURE__ */ jsxs(NativeSelect, { id, density: "sm", value: values[name], disabled: locked, onChange: (e) => set(name, e.target.value), children: [
          /* @__PURE__ */ jsx("option", { value: "", children: "\u2014" }),
          (resolved.node.enum ?? []).map((option) => /* @__PURE__ */ jsx("option", { value: String(option), children: String(option) }, String(option)))
        ] }) : wide ? /* @__PURE__ */ jsx(
          Textarea,
          {
            id,
            className: "min-h-[4rem] font-mono text-xs",
            placeholder: "JSON",
            value: values[name],
            disabled: locked,
            onChange: (e) => set(name, e.target.value)
          }
        ) : /* @__PURE__ */ jsx(
          Input,
          {
            id,
            className: cn("h-8 text-xs", (name === "address" || name.endsWith("_to")) && "font-mono"),
            type: kind === "integer" || kind === "number" ? "number" : "text",
            value: values[name],
            disabled: locked,
            onChange: (e) => set(name, e.target.value)
          }
        ),
        resolved.node.description ? /* @__PURE__ */ jsx("p", { className: "line-clamp-2 text-[11px] text-muted-foreground", title: resolved.node.description, children: resolved.node.description }) : null
      ] }, name);
    }) }),
    error ? /* @__PURE__ */ jsx("p", { className: "text-xs text-destructive", children: error }) : null,
    /* @__PURE__ */ jsxs("div", { className: "flex gap-2", children: [
      /* @__PURE__ */ jsx(Button, { size: "sm", onClick: submit, children: existing ? "Apply changes" : "Add to draft" }),
      /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", onClick: onCancel, children: "Cancel" })
    ] })
  ] });
}
function CellValue({
  chain,
  mono,
  value,
  origin,
  note,
  ctx
}) {
  const text = chain ? chainName(value) : display(value);
  return /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1", children: [
    /* @__PURE__ */ jsx("span", { className: cn(mono && !chain ? "font-mono" : void 0), title: display(value), children: text }),
    origin && origin.tier === ctx.tier ? /* @__PURE__ */ jsx("span", { className: "h-1.5 w-1.5 rounded-full bg-primary", title: `${ACTION_HERE[origin.action]}` }) : null,
    note ? /* @__PURE__ */ jsx("span", { className: "h-1.5 w-1.5 rounded-full bg-amber-500", title: downstreamText(note, ctx.tierLabel) }) : null
  ] });
}
function ObjectField({ ctx, path, node, label, depth }) {
  const properties = node.properties ?? {};
  return (
    // `min-w-0`: a fieldset's default min-width is its content's, so a nested
    // one pushed the whole editor past a phone's width.
    /* @__PURE__ */ jsxs("fieldset", { className: "min-w-0 space-y-3 rounded-md border p-3", "data-testid": `field-${originPath(path)}`, children: [
      /* @__PURE__ */ jsx("legend", { className: "px-1 text-sm font-medium", children: label }),
      node.description ? /* @__PURE__ */ jsx(Help, { text: node.description }) : null,
      /* @__PURE__ */ jsx(FieldProblems, { problems: fieldProblems(ctx, originPath(path), false) }),
      /* @__PURE__ */ jsx(FieldList, { ctx, base: path, names: Object.keys(properties), nodes: properties, depth: depth + 1 })
    ] })
  );
}
function declaredSpecs(ctx) {
  const raw = getAt(ctx.definition, ["parameter_specs"]);
  if (!Array.isArray(raw)) return [];
  return raw.filter(
    (spec) => Boolean(spec) && typeof spec === "object" && typeof spec.name === "string"
  );
}
function ParametersField(props) {
  const { ctx, path, node, label } = props;
  const specs = declaredSpecs(ctx);
  if (!specs.length) return /* @__PURE__ */ jsx(JsonField, { ...props });
  return /* @__PURE__ */ jsx(
    FieldShell,
    {
      label,
      description: node.description,
      problems: fieldProblems(ctx, originPath(path), false),
      testId: `field-${originPath(path)}`,
      children: /* @__PURE__ */ jsx("div", { className: "divide-y rounded-md border", children: specs.map((spec) => /* @__PURE__ */ jsx(ParameterInput, { ctx, path: [...path, spec.name], spec }, spec.name)) })
    }
  );
}
function parameterNumber(value) {
  return Number.isInteger(value) ? String(value) : String(Number(value.toPrecision(4)));
}
function parameterText(value) {
  if (Array.isArray(value)) return value.map((v) => typeof v === "number" ? parameterNumber(v) : String(v)).join(", ");
  if (typeof value === "number") return parameterNumber(value);
  return value === null || value === void 0 ? "" : String(value);
}
function parameterLabel(name) {
  const words = name.split("_").filter(Boolean);
  const expanded = words.map(
    (w, i) => i === 0 && w === "min" ? "minimum" : i === 0 && w === "max" ? "maximum" : w === "sat" ? "(sat)" : w
  );
  const text = expanded.join(" ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}
function parseParameter(spec, text) {
  if (spec.kind === "integer_list") {
    const items = text.split(/[\s,]+/).filter(Boolean).map(Number);
    return items.every(Number.isInteger) ? items : void 0;
  }
  const n = Number(text);
  if (text.trim() === "" || !Number.isFinite(n)) return void 0;
  return spec.kind === "integer" && !Number.isInteger(n) ? void 0 : n;
}
function ParameterInput({
  ctx,
  path,
  spec
}) {
  const { key, value, origin, set, reset } = useScalarBinding({ ctx, path });
  const inForce = value === void 0 || value === null ? spec.default : value;
  const shown = parameterText(inForce);
  const [text, setText] = React26.useState(shown);
  React26.useEffect(() => setText(shown), [shown]);
  const problems = fieldProblems(ctx, key, false);
  const commit = () => {
    if (text === shown) return;
    const parsed = parseParameter(spec, text);
    if (parsed === void 0) setText(shown);
    else set(parsed);
  };
  const bounds = spec.minimum != null && spec.maximum != null ? ` \xB7 ${parameterNumber(spec.minimum)}\u2013${parameterNumber(spec.maximum)}` : spec.minimum != null ? ` \xB7 \u2265 ${parameterNumber(spec.minimum)}` : spec.maximum != null ? ` \xB7 \u2264 ${parameterNumber(spec.maximum)}` : "";
  return /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-1 px-3 py-2", "data-testid": `parameter-${spec.name}`, "data-invalid": problems.length ? true : void 0, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
      /* @__PURE__ */ jsx("span", { className: "text-sm font-medium text-foreground", children: parameterLabel(spec.name) }),
      /* @__PURE__ */ jsx("code", { className: "font-mono text-[11px] text-muted-foreground", children: spec.name }),
      /* @__PURE__ */ jsx(OriginBadge, { origin, tier: ctx.tier, tierLabel: ctx.tierLabel }),
      reset ? /* @__PURE__ */ jsx(Button, { variant: "link", size: "sm", className: "h-auto p-0 text-xs", onClick: reset, children: "Reset to inherited" }) : null
    ] }),
    spec.description ? /* @__PURE__ */ jsx(Help, { text: spec.description }) : null,
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
      spec.kind === "boolean" ? /* @__PURE__ */ jsxs(
        NativeSelect,
        {
          "aria-label": spec.name,
          className: "w-32",
          density: "sm",
          value: inForce === true ? "true" : "false",
          disabled: !ctx.canEdit,
          onChange: (event) => set(event.target.value === "true"),
          children: [
            /* @__PURE__ */ jsx("option", { value: "true", children: "Yes" }),
            /* @__PURE__ */ jsx("option", { value: "false", children: "No" })
          ]
        }
      ) : /* @__PURE__ */ jsx(
        Input,
        {
          "aria-label": spec.name,
          "aria-invalid": problems.length > 0 || void 0,
          className: cn(spec.kind === "integer_list" ? "w-72" : "w-32", "font-mono", problems.length > 0 && "border-destructive"),
          type: spec.kind === "integer_list" ? "text" : "number",
          step: spec.kind === "number" ? "any" : 1,
          min: spec.minimum ?? void 0,
          max: spec.maximum ?? void 0,
          value: text,
          disabled: !ctx.canEdit,
          onChange: (event) => setText(event.target.value),
          onBlur: commit,
          onKeyDown: (event) => {
            if (event.key === "Enter") commit();
          }
        }
      ),
      /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
        spec.unit ? `${spec.unit} \xB7 ` : "",
        "code default ",
        parameterText(spec.default),
        bounds
      ] })
    ] }),
    /* @__PURE__ */ jsx(FieldProblems, { problems }),
    /* @__PURE__ */ jsx(DownstreamLine, { ctx, path: key })
  ] });
}
function JsonField({ ctx, path, node, label }) {
  const key = originPath(path);
  const effective = getAt(ctx.definition, path);
  const own = getAt(ctx.draft, path);
  const [open, setOpen] = React26.useState(false);
  const [text, setText] = React26.useState(() => own === void 0 ? "" : JSON.stringify(own, null, 2));
  const [error, setError] = React26.useState(null);
  const empty = isEmptyValue(effective);
  return /* @__PURE__ */ jsxs(
    FieldShell,
    {
      label,
      description: node.description,
      badge: /* @__PURE__ */ jsx(OriginBadge, { origin: deepestOriginUnder(ctx.origins, key), tier: ctx.tier, tierLabel: ctx.tierLabel }),
      onReset: own !== void 0 && ctx.canEdit ? () => ctx.edit((patch) => unsetAt(patch, path)) : void 0,
      problems: fieldProblems(ctx, originPath(path), true),
      testId: `field-${key}`,
      children: [
        empty ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Not set." }) : /* @__PURE__ */ jsxs("details", { children: [
          /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground", children: "Value at this rung" }),
          /* @__PURE__ */ jsx("pre", { className: "mt-1 max-h-64 overflow-auto rounded-md bg-muted/40 p-2 text-[11px]", children: JSON.stringify(effective, null, 2) })
        ] }),
        /* @__PURE__ */ jsx(DownstreamLine, { ctx, path: key }),
        ctx.canEdit ? open ? /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx(
            Textarea,
            {
              "aria-label": `${label} \u2014 this rung's value`,
              className: "min-h-[8rem] font-mono text-xs",
              value: text,
              placeholder: "This rung's value, as JSON. It merges onto the inherited value.",
              onChange: (event) => {
                setText(event.target.value);
                setError(null);
              }
            }
          ),
          error ? /* @__PURE__ */ jsx("p", { className: "text-xs text-destructive", children: error }) : null,
          /* @__PURE__ */ jsxs("div", { className: "flex gap-2", children: [
            /* @__PURE__ */ jsx(
              Button,
              {
                size: "sm",
                variant: "outline",
                onClick: () => {
                  if (!text.trim()) {
                    ctx.edit((patch) => unsetAt(patch, path));
                    setOpen(false);
                    return;
                  }
                  try {
                    const parsed = JSON.parse(text);
                    ctx.edit((patch) => setAt(patch, path, parsed));
                    setOpen(false);
                  } catch (err) {
                    setError(`That isn't valid JSON: ${err.message}`);
                  }
                },
                children: "Apply"
              }
            ),
            /* @__PURE__ */ jsx(Button, { size: "sm", variant: "ghost", onClick: () => setOpen(false), children: "Cancel" })
          ] })
        ] }) : /* @__PURE__ */ jsx(Button, { variant: "link", size: "sm", className: "h-auto p-0 text-xs", onClick: () => setOpen(true), children: own === void 0 ? "Override at this rung\u2026" : "Edit this rung's value\u2026" }) : null
      ]
    }
  );
}
function asList(value) {
  return Array.isArray(value) ? value : [];
}
function pick(row, fields) {
  return Object.fromEntries(fields.map((f) => [f, row[f] ?? null]));
}
function changedFields(before, after, identity) {
  const out = {};
  for (const [field, value] of Object.entries(after)) {
    if (identity.includes(field)) continue;
    const prior = before[field] ?? null;
    if (JSON.stringify(prior) !== JSON.stringify(value)) out[field] = value;
  }
  return out;
}
function isEmptyValue(value) {
  if (value === null || value === void 0 || value === "") return true;
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.values(value).every(isEmptyValue);
  return false;
}
function chainValue(value) {
  if (typeof value !== "string" || !value || value === "*") return "";
  return toCanonicalChainId(value) ?? value;
}
function chainName(value) {
  if (value === "*") return "Any chain";
  return typeof value === "string" && value ? chainDisplayName(value) : display(value);
}
function describeEntry(entry, identity) {
  if (!entry || typeof entry !== "object") return display(entry);
  const row = entry;
  const parts = identity.map((name) => name === "chain_id" ? row[name] ? chainName(row[name]) : "" : display(row[name])).filter((v) => v && v !== "\u2014");
  return parts.join(" \xB7 ") || display(entry);
}
function display(value) {
  if (value === null || value === void 0 || value === "") return "\u2014";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}
var PREVIEW_DEBOUNCE_MS = 350;
var EMPTY_ORIGINS = { fields: {}, removed: [] };
var EMPTY_DOWNSTREAM = { fields: {}, added: [] };
function samePatch(a, b) {
  return stable(a) === stable(b);
}
function stable(value) {
  if (Array.isArray(value)) return `[${value.map(stable).join(",")}]`;
  if (value && typeof value === "object") {
    const entries = Object.entries(value).filter(([, v]) => v !== void 0).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0);
    return `{${entries.map(([k, v]) => `${JSON.stringify(k)}:${stable(v)}`).join(",")}}`;
  }
  return JSON.stringify(value ?? null);
}
function useProtocolEditor(source, protocolId, { allowedTiers, defaultTier, rungView = true } = {}) {
  const [schema, setSchema] = React26.useState(null);
  const [detail, setDetail] = React26.useState(null);
  const [status, setStatus] = React26.useState("loading");
  const [error, setError] = React26.useState(null);
  const [tick, setTick] = React26.useState(0);
  const [drafts, setDrafts] = React26.useState({});
  const [chosenTier, setChosenTier] = React26.useState(null);
  const [view, setView] = React26.useState(null);
  const [busy, setBusy] = React26.useState(false);
  React26.useEffect(() => {
    let live = true;
    setStatus((s) => s === "ready" ? s : "loading");
    Promise.all([source.schema(), source.get(protocolId)]).then(
      ([nextSchema, nextDetail]) => {
        if (!live) return;
        setSchema(nextSchema);
        setDetail(nextDetail);
        setView(null);
        setStatus("ready");
        setError(null);
      },
      (err) => {
        if (!live) return;
        setError(err);
        setStatus("error");
      }
    );
    return () => {
      live = false;
    };
  }, [source, protocolId, tick]);
  React26.useEffect(() => {
    setDrafts({});
    setView(null);
    setChosenTier(null);
  }, [source, protocolId]);
  const tiers = React26.useMemo(() => {
    const served = detail?.authorable_tiers ?? [...OVERRIDE_TIERS];
    return OVERRIDE_TIERS.filter(
      (t) => served.includes(t) && (!allowedTiers || allowedTiers.includes(t))
    );
  }, [detail, allowedTiers]);
  const tier = (chosenTier && tiers.includes(chosenTier) ? chosenTier : null) ?? (defaultTier && tiers.includes(defaultTier) ? defaultTier : null) ?? tiers[tiers.length - 1] ?? "tenant";
  const saved = React26.useMemo(
    () => ({ ...detail?.overrides?.[tier] ?? {} }),
    [detail, tier]
  );
  const draft = drafts[tier] ?? saved;
  const dirty = !samePatch(draft, saved);
  const viewKey = `${tier}|${stable(draft)}`;
  const wantView = status === "ready" && tiers.length > 0 && (rungView || dirty);
  React26.useEffect(() => {
    if (!wantView || view?.key === viewKey) return;
    let live = true;
    const timer = setTimeout(
      () => {
        source.preview(protocolId, tier, draft).then(
          (result) => {
            if (live) setView({ key: viewKey, tier, result });
          },
          (err) => {
            if (!live) return;
            setView({
              key: viewKey,
              tier,
              result: {
                protocol_id: protocolId,
                scope: tier,
                definition: detail?.definition ?? {},
                origins: detail?.origins ?? EMPTY_ORIGINS,
                applied: [],
                problems: [{ scope: tier, detail: err instanceof Error ? err.message : String(err) }]
              }
            });
          }
        );
      },
      // A rung just chosen is shown at once; an edit settles first.
      dirty ? PREVIEW_DEBOUNCE_MS : 0
    );
    return () => {
      live = false;
      clearTimeout(timer);
    };
  }, [source, protocolId, tier, viewKey, wantView, dirty]);
  const current = view?.key === viewKey ? view.result : null;
  const shown = current ?? (view?.tier === tier ? view.result : null);
  const definition = shown?.definition ?? detail?.definition ?? {};
  const origins = shown?.origins ?? detail?.origins ?? EMPTY_ORIGINS;
  const downstream = shown?.downstream ?? EMPTY_DOWNSTREAM;
  const problems = dirty ? current?.problems ?? [] : detail?.problems ?? [];
  const edit = React26.useCallback(
    (update) => setDrafts((all) => ({ ...all, [tier]: update(all[tier] ?? saved) })),
    [tier, saved]
  );
  const replaceDraft = React26.useCallback(
    (patch) => setDrafts((all) => ({ ...all, [tier]: patch })),
    [tier]
  );
  const discard = React26.useCallback(
    () => setDrafts((all) => {
      const { [tier]: _dropped, ...rest } = all;
      return rest;
    }),
    [tier]
  );
  const reload = React26.useCallback(() => setTick((n) => n + 1), []);
  const baseRevision = detail?.revisions ? detail.revisions[tier] ?? null : void 0;
  const run = React26.useCallback(
    async (kind, write) => {
      setBusy(true);
      try {
        await write();
        setDrafts((all) => {
          const { [tier]: _dropped, ...rest } = all;
          return rest;
        });
        setView(null);
        setTick((n) => n + 1);
        return { kind, tier };
      } finally {
        setBusy(false);
      }
    },
    [tier]
  );
  const save = React26.useCallback(async () => {
    if (Object.keys(draft).length === 0) {
      return run("cleared", () => source.clear(protocolId, tier, { baseRevision }));
    }
    const below = overriddenBelow(origins, downstream, tier);
    const change = await run("saved", () => source.save(protocolId, tier, draft, { baseRevision }));
    return { ...change, overriddenBelow: below };
  }, [run, source, protocolId, tier, draft, baseRevision, origins, downstream]);
  const clear = React26.useCallback(
    () => run("cleared", () => source.clear(protocolId, tier, { baseRevision })),
    [run, source, protocolId, tier, baseRevision]
  );
  return {
    status,
    error,
    schema,
    detail,
    tier,
    tiers,
    saved,
    draft,
    dirty,
    definition,
    origins,
    downstream,
    problems,
    previewing: dirty && !current,
    viewing: wantView && !dirty && !current,
    busy,
    setTier: setChosenTier,
    edit,
    replaceDraft,
    discard,
    save,
    clear,
    reload
  };
}
var DEFAULT_TIER_LABELS = {
  // The platform's own patch over the code definition — what every tenancy
  // inherits. A value no rung set is the CODE's.
  system: "Platform",
  customer: "Customer",
  org: "Organisation",
  tenant: "Tenant",
  user: "Personal"
};
var ALWAYS_OPEN = /* @__PURE__ */ new Set(["overview", "contracts", "detection"]);
function ProtocolDefinitionEditor({
  source,
  protocolId,
  allowedTiers,
  defaultTier,
  onDirtyChange,
  ...rest
}) {
  const state = useProtocolEditor(source, protocolId, {
    allowedTiers,
    defaultTier,
    rungView: rest.canAuthor
  });
  useDirtyReport(state.dirty, onDirtyChange);
  return /* @__PURE__ */ jsx(ProtocolEditorView, { state, protocolId, ...rest });
}
function useDirtyReport(dirty, onDirtyChange) {
  const report = React26.useRef(onDirtyChange);
  report.current = onDirtyChange;
  React26.useEffect(() => report.current?.(dirty), [dirty]);
  React26.useEffect(() => () => report.current?.(false), []);
}
function ProtocolEditorView({
  state,
  protocolId,
  canAuthor,
  canRemove = canAuthor,
  defaultShowEngineering = false,
  tierLabels,
  owner,
  onChanged,
  notice
}) {
  const [showEngineering, setShowEngineering] = React26.useState(defaultShowEngineering);
  const [confirmRemove, setConfirmRemove] = React26.useState(false);
  const [saveError, setSaveError] = React26.useState(null);
  const problemsRef = React26.useRef(null);
  const labels = { ...DEFAULT_TIER_LABELS, ...tierLabels };
  const tierLabel = (tier) => labels[tier] ?? tier;
  if (state.status === "loading" && !state.detail) {
    return /* @__PURE__ */ jsxs("p", { className: "text-sm text-muted-foreground", children: [
      "Loading ",
      protocolId,
      "\u2026"
    ] });
  }
  if (state.status === "error" || !state.detail || !state.schema) {
    return /* @__PURE__ */ jsxs("div", { role: "alert", className: "rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm text-destructive", children: [
      protocolId,
      " could not be loaded: ",
      errorText(state.error)
    ] });
  }
  const { detail, schema } = state;
  const canEdit = canAuthor && state.tiers.length > 0;
  const blocking = state.problems.filter((p) => p.scope === state.tier);
  const hasOverride = Object.keys(state.saved).length > 0;
  const removes = state.dirty && Object.keys(state.draft).length === 0;
  const keys = detail.confidence_keys;
  const ctx = {
    root: schema.schema,
    definition: state.definition,
    origins: state.origins,
    downstream: state.downstream,
    draft: state.draft,
    tier: state.tier,
    canEdit,
    edit: (update) => {
      setSaveError(null);
      state.edit(update);
    },
    tierLabel,
    keySuggestions: keys ? { "confidence.method_base": keys.method_base, "confidence.signal_deltas": keys.signal_deltas } : void 0,
    // Only this rung's, and only those that name a field: a finer rung's
    // problem is not this rung's to fix, and a whole-rung one has no field.
    problems: state.problems.filter((problem) => problem.scope === state.tier && problem.path)
  };
  const panels = schema.panels.filter((panel) => showEngineering || panel.audience === "everyone");
  const engineeringCount = schema.panels.filter((panel) => panel.audience === "engineering").length;
  const below = Object.keys(state.downstream.fields).length + state.downstream.added.length;
  const finerTiers = [
    .../* @__PURE__ */ new Set([
      ...Object.values(state.downstream.fields).map((n) => n.tier),
      ...state.downstream.added.map((a) => a.tier)
    ])
  ];
  const save = async () => {
    setSaveError(null);
    try {
      const change = await state.save();
      onChanged?.(change);
    } catch (err) {
      setSaveError(errorText(err));
    }
  };
  const status = !canEdit ? "Read only" : state.previewing ? "Checking\u2026" : state.viewing ? `Loading the ${tierLabel(state.tier)} view\u2026` : state.dirty ? "Unsaved changes \u2014 preview shown" : hasOverride ? "Saved" : "No override at this rung";
  return /* @__PURE__ */ jsxs("div", { className: "space-y-4", "data-testid": "protocol-editor", children: [
    /* @__PURE__ */ jsxs("header", { className: "space-y-1", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-baseline gap-2", children: [
        /* @__PURE__ */ jsx("h2", { className: "text-lg font-semibold", children: detail.display_name || protocolId }),
        /* @__PURE__ */ jsx("span", { className: "font-mono text-xs text-muted-foreground", children: protocolId }),
        detail.category ? /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "font-normal", children: detail.category }) : null
      ] }),
      /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: detail.override_scopes?.length ? `Overridden at ${detail.override_scopes.map(tierLabel).join(" and ")}; the most specific wins.` : "Using the definition the code ships \u2014 nothing overrides it." }),
      detail.explanation?.length ? /* @__PURE__ */ jsxs("details", { className: "text-xs", children: [
        /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-muted-foreground", children: "How this definition resolved" }),
        /* @__PURE__ */ jsx("ul", { className: "mt-1 list-inside list-disc space-y-0.5 text-muted-foreground", children: detail.explanation.map((line, i) => /* @__PURE__ */ jsx("li", { children: line }, i)) })
      ] }) : null
    ] }),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "sticky top-0 z-10 flex flex-wrap items-center gap-3 rounded-md border bg-background/95 p-3 shadow-sm backdrop-blur supports-[backdrop-filter]:bg-background/80",
        "data-testid": "save-bar",
        children: [
          /* @__PURE__ */ jsxs("label", { className: "flex items-center gap-2 text-sm", children: [
            /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "Editing" }),
            /* @__PURE__ */ jsx(
              NativeSelect,
              {
                "aria-label": "Rung being edited",
                density: "sm",
                className: "w-auto",
                value: state.tier,
                disabled: !canEdit || state.dirty || state.tiers.length < 2,
                title: state.dirty ? "Save or discard this rung's changes first" : void 0,
                onChange: (event) => state.setTier(event.target.value),
                children: (state.tiers.length ? state.tiers : [state.tier]).map((tier) => /* @__PURE__ */ jsxs("option", { value: tier, children: [
                  tierLabel(tier),
                  detail.overrides?.[tier] ? " \xB7 has override" : " \xB7 inherits"
                ] }, tier))
              }
            )
          ] }),
          /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", "data-testid": "draft-status", children: status }),
          state.problems.length ? /* @__PURE__ */ jsxs(
            Button,
            {
              variant: "link",
              size: "sm",
              className: "h-auto p-0 text-xs text-destructive",
              onClick: () => problemsRef.current?.scrollIntoView({ behavior: "smooth", block: "center" }),
              "data-testid": "problem-count",
              children: [
                state.problems.length,
                " problem",
                state.problems.length === 1 ? "" : "s"
              ]
            }
          ) : null,
          /* @__PURE__ */ jsxs("div", { className: "ml-auto flex gap-2", children: [
            state.dirty ? /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: state.discard, disabled: state.busy, children: "Discard" }) : null,
            canEdit && canRemove && hasOverride && !state.dirty ? /* @__PURE__ */ jsx(Button, { variant: "outline", size: "sm", onClick: () => setConfirmRemove(true), disabled: state.busy, children: "Remove override" }) : null,
            canEdit ? /* @__PURE__ */ jsx(
              Button,
              {
                size: "sm",
                onClick: () => void save(),
                disabled: !state.dirty || state.busy || state.previewing || blocking.length > 0 || removes && !canRemove,
                title: blocking.length ? "Fix the problems below first" : removes && !canRemove ? "This draft removes the override, which you may not do" : void 0,
                children: "Save"
              }
            ) : null
          ] })
        ]
      }
    ),
    notice,
    canEdit && below ? /* @__PURE__ */ jsxs("p", { className: "text-xs text-amber-700 dark:text-amber-400", "data-testid": "downstream-summary", children: [
      "You are editing the ",
      tierLabel(state.tier),
      " rung. ",
      finerTiers.map(tierLabel).join(" and "),
      " ",
      finerTiers.length === 1 ? "changes" : "change",
      " ",
      below,
      " thing",
      below === 1 ? "" : "s",
      " on top of it \u2014 marked where they apply. Runs at ",
      finerTiers.map(tierLabel).join(" or "),
      " use those."
    ] }) : null,
    saveError ? /* @__PURE__ */ jsxs("div", { role: "alert", className: "space-y-2 rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm text-destructive", children: [
      /* @__PURE__ */ jsx("p", { children: saveError }),
      /conflict|changed after you opened it/i.test(saveError) ? /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-2", children: [
        /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            variant: "outline",
            onClick: () => {
              setSaveError(null);
              state.discard();
              state.reload();
            },
            children: "Reload and discard my changes"
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            variant: "ghost",
            onClick: () => {
              setSaveError(null);
              state.reload();
            },
            title: "Your draft stays; saving it replaces what is stored now",
            children: "Reload, keep my draft"
          }
        )
      ] }) : null
    ] }) : null,
    state.problems.length ? /* @__PURE__ */ jsxs(
      "div",
      {
        ref: problemsRef,
        role: "alert",
        className: "space-y-1 rounded-md border border-destructive/40 bg-destructive/5 p-3 text-sm",
        "data-testid": "problems",
        children: [
          /* @__PURE__ */ jsx("p", { className: "font-medium text-destructive", children: state.dirty ? "This draft can't be saved as it is:" : "An override is stored but not in use:" }),
          /* @__PURE__ */ jsx("ul", { className: "list-disc pl-5 text-xs text-destructive", children: state.problems.map((problem, i) => /* @__PURE__ */ jsxs("li", { children: [
            tierLabel(problem.scope),
            ": ",
            problemLine(problem),
            problem.path && problem.scope === state.tier ? /* @__PURE__ */ jsxs(Fragment, { children: [
              " ",
              /* @__PURE__ */ jsx(
                "button",
                {
                  type: "button",
                  className: "underline underline-offset-2",
                  onClick: () => showField(problem.path),
                  children: "Show"
                }
              )
            ] }) : null
          ] }, i)) })
        ]
      }
    ) : null,
    detail.warnings?.length ? /* @__PURE__ */ jsx("ul", { className: "space-y-0.5 rounded-md border border-amber-500/40 bg-amber-500/5 p-3 text-xs text-amber-700 dark:text-amber-400", children: detail.warnings.map((w, i) => /* @__PURE__ */ jsxs("li", { children: [
      tierLabel(w.scope),
      ": ",
      w.detail
    ] }, i)) }) : null,
    /* @__PURE__ */ jsx("div", { className: state.viewing ? "space-y-3 opacity-60 transition-opacity" : "space-y-3", children: panels.map((panel) => /* @__PURE__ */ jsx(PanelSection, { panel, ctx, state }, panel.id)) }),
    engineeringCount ? /* @__PURE__ */ jsx(Button, { variant: "link", size: "sm", className: "h-auto p-0", onClick: () => setShowEngineering((v) => !v), children: showEngineering ? "Hide engineering settings" : `Show engineering settings (${engineeringCount})` }) : null,
    /* @__PURE__ */ jsxs("details", { className: "text-xs", children: [
      /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-muted-foreground", children: canEdit ? `The ${tierLabel(state.tier)} view as JSON` : "Resolved definition (JSON)" }),
      /* @__PURE__ */ jsx("pre", { className: "mt-2 max-h-96 overflow-auto rounded-md bg-muted/40 p-3 text-[11px]", children: JSON.stringify(state.definition, null, 2) })
    ] }),
    /* @__PURE__ */ jsx(AlertDialog, { open: confirmRemove, onOpenChange: setConfirmRemove, children: /* @__PURE__ */ jsxs(AlertDialogContent, { children: [
      /* @__PURE__ */ jsxs(AlertDialogHeader, { children: [
        /* @__PURE__ */ jsxs(AlertDialogTitle, { children: [
          "Remove ",
          owner ? `${owner}'s ` : "the ",
          tierLabel(state.tier),
          " override for ",
          detail.display_name || protocolId,
          "?"
        ] }),
        /* @__PURE__ */ jsx(AlertDialogDescription, { children: "Everything this rung sets is dropped and it inherits again. New runs decode with the result; transactions already processed keep theirs until rerun." })
      ] }),
      /* @__PURE__ */ jsxs(AlertDialogFooter, { children: [
        /* @__PURE__ */ jsx(AlertDialogCancel, { children: "Keep it" }),
        /* @__PURE__ */ jsx(
          AlertDialogAction,
          {
            onClick: () => {
              void state.clear().then((change) => onChanged?.(change), (err) => setSaveError(errorText(err)));
            },
            children: "Remove override"
          }
        )
      ] })
    ] }) })
  ] });
}
function PanelSection({
  panel,
  ctx: baseCtx,
  state
}) {
  const ctx = { ...baseCtx, primary: new Set(panel.primary ?? []) };
  const used = panel.fields.some((field) => fieldInUse(baseCtx, [field], ctx.root.properties[field]));
  const counts = originCounts(ctx.origins, panel.fields);
  const removed = removedUnder(ctx.origins, panel.fields);
  const below = downstreamUnder(ctx.downstream, panel.fields);
  const problemCount = problemsUnder(ctx.problems, panel.fields);
  const setHere = counts[ctx.tier] ?? 0;
  const inherited = Object.entries(counts).filter(([tier]) => tier !== ctx.tier).reduce((sum, [, n]) => sum + n, 0);
  const [open, setOpen] = React26.useState(() => used || ALWAYS_OPEN.has(panel.id) || setHere > 0);
  React26.useEffect(() => {
    if (problemCount > 0) setOpen(true);
  }, [problemCount]);
  const [json, setJson] = React26.useState(false);
  const only = panel.fields.length === 1 ? panel.fields[0] : null;
  const single = only && fieldKind(ctx.root, ctx.root.properties[only]) === "object" ? { name: only, properties: resolveNode(ctx.root, ctx.root.properties[only]).node.properties ?? {} } : null;
  return /* @__PURE__ */ jsxs("section", { className: "rounded-lg border", "data-testid": `panel-${panel.id}`, "data-open": open, children: [
    /* @__PURE__ */ jsxs(
      "button",
      {
        type: "button",
        className: "flex w-full items-start justify-between gap-3 px-4 py-3 text-left",
        "aria-expanded": open,
        onClick: () => setOpen((v) => !v),
        children: [
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
              /* @__PURE__ */ jsx("span", { className: "font-medium", children: panel.title }),
              panel.audience === "engineering" ? /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "h-5 px-1.5 text-[10px] font-normal", children: "Engineering" }) : null,
              setHere ? /* @__PURE__ */ jsxs(Badge, { className: "h-5 px-1.5 text-[10px] font-normal", children: [
                setHere,
                " set here"
              ] }) : null,
              inherited ? /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "h-5 px-1.5 text-[10px] font-normal", children: [
                inherited,
                " inherited"
              ] }) : null,
              removed.length ? /* @__PURE__ */ jsxs(Badge, { variant: "outline", className: "h-5 px-1.5 text-[10px] font-normal text-destructive", children: [
                removed.length,
                " removed"
              ] }) : null,
              below ? /* @__PURE__ */ jsxs(
                Badge,
                {
                  variant: "outline",
                  className: "h-5 border-amber-500/50 px-1.5 text-[10px] font-normal text-amber-700 dark:text-amber-400",
                  children: [
                    below,
                    " changed below"
                  ]
                }
              ) : null,
              problemCount ? /* @__PURE__ */ jsxs(
                Badge,
                {
                  variant: "outline",
                  className: "h-5 border-destructive/50 px-1.5 text-[10px] font-normal text-destructive",
                  "data-testid": "panel-problems",
                  children: [
                    problemCount,
                    " problem",
                    problemCount === 1 ? "" : "s"
                  ]
                }
              ) : null,
              !used ? /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: "not used by this protocol" }) : null
            ] }),
            /* @__PURE__ */ jsx("p", { className: "mt-0.5 text-xs text-muted-foreground", children: panel.description })
          ] }),
          /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: "text-muted-foreground", children: open ? "\u2212" : "+" })
        ]
      }
    ),
    open ? /* @__PURE__ */ jsxs("div", { className: "space-y-4 border-t px-4 py-3", children: [
      ctx.canEdit ? /* @__PURE__ */ jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ jsx(Button, { variant: "link", size: "sm", className: "h-auto p-0 text-xs", onClick: () => setJson((v) => !v), children: json ? "Back to the form" : "Edit this panel as JSON" }) }) : null,
      panel.id === "confidence" && state.detail?.confidence_keys ? /* @__PURE__ */ jsx(ConfidenceKeys, { keys: state.detail.confidence_keys }) : null,
      json ? /* @__PURE__ */ jsx(PanelJson, { panel, state }) : single ? (
        // One group in the panel: its fields ARE the panel — a "Confidence"
        // fieldset inside the "Confidence" panel only added a frame.
        /* @__PURE__ */ jsx(FieldList, { ctx, base: [single.name], names: Object.keys(single.properties), nodes: single.properties })
      ) : /* @__PURE__ */ jsx(FieldList, { ctx, base: [], names: panel.fields, nodes: ctx.root.properties })
    ] }) : null
  ] });
}
function ConfidenceKeys({ keys }) {
  return /* @__PURE__ */ jsxs("details", { className: "rounded-md border p-3 text-xs", "data-testid": "confidence-keys", children: [
    /* @__PURE__ */ jsx("summary", { className: "cursor-pointer font-medium", children: "Available scoring keys" }),
    /* @__PURE__ */ jsx("p", { className: "mt-2 text-muted-foreground", children: "Method bases range from 0 to 1; signal deltas from \u22121 to 1." }),
    ["method_base", "signal_deltas"].map((channel) => /* @__PURE__ */ jsxs("p", { className: "mt-1 break-words", children: [
      /* @__PURE__ */ jsx("span", { className: "font-mono", children: channel }),
      ": ",
      keys[channel].join(", ") || "none declared"
    ] }, channel))
  ] });
}
function PanelJson({ panel, state }) {
  const slice = sliceOf(state.draft, panel.fields);
  const [text, setText] = React26.useState(() => JSON.stringify(slice, null, 2));
  const [error, setError] = React26.useState(null);
  return /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
    /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
      "This rung's patch for ",
      panel.title.toLowerCase(),
      ". Keyed entries merge onto the inherited ones; add",
      ' "$patch": "delete"',
      " to remove one, or ",
      '"$deleteFromPrimitiveList/<field>"',
      " beside a list to remove values."
    ] }),
    /* @__PURE__ */ jsx(
      Textarea,
      {
        "aria-label": `${panel.title} patch as JSON`,
        className: "min-h-[12rem] font-mono text-xs",
        value: text,
        onChange: (event) => {
          setText(event.target.value);
          setError(null);
        }
      }
    ),
    error ? /* @__PURE__ */ jsx("p", { className: "text-xs text-destructive", children: error }) : null,
    /* @__PURE__ */ jsx(
      Button,
      {
        size: "sm",
        variant: "outline",
        onClick: () => {
          try {
            const parsed = text.trim() ? JSON.parse(text) : {};
            if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
              setError("A patch is an object of definition fields.");
              return;
            }
            const outside = Object.keys(parsed).filter(
              (key) => !panel.fields.some((f) => key === f || key === `$deleteFromPrimitiveList/${f}`)
            );
            if (outside.length) {
              setError(`${outside.join(", ")} ${outside.length === 1 ? "belongs" : "belong"} to another panel.`);
              return;
            }
            state.replaceDraft(withSlice(state.draft, panel.fields, parsed));
          } catch (err) {
            setError(`That isn't valid JSON: ${err.message}`);
          }
        },
        children: "Apply to draft"
      }
    )
  ] });
}
function problemText(detail) {
  return detail.split("\n").map((line) => line.trim()).filter((line) => line && !line.startsWith("For further information visit")).join(" \u2014 ");
}
function problemLine(problem) {
  const text = problemText(problem.detail);
  const path = problem.path ?? "";
  if (!path.startsWith("parameters.")) return text;
  return `${parameterLabel(path.slice("parameters.".length))}: ${problemTextAt(text, path)}`;
}
function showField(path) {
  const parts = path.split(".");
  for (let depth = parts.length; depth > 0; depth -= 1) {
    const element = document.querySelector(`[data-testid="field-${CSS.escape(parts.slice(0, depth).join("."))}"]`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
      const focusable = element.querySelector("input, select, textarea, button");
      focusable?.focus({ preventScroll: true });
      return;
    }
  }
}
function errorText(error) {
  return error instanceof Error ? error.message : String(error ?? "unknown error");
}
var ACTION_ICONS = {
  exclude: ShieldOff,
  pin: Pin,
  detach: Scissors
};
var ACTION_EFFECTS = {
  exclude: "Holds this address out of clustering everywhere, the way a router or an exchange wallet is held out. For shared infrastructure \u2014 not for one wrong link.",
  pin: "Adds the member address to the identity of the address in view. This is an analyst judgment, not evidence of common ownership, and it carries no computed strength.",
  detach: "Removes the member address from the identity of the address in view only. It stays eligible for every other identity \u2014 that is the difference from \u201CNever cluster\u201D."
};
var SCOPE_EFFECTS = {
  system: "Everyone on the platform.",
  customer: "Everyone in every org and tenant under this customer.",
  org: "Everyone in every tenant in this org.",
  tenant: "Everyone in this tenant.",
  team: "Members of the team you choose.",
  user: "You alone \u2014 nobody else sees it."
};
var SCOPE_AUDIENCE = {
  system: "everyone on the platform",
  customer: "everyone under this customer",
  org: "everyone in this org",
  tenant: "everyone in this tenant",
  team: "that team's members",
  user: "you alone"
};
var NO_TEAMS = [];
function sameAddress(a, b) {
  const chainA = toCanonicalChainId(a.chainId) ?? a.chainId;
  const chainB = toCanonicalChainId(b.chainId) ?? b.chainId;
  return chainA === chainB && normalizeAddress(a.address.trim(), chainA) === normalizeAddress(b.address.trim(), chainB);
}
function ClusterOverridesPanel({
  overrides,
  isLoading = false,
  error,
  canEdit = false,
  peer = null,
  chainId,
  address,
  allowedScopes = CLUSTER_OVERRIDE_AUTHORING_SCOPES,
  teams = NO_TEAMS,
  applied,
  onSave,
  onRemove,
  isSaving = false
}) {
  const teamKey = teams.map((team) => team.id).join(",");
  const offeredScopes = React26.useMemo(
    () => allowedScopes.filter((value) => value !== "team" || teamKey !== ""),
    [allowedScopes, teamKey]
  );
  const defaultScope = offeredScopes.includes("tenant") ? "tenant" : offeredScopes[0] ?? "tenant";
  const [action, setAction] = React26.useState("exclude");
  const [scope, setScope] = React26.useState(defaultScope);
  const [teamId, setTeamId] = React26.useState("");
  const chosenTeam = teamId || (teams[0]?.id ?? "");
  const [reason, setReason] = React26.useState("");
  const [editing, setEditing] = React26.useState(null);
  const [failure, setFailure] = React26.useState(null);
  const [removeFailure, setRemoveFailure] = React26.useState(null);
  const [confirming, setConfirming] = React26.useState(null);
  const [memberAddress, setMemberAddress] = React26.useState(address);
  const [memberChain, setMemberChain] = React26.useState(chainId);
  const [notice, setNotice] = React26.useState(null);
  const [pending, setPending] = React26.useState(false);
  const inFlight = React26.useRef(false);
  const formId = React26.useId();
  const busy = isSaving || pending;
  const writable = (row) => canEdit && row.can_edit !== false && row.scope !== "system" && allowedScopes.includes(row.scope);
  const teamName = (id) => teams.find((team) => team.id === id)?.name ?? null;
  const appliedSet = React26.useMemo(
    () => applied ? new Set(applied) : null,
    [applied]
  );
  const ordered = React26.useMemo(
    () => [...overrides].sort(
      (a, b) => (CLUSTER_OVERRIDE_SCOPE_RANK[b.scope] ?? 0) - (CLUSTER_OVERRIDE_SCOPE_RANK[a.scope] ?? 0) || (b.updated_at ?? 0) - (a.updated_at ?? 0) || (a.id < b.id ? 1 : a.id > b.id ? -1 : 0)
    ),
    [overrides]
  );
  const withdraw = React26.useCallback(
    async (overrideSk) => {
      if (inFlight.current || busy) return;
      inFlight.current = true;
      setPending(true);
      setRemoveFailure(null);
      try {
        if (await onRemove(overrideSk) === false) throw new Error("The correction was not withdrawn. Reload and try again.");
        setNotice(
          "Correction withdrawn. It stops applying from the next read; a correction on a wider rung may apply again."
        );
      } catch (err) {
        setRemoveFailure(
          err instanceof Error && err.message ? `Could not withdraw the correction: ${err.message}` : "Could not withdraw the correction. It is still in force."
        );
      } finally {
        inFlight.current = false;
        setPending(false);
      }
    },
    [onRemove, busy]
  );
  const reset = React26.useCallback(() => {
    setEditing(null);
    setReason("");
    setFailure(null);
    setAction("exclude");
    setMemberAddress(address);
    setMemberChain(chainId);
    setScope(defaultScope);
    setTeamId("");
  }, [address, chainId, defaultScope]);
  const peerChain = peer?.chainId ?? "";
  const peerAddress = peer?.address ?? "";
  React26.useEffect(() => {
    reset();
    setConfirming(null);
    setRemoveFailure(null);
    setNotice(null);
  }, [reset, peerChain, peerAddress]);
  const beginEdit = React26.useCallback((row) => {
    setEditing(row);
    setAction(row.action);
    setScope(row.scope);
    setTeamId(row.team_id ?? "");
    setReason(row.reason);
    setMemberAddress(row.address);
    setMemberChain(row.chain_id);
    setFailure(null);
    setConfirming(null);
  }, []);
  const targetPeer = React26.useMemo(
    () => editing?.peer_address ? { chainId: editing.peer_chain_id ?? editing.chain_id, address: editing.peer_address } : peerAddress ? { chainId: peerChain, address: peerAddress } : null,
    [editing, peerChain, peerAddress]
  );
  const validMember = Boolean(toCanonicalChainId(memberChain)) && isValidAddress(memberAddress.trim(), memberChain);
  const selfTarget = overrideNeedsPeer(action) && targetPeer !== null && validMember && sameAddress(targetPeer, { chainId: memberChain, address: memberAddress });
  const blocked = overrideNeedsPeer(action) && (!targetPeer || selfTarget);
  const teamValid = scope !== "team" || teams.some((team) => team.id === chosenTeam);
  const canSubmit = canEdit && offeredScopes.includes(scope) && teamValid && !blocked && validMember && reason.trim().length > 0 && !busy && !isLoading && !error && (!editing || writable(editing));
  const submit = React26.useCallback(async () => {
    if (!canSubmit || inFlight.current) return;
    inFlight.current = true;
    setPending(true);
    setFailure(null);
    const needsPeer = overrideNeedsPeer(action);
    try {
      const reply = await onSave({
        action,
        scope,
        peer_chain_id: needsPeer && targetPeer ? toCanonicalChainId(targetPeer.chainId) ?? targetPeer.chainId : null,
        peer_address: needsPeer && targetPeer ? targetPeer.address.trim() : null,
        team_id: scope === "team" ? chosenTeam : null,
        address: memberAddress.trim(),
        chain_id: toCanonicalChainId(memberChain) ?? memberChain,
        reason: reason.trim(),
        // The row being replaced, so the backend can remove it where it used to
        // live: the sort key carries the rung and the owner, and the partition
        // carries the rung's reach, so an edit that changes the rung writes a
        // DIFFERENT key. Without this the original stays in force beside it.
        replaces: editing?.override_sk ?? null,
        ...editing ? { expected_updated_at: editing.updated_at ?? null } : {}
      });
      const queued = typeof reply?.analysis_queued === "string";
      reset();
      setNotice(
        "Correction saved. It applies from the next read for the people it reaches; the shared analysis is unchanged." + (queued ? " Nobody had analysed the pinned address, so its analysis was queued." : "")
      );
    } catch (err) {
      setFailure(err instanceof Error ? err.message : "Could not save the correction.");
    } finally {
      inFlight.current = false;
      setPending(false);
    }
  }, [canSubmit, action, scope, chosenTeam, targetPeer, memberAddress, memberChain, editing, onSave, reason, reset]);
  return /* @__PURE__ */ jsxs(Card, { children: [
    /* @__PURE__ */ jsxs(CardHeader, { children: [
      /* @__PURE__ */ jsxs(CardTitle, { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(ShieldOff, { className: "h-4 w-4", "aria-hidden": true }),
        "Corrections"
      ] }),
      /* @__PURE__ */ jsxs("p", { className: "text-sm text-muted-foreground", children: [
        "Analyst decisions about who this address is. The analysis itself is shared and never changes; a correction changes what the people it reaches see \u2014 only you, your team, or everyone in your tenant, org or customer \u2014 from their",
        " ",
        /* @__PURE__ */ jsx("strong", { children: "next read" }),
        ". No run is needed. Corrections apply coarsest rung first, so the narrower rung has the last word."
      ] })
    ] }),
    /* @__PURE__ */ jsxs(CardContent, { className: "space-y-4", children: [
      isLoading ? /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: "Reading corrections\u2026" }) : error ? /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: "Could not read the corrections. The answer above may or may not already have one applied." }) : overrides.length === 0 ? /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: "No corrections. What you see is the engine's own answer." }) : /* @__PURE__ */ jsx("ul", { className: "space-y-2", "data-testid": "cluster-override-rows", children: ordered.map((row) => {
        const Icon = ACTION_ICONS[row.action];
        const team = row.scope === "team" ? teamName(row.team_id) : null;
        return /* @__PURE__ */ jsxs(
          "li",
          {
            className: "flex items-start justify-between gap-3 rounded-md border p-3",
            children: [
              /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-1", children: [
                /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
                  /* @__PURE__ */ jsx(Icon, { className: "h-4 w-4 shrink-0", "aria-hidden": true }),
                  /* @__PURE__ */ jsx("span", { className: "font-medium", children: CLUSTER_OVERRIDE_ACTION_LABELS[row.action] }),
                  /* @__PURE__ */ jsxs(Badge, { variant: "outline", title: SCOPE_EFFECTS[row.scope], children: [
                    CLUSTER_OVERRIDE_SCOPE_LABELS[row.scope] ?? row.scope,
                    team ? ` \xB7 ${team}` : ""
                  ] }),
                  !row.enabled ? /* @__PURE__ */ jsx(Badge, { variant: "outline", children: "disabled" }) : appliedSet ? appliedSet.has(row.override_sk) ? /* @__PURE__ */ jsx(Badge, { title: "This correction changed what you are shown for this address.", children: "applied" }) : /* @__PURE__ */ jsx(
                    Badge,
                    {
                      variant: "outline",
                      title: "It changed nothing in what you see here: the answer already agreed with it, or a narrower or newer correction had the last word.",
                      children: "no effect here"
                    }
                  ) : null
                ] }),
                /* @__PURE__ */ jsxs("div", { className: "text-sm text-muted-foreground", children: [
                  /* @__PURE__ */ jsx(AddressDisplay, { address: row.address, chain: row.chain_id }),
                  row.peer_address ? /* @__PURE__ */ jsxs(Fragment, { children: [
                    " \xB7 identity of ",
                    /* @__PURE__ */ jsx(AddressDisplay, { address: row.peer_address, chain: row.peer_chain_id ?? row.chain_id })
                  ] }) : null
                ] }),
                /* @__PURE__ */ jsx("p", { className: "text-sm", children: row.reason }),
                /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
                  /* @__PURE__ */ jsx(ActorName, { id: row.updated_by ?? row.created_by }),
                  authoredAt(row) ? /* @__PURE__ */ jsxs("span", { title: formatTimestamp(authoredAt(row)), children: [
                    " \xB7 ",
                    formatRelativeTime(authoredAt(row)),
                    wasEdited(row) ? " (edited)" : ""
                  ] }) : null
                ] })
              ] }),
              writable(row) ? /* @__PURE__ */ jsxs("div", { className: "flex shrink-0 gap-1", children: [
                /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    disabled: busy,
                    onClick: () => beginEdit(row),
                    "aria-label": "Edit this correction",
                    children: /* @__PURE__ */ jsx(Pencil, { className: "h-4 w-4", "aria-hidden": true })
                  }
                ),
                confirming === row.override_sk ? /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "destructive",
                    size: "sm",
                    disabled: busy,
                    onClick: () => {
                      setConfirming(null);
                      void withdraw(row.override_sk);
                    },
                    "aria-label": "Confirm withdrawal of this correction",
                    children: "Withdraw?"
                  }
                ) : /* @__PURE__ */ jsx(
                  Button,
                  {
                    variant: "ghost",
                    size: "sm",
                    disabled: busy,
                    onClick: () => setConfirming(row.override_sk),
                    "aria-label": "Withdraw this correction",
                    children: /* @__PURE__ */ jsx(Trash2, { className: "h-4 w-4", "aria-hidden": true })
                  }
                )
              ] }) : null
            ]
          },
          row.override_sk
        );
      }) }),
      removeFailure ? /* @__PURE__ */ jsx("p", { className: "text-sm text-destructive", role: "alert", children: removeFailure }) : null,
      notice ? /* @__PURE__ */ jsx("p", { role: "status", className: "text-sm", children: notice }) : null,
      canEdit && offeredScopes.length > 0 ? /* @__PURE__ */ jsxs("div", { className: "space-y-3 rounded-md border p-3", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", children: editing ? "Edit correction" : "Record a correction" }),
          editing ? /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: reset, "aria-label": "Cancel edit", children: /* @__PURE__ */ jsx(X, { className: "h-4 w-4", "aria-hidden": true }) }) : null
        ] }),
        /* @__PURE__ */ jsx("div", { className: "flex flex-wrap gap-2", children: Object.keys(CLUSTER_OVERRIDE_ACTION_LABELS).map(
          (value) => /* @__PURE__ */ jsx(
            Button,
            {
              size: "sm",
              variant: action === value ? "default" : "outline",
              onClick: () => setAction(value),
              disabled: busy || overrideNeedsPeer(value) && !targetPeer,
              title: overrideNeedsPeer(value) && !targetPeer ? "No address is in view, so there is no identity to act on." : void 0,
              children: CLUSTER_OVERRIDE_ACTION_LABELS[value]
            },
            value
          )
        ) }),
        /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: ACTION_EFFECTS[action] }),
        !targetPeer ? (
          // Two disabled buttons with no reason read as a broken control. The
          // reason is not a missing permission — pin and remove act on the
          // identity of an address, and none was given.
          /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Pin and Remove act on the identity of the address in view, and there is none. Open an address to add a member to its identity or take one out." })
        ) : null,
        /* @__PURE__ */ jsx("label", { className: "block text-sm font-medium", htmlFor: `${formId}-chain`, children: "Member chain" }),
        /* @__PURE__ */ jsx("input", { id: `${formId}-chain`, className: "w-full rounded-md border p-2 text-sm", value: memberChain, disabled: Boolean(editing) || busy, onChange: (e) => setMemberChain(e.target.value) }),
        /* @__PURE__ */ jsx("label", { className: "block text-sm font-medium", htmlFor: `${formId}-address`, children: "Member address" }),
        /* @__PURE__ */ jsx("input", { id: `${formId}-address`, className: "w-full rounded-md border p-2 text-sm", value: memberAddress, disabled: Boolean(editing) || busy, onChange: (e) => setMemberAddress(e.target.value) }),
        !validMember ? /* @__PURE__ */ jsx("p", { role: "alert", className: "text-sm text-destructive", children: "Enter a valid address for the selected chain." }) : null,
        overrideNeedsPeer(action) && targetPeer ? /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
          "Identity of: ",
          /* @__PURE__ */ jsx(AddressDisplay, { address: targetPeer.address, chain: targetPeer.chainId })
        ] }) : null,
        selfTarget ? /* @__PURE__ */ jsx("p", { role: "alert", className: "text-sm text-destructive", children: "Pin and Remove act on another address: enter the member to add to, or take out of, this address's identity." }) : null,
        /* @__PURE__ */ jsx("label", { className: "block text-sm font-medium", htmlFor: `${formId}-scope`, children: "Who sees it" }),
        /* @__PURE__ */ jsx(
          NativeSelect,
          {
            id: `${formId}-scope`,
            disabled: busy,
            value: scope,
            onChange: (e) => setScope(e.target.value),
            children: offeredScopes.map((value) => /* @__PURE__ */ jsxs("option", { value, children: [
              CLUSTER_OVERRIDE_SCOPE_LABELS[value],
              " \u2014 ",
              SCOPE_EFFECTS[value]
            ] }, value))
          }
        ),
        scope === "team" && teams.length > 0 ? /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx("label", { className: "block text-sm font-medium", htmlFor: `${formId}-team`, children: "Team" }),
          /* @__PURE__ */ jsx(
            NativeSelect,
            {
              id: `${formId}-team`,
              disabled: busy,
              value: chosenTeam,
              onChange: (e) => setTeamId(e.target.value),
              children: teams.map((team) => /* @__PURE__ */ jsx("option", { value: team.id, children: team.name || team.id }, team.id))
            }
          )
        ] }) : null,
        scope === "team" && !teamValid ? /* @__PURE__ */ jsx("p", { role: "alert", className: "text-sm text-destructive", children: "Choose one of your teams. A team correction reaches that team's members only." }) : null,
        /* @__PURE__ */ jsx("label", { className: "block text-sm font-medium", htmlFor: `${formId}-reason`, children: "Why" }),
        /* @__PURE__ */ jsx(
          "textarea",
          {
            id: `${formId}-reason`,
            disabled: busy,
            className: "w-full rounded-md border p-2 text-sm",
            rows: 2,
            value: reason,
            onChange: (e) => setReason(e.target.value),
            placeholder: "What did you check, and what did it show?"
          }
        ),
        /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Required. A correction with no stated reason cannot be reviewed later." }),
        failure ? /* @__PURE__ */ jsx("p", { className: "text-sm text-destructive", children: failure }) : null,
        /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx(Button, { size: "sm", disabled: !canSubmit, onClick: () => void submit(), children: busy ? "Saving\u2026" : editing ? "Save changes" : "Record correction" }),
          /* @__PURE__ */ jsxs("span", { className: "text-xs text-muted-foreground", children: [
            "Applies from the next read of",
            " ",
            /* @__PURE__ */ jsx(AddressDisplay, { address: memberAddress, chain: memberChain }),
            ", for",
            " ",
            SCOPE_AUDIENCE[scope],
            "."
          ] })
        ] })
      ] }) : null
    ] })
  ] });
}
function authoredAt(row) {
  return row.updated_at ?? row.created_at ?? null;
}
function wasEdited(row) {
  return Boolean(row.updated_at && row.created_at && row.updated_at > row.created_at);
}
function parseBlockPin(text) {
  const t = text.trim();
  if (!t || t.toLowerCase() === "latest") return null;
  if (!/^\d+$/.test(t)) return void 0;
  try {
    return BigInt(t);
  } catch {
    return void 0;
  }
}
function BlockPinControl({
  value,
  onChange,
  latestBlock = null,
  label = "Block",
  disabled = false,
  id = "block-pin",
  className
}) {
  const [text, setText] = React26.useState(value === null ? "" : value.toString());
  const committed = React26.useRef(text);
  React26.useEffect(() => {
    const next = value === null ? "" : value.toString();
    if (next !== committed.current) {
      committed.current = next;
      setText(next);
    }
  }, [value]);
  const parsed = parseBlockPin(text);
  const invalid = parsed === void 0;
  const beyondHead = !invalid && parsed !== null && latestBlock != null && parsed > latestBlock;
  const commit = React26.useCallback(() => {
    if (parsed === void 0) return;
    committed.current = parsed === null ? "" : parsed.toString();
    onChange(parsed);
  }, [parsed, onChange]);
  const clear = React26.useCallback(() => {
    committed.current = "";
    setText("");
    onChange(null);
  }, [onChange]);
  const describedBy = invalid ? `${id}-error` : beyondHead ? `${id}-warning` : void 0;
  return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-col gap-1", className), children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1.5", children: [
      /* @__PURE__ */ jsx(Label, { htmlFor: id, className: "text-xs text-muted-foreground", children: label }),
      /* @__PURE__ */ jsx(
        Input,
        {
          id,
          value: text,
          onChange: (e) => setText(e.target.value),
          onBlur: commit,
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              commit();
            }
          },
          disabled,
          inputMode: "numeric",
          placeholder: "latest",
          "aria-invalid": invalid || void 0,
          "aria-describedby": describedBy,
          className: cn("h-8 w-32 font-mono text-xs", invalid && "border-destructive")
        }
      ),
      value !== null && /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(Badge, { variant: "secondary", className: "text-[10px] tabular-nums", children: "pinned" }),
        /* @__PURE__ */ jsx(
          Button,
          {
            size: "sm",
            variant: "ghost",
            className: "h-8 px-2 text-xs",
            disabled,
            onClick: clear,
            children: "Clear"
          }
        )
      ] })
    ] }),
    invalid && /* @__PURE__ */ jsx("p", { id: `${id}-error`, className: "text-[11px] text-destructive", children: "Enter a block number, or leave empty for the latest block." }),
    beyondHead && /* @__PURE__ */ jsxs("p", { id: `${id}-warning`, className: "text-[11px] text-muted-foreground", children: [
      "Block ",
      parsed?.toString(),
      " is ahead of the chain head (",
      latestBlock?.toString(),
      ")."
    ] })
  ] });
}
function scopedReadDeps(scope, block) {
  return [scope, block === null ? "" : block.toString()];
}
function isScopePinned(scope, block) {
  return scope !== null || block !== null;
}
function resolveWriteTarget(target, active) {
  return {
    scope: target && "scope" in target ? target.scope ?? null : active.scope,
    block: target && "block" in target ? target.block ?? null : active.block
  };
}
function useScopedOverride(resource, options = {}) {
  const [scope, setScope] = React26.useState(options.initialScope ?? null);
  const [block, setBlock] = React26.useState(options.initialBlock ?? null);
  const resourceRef = React26.useRef(resource);
  resourceRef.current = resource;
  const onWrittenRef = React26.useRef(options.onWritten);
  onWrittenRef.current = options.onWritten;
  const read = useQuery(
    (client, signal) => resourceRef.current.read(client, { scope, block, signal }),
    {
      deps: scopedReadDeps(scope, block),
      enabled: options.enabled !== false,
      onSuccess: options.onRead
    }
  );
  const { refetch } = read;
  const stale = React26.useCallback(
    (client) => {
      client.invalidateMatching(resourceRef.current.cacheFragment);
    },
    []
  );
  const writeMutation = useMutation(
    async (client, args) => {
      const write = resourceRef.current.write;
      if (!write) throw new Error("scoped override: resource is read-only");
      const res = await write(client, args);
      if (res.ok) stale(client);
      return res;
    },
    { notifyOnError: true }
  );
  const removeMutation = useMutation(
    async (client, args) => {
      const remove2 = resourceRef.current.remove;
      if (!remove2) throw new Error("scoped override: resource is not removable");
      const res = await remove2(client, args);
      if (res.ok) stale(client);
      return res;
    },
    { notifyOnError: true }
  );
  const activeRef = React26.useRef({ scope, block });
  activeRef.current = { scope, block };
  const save = React26.useCallback(
    async (input, target) => {
      const res = await writeMutation.mutate({
        input,
        ...resolveWriteTarget(target, activeRef.current)
      });
      if (!res.ok) return void 0;
      refetch();
      onWrittenRef.current?.();
      return res.data;
    },
    [writeMutation, refetch]
  );
  const remove = React26.useCallback(async (target) => {
    const res = await removeMutation.mutate(resolveWriteTarget(target, activeRef.current));
    if (!res.ok) return false;
    refetch();
    onWrittenRef.current?.();
    return true;
  }, [removeMutation, refetch]);
  const reset = React26.useCallback(() => {
    setScope(null);
    setBlock(null);
  }, []);
  return {
    data: read.data,
    error: read.error,
    isLoading: read.isLoading,
    isFetching: read.isFetching,
    refetch,
    scope,
    setScope,
    block,
    setBlock,
    isPinned: isScopePinned(scope, block),
    reset,
    save,
    remove,
    isSaving: writeMutation.isLoading || removeMutation.isLoading,
    saveError: writeMutation.error ?? removeMutation.error,
    lastWrite: writeMutation.data,
    canWrite: typeof resource.write === "function"
  };
}
function useOverrideWriteScope(identity = {}, preferred = "tenant") {
  const offered = useOfferedRungs();
  const scopes = offeredOptions(availableOverrideRungs(identity), offered, (rung) => rung);
  const identityKey = JSON.stringify([identity.customerId, identity.orgId, identity.tenantId, identity.userId]);
  const [chosen, setChosen] = React26.useState(null);
  const fallback = scopes.includes(preferred) ? preferred : scopes[0];
  const scope = chosen?.identityKey === identityKey && scopes.includes(chosen.scope) ? chosen.scope : fallback;
  const setScope = (next) => {
    if (scopes.includes(next)) setChosen({ identityKey, scope: next });
  };
  return { scopes, scope, setScope };
}
var TONE_CLASSES = {
  critical: {
    box: "border-red-500/40 bg-red-500/10",
    icon: "text-red-600 dark:text-red-400",
    title: "text-red-700 dark:text-red-400"
  },
  warning: {
    box: "border-amber-500/40 bg-amber-500/10",
    icon: "text-amber-600 dark:text-amber-400",
    title: "text-amber-700 dark:text-amber-400"
  },
  info: {
    box: "border-sky-500/40 bg-sky-500/10",
    icon: "text-sky-600 dark:text-sky-400",
    title: "text-sky-700 dark:text-sky-400"
  }
};
function IncidentBannerCard({
  banner,
  className
}) {
  const tone2 = TONE_CLASSES[banner.tone];
  const Icon = banner.subjectOfHarm ? ShieldAlert : AlertTriangle;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: "note",
      className: cn("flex items-start gap-2.5 rounded-lg border px-3.5 py-2.5", tone2.box, className),
      children: [
        /* @__PURE__ */ jsx(Icon, { className: cn("mt-0.5 h-4 w-4 shrink-0", tone2.icon), "aria-hidden": true }),
        /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-1", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-2", children: [
            /* @__PURE__ */ jsx("p", { className: cn("text-sm font-semibold", tone2.title), children: banner.chipLabel }),
            banner.subjectOfHarm ? /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "text-[10px] uppercase tracking-wide", children: "Not a suspect" }) : null
          ] }),
          /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: banner.headline }),
          banner.note ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: banner.note }) : null,
          banner.summary ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground/80", children: banner.summary }) : null,
          banner.references.length ? /* @__PURE__ */ jsx("div", { className: "flex flex-wrap items-center gap-x-3 gap-y-1 pt-0.5", children: banner.references.map((reference) => /* @__PURE__ */ jsxs(
            "a",
            {
              href: reference.url,
              target: "_blank",
              rel: "noreferrer noopener",
              className: "inline-flex items-center gap-1 text-xs font-medium underline underline-offset-2 hover:no-underline",
              children: [
                reference.label,
                reference.handle ? /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: reference.handle }) : null,
                /* @__PURE__ */ jsx(ExternalLink, { className: "h-3 w-3", "aria-hidden": true })
              ]
            },
            reference.url
          )) }) : null
        ] })
      ]
    }
  );
}
function IncidentBanners({
  notices,
  className
}) {
  const banners = React26.useMemo(() => bannersFor(notices), [notices]);
  if (!banners.length) return null;
  return /* @__PURE__ */ jsx("div", { className: cn("space-y-2", className), children: banners.map((banner) => /* @__PURE__ */ jsx(IncidentBannerCard, { banner }, banner.incidentId)) });
}
function DataViewScope({ id, label, value, scopes, defaultScope, overridden, onChange, onReset }) {
  return /* @__PURE__ */ jsxs("div", { className: "space-y-1.5", children: [
    /* @__PURE__ */ jsx(Label, { htmlFor: id, children: "View scope" }),
    /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ jsxs(Select, { value, onValueChange: (next) => {
        const scope = scopes.find((s) => s === next);
        if (scope) onChange(scope);
      }, children: [
        /* @__PURE__ */ jsx(SelectTrigger, { id, className: "w-44", "aria-label": `${label} view scope`, children: /* @__PURE__ */ jsx(SelectValue, {}) }),
        /* @__PURE__ */ jsx(SelectContent, { children: scopes.map((scope) => /* @__PURE__ */ jsx(SelectItem, { value: scope, children: RESOLVE_SCOPE_LABEL[scope] }, scope)) })
      ] }),
      overridden && /* @__PURE__ */ jsxs(Button, { size: "sm", variant: "ghost", onClick: onReset, children: [
        "Use default (",
        RESOLVE_SCOPE_LABEL[defaultScope],
        ")"
      ] })
    ] })
  ] });
}
var TIER_PILL = {
  [ConfidenceTier.HIGH]: "border-emerald-500/40 bg-emerald-500/10 text-emerald-600",
  [ConfidenceTier.MEDIUM]: "border-amber-500/40 bg-amber-500/10 text-amber-600",
  [ConfidenceTier.LOW]: "border-destructive/40 bg-destructive/10 text-destructive"
};
function TierPill({ score }) {
  const tier = useTierFor()(score);
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: `inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-semibold capitalize ${TIER_PILL[tier]}`,
      children: tier
    }
  );
}
var CLUSTER_MEMBER_COLUMN_LABELS = {
  address: "Address",
  chain: "Chain",
  role: "Role",
  tie: "Tie",
  // "Strength", not "Confidence": the engine calls these uncalibrated evidence
  // scores, and a column of percentages headed Confidence reads as a probability.
  confidence: "Strength",
  joined_by: "Joined by"
};
var TIE_COPY = {
  "same-actor": {
    label: "Same identity",
    title: "This address belongs to the current identity returned by the service.",
    variant: "default"
  },
  related: {
    label: "Related",
    title: "Included in the analysis snapshot, but outside the current identity's membership.",
    variant: "secondary"
  },
  unknown: null
};
function createClusterMemberColumns() {
  return [
    {
      id: "address",
      accessorFn: (row) => row.address,
      header: ({ column }) => /* @__PURE__ */ jsx(DataTableColumnHeader, { column, title: "Address" }),
      enableHiding: false,
      cell: ({ row }) => /* @__PURE__ */ jsx(AddressIdentity, { address: row.original.address, chain: row.original.chainId, children: row.original.role === "seed" ? /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "text-[10px] font-normal", children: "the address you are on" }) : null })
    },
    {
      id: "chain",
      accessorFn: (row) => row.chainId,
      header: "Chain",
      enableSorting: false,
      // `showName={false}`: `ChainAvatar` defaults it to TRUE, so the avatar
      // rendered the chain name itself and the span beside it rendered the same
      // name again — "Ethereum Ethereum" in one cell, on the table an analyst
      // reads to decide whether two addresses are one actor. The name stays
      // here rather than being delegated to the avatar because a table cell
      // wants it muted and small, which is the styling this span carries; every
      // other chain cell in the codebase does the same.
      //
      // No `title` on the wrapper either: the name is rendered in full and is
      // not truncated, so a tooltip repeating it says nothing — and `ChainAvatar`
      // already titles its own icon, which is the part that needs one.
      cell: ({ row }) => /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1.5", children: [
        /* @__PURE__ */ jsx(ChainAvatar, { chain: row.original.chainId, size: "sm", showName: false }),
        /* @__PURE__ */ jsx("span", { className: "text-xs text-muted-foreground", children: chainDisplayName(row.original.chainId) })
      ] })
    },
    {
      id: "tie",
      accessorFn: (row) => row.tie,
      header: ({ column }) => /* @__PURE__ */ jsx(DataTableColumnHeader, { column, title: "Tie" }),
      cell: ({ row }) => {
        const copy = TIE_COPY[row.original.tie];
        if (!copy) return /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "\u2014" });
        return /* @__PURE__ */ jsx(Badge, { variant: copy.variant, className: "font-normal", title: copy.title, children: copy.label });
      }
    },
    {
      id: "confidence",
      accessorFn: (row) => row.confidence,
      header: ({ column }) => /* @__PURE__ */ jsx("span", { title: STRENGTH_EXPLAINER, children: /* @__PURE__ */ jsx(DataTableColumnHeader, { column, title: STRENGTH_LABEL }) }),
      cell: ({ row }) => row.original.linkKinds.includes("manual_membership") && row.original.confidence === 0 ? /* @__PURE__ */ jsx(Badge, { variant: "outline", title: "Added by an analyst; no computed membership confidence.", children: "Manual" }) : /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-1.5", title: STRENGTH_EXPLAINER, children: [
        /* @__PURE__ */ jsx(TierPill, { score: row.original.confidence }),
        /* @__PURE__ */ jsx("span", { className: "tabular-nums text-xs text-muted-foreground", children: formatConfidence(row.original.confidence) })
      ] })
    },
    {
      id: "joined_by",
      accessorFn: (row) => row.linkKinds.join(", "),
      header: "Joined by",
      enableSorting: false,
      cell: ({ row }) => {
        const kinds = row.original.linkKinds;
        if (kinds.length === 0) {
          return /* @__PURE__ */ jsx("span", { className: "text-muted-foreground", children: "\u2014" });
        }
        const deterministic = new Set(
          row.original.why.filter((link) => link.deterministic).map((link) => link.kind)
        );
        return /* @__PURE__ */ jsx("span", { className: "inline-flex flex-wrap gap-1", children: kinds.map((kind) => /* @__PURE__ */ jsx(
          Badge,
          {
            variant: deterministic.has(kind) ? "default" : "secondary",
            className: "font-normal",
            title: deterministic.has(kind) ? "Structural \u2014 cites a specific transaction" : "Behavioural \u2014 a pattern across transactions",
            children: linkKindLabel(kind)
          },
          kind
        )) });
      }
    }
  ];
}
function ContractReferenceEvidence({ link }) {
  const facts = contractObservations(link);
  if (!facts.length) return link.kind === "contract_state_reference" ? /* @__PURE__ */ jsx("p", { role: "status", className: "text-muted-foreground", children: "No valid dated contract observation was read for this reference. Its direction and provenance are unverified." }) : null;
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
    /* @__PURE__ */ jsx("p", { className: "text-muted-foreground", children: "Confidence measures this reference\u2019s evidence strength, not the probability of common ownership. These are dated observations; re-analyse to check newer state." }),
    facts.map((fact) => /* @__PURE__ */ jsxs("details", { className: "rounded border p-2", children: [
      /* @__PURE__ */ jsxs("summary", { className: "cursor-pointer", children: [
        contractPredicateLabel(fact.predicate),
        " \xB7 ",
        fact.assurance,
        " \xB7 ",
        fact.block_number != null ? `block ${fact.block_number.toLocaleString()}` : "current state",
        " (",
        fact.finality,
        ")"
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "mt-2 space-y-1 break-words", children: [
        /* @__PURE__ */ jsx("p", { children: fact.confidence_reason }),
        fact.source === "getter" && /* @__PURE__ */ jsx(AbiSourceStrength, { rows: fact.context.abi_provenance }),
        /* @__PURE__ */ jsxs("dl", { className: "grid grid-cols-[auto_1fr] gap-x-3 gap-y-1", children: [
          /* @__PURE__ */ jsx("dt", { children: "Source" }),
          /* @__PURE__ */ jsxs("dd", { children: [
            fact.source,
            " \xB7 ",
            fact.abi_source ?? "No ABI"
          ] }),
          /* @__PURE__ */ jsx("dt", { children: "Read" }),
          /* @__PURE__ */ jsxs("dd", { className: "break-all font-mono", children: [
            fact.signature ?? fact.slot ?? fact.value_ref,
            fact.output_path ? ` \u2192 ${fact.output_path}` : ""
          ] }),
          fact.params.length > 0 && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("dt", { children: "Arguments" }),
            /* @__PURE__ */ jsx("dd", { className: "break-all font-mono", children: JSON.stringify(fact.params) })
          ] }),
          fact.call_from && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("dt", { children: "Call sender" }),
            /* @__PURE__ */ jsx("dd", { className: "break-all font-mono", children: fact.call_from })
          ] }),
          fact.slot && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("dt", { children: "Byte offset" }),
            /* @__PURE__ */ jsx("dd", { children: fact.storage_offset ?? 0 })
          ] }),
          fact.block_hash && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("dt", { children: "Block hash" }),
            /* @__PURE__ */ jsx("dd", { className: "break-all font-mono", children: fact.block_hash })
          ] }),
          fact.observed_at != null && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("dt", { children: "Observed at" }),
            /* @__PURE__ */ jsx("dd", { children: new Date(fact.observed_at * 1e3).toISOString() })
          ] }),
          fact.abi_fingerprint && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("dt", { children: "ABI fingerprint" }),
            /* @__PURE__ */ jsx("dd", { className: "break-all font-mono", children: fact.abi_fingerprint })
          ] }),
          fact.code_hash && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("dt", { children: "Code hash (SHA-256)" }),
            /* @__PURE__ */ jsx("dd", { className: "break-all font-mono", children: fact.code_hash })
          ] }),
          fact.context.threshold != null && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("dt", { children: "Reported threshold" }),
            /* @__PURE__ */ jsx("dd", { children: String(fact.context.threshold) })
          ] }),
          fact.context.role_id != null && /* @__PURE__ */ jsxs(Fragment, { children: [
            /* @__PURE__ */ jsx("dt", { children: "Role ID" }),
            /* @__PURE__ */ jsx("dd", { className: "break-all font-mono", children: String(fact.context.role_id) })
          ] }),
          /* @__PURE__ */ jsx("dt", { children: "Observation" }),
          /* @__PURE__ */ jsxs("dd", { className: "break-all font-mono", children: [
            fact.observation_id,
            " \xB7 extractor ",
            fact.extractor_version
          ] })
        ] }),
        Object.keys(fact.context).length > 0 && /* @__PURE__ */ jsxs("details", { children: [
          /* @__PURE__ */ jsx("summary", { className: "cursor-pointer", children: "Source details" }),
          /* @__PURE__ */ jsx("pre", { className: "max-h-48 overflow-auto whitespace-pre-wrap break-all", children: JSON.stringify(fact.context, null, 2) })
        ] })
      ] })
    ] }, fact.observation_id))
  ] });
}
function AbiSourceStrength({ rows }) {
  if (!Array.isArray(rows)) return null;
  const sources = rows.filter((row) => Boolean(row) && typeof row === "object");
  if (!sources.some((row) => typeof row.confidence === "number" || typeof row.provider_confidence === "number")) return null;
  return /* @__PURE__ */ jsxs("div", { className: "space-y-1 text-muted-foreground", children: [
    /* @__PURE__ */ jsx("p", { children: "The reference score is capped by its ABI and provider evidence." }),
    sources.map((row, index) => /* @__PURE__ */ jsxs("p", { children: [
      "ABI source: ",
      String(row.origin ?? row.source ?? "unknown").replaceAll("_", " "),
      typeof row.confidence === "number" && ` \xB7 ABI strength ${Math.round(row.confidence * 100)}%`,
      typeof row.provider_confidence === "number" && ` \xB7 provider strength ${Math.round(row.provider_confidence * 100)}%`
    ] }, index))
  ] });
}
var REJECTION_REASONS = {
  suppressed: "A suppression rule rejected this claim.",
  bidirectionality: "The required activity in both directions was not observed.",
  below_link_floor: "The evidence did not meet the confidence threshold.",
  no_endorsement: "No ownership rule endorsed this pair.",
  revoked: "The ownership attestation was revoked.",
  expired: "The ownership attestation expired.",
  future_evidence: "The evidence was dated after the analysis time.",
  stale_evidence: "The evidence was too old under this policy.",
  unfinalized_identity: "The ownership attestation was not finalized.",
  disabled_signal: "This signal was disabled by the analysis policy."
};
function RelatedAddressEvidence({ links, renderAddress }) {
  const tierCutoffs = useTierCutoffs();
  return /* @__PURE__ */ jsx("ul", { className: "space-y-2.5", children: expandContractLinks(links).map((link, index) => /* @__PURE__ */ jsxs("li", { className: "space-y-1 text-xs", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center gap-1.5", children: [
      /* @__PURE__ */ jsx(Badge, { variant: link.deterministic ? "default" : "secondary", className: "font-normal", children: linkKindLabel(link.kind) }),
      /* @__PURE__ */ jsx(TierPill, { score: link.confidence }),
      /* @__PURE__ */ jsx("span", { className: "tabular-nums text-muted-foreground", children: formatConfidence(link.confidence) }),
      link.tx_count > 0 ? /* @__PURE__ */ jsxs("span", { className: "text-muted-foreground", children: [
        "across ",
        link.tx_count,
        " transaction",
        link.tx_count === 1 ? "" : "s"
      ] }) : null
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "text-muted-foreground", children: [
      renderAddress?.(link.a_address, link.a_chain_id) ?? /* @__PURE__ */ jsx("span", { className: "break-all font-mono", children: link.a_address }),
      hasContractReferenceDirection(link) ? " \u2192 " : " \u2194 ",
      renderAddress?.(link.b_address, link.b_chain_id) ?? /* @__PURE__ */ jsx("span", { className: "break-all font-mono", children: link.b_address }),
      /* @__PURE__ */ jsxs("span", { className: "ml-2", children: [
        chainDisplayName(link.a_chain_id),
        link.b_chain_id !== link.a_chain_id ? ` \u2194 ${chainDisplayName(link.b_chain_id)}` : ""
      ] })
    ] }),
    link.description ? /* @__PURE__ */ jsx("p", { children: link.description }) : null,
    /* @__PURE__ */ jsx(ContractReferenceEvidence, { link }),
    link.rejection_reason ? /* @__PURE__ */ jsx("p", { children: REJECTION_REASONS[link.rejection_reason] ?? linkKindLabel(link.rejection_reason) }) : null,
    link.tx_hash ? /* @__PURE__ */ jsx(HashDisplay, { hash: link.tx_hash, chain: link.a_chain_id, type: "tx", copyable: true }) : null,
    (link.explanation?.length ?? 0) > 0 ? /* @__PURE__ */ jsx(
      WhyPanel,
      {
        explanation: [...link.explanation ?? []],
        confidence: link.confidence,
        cutoffs: tierCutoffs
      }
    ) : null
  ] }, `${link.a_id}|${link.b_id}|${link.kind}|${index}`)) });
}
function RelatedAddressesExplorer({ view, renderGraph, renderAddress, isLoading, resolveOverlay, enrichmentNotice, renderNodeDetails }) {
  const [preferredMode, setMode] = React26.useState(null);
  const [filter, setFilter] = React26.useState("accepted");
  const [evidenceType, setEvidenceType] = React26.useState("all");
  const [query, setQuery] = React26.useState("");
  const [strengthView, setStrengthView] = React26.useState("any");
  const cutoffs = useTierCutoffs();
  const strengthOptions = React26.useMemo(() => strengthViewOptions(cutoffs), [cutoffs.high, cutoffs.medium]);
  const minimumConfidence = strengthViewMin(strengthView, cutoffs);
  const [selection, setSelection] = React26.useState({});
  const visible = React26.useMemo(() => filterRelatedAddressView(view, filter, query, minimumConfidence, evidenceType), [view, filter, query, minimumConfidence, evidenceType]);
  const mode = preferredMode ?? (visible.nodes.length > RELATED_ADDRESS_GRAPH_LIMITS.nodes || visible.relationships.length > RELATED_ADDRESS_GRAPH_LIMITS.edges ? "table" : "graph");
  const selectedNode = visible.nodes.find((node) => node.id === selection.node);
  const nodeLinks = selectedNode ? visible.relationships.filter((row) => row.source === selectedNode.id || row.target === selectedNode.id) : [];
  const selectedRelationship = visible.relationships.find((row) => row.id === selection.relationship);
  const rejectedCount = view.relationships.filter((row) => row.claim === "rejected").length;
  const acceptedCount = view.relationships.length - rejectedCount;
  const address = React26.useCallback((value, chainId) => {
    const overlay = resolveOverlay?.(value, chainId);
    return /* @__PURE__ */ jsxs("span", { className: "inline-flex min-w-0 flex-col gap-0.5", children: [
      overlay?.label || overlay?.primaryEntityName ? /* @__PURE__ */ jsx("span", { className: "truncate text-xs font-medium", title: "Catalog attribution", children: overlay.label ?? overlay.primaryEntityName }) : null,
      renderAddress?.(value, chainId) ?? /* @__PURE__ */ jsx("span", { className: "break-all font-mono text-xs", children: value }),
      /* @__PURE__ */ jsxs("span", { className: "text-[11px] text-muted-foreground", children: [
        chainDisplayName(chainId),
        overlay?.riskLevel ? ` \xB7 Catalog risk: ${overlay.riskLevel}` : ""
      ] })
    ] });
  }, [renderAddress, resolveOverlay]);
  const columns = React26.useMemo(() => [
    { id: "from", header: "Address", cell: ({ row }) => address(row.original.link.a_address, row.original.link.a_chain_id) },
    { id: "to", header: "Connected address", cell: ({ row }) => address(row.original.link.b_address, row.original.link.b_chain_id) },
    {
      id: "claim",
      header: "Claim",
      cell: ({ row }) => /* @__PURE__ */ jsxs("span", { className: "flex flex-col items-start gap-0.5", children: [
        /* @__PURE__ */ jsx(Badge, { variant: "outline", children: RELATIONSHIP_CLAIM_LABELS[row.original.claim] }),
        row.original.pairAlsoAccepted ? /* @__PURE__ */ jsx(
          "span",
          {
            className: "text-[10px] text-muted-foreground",
            title: "This pair is also linked by evidence that was accepted \u2014 see the accepted view. Only THIS claim was refused.",
            children: "also linked"
          }
        ) : null
      ] })
    },
    // Rejected rows say WHY: a pair nothing endorsed has no meaningful kind, and
    // the table showed seven of them as "unknown · 0%" — a refusal with no reason.
    { id: "rule", header: "Evidence", accessorFn: (row) => evidenceLabel(row.link) },
    { id: "confidence", accessorFn: (row) => row.link.confidence, header: ({ column }) => /* @__PURE__ */ jsx(DataTableColumnHeader, { column, title: STRENGTH_LABEL }), cell: ({ row }) => formatConfidence(row.original.link.confidence) }
  ], [address]);
  const changeFilter = (next) => {
    setFilter(next);
    setSelection({});
  };
  const hasFilters = filter !== "accepted" || evidenceType !== "all" || query.length > 0 || strengthView !== "any";
  const clearFilters = () => {
    setFilter("accepted");
    setEvidenceType("all");
    setQuery("");
    setStrengthView("any");
    setSelection({});
  };
  return /* @__PURE__ */ jsxs("section", { "aria-label": "Relationship explorer", className: "space-y-3 rounded-lg border bg-card p-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-start justify-between gap-3", children: [
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx("h3", { className: "font-semibold", children: "Explore relationships" }),
        /* @__PURE__ */ jsxs("p", { className: "mt-1 text-xs text-muted-foreground", children: [
          acceptedCount,
          " evidence links \xB7 ",
          rejectedCount,
          " rejected claims"
        ] })
      ] }),
      /* @__PURE__ */ jsx(ViewModeToggle, { "aria-label": "Relationship display", options: [
        { value: "graph", label: "Graph", icon: /* @__PURE__ */ jsx(Network, { className: "h-4 w-4", "aria-hidden": true }) },
        { value: "table", label: "Table", icon: /* @__PURE__ */ jsx(Table2, { className: "h-4 w-4", "aria-hidden": true }) }
      ], value: mode, onChange: setMode })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap gap-2", children: [
      /* @__PURE__ */ jsx(Input, { "aria-label": "Search relationships", placeholder: "Search address, chain or evidence\u2026", className: "min-w-40 flex-1", value: query, onChange: (event) => {
        setQuery(event.target.value);
        setSelection({});
      } }),
      /* @__PURE__ */ jsxs("select", { "aria-label": "Relationship claims", className: "h-9 rounded-md border bg-background px-3 text-sm", value: filter, onChange: (event) => changeFilter(event.target.value), children: [
        /* @__PURE__ */ jsxs("option", { value: "accepted", children: [
          "Accepted evidence (",
          acceptedCount,
          ")"
        ] }),
        /* @__PURE__ */ jsxs("option", { value: "identity", children: [
          "Identity evidence (",
          view.relationships.filter((row) => row.claim === "identity").length,
          ")"
        ] }),
        /* @__PURE__ */ jsxs("option", { value: "related", children: [
          "Related only (",
          view.relationships.filter((row) => row.claim === "related").length,
          ")"
        ] }),
        /* @__PURE__ */ jsxs("option", { value: "rejected", children: [
          "Rejected claims (",
          rejectedCount,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ jsxs("select", { "aria-label": "Evidence type", className: "h-9 rounded-md border bg-background px-3 text-sm", value: evidenceType, onChange: (event) => {
        setEvidenceType(event.target.value);
        setSelection({});
      }, children: [
        /* @__PURE__ */ jsx("option", { value: "all", children: "All evidence types" }),
        /* @__PURE__ */ jsx("option", { value: "contract", children: "All contract references" }),
        /* @__PURE__ */ jsx("option", { value: "contract-observed", children: "Observed contract references" }),
        /* @__PURE__ */ jsx("option", { value: "other", children: "Other evidence" })
      ] }),
      /* @__PURE__ */ jsx("select", { "aria-label": "Minimum strength", className: "h-9 rounded-md border bg-background px-3 text-sm", value: strengthView, onChange: (event) => {
        setStrengthView(event.target.value);
        setSelection({});
      }, children: strengthOptions.map((option) => /* @__PURE__ */ jsx("option", { value: option.view, children: option.label }, option.view)) }),
      hasFilters ? /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: clearFilters, children: "Clear relationship filters" }) : null
    ] }),
    enrichmentNotice,
    /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Links show evidence, not transfers or proof of current shared ownership." }),
    /* @__PURE__ */ jsxs("p", { role: "status", className: "text-xs text-muted-foreground", children: [
      isLoading ? "Reading evidence\u2026 " : "",
      visible.nodes.length,
      " addresses \xB7 ",
      visible.relationships.length,
      " evidence links match this view"
    ] }),
    mode === "table" ? /* @__PURE__ */ jsx(
      ResourceTable,
      {
        rows: visible.relationships,
        columns,
        getRowId: (row) => row.id,
        isLoading,
        height: "h-[440px]",
        initialSorting: [{ id: "confidence", desc: true }],
        emptyTitle: hasFilters ? "No matching evidence" : "No evidence in this view",
        emptyDescription: "Try another search, strength, claim or evidence-type filter, or inspect the cluster members below.",
        renderRowDetail: (row) => /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(RelatedAddressEvidence, { links: [row.link], renderAddress }),
          renderNodeDetails ? /* @__PURE__ */ jsx(RelationshipAddressContext, { row, view: visible, renderNodeDetails }, row.id) : null
        ] }),
        detailEyebrow: "Relationship evidence",
        detailTitle: (row) => evidenceLabel(row.link),
        detailSubtitle: (row) => RELATIONSHIP_CLAIM_LABELS[row.claim]
      }
    ) : /* @__PURE__ */ jsxs(Fragment, { children: [
      visible.relationships.length || visible.nodes.length > 1 ? renderGraph({
        view: visible,
        onSelectNode: (node) => setSelection({ node }),
        onSelectRelationship: (relationship) => setSelection({ relationship })
      }) : /* @__PURE__ */ jsxs("div", { className: "rounded-md border border-dashed p-8 text-center text-sm text-muted-foreground", children: [
        query || minimumConfidence > 0 || evidenceType !== "all" ? "No matching relationships." : filter === "rejected" ? "No rejected claims were read." : "No links to draw in this view.",
        filter === "accepted" && evidenceType === "all" && !query.trim() && minimumConfidence === 0 && rejectedCount > 0 ? /* @__PURE__ */ jsxs(Button, { variant: "link", onClick: () => changeFilter("rejected"), children: [
          "Inspect rejected claims (",
          rejectedCount,
          ")"
        ] }) : null
      ] }),
      selectedNode || selectedRelationship ? /* @__PURE__ */ jsxs("div", { className: "space-y-3 rounded-md border p-3", "aria-label": "Selected relationship details", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-start justify-between gap-2", children: [
          /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
            /* @__PURE__ */ jsx("h4", { className: "text-sm font-medium", children: selectedNode ? "Address evidence" : RELATIONSHIP_CLAIM_LABELS[selectedRelationship.claim] }),
            selectedNode ? /* @__PURE__ */ jsxs(Fragment, { children: [
              address(selectedNode.address, selectedNode.chainId),
              /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
                selectedNode.isSeed ? "Starting address \xB7 " : "",
                selectedNode.membership === "same-actor" ? "Current identity member" : selectedNode.membership === "snapshot" ? "Analysis snapshot member" : "Current membership not established"
              ] })
            ] }) : null
          ] }),
          /* @__PURE__ */ jsx(Button, { size: "icon", variant: "ghost", "aria-label": "Close evidence details", onClick: () => setSelection({}), children: /* @__PURE__ */ jsx(X, { className: "h-4 w-4" }) })
        ] }),
        selectedNode ? nodeLinks.length ? /* @__PURE__ */ jsxs("select", { "aria-label": "Evidence for selected address", className: "h-9 w-full min-w-0 rounded-md border bg-background px-2 text-sm", value: selectedRelationship?.id ?? "", onChange: (event) => setSelection({ node: selectedNode.id, relationship: event.target.value }), children: [
          /* @__PURE__ */ jsxs("option", { value: "", children: [
            "Choose evidence (",
            nodeLinks.length,
            ")"
          ] }),
          nodeLinks.map((row) => /* @__PURE__ */ jsxs("option", { value: row.id, children: [
            RELATIONSHIP_CLAIM_LABELS[row.claim],
            " \xB7 ",
            evidenceLabel(row.link),
            " \xB7 ",
            formatConfidence(row.link.confidence),
            " \xB7 ",
            row.source === selectedNode.id ? row.link.b_address : row.link.a_address
          ] }, row.id))
        ] }) : /* @__PURE__ */ jsx("p", { className: "text-sm text-muted-foreground", children: "No matching evidence was read for this member. No joining link has been inferred." }) : null,
        selectedNode && renderNodeDetails ? renderNodeDetails(selectedNode) : null,
        selectedRelationship ? /* @__PURE__ */ jsx(RelatedAddressEvidence, { links: [selectedRelationship.link], renderAddress }) : null,
        !selectedNode && selectedRelationship && renderNodeDetails ? /* @__PURE__ */ jsx(RelationshipAddressContext, { row: selectedRelationship, view: visible, renderNodeDetails }, selectedRelationship.id) : null
      ] }) : visible.relationships.length || visible.nodes.length > 1 ? /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: "Select an address or link to inspect its evidence. Use Table for exact comparisons." }) : null
    ] })
  ] });
}
function RelationshipAddressContext({ row, view, renderNodeDetails }) {
  const endpoints = view.nodes.filter((node) => node.id === row.source || node.id === row.target);
  const [selectedId, select] = React26.useState(row.target);
  const selected = endpoints.find((node) => node.id === selectedId) ?? endpoints[0];
  if (!selected) return null;
  return /* @__PURE__ */ jsxs("div", { className: "mt-4 space-y-2 border-t pt-3", children: [
    /* @__PURE__ */ jsxs("label", { className: "block space-y-1 text-xs font-medium", children: [
      /* @__PURE__ */ jsx("span", { children: "Address context" }),
      /* @__PURE__ */ jsx("select", { "aria-label": "Address context", className: "h-9 w-full min-w-0 rounded-md border bg-background px-2 text-xs", value: selected.id, onChange: (event) => select(event.target.value), children: endpoints.map((node) => /* @__PURE__ */ jsxs("option", { value: node.id, children: [
        node.address,
        " \xB7 ",
        chainDisplayName(node.chainId)
      ] }, node.id)) })
    ] }),
    renderNodeDetails(selected)
  ] });
}
function CatalogEnrichmentNotice({ requestedCount, queriedCount, truncated, error, onRetry }) {
  if (error) return /* @__PURE__ */ jsxs("div", { role: "alert", className: "rounded-md border border-amber-500/30 bg-amber-500/5 p-2 text-xs", children: [
    "Catalog details could not be read. Addresses and evidence remain available.",
    onRetry ? /* @__PURE__ */ jsx(Button, { size: "sm", variant: "link", onClick: onRetry, children: "Retry catalog details" }) : null
  ] });
  if (!truncated) return null;
  return /* @__PURE__ */ jsxs("p", { role: "status", className: "rounded-md border bg-muted/40 p-2 text-xs text-muted-foreground", children: [
    "Catalog lookup is limited to ",
    queriedCount.toLocaleString(),
    " of ",
    requestedCount.toLocaleString(),
    " addresses by the enrichment budget. Other addresses remain visible without catalog details."
  ] });
}
var TONES = {
  // A loss that already happened — solid, and the loudest thing in a row.
  critical: {
    box: "border-risk-critical/60 bg-risk-critical/15",
    icon: "text-risk-critical",
    title: "text-risk-critical",
    chip: "border-risk-critical bg-risk-critical text-white",
    Icon: AlertTriangle
  },
  alert: {
    box: "border-risk-high/40 bg-risk-high/10",
    icon: "text-risk-high",
    title: "text-risk-high",
    chip: "border-risk-high/40 bg-risk-high/10 text-risk-high",
    Icon: AlertTriangle
  },
  notice: {
    box: "border-muted-foreground/30 bg-muted",
    icon: "text-muted-foreground",
    title: "text-foreground",
    chip: "border-muted-foreground/30 bg-muted text-muted-foreground",
    Icon: Info
  }
};
function TransactionFlagNotice({
  flag,
  headline,
  className
}) {
  if (!flag) return null;
  const meta = TRANSACTION_FLAG_META[flag.kind];
  const tone2 = TONES[meta.tone];
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role: meta.tone === "alert" ? "alert" : "note",
      "data-flag-kind": flag.kind,
      className: cn("flex items-start gap-2.5 rounded-lg border px-3.5 py-2.5", tone2.box, className),
      children: [
        /* @__PURE__ */ jsx(tone2.Icon, { className: cn("mt-0.5 h-4 w-4 shrink-0", tone2.icon), "aria-hidden": true }),
        /* @__PURE__ */ jsxs("div", { className: "min-w-0 space-y-0.5", children: [
          /* @__PURE__ */ jsx("p", { className: cn("text-sm font-semibold", tone2.title), children: headline ?? flag.label }),
          /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", children: flag.reason })
        ] })
      ]
    }
  );
}
function TransactionFlagBadge({
  flag,
  className
}) {
  const tone2 = TONES[TRANSACTION_FLAG_META[flag.kind].tone];
  return /* @__PURE__ */ jsx(
    Badge,
    {
      variant: "outline",
      title: flag.reason,
      "data-flag-kind": flag.kind,
      className: cn("font-normal", tone2.chip, className),
      children: flag.label
    }
  );
}
function TokenHoldersTable({ holders, renderAddress, isLoading }) {
  const columns = React26.useMemo(() => [
    { id: "holder", header: "Holder", cell: ({ row }) => renderAddress(row.original) },
    { id: "balance", header: "Balance", cell: ({ row }) => /* @__PURE__ */ jsx(HolderBalance, { holder: row.original }) },
    { id: "share", header: "Supply share", cell: ({ row }) => row.original.percentage_of_supply != null ? formatPercentCell(row.original.percentage_of_supply) : "Unknown" },
    { id: "value", header: "Value (USD)", cell: ({ row }) => row.original.usd_value != null ? row.original.usd_value.toLocaleString(void 0, { style: "currency", currency: "USD" }) : "Unknown" }
  ], [renderAddress]);
  return /* @__PURE__ */ jsx(ResourceTable, { rows: holders, columns, getRowId: (holder) => holder.address, isLoading, height: "h-[420px]", emptyTitle: "No holders returned by the provider." });
}
function HolderBalance({ holder }) {
  const display2 = formatBalanceCell(holder.balance_formatted);
  if (display2) return /* @__PURE__ */ jsx("span", { className: "tabular-nums", title: display2.title, children: display2.text });
  return /* @__PURE__ */ jsx(Fragment, { children: holder.balance != null ? `${holder.balance} raw units` : "Unknown" });
}
function useConfidencePolicy(source) {
  const [status, setStatus] = React26.useState("loading");
  const [statusSource, setStatusSource] = React26.useState(source);
  const [loaded, setLoaded] = React26.useState(null);
  const data = loaded?.source === source ? loaded.data : null;
  const [error, setError] = React26.useState(null);
  const [busy, setBusy] = React26.useState(false);
  const [nonce, setNonce] = React26.useState(0);
  React26.useEffect(() => {
    let live = true;
    setStatusSource(source);
    setStatus("loading");
    setError(null);
    source.getLadder().then(
      (next) => {
        if (!live) return;
        setLoaded({ source, data: next });
        setStatus("ready");
      },
      (err) => {
        if (!live) return;
        setError(err);
        setStatus("error");
      }
    );
    return () => {
      live = false;
    };
  }, [source, nonce]);
  const reload = React26.useCallback(() => setNonce((n) => n + 1), []);
  React26.useEffect(() => source.subscribe?.(reload), [source, reload]);
  const save = React26.useCallback(
    async (tier, section, note) => {
      setBusy(true);
      try {
        await source.save(tier, section, note);
        if (!source.subscribe) reload();
      } finally {
        setBusy(false);
      }
    },
    [source, reload]
  );
  const clear = React26.useCallback(
    async (tier) => {
      setBusy(true);
      try {
        await source.clear(tier);
        if (!source.subscribe) reload();
      } finally {
        setBusy(false);
      }
    },
    [source, reload]
  );
  const preview = React26.useCallback(
    (tier, section) => source.preview(tier, section),
    [source]
  );
  return { status: statusSource === source ? status : "loading", data, error, reload, busy, save, clear, preview };
}
var KNOBS = ["catalog_read_floor", "catalog_include_unscored"];
function ReadConfidencePreferences({
  source,
  canAuthor,
  policyLink
}) {
  const policy = useConfidencePolicy(source);
  const included = useEntitlement(ENTITLEMENT.CATALOG_CONFIDENCE_CONTROLS);
  const [tier, setTier] = React26.useState("user");
  const offeredLadder = useOfferedRungs();
  const allowedTiers = React26.useMemo(
    () => (policy.data?.tiers ?? []).filter((t) => t.tier !== "base" && t.editable !== false && rungOffered(t.tier, offeredLadder)).map((t) => t.tier),
    [policy.data, offeredLadder]
  );
  const authored = policy.data?.tiers.find((t) => t.tier === tier)?.section ?? {};
  const resettable = canAuthor && included && KNOBS.some((key) => key in authored);
  return /* @__PURE__ */ jsxs("section", { className: "space-y-3 rounded-lg border p-4", id: "catalog-confidence", children: [
    /* @__PURE__ */ jsx("h3", { className: "text-lg font-semibold", children: "Read confidence" }),
    /* @__PURE__ */ jsxs("p", { className: "text-sm text-muted-foreground", children: [
      "Choose which catalog findings, ABIs, decoded calls, events and internal call interpretations appear. A higher floor can reduce noise, but can also hide useful findings. Scores do not guarantee correctness. Raw transactions, logs, traces, saved evidence and automated decisions are retained. Updates may take up to one minute to reach every view.",
      policyLink ? /* @__PURE__ */ jsxs(Fragment, { children: [
        " These two settings are part of your confidence policy \u2014 ",
        policyLink,
        " holds the rest of it."
      ] }) : null
    ] }),
    !included && /* @__PURE__ */ jsx("p", { className: "text-sm", children: "Your plan keeps saved preferences but does not include changing them. You can reset to inherited defaults." }),
    /* @__PURE__ */ jsx(
      ConfidencePolicyEditor,
      {
        policy,
        canAuthor: canAuthor && included,
        defaultTier: "user",
        allowedTiers,
        knobs: KNOBS,
        knobsOnly: true,
        allowClear: false,
        onTierChange: setTier,
        savedDescription: "New reads use it; stored evidence and automated decisions are unchanged. It can take up to a minute to reach every view."
      }
    ),
    resettable && // Scoped to THESE keys. The editor's own clear removes the rung's whole
    // section, which on this page would delete settings nobody here can see.
    /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        disabled: policy.busy,
        onClick: () => void policy.save(
          tier,
          Object.fromEntries(
            Object.entries(authored).filter(
              ([key]) => !KNOBS.includes(key)
            )
          )
        ),
        children: "Reset read preferences to inherited"
      }
    )
  ] });
}
var CatalogConfidencePreferences = ReadConfidencePreferences;
function help(fields, name) {
  return fields.find((f) => f.name === name)?.description;
}
function Hint({ text }) {
  if (!text) return null;
  return /* @__PURE__ */ jsx("p", { className: "text-[11px] leading-snug text-muted-foreground", children: text });
}
function OptionSelect2({
  label,
  value,
  options,
  onChange,
  hint
}) {
  return /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
    /* @__PURE__ */ jsx(Label, { className: "text-xs", children: label }),
    /* @__PURE__ */ jsxs(Select, { value, onValueChange: onChange, children: [
      /* @__PURE__ */ jsx(SelectTrigger, { className: "h-8 text-xs", "aria-label": label, children: /* @__PURE__ */ jsx(SelectValue, {}) }),
      /* @__PURE__ */ jsx(SelectContent, { children: options.map((option) => /* @__PURE__ */ jsx(SelectItem, { value: option.value, title: option.description, children: option.label }, option.value)) })
    ] }),
    /* @__PURE__ */ jsx(Hint, { text: hint })
  ] });
}
function locationOptions(catalog) {
  return catalog.valueLocations.map((location) => ({
    value: location.name,
    label: location.name.replace(/_/g, " "),
    description: location.description
  }));
}
function ValuePartRow({
  part,
  catalog,
  onChange,
  onRemove,
  canRemove
}) {
  const kind = catalog.valueLocations.find((l) => l.name === part.location)?.kind;
  const isFlag = kind === "flag";
  const isNumeric = kind === "integer";
  return /* @__PURE__ */ jsxs("div", { className: "rounded-md border border-border/60 bg-muted/20 p-2", children: [
    /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-end gap-2", children: [
      /* @__PURE__ */ jsx("div", { className: "w-[150px]", children: /* @__PURE__ */ jsx(
        OptionSelect2,
        {
          label: "Read from",
          value: part.location,
          options: locationOptions(catalog),
          onChange: (value) => (
            // Choosing a location resolves the conflict below, so the warning
            // goes with it — it describes the STORED part, not this one.
            onChange({
              ...part,
              location: value,
              operand: "",
              droppedLocations: void 0
            })
          )
        }
      ) }),
      !isFlag ? /* @__PURE__ */ jsxs("div", { className: "min-w-0 flex-1 space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: isNumeric ? "Word index" : "Path" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 text-xs",
            inputMode: isNumeric ? "numeric" : "text",
            value: part.operand,
            onChange: (e) => onChange({ ...part, operand: e.target.value }),
            placeholder: isNumeric ? "0" : "message.messageId"
          }
        )
      ] }) : (
        // A flag location IS the value — there is nothing to type, and an
        // input here would invite an operand the engine ignores.
        /* @__PURE__ */ jsx("p", { className: "min-w-0 flex-1 pb-2 text-[11px] text-muted-foreground", children: "Reads the leg itself; nothing further to configure." })
      ),
      /* @__PURE__ */ jsx("div", { className: "w-[130px]", children: /* @__PURE__ */ jsx(
        OptionSelect2,
        {
          label: "Normalise",
          value: part.transform,
          options: catalog.transforms,
          onChange: (value) => onChange({ ...part, transform: value })
        }
      ) }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "icon",
          className: "mb-1 h-8 w-8",
          onClick: onRemove,
          disabled: !canRemove,
          "aria-label": "Remove value part",
          children: /* @__PURE__ */ jsx(Trash2, { className: "h-3.5 w-3.5", "aria-hidden": true })
        }
      )
    ] }),
    part.droppedLocations?.length ? (
      // A stored part that set more than one location. The engine resolves it
      // by whichever branch its resolver tests first, so the rule is already
      // ambiguous — but saving from here silently picks one and drops the
      // rest, and the author would never know their rule changed.
      /* @__PURE__ */ jsxs("p", { className: "mt-2 rounded border border-dashed border-amber-500/50 px-2 py-1 text-[11px] leading-snug text-muted-foreground", children: [
        "This part also sets ",
        part.droppedLocations.join(", "),
        ". A value part reads from exactly one location \u2014 saving keeps",
        " ",
        /* @__PURE__ */ jsx("span", { className: "font-medium", children: part.location }),
        " and drops the rest."
      ] })
    ) : null,
    part.location === "data_bytes_word" ? /* @__PURE__ */ jsxs("div", { className: "mt-2 flex gap-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "w-[120px] space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Byte offset" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 text-xs",
            value: part.byteOffset,
            onChange: (e) => onChange({ ...part, byteOffset: e.target.value }),
            placeholder: "0"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "w-[120px] space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Byte length" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 text-xs",
            value: part.byteLength,
            onChange: (e) => onChange({ ...part, byteLength: e.target.value }),
            placeholder: "to the end"
          }
        )
      ] })
    ] }) : null
  ] });
}
function SelectorCard({
  selector,
  index,
  catalog,
  error,
  onChange,
  onRemove,
  canRemove
}) {
  const setPart = (partIndex, next) => onChange({
    ...selector,
    value: selector.value.map((p, i) => i === partIndex ? next : p)
  });
  return /* @__PURE__ */ jsxs("div", { className: "rounded-md border border-border/60 p-3", children: [
    /* @__PURE__ */ jsxs("div", { className: "mb-2 flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsxs("span", { className: "text-xs font-medium", children: [
        "Leg ",
        index + 1
      ] }),
      /* @__PURE__ */ jsx(
        Button,
        {
          variant: "ghost",
          size: "icon",
          className: "h-7 w-7",
          onClick: onRemove,
          disabled: !canRemove,
          "aria-label": `Remove leg ${index + 1}`,
          children: /* @__PURE__ */ jsx(Trash2, { className: "h-3.5 w-3.5", "aria-hidden": true })
        }
      )
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-2 sm:grid-cols-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Role" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 text-xs",
            value: selector.role,
            onChange: (e) => onChange({ ...selector, role: e.target.value }),
            list: `grouping-roles-${index}`,
            placeholder: "source"
          }
        ),
        /* @__PURE__ */ jsx("datalist", { id: `grouping-roles-${index}`, children: catalog.roles.known.map((role) => /* @__PURE__ */ jsx("option", { value: role }, role)) }),
        /* @__PURE__ */ jsx(Hint, { text: help(catalog.selectorFields, "role") })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Event name" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 text-xs",
            value: selector.event,
            onChange: (e) => onChange({ ...selector, event: e.target.value }),
            placeholder: "CCIPSendRequested"
          }
        ),
        /* @__PURE__ */ jsx(Hint, { text: help(catalog.selectorFields, "event") })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Topic0" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 font-mono text-xs",
            value: selector.topic0,
            onChange: (e) => onChange({ ...selector, topic0: e.target.value }),
            placeholder: "0x\u2026"
          }
        ),
        /* @__PURE__ */ jsx(Hint, { text: help(catalog.selectorFields, "topic0") })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-end gap-2 pb-1", children: [
        /* @__PURE__ */ jsx(
          Switch,
          {
            id: `include-call-${index}`,
            checked: selector.includeCall,
            onCheckedChange: (v) => onChange({ ...selector, includeCall: v })
          }
        ),
        /* @__PURE__ */ jsx(Label, { htmlFor: `include-call-${index}`, className: "text-xs", children: "Also match the top-level call" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "mt-3 space-y-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Value parts" }),
        /* @__PURE__ */ jsxs(
          Button,
          {
            variant: "ghost",
            size: "sm",
            className: "h-7 text-xs",
            onClick: () => onChange({ ...selector, value: [...selector.value, emptyPart(catalog)] }),
            children: [
              /* @__PURE__ */ jsx(Plus, { className: "mr-1 h-3 w-3", "aria-hidden": true }),
              "Add part"
            ]
          }
        )
      ] }),
      selector.value.map((part, partIndex) => /* @__PURE__ */ jsx(
        ValuePartRow,
        {
          part,
          catalog,
          onChange: (next) => setPart(partIndex, next),
          onRemove: () => onChange({
            ...selector,
            value: selector.value.filter((_, i) => i !== partIndex)
          }),
          canRemove: selector.value.length > 1
        },
        partIndex
      )),
      /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: "Parts are joined with \u201C:\u201D into this leg's key. Two legs match when their joined values are equal." })
    ] }),
    error ? /* @__PURE__ */ jsx("p", { className: "mt-2 text-[11px] text-destructive", children: error }) : null
  ] });
}
var MATCH_LABELS = {
  between: "Between these addresses",
  touching: "Touching any of these addresses"
};
var GROUP_BY_LABELS = {
  rule: "One group for everything",
  address: "One group per listed address",
  pair: "One group per pair of addresses",
  counterparty: "One group per counterparty"
};
var DIRECTION_LABELS = {
  any: "Sent or received",
  outgoing: "Sent by a listed address",
  incoming: "Received by a listed address"
};
function relabel(options, labels) {
  return options.map((o) => ({ ...o, label: labels[o.value] ?? o.label }));
}
function Err({ text }) {
  if (!text) return null;
  return /* @__PURE__ */ jsx("p", { className: "text-[11px] text-destructive", children: text });
}
function FlowEditor({
  draft,
  flowCatalog,
  errors,
  showErrors,
  onChange
}) {
  const flow = draft.flow;
  const setFlow = (key, value) => onChange({ ...draft, flow: { ...flow, [key]: value } });
  const touching = flow.match === "touching";
  const addressCount = new Set(splitAddresses(flow.addresses)).size;
  const fieldHelp = (name) => help(flowCatalog.fields, name);
  const groupBys = flowCatalog.groupBys.filter(
    // A counterparty only exists when one end may be outside the list.
    (o) => touching || o.value !== "counterparty"
  );
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
    /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Saga kind" }),
      /* @__PURE__ */ jsx(
        Input,
        {
          className: "h-8 text-xs",
          value: draft.sagaKind,
          onChange: (e) => onChange({ ...draft, sagaKind: e.target.value }),
          placeholder: "custom.treasury_wallets"
        }
      ),
      showErrors && errors.sagaKind ? /* @__PURE__ */ jsx(Err, { text: errors.sagaKind }) : /* @__PURE__ */ jsx(Hint, { text: "Names this rule's groups, and what it competes for \u2014 one rule applies per kind." })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", htmlFor: "flow-addresses", children: "Addresses" }),
        /* @__PURE__ */ jsxs("span", { className: "text-[11px] text-muted-foreground", children: [
          addressCount,
          " of ",
          flowCatalog.maxAddresses
        ] })
      ] }),
      /* @__PURE__ */ jsx(
        Textarea,
        {
          id: "flow-addresses",
          className: "font-mono text-[11px]",
          rows: 4,
          spellCheck: false,
          value: flow.addresses,
          onChange: (e) => setFlow("addresses", e.target.value),
          placeholder: "0x\u2026\n0x\u2026\n0x\u2026"
        }
      ),
      showErrors && errors.addresses ? /* @__PURE__ */ jsx(Err, { text: errors.addresses }) : /* @__PURE__ */ jsx(Hint, { text: "One per line. EVM addresses are matched case-insensitively; base58 addresses exactly." })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-2 sm:grid-cols-2", children: [
      /* @__PURE__ */ jsx(
        OptionSelect2,
        {
          label: "Match transactions",
          value: flow.match,
          options: relabel(flowCatalog.matches, MATCH_LABELS),
          onChange: (value) => onChange({
            ...draft,
            flow: {
              ...flow,
              match: value,
              // Leaving "touching" takes its only group-by with it.
              groupBy: value !== "touching" && flow.groupBy === "counterparty" ? flowCatalog.groupBys[0]?.value ?? "rule" : flow.groupBy
            }
          }),
          hint: flowCatalog.matches.find((o) => o.value === flow.match)?.description
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(
          OptionSelect2,
          {
            label: "Group into",
            value: flow.groupBy,
            options: relabel(groupBys, GROUP_BY_LABELS),
            onChange: (value) => setFlow("groupBy", value),
            hint: flowCatalog.groupBys.find((o) => o.value === flow.groupBy)?.description
          }
        ),
        showErrors ? /* @__PURE__ */ jsx(Err, { text: errors.groupBy }) : null
      ] })
    ] }),
    touching ? /* @__PURE__ */ jsxs("div", { className: "space-y-2 rounded-md border border-border/60 p-3", children: [
      /* @__PURE__ */ jsx(
        OptionSelect2,
        {
          label: "Direction",
          value: flow.direction,
          options: relabel(flowCatalog.directions, DIRECTION_LABELS),
          onChange: (value) => setFlow("direction", value),
          hint: fieldHelp("direction")
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", htmlFor: "flow-counterparties", children: "Only with these counterparties" }),
        /* @__PURE__ */ jsx(
          Textarea,
          {
            id: "flow-counterparties",
            className: "font-mono text-[11px]",
            rows: 2,
            spellCheck: false,
            value: flow.counterparties,
            onChange: (e) => setFlow("counterparties", e.target.value),
            placeholder: "Anyone \u2014 or one address per line"
          }
        ),
        showErrors && errors.counterparties ? /* @__PURE__ */ jsx(Err, { text: errors.counterparties }) : /* @__PURE__ */ jsx(Hint, { text: fieldHelp("counterparties") })
      ] })
    ] }) : null,
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-2 sm:grid-cols-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Only these assets" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 font-mono text-xs",
            value: flow.assets,
            onChange: (e) => setFlow("assets", e.target.value),
            placeholder: `Any \u2014 or ${flowCatalog.nativeAsset}, 0x\u2026 token`
          }
        ),
        showErrors && errors.assets ? /* @__PURE__ */ jsx(Err, { text: errors.assets }) : /* @__PURE__ */ jsx(Hint, { text: fieldHelp("assets") })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Most transactions per group" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 text-xs",
            inputMode: "numeric",
            value: draft.maxMembers,
            onChange: (e) => onChange({ ...draft, maxMembers: e.target.value }),
            placeholder: "500"
          }
        ),
        showErrors && errors.maxMembers ? /* @__PURE__ */ jsx(Err, { text: errors.maxMembers }) : /* @__PURE__ */ jsx(Hint, { text: "These groups never complete; past this many they stop growing." })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-2", children: [
      /* @__PURE__ */ jsx(
        Switch,
        {
          id: "flow-include-calls",
          checked: flow.includeCalls,
          onCheckedChange: (v) => setFlow("includeCalls", v)
        }
      ),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Label, { htmlFor: "flow-include-calls", className: "text-xs", children: "Include direct calls that move no value" }),
        /* @__PURE__ */ jsx(Hint, { text: fieldHelp("include_calls") })
      ] })
    ] })
  ] });
}
function SpecBuilder({
  draft,
  catalog,
  onChange,
  showErrors
}) {
  const errors = validateDraft(draft);
  const set = (key, value) => onChange({ ...draft, [key]: value });
  const matchToggle = catalog.flow ? /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-center justify-between gap-2", children: [
    /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Group transactions that share" }),
    /* @__PURE__ */ jsx(
      ViewModeToggle,
      {
        options: [
          {
            value: "addresses",
            label: "Addresses",
            title: "Everything moving between (or touching) addresses you list"
          },
          {
            value: "id",
            label: "An identifier",
            title: "A value the protocol writes on every leg \u2014 a message id, a deposit key"
          }
        ],
        value: draft.matchBy,
        onChange: (next) => onChange(withMatchBy(draft, next, catalog))
      }
    )
  ] }) : null;
  if (draft.matchBy === "addresses" && catalog.flow) {
    return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
      matchToggle,
      /* @__PURE__ */ jsx(
        FlowEditor,
        {
          draft,
          flowCatalog: catalog.flow,
          errors,
          showErrors,
          onChange
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
    matchToggle,
    /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-2 sm:grid-cols-2", children: [
      /* @__PURE__ */ jsx(
        OptionSelect2,
        {
          label: "Relationship",
          value: draft.type,
          options: catalog.relationshipTypes,
          onChange: (v) => set("type", v),
          hint: help(catalog.specFields, "type")
        }
      ),
      /* @__PURE__ */ jsx(
        OptionSelect2,
        {
          label: "Linkage model",
          value: draft.linkageModel,
          options: catalog.linkageModels,
          onChange: (v) => set("linkageModel", v),
          hint: help(catalog.specFields, "linkage_model")
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Id label" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 text-xs",
            value: draft.idLabel,
            onChange: (e) => set("idLabel", e.target.value),
            placeholder: "message_id"
          }
        ),
        showErrors && errors.idLabel ? /* @__PURE__ */ jsx("p", { className: "text-[11px] text-destructive", children: errors.idLabel }) : /* @__PURE__ */ jsx(Hint, { text: help(catalog.specFields, "id_label") })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Saga kind" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 text-xs",
            value: draft.sagaKind,
            onChange: (e) => set("sagaKind", e.target.value),
            placeholder: "bridge.my_protocol"
          }
        ),
        showErrors && errors.sagaKind ? /* @__PURE__ */ jsx("p", { className: "text-[11px] text-destructive", children: errors.sagaKind }) : /* @__PURE__ */ jsx(Hint, { text: help(catalog.specFields, "saga_kind") })
      ] }),
      /* @__PURE__ */ jsx(
        OptionSelect2,
        {
          label: "Read the id from",
          value: draft.truthLocation,
          options: catalog.truthLocations,
          onChange: (v) => set("truthLocation", v),
          hint: help(catalog.specFields, "truth_location")
        }
      ),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Complete when present" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            className: "h-8 text-xs",
            value: draft.completeRoles,
            onChange: (e) => set("completeRoles", e.target.value),
            placeholder: "source, destination"
          }
        ),
        showErrors && errors.completeRoles ? /* @__PURE__ */ jsx("p", { className: "text-[11px] text-destructive", children: errors.completeRoles }) : /* @__PURE__ */ jsx(
          Hint,
          {
            text: draft.openEnded ? "Ignored: an open-ended group never completes." : help(catalog.specFields, "complete_roles")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex items-start gap-2", children: [
      /* @__PURE__ */ jsx(
        Switch,
        {
          id: "spec-open-ended",
          checked: draft.openEnded,
          onCheckedChange: (v) => set("openEnded", v)
        }
      ),
      /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(Label, { htmlFor: "spec-open-ended", className: "text-xs", children: "Keep collecting \u2014 never complete" }),
        /* @__PURE__ */ jsx(Hint, { text: help(catalog.specFields, "open_ended") })
      ] })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Legs" }),
        /* @__PURE__ */ jsxs(
          Button,
          {
            variant: "ghost",
            size: "sm",
            className: "h-7 text-xs",
            onClick: () => set("selectors", [...draft.selectors, emptySelector(catalog)]),
            children: [
              /* @__PURE__ */ jsx(Plus, { className: "mr-1 h-3 w-3", "aria-hidden": true }),
              "Add leg"
            ]
          }
        )
      ] }),
      draft.selectors.map((selector, index) => /* @__PURE__ */ jsx(
        SelectorCard,
        {
          selector,
          index,
          catalog,
          error: showErrors ? errors.selectors?.[index] : void 0,
          onChange: (next) => set(
            "selectors",
            draft.selectors.map((s, i) => i === index ? next : s)
          ),
          onRemove: () => set("selectors", draft.selectors.filter((_, i) => i !== index)),
          canRemove: draft.selectors.length > 1
        },
        index
      ))
    ] })
  ] });
}
var EXAMPLE_SPEC = `{
  "type": "cross_chain_message",
  "linkage_model": "deterministic",
  "id_label": "message_id",
  "saga_kind": "bridge.my_protocol",
  "truth_location": "decoded_args",
  "complete_roles": ["source", "destination"],
  "selectors": []
}`;
function initialValues(rule, fallbackScope, startFrom) {
  const seed = rule ?? startFrom;
  return {
    name: seed?.name ?? "",
    description: seed?.description ?? "",
    scope: rule?.scope ?? startFrom?.scope ?? fallbackScope,
    enabled: seed?.enabled ?? true,
    priority: seed?.priority ?? 100,
    sagaKind: seed?.sagaKind ?? "",
    chainIds: seed?.chainIds ?? [],
    specText: seed?.spec ? JSON.stringify(seed.spec, null, 2) : EXAMPLE_SPEC
  };
}
function GroupingRuleDialog({
  source,
  open,
  onOpenChange,
  rule,
  startFrom,
  canAuthorSystem,
  defaultScope,
  scopes: allowedScopes,
  onSaved
}) {
  const editing = rule !== void 0;
  const [values, setValues] = React26.useState(
    () => initialValues(rule, defaultScope, startFrom)
  );
  const [saving, setSaving] = React26.useState(false);
  const [touched, setTouched] = React26.useState(false);
  const [chosenMode, setMode] = React26.useState("builder");
  const [draft, setDraft] = React26.useState(() => emptyDraft());
  const { data: catalog, error: catalogError, refetch: retryCatalog } = useAsyncResource(
    () => open ? source.specCatalog() : Promise.resolve(void 0),
    [source, open]
  );
  const catalogFailed = open && !catalog && Boolean(catalogError);
  const builderCatalog = catalog?.valueLocations.length ? catalog : void 0;
  const builderUnavailable = Boolean(catalog) && !builderCatalog || catalogFailed;
  const mode = builderUnavailable ? "json" : chosenMode;
  React26.useEffect(() => {
    if (!open) return;
    setValues(initialValues(rule, defaultScope, startFrom));
    setTouched(false);
    setMode("builder");
  }, [open, rule, defaultScope, startFrom]);
  React26.useEffect(() => {
    if (!open || !builderCatalog) return;
    setDraft(
      rule ? specToDraft(rule.spec, builderCatalog) : startFrom?.spec ? specToDraft(startFrom.spec, builderCatalog) : builderCatalog.flow ? withMatchBy(emptyDraft(builderCatalog), "addresses", builderCatalog) : emptyDraft(builderCatalog)
    );
  }, [open, rule, startFrom, builderCatalog]);
  React26.useEffect(() => {
    if (mode !== "builder" || !builderCatalog) return;
    setValues((prev) => ({
      ...prev,
      specText: JSON.stringify(draftToSpec(draft), null, 2)
    }));
  }, [draft, mode, builderCatalog]);
  const required = React26.useMemo(() => requiredSpecFields(catalog), [catalog]);
  const errors = validate(values, required);
  const scopes = scopeOptions(catalog?.scopes ?? [], canAuthorSystem, values.scope, allowedScopes);
  const scopeHelp = scopes.find((scope) => scope.value === values.scope)?.description;
  const set = (key, value) => setValues((prev) => ({ ...prev, [key]: value }));
  function switchMode(next) {
    if (next === "builder" && mode === "json") {
      if (!builderCatalog) return;
      const { spec } = parseSpec(values.specText);
      if (!spec) {
        setTouched(true);
        return;
      }
      setDraft(specToDraft(spec, builderCatalog));
    }
    setMode(next);
  }
  async function submit() {
    setTouched(true);
    if (mode === "builder" && !draftIsValid(draft)) return;
    if (!isValid(values, required)) return;
    setSaving(true);
    try {
      if (editing) {
        await source.update(rule.id, toUpdateInput(values));
      } else {
        await source.create(toCreateInput(values));
      }
      notifySuccess(editing ? "Rule updated" : "Rule created", {
        description: "Applies to runs that start in about a minute. Transactions already ingested are not regrouped until they are run again."
      });
      onOpenChange(false);
      onSaved();
    } catch (err) {
      const problems = err?.details?.problems;
      const reasons = Array.isArray(problems) ? problems.map(String).filter(Boolean) : [];
      notifyError(
        reasons.length ? `The grouping engine cannot use this spec: ${reasons.join("; ")}` : err instanceof Error ? err.message : String(err)
      );
    } finally {
      setSaving(false);
    }
  }
  const showError = (key) => touched ? errors[key] : void 0;
  return /* @__PURE__ */ jsx(Dialog, { open, onOpenChange, children: /* @__PURE__ */ jsxs(DialogContent, { className: "max-h-[90vh] overflow-y-auto sm:max-w-[560px]", children: [
    /* @__PURE__ */ jsxs(DialogHeader, { children: [
      /* @__PURE__ */ jsx(DialogTitle, { children: editing ? "Edit grouping rule" : "New grouping rule" }),
      /* @__PURE__ */ jsx(DialogDescription, { children: "The engine applies one rule per saga kind \u2014 the most specific enabled one. A rule here overrides the tier above it rather than combining with it." })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "space-y-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Name" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            value: values.name,
            onChange: (e) => set("name", e.target.value),
            placeholder: "Our bridge's message correlation"
          }
        ),
        showError("name") ? /* @__PURE__ */ jsx("p", { className: "text-[11px] text-destructive", children: errors.name }) : null
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Description" }),
        /* @__PURE__ */ jsx(
          Input,
          {
            value: values.description,
            onChange: (e) => set("description", e.target.value),
            placeholder: "What this rule correlates, and why (shown in the list)"
          }
        )
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "grid grid-cols-1 gap-3 sm:grid-cols-2", children: [
        /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Applies at" }),
          /* @__PURE__ */ jsxs(
            Select,
            {
              value: values.scope,
              onValueChange: (v) => set("scope", v),
              disabled: editing,
              children: [
                /* @__PURE__ */ jsx(SelectTrigger, { className: "h-8 text-xs", "aria-label": "Scope this rule applies at", children: /* @__PURE__ */ jsx(SelectValue, {}) }),
                /* @__PURE__ */ jsx(SelectContent, { children: scopes.map((scope) => /* @__PURE__ */ jsx(SelectItem, { value: scope.value, title: scope.description, children: scope.label }, scope.value)) })
              ]
            }
          ),
          /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: editing ? "A rule's tier is fixed once created \u2014 delete and re-create to move it." : scopeHelp })
        ] }),
        /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
          /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Priority" }),
          /* @__PURE__ */ jsx(
            Input,
            {
              type: "number",
              value: values.priority,
              onChange: (e) => set("priority", Number(e.target.value))
            }
          ),
          /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: "Lower wins, but only against rules at the same tier." }),
          showError("priority") ? /* @__PURE__ */ jsx("p", { className: "text-[11px] text-destructive", children: errors.priority }) : null
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Chains" }),
        /* @__PURE__ */ jsx(
          ChainMultiSelect,
          {
            value: values.chainIds,
            onChange: (chainIds) => set("chainIds", chainIds),
            valueKind: CANONICAL_CHAIN_VALUE_KIND,
            fallback: "slug",
            includeTestnets: true,
            allChainsLabel: "Every chain",
            clearLabel: "Clear \u2014 applies to every chain"
          }
        ),
        /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: values.chainIds.length === 0 ? "Every chain. A rule with no chain restriction competes for its saga kind everywhere." : `Only on ${values.chainIds.length} chain${values.chainIds.length === 1 ? "" : "s"} \u2014 transactions on any other chain will not match this rule, however well the spec fits.` })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ jsx(Label, { className: "text-xs", children: "Relationship spec" }),
          /* @__PURE__ */ jsx(
            ViewModeToggle,
            {
              options: [
                {
                  value: "builder",
                  label: "Builder",
                  // Loaded from an API that predates the location vocabulary,
                  // or not loaded at all.
                  disabled: builderUnavailable,
                  title: catalogFailed ? "The builder's vocabulary could not be loaded. Edit the spec as JSON." : builderUnavailable ? "The builder needs a newer grouping API. Edit the spec as JSON." : void 0
                },
                {
                  value: "json",
                  label: "JSON",
                  title: "The same spec as the API stores it. Edit here for anything the builder does not yet model."
                }
              ],
              value: mode,
              onChange: switchMode
            }
          )
        ] }),
        mode === "builder" && builderCatalog ? /* @__PURE__ */ jsx(
          SpecBuilder,
          {
            draft,
            catalog: builderCatalog,
            onChange: setDraft,
            showErrors: touched
          }
        ) : mode === "builder" ? /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: "Loading the vocabulary\u2026" }) : /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            Textarea,
            {
              value: values.specText,
              onChange: (e) => set("specText", e.target.value),
              rows: 14,
              spellCheck: false,
              className: "font-mono text-[11px]"
            }
          ),
          catalogFailed ? /* @__PURE__ */ jsxs("p", { className: "text-[11px] text-amber-600 dark:text-amber-500", children: [
            "The builder's vocabulary could not be loaded, so the spec is edited as JSON \u2014 the API still checks it on save.",
            " ",
            /* @__PURE__ */ jsx("button", { type: "button", className: "underline", onClick: retryCatalog, children: "Retry" })
          ] }) : null,
          showError("specText") ? /* @__PURE__ */ jsx("p", { className: "text-[11px] text-destructive", children: errors.specText }) : /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: "An escape hatch for anything the builder does not model yet. Switching back to the builder keeps these edits, including fields it has no control for." })
        ] })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(
          Switch,
          {
            checked: values.enabled,
            onCheckedChange: (v) => set("enabled", v),
            id: "grouping-rule-enabled"
          }
        ),
        /* @__PURE__ */ jsx(Label, { htmlFor: "grouping-rule-enabled", className: "text-xs", children: "Enabled" })
      ] })
    ] }),
    /* @__PURE__ */ jsxs(DialogFooter, { children: [
      /* @__PURE__ */ jsx(Button, { variant: "ghost", size: "sm", onClick: () => onOpenChange(false), children: "Cancel" }),
      /* @__PURE__ */ jsx(Button, { size: "sm", onClick: submit, disabled: saving, children: saving ? "Saving\u2026" : editing ? "Save changes" : "Create rule" })
    ] })
  ] }) });
}
var ORIGIN = {
  bundled_catalog: {
    label: "Bundled recipe",
    title: "A recipe shipped with the grouping engine that reads the protocol's raw logs. Override it by authoring a rule for its saga kind \u2014 the override starts as an exact copy."
  },
  protocol_definition: {
    label: "Protocol definition",
    title: "The protocol definition's own cross-chain linkage, extracted when a transaction is decoded. Override it by authoring a rule for its saga kind; the override starts from its identity, and the selectors are yours to write."
  },
  engine_rule: {
    label: "Engine rule",
    title: "Behavioural grouping implemented in the engine itself. It has no spec to override \u2014 turn it off instead, which the grouping settings record per saga kind."
  }
};
var STATE = {
  in_effect: { label: "In effect", variant: "default" },
  replaced: { label: "Replaced", variant: "secondary" },
  replaced_on_chains: { label: "Partly replaced", variant: "secondary" },
  turned_off: { label: "Turned off", variant: "outline", muted: true },
  unknown: { label: "Unknown", variant: "outline", muted: true }
};
function standingDetail(standing) {
  if (!standing) {
    return "The server could not work out what a run does with this recipe just now (its read of the rules failed). Reload to see.";
  }
  const who = standing.replacedBy.map((r) => `\u201C${r.name || r.id}\u201D (${r.scope})`).join(", ");
  switch (standing.state) {
    case "in_effect":
      return "Runs as written: no authored rule replaces it and the grouping settings leave it on.";
    case "replaced":
      return `An authored rule groups this saga kind instead: ${who}.`;
    case "replaced_on_chains":
      return `Replaced on ${standing.chainIds.map((c) => chainDisplayName(c)).join(", ")} by ${who}; it still runs on every other chain.`;
    case "turned_off":
      return standing.reason ?? "Turned off by the grouping settings.";
    default:
      return "";
  }
}
function SwitchButton({
  recipe,
  siblings,
  switching
}) {
  const [confirming, setConfirming] = React26.useState(false);
  const standing = recipe.standing?.state;
  if (!standing || !recipeCanBeSwitched(recipe)) return null;
  const busy = switching.busyKey === recipe.key;
  const on = standing === "turned_off";
  if (on) {
    return /* @__PURE__ */ jsxs(
      Button,
      {
        size: "sm",
        variant: "ghost",
        className: "h-7 shrink-0 px-2 text-xs",
        disabled: busy,
        onClick: () => void switching.onSwitch(recipe, true),
        title: `Turn ${recipe.sagaKind} back on at ${switching.tierLabel}`,
        children: [
          /* @__PURE__ */ jsx(Power, { className: "mr-1 h-3.5 w-3.5", "aria-hidden": true }),
          busy ? "Turning on\u2026" : "Turn on"
        ]
      }
    );
  }
  return /* @__PURE__ */ jsxs(AlertDialog, { open: confirming, onOpenChange: (next) => !busy && setConfirming(next), children: [
    /* @__PURE__ */ jsxs(
      Button,
      {
        size: "sm",
        variant: "ghost",
        className: "h-7 shrink-0 px-2 text-xs text-muted-foreground",
        disabled: busy,
        onClick: () => setConfirming(true),
        title: `Stop grouping ${recipe.sagaKind} at ${switching.tierLabel}`,
        children: [
          /* @__PURE__ */ jsx(PowerOff, { className: "mr-1 h-3.5 w-3.5", "aria-hidden": true }),
          "Turn off"
        ]
      }
    ),
    /* @__PURE__ */ jsxs(AlertDialogContent, { children: [
      /* @__PURE__ */ jsxs(AlertDialogHeader, { children: [
        /* @__PURE__ */ jsxs(AlertDialogTitle, { children: [
          "Turn off ",
          recipe.name,
          "?"
        ] }),
        /* @__PURE__ */ jsx(AlertDialogDescription, { asChild: true, children: /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
          /* @__PURE__ */ jsxs("p", { children: [
            "New transactions stop being grouped as",
            " ",
            /* @__PURE__ */ jsx("span", { className: "font-mono text-foreground", children: recipe.sagaKind }),
            recipe.standing?.state === "replaced" || recipe.standing?.state === "replaced_on_chains" ? " \u2014 including by the authored rules that replace this recipe, since the setting switches the saga kind, not one recipe" : "",
            ". ",
            switching.reach
          ] }),
          siblings.length > 0 ? /* @__PURE__ */ jsxs("p", { children: [
            siblings.length === 1 ? "One other recipe groups" : `${siblings.length} other recipes group`,
            " the same saga kind and stop too: ",
            siblings.map((r) => r.name).join(", "),
            "."
          ] }) : null,
          /* @__PURE__ */ jsx("p", { children: "Groups already formed keep their legs. Turning it back on is one click." })
        ] }) })
      ] }),
      /* @__PURE__ */ jsxs(AlertDialogFooter, { children: [
        /* @__PURE__ */ jsx(AlertDialogCancel, { disabled: busy, children: "Keep it on" }),
        /* @__PURE__ */ jsx(
          AlertDialogAction,
          {
            disabled: busy,
            onClick: async (e) => {
              e.preventDefault();
              await switching.onSwitch(recipe, false);
              setConfirming(false);
            },
            children: busy ? "Turning off\u2026" : `Turn off at ${switching.tierLabel}`
          }
        )
      ] })
    ] })
  ] });
}
function RecipeRow({
  recipe,
  siblings,
  canOverride,
  onOverride,
  switching
}) {
  const origin = ORIGIN[recipe.origin] ?? { label: recipe.origin, title: "" };
  const state = STATE[recipe.standing?.state ?? "unknown"] ?? STATE.unknown;
  return /* @__PURE__ */ jsxs(
    "li",
    {
      className: "flex flex-wrap items-center gap-x-3 gap-y-1 rounded-md border px-3 py-2",
      "data-testid": "builtin-recipe",
      "data-saga-kind": recipe.sagaKind,
      children: [
        /* @__PURE__ */ jsxs("div", { className: "min-w-0 flex-1", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex flex-wrap items-baseline gap-x-2", children: [
            /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", children: recipe.name }),
            /* @__PURE__ */ jsx("span", { className: "font-mono text-[11px] text-muted-foreground", title: sagaLabel(recipe.sagaKind), children: recipe.sagaKind })
          ] }),
          /* @__PURE__ */ jsx("p", { className: "text-[11px] text-muted-foreground", children: recipe.idLabel ? /* @__PURE__ */ jsxs(Fragment, { children: [
            "Correlates on ",
            /* @__PURE__ */ jsx("span", { className: "font-mono", children: recipe.idLabel }),
            recipe.recipeCount > 1 ? ` (${recipe.recipeCount} id recipes)` : ""
          ] }) : recipe.description ?? "Behavioural rule" })
        ] }),
        /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "shrink-0 whitespace-nowrap text-[10px]", title: origin.title, children: origin.label }),
        /* @__PURE__ */ jsx(
          Badge,
          {
            variant: state.variant,
            className: `shrink-0 whitespace-nowrap text-[10px]${state.muted ? " text-muted-foreground" : ""}`,
            title: standingDetail(recipe.standing),
            children: state.label
          }
        ),
        recipe.overridable && canOverride ? /* @__PURE__ */ jsxs(
          Button,
          {
            size: "sm",
            variant: "ghost",
            className: "h-7 shrink-0 px-2 text-xs",
            onClick: () => onOverride(recipe),
            title: `Author a rule for ${recipe.sagaKind} that replaces this recipe at the tier you manage`,
            children: [
              /* @__PURE__ */ jsx(Copy, { className: "mr-1 h-3.5 w-3.5", "aria-hidden": true }),
              "Override"
            ]
          }
        ) : null,
        switching ? /* @__PURE__ */ jsx(SwitchButton, { recipe, siblings, switching }) : null
      ]
    }
  );
}
function BuiltinRecipesSection({
  recipes,
  loading,
  error,
  onRetry,
  canOverride,
  onOverride,
  switching = null
}) {
  const [query, setQuery] = React26.useState("");
  const shown = React26.useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!recipes || !q) return recipes ?? [];
    return recipes.filter(
      (r) => [r.name, r.sagaKind, r.idLabel ?? "", r.protocolId ?? ""].some((v) => v.toLowerCase().includes(q))
    );
  }, [recipes, query]);
  const byKind = React26.useMemo(() => {
    const out = /* @__PURE__ */ new Map();
    for (const r of recipes ?? []) out.set(r.sagaKind, [...out.get(r.sagaKind) ?? [], r]);
    return out;
  }, [recipes]);
  const counts = React26.useMemo(() => {
    const tally = {};
    for (const r of recipes ?? []) {
      const key = r.standing?.state ?? "unknown";
      tally[key] = (tally[key] ?? 0) + 1;
    }
    return tally;
  }, [recipes]);
  return /* @__PURE__ */ jsx(Card, { className: "mt-6", "data-testid": "builtin-recipes", children: /* @__PURE__ */ jsxs(CardContent, { className: "pt-4", children: [
    /* @__PURE__ */ jsxs("div", { className: "mb-3 flex flex-wrap items-end justify-between gap-3", children: [
      /* @__PURE__ */ jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx("h3", { className: "text-sm font-semibold", children: "Built into the platform" }),
        /* @__PURE__ */ jsxs("p", { className: "max-w-2xl text-xs text-muted-foreground", children: [
          "What groups transactions before any rule is authored. A rule for the same saga kind replaces a recipe at the tiers it reaches; turning one off stops its saga kind",
          switching ? ` at ${switching.tierLabel}` : " in the grouping settings",
          "."
        ] }),
        recipes && recipes.length > 0 ? /* @__PURE__ */ jsxs("p", { className: "text-[11px] text-muted-foreground", children: [
          recipes.length,
          " recipes \xB7 ",
          counts.in_effect ?? 0,
          " in effect",
          counts.replaced || counts.replaced_on_chains ? ` \xB7 ${(counts.replaced ?? 0) + (counts.replaced_on_chains ?? 0)} replaced` : "",
          counts.turned_off ? ` \xB7 ${counts.turned_off} turned off` : ""
        ] }) : null
      ] }),
      recipes && recipes.length > 8 ? /* @__PURE__ */ jsx(
        Input,
        {
          value: query,
          onChange: (e) => setQuery(e.target.value),
          placeholder: "Filter recipes\u2026",
          "aria-label": "Filter built-in recipes",
          className: "h-8 w-56 text-xs"
        }
      ) : null
    ] }),
    loading ? /* @__PURE__ */ jsx(Skeleton, { className: "h-24 w-full" }) : error ? /* @__PURE__ */ jsx(ErrorState, { title: "Could not load the built-in recipes", error, onRetry }) : recipes === null ? (
      // A server that predates the listing — an answer, not a failure.
      /* @__PURE__ */ jsx("p", { className: "text-xs text-muted-foreground", "data-testid": "builtin-recipes-unavailable", children: "This server does not list its built-in recipes yet. They still run: every saga kind without an authored rule groups with the engine's bundled recipes and the protocol definitions' own linkage." })
    ) : shown.length === 0 ? /* @__PURE__ */ jsxs("p", { className: "text-xs text-muted-foreground", children: [
      "No recipe matches \u201C",
      query,
      "\u201D."
    ] }) : /* @__PURE__ */ jsx("ul", { className: "space-y-1.5", children: shown.map((recipe) => /* @__PURE__ */ jsx(
      RecipeRow,
      {
        recipe,
        siblings: (byKind.get(recipe.sagaKind) ?? []).filter((r) => r.key !== recipe.key),
        canOverride,
        onOverride,
        switching
      },
      recipe.key
    )) })
  ] }) });
}
var STANDING = {
  in_effect: {
    label: "In effect",
    title: "The engine applies this rule for this saga kind \u2014 on its own chains when it is restricted, and on every chain a more specific restricted rule does not cover.",
    variant: "secondary",
    muted: false
  },
  disabled: {
    label: "Disabled",
    title: "Turned off. The engine skips it before the ladder runs.",
    variant: "outline",
    muted: false
  },
  shadowed: {
    label: "Shadowed",
    title: "A more specific rule wins for this saga kind, so this one never applies. The ladder resolves to ONE rule per kind \u2014 it does not blend them.",
    variant: "outline",
    muted: true
  },
  invalid: {
    label: "Invalid spec",
    title: "The engine cannot read this rule's spec, so it is dropped before the ladder runs \u2014 nothing is shadowing it. Enabled is not the same as working: fix the spec and it will start competing.",
    variant: "destructive",
    muted: false
  },
  not_applicable: {
    label: "Not yours",
    title: "Another user's private rule. It applies to their runs only, so it neither applies to yours nor shadows any rule in them.",
    variant: "outline",
    muted: true
  },
  unknown: {
    label: "Unknown",
    title: "The server could not work out which rules are in effect just now (its read of the rule set failed). The engine still resolves them \u2014 reload to see where this one stands.",
    variant: "outline",
    muted: true
  }
};
function standingDetail2(rule, rules) {
  const standing = rule.standing;
  if (!standing) return "";
  const names = (ids) => ids.map((id) => rules.find((r) => r.id === id)?.name || id).join(", ");
  switch (standing.state) {
    case "in_effect":
      if (standing.chainIds.length) return `Applies on: ${standing.chainIds.join(", ")}.`;
      if (standing.exceptChainIds.length) {
        return `Applies on every chain except ${standing.exceptChainIds.join(", ")}, where a more specific rule applies.`;
      }
      return "Applies on every chain.";
    case "shadowed":
      return standing.shadowedBy.length ? `Shadowed by: ${names(standing.shadowedBy)}.` : "";
    case "invalid":
      return standing.problems.length ? `Problems: ${standing.problems.join("; ")}` : "";
    default:
      return "";
  }
}
function StandingBadge({
  rule,
  rules
}) {
  const { label, title, variant, muted } = STANDING[standingOf(rule)];
  const detail = standingDetail2(rule, rules);
  return /* @__PURE__ */ jsx(
    Badge,
    {
      variant,
      className: muted ? "shrink-0 whitespace-nowrap text-[10px] text-muted-foreground" : "shrink-0 whitespace-nowrap text-[10px]",
      title: detail ? `${title}

${detail}` : title,
      children: label
    }
  );
}
function MatchState({ rule }) {
  if (rule.matchCount > 0) {
    return /* @__PURE__ */ jsxs("span", { className: "text-[11px] text-muted-foreground", children: [
      rule.matchCount,
      " match",
      rule.matchCount === 1 ? "" : "es",
      rule.lastMatchedAt ? `, last ${formatRelativeTime(rule.lastMatchedAt, { unit: "seconds" })}` : ""
    ] });
  }
  const note = neverMatchedNote(rule);
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: note.warn ? "text-[11px] text-amber-600 dark:text-amber-500" : "text-[11px] text-muted-foreground",
      title: note.title,
      children: "Never matched"
    }
  );
}
function DeleteRuleButton({
  rule,
  rules,
  onConfirm,
  busy
}) {
  const impact = deletionImpact(rule, rules);
  const label = rule.name || rule.id;
  return /* @__PURE__ */ jsxs(AlertDialog, { children: [
    /* @__PURE__ */ jsx(AlertDialogTrigger, { asChild: true, children: /* @__PURE__ */ jsx(
      Button,
      {
        variant: "ghost",
        size: "icon",
        className: "h-7 w-7 text-muted-foreground hover:text-destructive",
        "aria-label": `Delete ${label}`,
        children: /* @__PURE__ */ jsx(Trash2, { className: "h-3.5 w-3.5", "aria-hidden": true })
      }
    ) }),
    /* @__PURE__ */ jsxs(AlertDialogContent, { children: [
      /* @__PURE__ */ jsxs(AlertDialogHeader, { children: [
        /* @__PURE__ */ jsxs(AlertDialogTitle, { children: [
          "Delete \u201C",
          label,
          "\u201D?"
        ] }),
        /* @__PURE__ */ jsx(AlertDialogDescription, { asChild: true, children: /* @__PURE__ */ jsxs("div", { className: "space-y-2", children: [
          /* @__PURE__ */ jsx("p", { children: "The spec is removed permanently \u2014 there is no version history for grouping rules, so re-creating it means re-authoring it." }),
          !impact.known ? /* @__PURE__ */ jsxs("p", { children: [
            "Which rule takes over for",
            " ",
            /* @__PURE__ */ jsx("span", { className: "font-mono text-foreground", children: impact.kind || "this saga kind" }),
            " ",
            "could not be determined just now \u2014 the server could not read the full rule set."
          ] }) : impact.wasInEffect ? impact.successors.length > 0 ? /* @__PURE__ */ jsxs("p", { children: [
            "This rule is one the engine applies for",
            " ",
            /* @__PURE__ */ jsx("span", { className: "font-mono text-foreground", children: impact.kind }),
            ". Deleting it promotes",
            " ",
            impact.successors.map((successor, index) => /* @__PURE__ */ jsxs(React26.Fragment, { children: [
              index > 0 ? ", " : null,
              /* @__PURE__ */ jsx("strong", { className: "text-foreground", children: successor.name || successor.id }),
              " ",
              /* @__PURE__ */ jsxs("span", { className: "capitalize", children: [
                "(",
                successor.scope
              ] }),
              ", p",
              successor.priority,
              ")"
            ] }, successor.id)),
            ", which takes over on the chains this rule held, immediately."
          ] }) : /* @__PURE__ */ jsxs("p", { children: [
            "This rule is the one the engine applies for",
            " ",
            /* @__PURE__ */ jsx("span", { className: "font-mono text-foreground", children: impact.kind }),
            ", and no other authored rule competes for it. Correlation falls back to the engine's bundled default and the protocol definitions' own linkage specs."
          ] }) : /* @__PURE__ */ jsxs("p", { children: [
            "This rule is not the one the engine applies for",
            " ",
            /* @__PURE__ */ jsx("span", { className: "font-mono text-foreground", children: impact.kind }),
            ", so deleting it does not change how anything is grouped today."
          ] })
        ] }) })
      ] }),
      /* @__PURE__ */ jsxs(AlertDialogFooter, { children: [
        /* @__PURE__ */ jsx(AlertDialogCancel, { disabled: busy, children: "Keep it" }),
        /* @__PURE__ */ jsx(
          AlertDialogAction,
          {
            disabled: busy,
            className: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
            onClick: (e) => {
              e.preventDefault();
              onConfirm(rule);
            },
            children: busy ? "Deleting\u2026" : "Delete rule"
          }
        )
      ] })
    ] })
  ] });
}
function RuleRow({
  rule,
  rules,
  canEdit: pageCanEdit,
  canDelete: pageCanDelete,
  canDisable: pageCanDisable,
  deleting,
  onEdit,
  onDelete,
  onDisable
}) {
  const locked = rule.canEdit === false;
  const canEdit = pageCanEdit && !locked;
  const canDelete = pageCanDelete && !locked;
  const canDisable = pageCanDisable && !locked;
  return (
    // Wraps: the counters and controls on the right are fixed-width, and at a
    // narrow card they starved the name to "E2E: Ne…" and folded "In effect"
    // onto two lines. Below that width the controls drop to their own line.
    /* @__PURE__ */ jsxs("li", { className: "flex flex-wrap items-center justify-between gap-x-3 gap-y-1.5 rounded-md border border-border/60 bg-card/40 px-3 py-2", children: [
      /* @__PURE__ */ jsxs("div", { className: "min-w-0 flex-1 basis-64", children: [
        /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-2", children: [
          /* @__PURE__ */ jsx("span", { className: "min-w-0 truncate text-sm font-medium", children: rule.name || rule.id }),
          /* @__PURE__ */ jsx(Badge, { variant: "outline", className: "shrink-0 whitespace-nowrap text-[10px] capitalize", children: rule.scope }),
          /* @__PURE__ */ jsx(StandingBadge, { rule, rules }),
          rule.chainIds.length > 0 ? /* @__PURE__ */ jsx(
            Badge,
            {
              variant: "outline",
              className: "shrink-0 whitespace-nowrap text-[10px] text-muted-foreground",
              title: `Only matches on: ${rule.chainIds.join(", ")}. Transactions on any other chain cannot match this rule.`,
              children: rule.chainIds.length === 1 ? rule.chainIds[0] : `${rule.chainIds.length} chains only`
            }
          ) : null
        ] }),
        flowSummary(rule.spec) ? /* @__PURE__ */ jsx("p", { className: "truncate text-xs text-foreground/80", children: flowSummary(rule.spec) }) : null,
        rule.description ? /* @__PURE__ */ jsx("p", { className: "truncate text-xs text-muted-foreground", children: rule.description }) : null
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "ml-auto flex shrink-0 items-center gap-3", children: [
        /* @__PURE__ */ jsx(MatchState, { rule }),
        /* @__PURE__ */ jsxs("span", { className: "text-[11px] text-muted-foreground", title: "Lower wins within a scope.", children: [
          "p",
          rule.priority
        ] }),
        locked ? (
          // The API's own write gate said no for this row — typically a
          // platform `system` rule seen from a tenant. Saying so beats three
          // controls that would each come back 403.
          /* @__PURE__ */ jsx(
            "span",
            {
              className: "whitespace-nowrap text-[11px] text-muted-foreground",
              title: "You can use this rule but not change it. Platform rules are managed in the admin portal.",
              children: "Read-only"
            }
          )
        ) : null,
        canEdit ? /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "icon",
            className: "h-7 w-7",
            "aria-label": `Edit ${rule.name || rule.id}`,
            onClick: () => onEdit(rule),
            children: /* @__PURE__ */ jsx(Pencil, { className: "h-3.5 w-3.5", "aria-hidden": true })
          }
        ) : null,
        !canEdit && canDisable && rule.enabled ? /* @__PURE__ */ jsx(
          Button,
          {
            variant: "ghost",
            size: "icon",
            className: "h-7 w-7",
            "aria-label": `Turn off ${rule.name || rule.id}`,
            title: "Turn this rule off. Your plan no longer includes editing rules, but a rule can always be stopped.",
            onClick: () => onDisable(rule),
            children: /* @__PURE__ */ jsx(PowerOff, { className: "h-3.5 w-3.5", "aria-hidden": true })
          }
        ) : null,
        canDelete ? /* @__PURE__ */ jsx(DeleteRuleButton, { rule, rules, onConfirm: onDelete, busy: deleting }) : null
      ] })
    ] })
  );
}
function GroupingRulesManager({
  source,
  canWrite,
  authoringIncluded = true,
  canAuthorSystem,
  defaultScope,
  scopes,
  header,
  emptyDescription = "The engine is running on its bundled defaults and the protocol definitions' own linkage specs. Author a rule to override how a saga kind is correlated.",
  runsGrouping,
  policy
}) {
  const canCreate = canWrite && authoringIncluded;
  const canEdit = canWrite && authoringIncluded;
  const canDelete = canWrite;
  const canDisable = canWrite;
  const { data, isLoading, error, refetch: refetchRules } = useAsyncResource(() => source.list(), [source]);
  const builtins = useAsyncResource(
    () => source.builtins ? source.builtins() : Promise.resolve(void 0),
    [source, policy?.revision]
  );
  const policySource = policy?.source;
  const policyView = useAsyncResource(
    () => policySource ? policySource.read() : Promise.resolve(void 0),
    [policySource, policy?.revision]
  );
  const refetchPolicy = policyView.refetch;
  const refetchBuiltins = builtins.refetch;
  const refetch = React26.useCallback(() => {
    refetchRules();
    refetchBuiltins();
  }, [refetchRules, refetchBuiltins]);
  const [editing, setEditing] = React26.useState();
  const [startFrom, setStartFrom] = React26.useState();
  const [dialogOpen, setDialogOpen] = React26.useState(false);
  const rules = React26.useMemo(() => data ?? [], [data]);
  const buckets = React26.useMemo(() => groupBySagaKind(rules), [rules]);
  const openCreate = () => {
    setEditing(void 0);
    setStartFrom(void 0);
    setDialogOpen(true);
  };
  const openEdit = (rule) => {
    setEditing(rule);
    setStartFrom(void 0);
    setDialogOpen(true);
  };
  const openOverride = (recipe) => {
    setEditing(void 0);
    setStartFrom(builtinOverrideDraft(recipe, defaultScope));
    setDialogOpen(true);
  };
  const [switchingKey, setSwitchingKey] = React26.useState(null);
  const policyTier = policy?.tier;
  const policyRung = policyView.data?.tiers.find((t) => t.tier === policyTier);
  const onPolicyChanged = policy?.onChanged;
  const switchRecipe = React26.useCallback(
    async (recipe, on) => {
      if (!policySource || !policyTier) return;
      setSwitchingKey(recipe.key);
      try {
        const view = await policySource.read();
        await policySource.save(policyTier, sectionWithRecipeSwitched(view, policyTier, recipe, on));
        notifySuccess(on ? `${recipe.name} turned on` : `${recipe.name} turned off`, {
          description: "Applies to transactions grouped from now on. Groups already formed keep their legs."
        });
        refetchPolicy();
        refetchBuiltins();
        onPolicyChanged?.();
      } catch (err) {
        notifyError(err instanceof Error ? err.message : String(err));
      } finally {
        setSwitchingKey(null);
      }
    },
    [policySource, policyTier, refetchPolicy, refetchBuiltins, onPolicyChanged]
  );
  const switching = policy && policyRung?.editable && canCreate ? {
    tierLabel: policyRung.label,
    reach: policy.reach ?? `It applies wherever ${policyRung.label} settings reach, unless a narrower scope sets its own.`,
    onSwitch: switchRecipe,
    busyKey: switchingKey
  } : null;
  const disable = async (rule) => {
    try {
      await source.update(rule.id, { enabled: false });
      notifySuccess("Rule turned off", {
        description: "It no longer groups transactions. Deleting it is always possible too."
      });
      refetch();
    } catch (err) {
      notifyError(err instanceof Error ? err.message : String(err));
    }
  };
  const [deletingId, setDeletingId] = React26.useState(null);
  const remove = async (rule) => {
    setDeletingId(rule.id);
    try {
      await source.remove(rule.id);
      const { successors, wasInEffect } = deletionImpact(rule, rules);
      notifySuccess("Rule deleted", {
        description: wasInEffect && successors.length ? `${successors.map((s) => `\u201C${s.name || s.id}\u201D`).join(", ")} now in effect where this rule applied.` : wasInEffect ? "No authored rule takes its place \u2014 the engine's bundled default applies there now." : void 0
      });
      refetch();
    } catch (err) {
      notifyError(err instanceof Error ? err.message : String(err));
    } finally {
      setDeletingId(null);
    }
  };
  const newRule = canCreate ? /* @__PURE__ */ jsxs(Button, { size: "sm", onClick: openCreate, children: [
    /* @__PURE__ */ jsx(Plus, { className: "mr-1.5 h-4 w-4", "aria-hidden": true }),
    "New rule"
  ] }) : null;
  return /* @__PURE__ */ jsxs("div", { children: [
    header ? header(newRule) : newRule ? /* @__PURE__ */ jsx("div", { className: "mb-4 flex justify-end", children: newRule }) : null,
    runsGrouping && !runsGrouping.any ? (
      // Not a plan refusal and not a broken rule: the pipelines available to
      // this caller switch the grouping lane off, so nothing here is applied.
      /* @__PURE__ */ jsx(Alert, { className: "mb-4", children: /* @__PURE__ */ jsx(AlertDescription, { children: "None of the pipelines you can run evaluate grouping rules \u2014 the tiers that skip the grouping lane (Fast, Minimum) are the only ones on offer, so the rules below are authored but never applied. Pick a pipeline that runs grouping when you start a run, or ask an operator to switch the lane on for the tier you use." }) })
    ) : null,
    !authoringIncluded ? (
      // State the ceiling rather than offer a control that would be refused.
      /* @__PURE__ */ jsx(Alert, { className: "mb-4", children: /* @__PURE__ */ jsx(AlertDescription, { children: "Your plan does not include custom grouping rules. The bundled grouping keeps working, and so do the rules you already have \u2014 you can turn them off or delete them, but not create or edit them." }) })
    ) : null,
    /* @__PURE__ */ jsx(
      GroupingRuleDialog,
      {
        source,
        open: dialogOpen,
        onOpenChange: setDialogOpen,
        rule: editing,
        startFrom,
        canAuthorSystem,
        defaultScope,
        scopes,
        onSaved: refetch
      }
    ),
    isLoading ? /* @__PURE__ */ jsx(Skeleton, { className: "h-40 w-full" }) : error ? /* @__PURE__ */ jsx(
      ErrorState,
      {
        title: "Could not load grouping rules",
        error,
        onRetry: refetch
      }
    ) : rules.length === 0 ? /* @__PURE__ */ jsx(
      EmptyState,
      {
        title: "No grouping rules authored",
        description: builtins.data?.length ? `Nothing overrides the platform here: every saga kind groups with the ${builtins.data.length} built-in recipes below.` : emptyDescription,
        action: canCreate ? /* @__PURE__ */ jsx(Button, { size: "sm", onClick: openCreate, children: "New rule" }) : void 0
      }
    ) : /* @__PURE__ */ jsx("div", { className: "space-y-4", children: buckets.map((bucket) => /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsxs(CardContent, { className: "pt-4", children: [
      /* @__PURE__ */ jsxs("div", { className: "mb-2 flex items-center gap-2", children: [
        /* @__PURE__ */ jsx("span", { className: "text-sm font-medium", children: bucket.kind ? sagaLabel(bucket.kind) : "No saga kind" }),
        bucket.kind ? /* @__PURE__ */ jsx("span", { className: "font-mono text-[11px] text-muted-foreground", children: bucket.kind }) : null,
        bucket.rules.length > 1 ? /* @__PURE__ */ jsxs("span", { className: "text-[11px] text-muted-foreground", children: [
          bucket.rules.length,
          " rules \xB7 one applies per chain"
        ] }) : null
      ] }),
      /* @__PURE__ */ jsx("ul", { className: "space-y-1.5", children: bucket.rules.map((rule) => /* @__PURE__ */ jsx(
        RuleRow,
        {
          rule,
          rules,
          canEdit,
          canDelete,
          canDisable,
          deleting: deletingId === rule.id,
          onEdit: openEdit,
          onDelete: (r) => void remove(r),
          onDisable: (r) => void disable(r)
        },
        rule.id
      )) })
    ] }) }, bucket.kind || "untargeted")) }),
    source.builtins ? /* @__PURE__ */ jsx(
      BuiltinRecipesSection,
      {
        recipes: builtins.data,
        loading: builtins.isLoading,
        error: builtins.error,
        onRetry: refetchBuiltins,
        canOverride: canCreate,
        onOverride: openOverride,
        switching
      }
    ) : null
  ] });
}

export { ADDRESS_SCOPE_COPY, ADVANCED_WRITE_SCOPES, ATTRIBUTE_FIELDS, AbiRungBadge, AddressActivityCard, AddressActivityStats, AddressAttributesGrid, AddressChainComparison, AddressChainSwitcher, AddressDomainBadge, AddressFieldGrid, AddressHeaderCard, AddressIdentity, AddressScopeSwitcher, AddressTypeBadge, AppCategoryBadge, AssertedAmountsEditor, AssignmentAttributesForm, AttributionAttributesPanel, AttributionEditor, AttributionRefinePrompt, AttributionWriteHint, AuthorizerAliasBadge, BASIC_ATTRIBUTE_KEYS, BASIC_ATTRIBUTION_TARGETS, BASIC_SUBJECT_KINDS, BlockPinControl, BuiltinRecipesSection, CATALOG_ADVANCED_NOT_INCLUDED, CLUSTER_MEMBER_COLUMN_LABELS, CRITICALITY_DOT_CLASS, CRITICALITY_TONE_CLASS, CallView, CatalogConfidencePreferences, CatalogEnrichmentNotice, CatalogFieldOverridesEditor, CatalogItemForm, CatalogItemPicker, CatalogTenancyHint, ChainFeedFilter, ChainMultiSelect, ChainSelect, ChainWrittenText, ClusterOverridesPanel, ConditionRows, ConfidenceGateNotice, ConfidencePolicyEditor, ConfidencePolicyPanel, CriticalityBadge, DEFAULT_DEBOUNCE_MS, DEFAULT_TIER_LABELS, DataViewScope, DecodedCall, DecodedParamList, DecodedValue, DeploymentColourBadge, EntityCard, EntityMembershipCard, EnvBadge, FieldList, FinalityPill, FundsFlowColumns, FundsFlowSide, GENERIC_KINDS, GroupMemberPicker, GroupingRuleDialog, GroupingRulesManager, HashDisplay, HoldingsPanel, IncidentBannerCard, IncidentBanners, KindBadge, LayerVersionBadge, LiveIndicator, LiveModeControl, MembershipMatrix, NetFlow, OriginBadge, PREVIEW_DEBOUNCE_MS, PrimaryAssociation, PrimaryChainBadge, ProtocolDefinitionEditor, ProtocolEditorView, RawToggle, ReadConfidencePreferences, RecordScopeHint, RegionTag, RelatedAddressEvidence, RelatedAddressesExplorer, RelationBadge, ResolvedScopeHint, RoleCombobox, SCOPE_PREF_ANCHOR, SHARED_WRITE_SCOPES, SagaPill, SchemaField, ScopeHintProvider, ScopePreferencesPanel, ScopeSwitcher, SpecBuilder, StalenessBadge, StepCitationChips, StepFlowSummary, SurfaceScopeHint, TeamShareField, TierPill, TokenAmount, TokenDefinitionGrid, TokenHoldersTable, TokenValue, TransactionFlagBadge, TransactionFlagNotice, TxScopeHint, TypeChip, VersionDriftBadge, VersionSyncBadge, WithheldNotice, ambiguousNames, authoredAt, basicAttributes, basicCatalogDraft, basicVisibility, basicWriteScope, buildAddressScopeChoices, buildScopeChoices, catalogAdvancedRefusalMessage, catalogSubjectOffered, catalogWriteErrorMessage, commitsOnPick, createClusterMemberColumns, downstreamText, effectiveLiveMode, fieldInUse, hasWithheldContent, isCatalogAdvancedRefusal, isCatalogWriteResource, isGenericDecodedKind, isScopePinned, liveModeOptions, liveStatusFromConnection, membershipCellKey, offeredAttributeKeys, offeredAttributionTargets, offeredWriteScopes, offersRefine, parseBlockPin, relationLabel, resolveWriteTarget, samePatch, savedPolicyReach, scopedReadDeps, txRecordScope, useAddressBalances, useAddressDefi, useAddressDomain, useAddressNfts, useAddressNftsPaged, useCatalogAdvanced, useCatalogPromote, useConfidencePolicy, useDebounced, useDirtyReport, useFlatCondition, useNftCollection, useOverrideWriteScope, usePendingAttribution, usePrimaryWriteTarget, useProtocolEditor, useScopeHintContext, useScopeHints, useScopedOverride, visibilityFieldState, wasEdited, withheldSummary };
//# sourceMappingURL=chunk-CULTOWAF.js.map
//# sourceMappingURL=chunk-CULTOWAF.js.map